
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8VLb5", function(module, exports) {
/**
 * Registry of non-essential Rovo Chat localStorage keys.
 *
 * Add new non-essential keys here to allow them to be selectively disabled
 * via the Statsig dynamic config `rovo_chat_disabled_non_essential_ls_keys`
 * during an incident — without requiring a code deploy.
 *
 * A key is "non-essential" if Rovo Chat can function correctly without it
 * (e.g. a UI preference or optimisation). Wrap all accesses to these keys
 * with `withNonEssentialLocalStorage`.
 */ const $fb7e48e43c24c35d$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $fb7e48e43c24c35d$export$94d37e3eb83c6a20 = 'rovoChatRecentConversationActivity';
const $fb7e48e43c24c35d$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
const $fb7e48e43c24c35d$export$291a0efcaf2bb286 = 'is-rovo-sidenav-collapsed';
const $fb7e48e43c24c35d$export$a757cb7dc7c3e00c = 'rovo-sidenav-width';
const $fb7e48e43c24c35d$export$968eb2b238c995e3 = 'rovoSettingsAvailableConnectorsCache';
const $fb7e48e43c24c35d$export$29d77a2b275143a9 = 'rovoCwrChatPanelWidth';
const $fb7e48e43c24c35d$export$8068ec1dd5e92a56 = [
    $fb7e48e43c24c35d$export$a0d33d6e93abfb90,
    $fb7e48e43c24c35d$export$94d37e3eb83c6a20,
    $fb7e48e43c24c35d$export$97d0beb2ccc70a4d,
    $fb7e48e43c24c35d$export$291a0efcaf2bb286,
    $fb7e48e43c24c35d$export$a757cb7dc7c3e00c,
    $fb7e48e43c24c35d$export$968eb2b238c995e3,
    $fb7e48e43c24c35d$export$29d77a2b275143a9
];
module.exports["LS_CHAT_LOAD_PREFERENCE_KEY"] = $fb7e48e43c24c35d$export$a0d33d6e93abfb90;
module.exports["LS_RECENT_CONVERSATION_ACTIVITY_KEY"] = $fb7e48e43c24c35d$export$94d37e3eb83c6a20;
module.exports["LS_SIDE_NAV_COLLAPSED_KEY"] = $fb7e48e43c24c35d$export$291a0efcaf2bb286;
module.exports["LS_SIDE_NAV_WIDTH_KEY"] = $fb7e48e43c24c35d$export$a757cb7dc7c3e00c;
module.exports["LS_ROVO_SETTINGS_AVAILABLE_CONNECTORS_CACHE_KEY"] = $fb7e48e43c24c35d$export$968eb2b238c995e3;
module.exports["LS_CWR_CHAT_PANEL_WIDTH_KEY"] = $fb7e48e43c24c35d$export$29d77a2b275143a9;

});

parcelRegister("iWk4y", function(module, exports) {
/**
 * Selective dynamic-config-protected wrapper for non-essential Rovo Chat localStorage access.
 *
 * Background (HOT-303866): a corrupt value in a localStorage key broke Rovo Chat
 * for ~23,000 users. During the incident, there was no way to quickly disable the
 * code reading that key, so the fix took days to ship.
 *
 * When `rovo_chat_disabled_nonessential_ls_keys` is enabled, this wrapper checks
 * the Statsig dynamic config `rovo_chat_disabled_non_essential_ls_keys` before
 * executing the provided callback. The config value is a `string[]` of localStorage key names that are currently
 * disabled. If the given `key` appears in that list, the callback is skipped and `null`
 * is returned. If the key is not in the list (default), the callback is executed normally.
 *
 * This allows individual localStorage keys to be selectively disabled during an incident
 * without affecting others — no code deploy required.
 *
 * ```ts
 * import { withNonEssentialLocalStorage } from
 *   '@atlassian/conversation-assistant-utils/nonEssentialLocalStorage/withNonEssentialLocalStorage';
 *
 * // Read
 * const value = withNonEssentialLocalStorage(
 *   'aiMateChatLoadPreference',
 *   () => localStorage.getItem(getChatLoadPreferenceKey(siteId))
 * );
 *
 * // Write (return value ignored)
 * withNonEssentialLocalStorage(
 *   'aiMateChatLoadPreference',
 *   () => localStorage.setItem(getChatLoadPreferenceKey(siteId), conversationId)
 * );
 * ```
 */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $76e028d2d11d3b36$var$DYNAMIC_CONFIG_NAME = 'rovo_chat_disabled_non_essential_ls_keys';
const $76e028d2d11d3b36$var$DYNAMIC_CONFIG_PARAM = 'value';
const $76e028d2d11d3b36$export$870e7f78af43b2fe = (key, callback)=>{
    if (!(0, $iDrrr.fg)('rovo_chat_disabled_nonessential_ls_keys')) return callback();
    const disabledKeys = (0, $cXtTj.default).getExperimentValue($76e028d2d11d3b36$var$DYNAMIC_CONFIG_NAME, $76e028d2d11d3b36$var$DYNAMIC_CONFIG_PARAM, [], {
        fireExperimentExposure: false
    });
    if (Array.isArray(disabledKeys) && disabledKeys.includes(key)) return null;
    return callback();
};
module.exports["withNonEssentialLocalStorage"] = $76e028d2d11d3b36$export$870e7f78af43b2fe;

});

parcelRegister("dw75i", function(module, exports) {
const $298e232207fb2253$export$4081752c8da17394 = {
    // Atlassian Projects
    CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
    // Jira
    UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
    UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
    TriageApplyRecommendationTool: 'TriageApplyRecommendationTool',
    JiraFindIssues: 'jira-find-issues',
    JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
    JiraSmartIssueCreateBulk: 'jira-atlassian-work-item-create-all-field-types-bulk',
    JiraAdminAgent: 'JiraAdminAgentActionableTool',
    JiraAdminFieldTrash: 'JiraAdminFieldTrashActionableTool',
    JiraAdminFieldMerge: 'JiraAdminFieldMergeActionableTool',
    JiraIssueTransition: 'jira-issue-transition-bulk',
    JiraIssueTransitionIS: 'jira-atlassian-work-item-update-status',
    JiraEpicsSuggest: 'jira-epics-suggest',
    JiraIssueDelete: 'jira-issue-delete',
    JiraIssueMove: 'jira-issue-move',
    JiraIssueAssign: 'jira-issue-assign-bulk',
    JiraIssueAssignIS: 'jira-atlassian-work-item-update-assignee',
    JiraVersionCreate: 'jira-version-create',
    JiraVersionCreateIS: 'jira-atlassian-project-create-version',
    JiraViewCreateAndConfigure: 'jira-view-create-and-configure',
    JiraViewSaveListViewConfig: 'jira-view-save-list-view-config',
    RovoWhenAssignedTool: 'RovoWhenAssignedTool',
    RovoJiraDelegationIntentTool: 'RovoJiraDelegationIntentTool',
    // Work organizer sprint actions
    JiraCreateSprint: 'jira-atlassian-work-item-create-sprint',
    JiraStartSprint: 'jira-atlassian-board-start-sprint',
    JiraMoveToSprint: 'jira-atlassian-workspace-move-to-sprint-work-item',
    JiraWorkflowEditor: 'jira-workflow-operations',
    // Confluence
    ConfluenceFolderCreate: 'confluence-atlassian-workspace-create-folder',
    ConfluencePageCreate: 'confluence-page-create',
    ConfluencePageCreateIS: 'confluence-atlassian-workspace-create-document',
    ConfluencePageComment: 'confluence-page-comment',
    ConfluencePageCommentIS: 'confluence-atlassian-document-create-comment',
    ConfluenceComment: 'confluence-comment',
    // Comments on content other than pages and blog posts, such as whiteboards
    ConfluencePageAddLabel: 'confluence-label-create',
    ConfluencePageAddLabelIS: 'confluence-atlassian-workspace-create-label',
    // Integration Service tool name variant
    ConfluencePageRename: 'confluence-page-rename',
    ConfluencePageRenameIS: 'confluence-atlassian-workspace-update-document-title',
    ConfluencePageMove: 'confluence-page-move',
    ConfluencePageMoveIS: 'confluence-atlassian-workspace-update-document-location',
    // Confluence approval action keys emitted by Integration Service.
    ConfluenceApprovalCreate: 'confluence-atlassian-document-create-approval',
    ConfluenceApprovalDelete: 'confluence-atlassian-document-delete-approval',
    ConfluenceApprovalGet: 'confluence-atlassian-document-get-approval',
    ConfluenceApprovalGetHistory: 'confluence-atlassian-document-get-approval-history',
    ConfluenceApprovalUpdateCancel: 'confluence-atlassian-document-update-approval-cancel',
    ConfluenceApprovalUpdateDecision: 'confluence-atlassian-document-update-approval-decision',
    ConfluenceApprovalUpdateDueDate: 'confluence-atlassian-document-update-approval-due-date',
    ConfluenceApprovalUpdateMessage: 'confluence-atlassian-document-update-approval-message',
    ConfluenceApprovalUpdateReviewerMembership: 'confluence-atlassian-document-update-approval-reviewer-membership',
    ConfluenceApprovalUpdateReviewers: 'confluence-atlassian-document-update-approval-reviewers',
    // RCS Long Horizon approval action keys (IS action types) for the confluence-approvals skill.
    ConfluenceApprovalCreateActionType: 'atlassian:document:create:approval',
    ConfluenceApprovalDeleteActionType: 'atlassian:document:delete:approval',
    ConfluenceApprovalUpdateCancelActionType: 'atlassian:document:update:approval-cancel',
    ConfluenceApprovalUpdateDecisionActionType: 'atlassian:document:update:approval-decision',
    ConfluenceApprovalUpdateDueDateActionType: 'atlassian:document:update:approval-due-date',
    ConfluenceApprovalUpdateMessageActionType: 'atlassian:document:update:approval-message',
    ConfluenceApprovalUpdateReviewerMembershipActionType: 'atlassian:document:update:approval-reviewer-membership',
    ConfluenceApprovalUpdateReviewersActionType: 'atlassian:document:update:approval-reviewers',
    ConfluenceApprovalUpdateApproveActionType: 'atlassian:document:update:approval-approve',
    ConfluenceApprovalUpdateDenyActionType: 'atlassian:document:update:approval-deny',
    // Convo AI and CAP LongHorizon approval action keys.
    ConfluenceApprovalCreateConvoAi: 'confluence-approval-create',
    ConfluenceApprovalReviewApprove: 'confluence-approval-review-approve',
    ConfluenceApprovalReviewDeny: 'confluence-approval-review-deny',
    ConfluenceApprovalReviewCancel: 'confluence-approval-review-cancel',
    ConfluenceApprovalReviewClear: 'confluence-approval-review-clear',
    ConfluenceApprovalReviewersUpdate: 'confluence-approval-reviewers-update',
    ConfluenceApprovalMessageUpdate: 'confluence-approval-message-update',
    ConfluenceApprovalDueDateUpdate: 'confluence-approval-due-date-update',
    ConfluenceApprovalSpaceSettingsUpdate: 'confluence-approval-space-settings-update',
    ConfluenceApprovalSiteSettingsUpdate: 'confluence-approval-site-settings-update',
    // JSM
    JsmJourneyBuilder: 'jsm-invoke-orchestrator-agent',
    JsmCreateRequest: 'jsm-create-request',
    JsmCreateRequestV2: 'jsm-create-request-v2',
    CreateRequest: 'create-request',
    JsmCreateEmbeddedRequest: 'help-form-submit',
    JsmCreateSurvey: 'jsm-create-survey',
    JsmCreateFormTemplate: 'jsm-atlassian-project-create-form-template',
    JsmCreateSolutionComposerSpace: 'jsm-atlassian-project-create-solution-composer-space',
    JsmLivechat: 'jsm-livechat',
    JsmLivechatIS: 'jsm-livechat-plugin',
    JsmSolutionComposerPlanSummary: 'jsm-solution-composer-plan-summary',
    // Deep Research
    DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
    // Studio
    StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
    StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
    StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
    StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
    StudioAutomationCreateRule: 'automation-platform-atlassian-automation-create-rule',
    UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
    StudioCreateAgent: 'CreateAgentTool',
    RovoPublishAgent: 'rovo-publish-agent',
    StudioLandingPageRedirect: 'studio-landing-page-redirect',
    // Plans — canonical keys; keep in sync with the JIRA_PLANS_*_KEY constants below.
    JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
    JiraPlansCreateProgramBoard: 'jira-atlassian-plan-add-program-board',
    JiraPlansDeleteProgramBoard: 'jira-atlassian-plan-delete-program-board',
    JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
    JiraPlansCreateWorkItemIS: 'jira-atlassian-plan-add-work-item',
    JiraPlansCreateRelease: 'jira-atlassian-plan-create-release',
    JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
    JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
    JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
    // Capacity Planning
    ManageCapacityPlan: 'capacity-plan-update-single-action',
    ManageCapacityPlanIS: 'capacity-plan-update-single-plugin',
    // Allocation Planning
    ManagePlanAllocations: 'manage-plan-allocations',
    // Atlassian Teams
    AtlassianTeamUpdateArchive: 'atlassian-team-atlassian-team-update-archive',
    // Focus Asks
    FocusCreateAsk: 'passionfruit-atlassian-workspace-create-asks',
    FocusCreateAskIS: 'focus-atlassian-workspace-create-asks',
    FocusCreateAskAnthropic: 'ari:cloud:platform::skill/b3f8a1c2-7e4d-4a9b-8c6f-2d1e5b9a3f7es',
    // Bitbucket
    BitbucketPullRequestComment: 'bitbucket-pull-request-comment',
    BitbucketPullRequestCommentIS: 'bitbucket-atlassian-pull-request-create-direct-comment',
    // Slack
    SlackSendChannelMessage: 'slack-send-channel-message',
    SlackSendChannelMessageIS: 'slack-atlassian-channel-create-message',
    // Others
    StoreRecommendationCard: 'store-recommendation-card',
    RequireInformationTool: 'RequireInformationTool',
    HiringManagerTool: 'HiringManagerTool',
    JsmSuggestAndAddFieldsToRequestType: 'SuggestAndAddFieldsToRequestType',
    JsmAtlassianProjectCreateJsmRequestType: 'jsm-atlassian-project-create-jsm-request-type',
    JsmAtlassianProjectCreateJsmRequestTypeWithFields: 'jsm-atlassian-project-create-jsm-request-type-with-fields',
    // Google Docs
    GoogleDocCreate: 'google-doc-create',
    GoogleDocCreateIS: 'google-atlassian-workspace-create-document',
    // Convo AI agent tools
    ExecutePython: 'execute_python',
    PlanComplete: 'plan_complete',
    AskQuestion: 'ask_question',
    JsmAtlassianProjectCreateJsmQueue: 'jsm-atlassian-project-create-jsm-queue',
    JsmAtlassianProjectCreateJsmQueueGroup: 'jsm-atlassian-project-create-jsm-queue-group',
    JsmAtlassianProjectUpdateJsmQueue: 'jsm-atlassian-project-update-jsm-queue',
    JsmAtlassianProjectUpdateJsmQueueGroup: 'jsm-atlassian-project-update-jsm-queue-group',
    JsmAtlassianProjectUpdateRequestTypePortalGroups: 'jsm-atlassian-project-update-request-type-groups',
    JsmAtlassianRequestTypeUpdateWorkflow: 'jsm-atlassian-request-type-update-workflow',
    JsmSelectHardwareTypes: 'ham-onboarding-hardware-assets-types',
    JsmSelectHardwareTypesSkill: 'ham-onboarding-hardware-assets-types-skill',
    HamOnboardingSetupComplete: 'ham-onboarding-setup-complete',
    HamOnboardingSetupCompleteSkill: 'ham-onboarding-setup-complete-skill',
    // Solution Composer SLA-plugin keys (fire-and-forget staging + embed-view routing).
    JsmCreateSlaPlugin: 'jsm-create-sla-plugin',
    JsmUpdateSlaPlugin: 'jsm-update-sla-plugin',
    // Bare `manage-sla` skill keys (Rovo Chat SLA create/update card). Distinct from the
    // Solution Composer plugin keys above — see jira `useSlaSavedBridge`.
    JsmCreateSla: 'jsm-create-sla',
    JsmUpdateSla: 'jsm-update-sla',
    // Confluence AIFC
    AifcAdfUpdate: 'aifc-adf-update',
    // AdminHub policy platform
    AdminhubPolicyCreate: 'atlassian:admin:create:policy-preview',
    AdminhubPolicyUpdate: 'atlassian:admin:update:policy-preview',
    // Google Calendar
    GoogleCalendarEventCreate: 'google-calendar-event-create',
    GoogleCalendarEventCreateIS: 'google-atlassian-calendar-create-event',
    // Assets
    AssetsCreateSchema: 'assets-create-schema',
    AssetsSchemaCreateObjectType: 'assets-schema-create-object-type',
    AssetsObjectTypeCreateAttribute: 'assets-object-type-create-attribute',
    AssetsObjectTypeCreateObject: 'assets-object-type-create-object',
    AssetsObjectTypeCreateObjectBulk: 'assets-object-type-create-object-bulk',
    AssetsObjectCreateAttribute: 'assets-object-create-attribute',
    AssetsUpdateSchema: 'assets-update-schema',
    AssetsSchemaUpdateObjectType: 'assets-schema-update-object-type',
    AssetsObjectTypeUpdateAttribute: 'assets-object-type-update-attribute',
    AssetsObjectTypeUpdateObject: 'assets-object-type-update-object',
    AssetsObjectUpdateAttribute: 'assets-object-update-attribute',
    AssetsEditObject: 'assets-edit-object',
    // Add other keys here as needed
    ArtifactCreate: 'rovo-artifact-create',
    ScheduledChat: 'ScheduleRovoChatTool',
    ImageSearch: 'image-search',
    MultipleChoiceQuestionsTool: 'MultipleChoiceQuestionsTool',
    AgenticPlanTool: 'AgenticPlanTool',
    RepositoryChoiceTool: 'RepositoryChoiceTool',
    CreateKBCard: 'jsm-atlassian-jsm-kb-bulk-create-draft-topics',
    CreateKbArticlesCard: 'jsm-atlassian-jsm-kb-validate-draft-articles',
    // Custom Skills
    CreateCustomSkillTool: 'CreateCustomSkillTool',
    UpdateCustomSkillTool: 'UpdateCustomSkillTool',
    // Rovo Data Insights (the backend action key retains the legacy Analytics identifier)
    AtlassianAnalyticsStartSession: 'atlassian-analytics-start-session'
};
const $298e232207fb2253$export$c5959ebd02278fb3 = $298e232207fb2253$export$4081752c8da17394.FocusCreateAsk;
const $298e232207fb2253$export$13a3c9f5b74f4587 = $298e232207fb2253$export$4081752c8da17394.FocusCreateAskAnthropic;
const $298e232207fb2253$export$a43abf6a24956d01 = $298e232207fb2253$export$4081752c8da17394.GoogleDocCreate;
const $298e232207fb2253$export$98251f227f05fc03 = 'execute_python';
const $298e232207fb2253$export$2cf48170a90af7e3 = 'plan_complete';
const $298e232207fb2253$export$52c76e2fb6c72799 = 'ask_question';
const $298e232207fb2253$export$d3fc7569bcc4e4e7 = new Set([
    $298e232207fb2253$export$52c76e2fb6c72799,
    $298e232207fb2253$export$2cf48170a90af7e3
]);
const $298e232207fb2253$export$f4709e6eb43898ae = {
    DynamicAction: 'dynamicAction',
    Resumption: 'resumption'
};
const $298e232207fb2253$export$bc586be7fadebdbb = {
    create: '2252e7f5-51e6-4886-8f49-842f938f567a',
    update: '0aca7f23-fec8-46a7-ae87-107c17a6caee'
};
const $298e232207fb2253$export$baaa705c57b80252 = {
    [$298e232207fb2253$export$bc586be7fadebdbb.create]: $298e232207fb2253$export$4081752c8da17394.CreateCustomSkillTool,
    [$298e232207fb2253$export$bc586be7fadebdbb.update]: $298e232207fb2253$export$4081752c8da17394.UpdateCustomSkillTool
};
const $298e232207fb2253$export$ccebfc8784baf74e = (action)=>action?.actionId && $298e232207fb2253$export$baaa705c57b80252[action.actionId] || action?.key || '';
const $298e232207fb2253$export$b35047323301aad6 = (action)=>Boolean(action?.actionId && $298e232207fb2253$export$baaa705c57b80252[action.actionId]);
const $298e232207fb2253$export$dc0b7ce6d28cc1a4 = Object.values($298e232207fb2253$export$4081752c8da17394);
const $298e232207fb2253$export$83855c070e12d9d0 = new Set([
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalCreate,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalDelete,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalGet,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalGetHistory,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateCancel,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateDecision,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateDueDate,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateMessage,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateReviewerMembership,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateReviewers,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalCreateActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalDeleteActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateCancelActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateDecisionActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateDueDateActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateMessageActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateReviewerMembershipActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateReviewersActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateApproveActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalUpdateDenyActionType,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalCreateConvoAi,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalReviewApprove,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalReviewDeny,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalReviewCancel,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalReviewClear,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalReviewersUpdate,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalMessageUpdate,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalDueDateUpdate,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalSpaceSettingsUpdate,
    $298e232207fb2253$export$4081752c8da17394.ConfluenceApprovalSiteSettingsUpdate
]);
const $298e232207fb2253$export$a70752a3aa5d7b44 = 'generic-external-action-error';
const $298e232207fb2253$export$4017c867f2f7bb4 = 'jira-find-issues';
const $298e232207fb2253$export$d94c92560b8e6d9 = 'jira-atlassian-work-item-create-all-field-types';
const $298e232207fb2253$export$c61d181fda8156c4 = 'jira-atlassian-work-item-create-all-field-types-bulk';
const $298e232207fb2253$export$d4f6bcd6a31631e7 = 'atlassian:admin:create:policy-preview';
const $298e232207fb2253$export$197aaeb156d8188d = 'atlassian:admin:update:policy-preview';
const $298e232207fb2253$export$ae7170c1349b8d03 = 'jsm-create-request';
const $298e232207fb2253$export$bd97f2d43b42e54b = 'jsm-create-request-v2';
const $298e232207fb2253$export$ce5ab65c94ba90a5 = 'create-request';
const $298e232207fb2253$export$d8b6e8d910775d71 = 'help-form-submit';
const $298e232207fb2253$export$63066a4ea024d6dc = 'jsm-livechat';
const $298e232207fb2253$export$12df73851574d597 = 'jira-issue-transition-bulk';
const $298e232207fb2253$export$3409cf7709732f7a = 'jira-epics-suggest';
const $298e232207fb2253$export$28eab0a47cd4bdb7 = 'jira-issue-delete';
const $298e232207fb2253$export$7814024c83fb6ff0 = 'jira-issue-move';
const $298e232207fb2253$export$1621b7bb3a34aaf8 = 'jira-issue-assign-bulk';
const $298e232207fb2253$export$5d140de35a141589 = 'jira-version-create';
const $298e232207fb2253$export$5930d4956edc85a0 = 'jira-view-create-and-configure';
const $298e232207fb2253$export$104eac9150443c9c = 'jira-view-save-list-view-config';
const $298e232207fb2253$export$9fd86b62c760a9f1 = 'RovoWhenAssignedTool';
const $298e232207fb2253$export$8ca833ea85a8fbca = 'RovoJiraDelegationIntentTool';
const $298e232207fb2253$export$9c43c5b52e38bd7b = 'capacity-plan-update-single-action';
const $298e232207fb2253$export$5822a2e7b967ba2a = 'manage-plan-allocations';
const $298e232207fb2253$export$7daabf9beae1e394 = 'jira-workflow-operations';
const $298e232207fb2253$export$b34d7535a3731e6 = 'confluence-page-create';
const $298e232207fb2253$export$5eead95dddb4d85e = 'confluence-page-comment';
const $298e232207fb2253$export$dd1d4f1078af0323 = 'confluence-page-rename';
const $298e232207fb2253$export$ea076e5315cd0441 = 'confluence-label-create';
const $298e232207fb2253$export$2d6387634f79866d = 'confluence-page-move';
const $298e232207fb2253$export$c35e156d5b3ba839 = 'deep-research-report-confluence-export';
const $298e232207fb2253$export$4e69e2bf4f236f9 = 'image-search';
const $298e232207fb2253$export$6509c2efb7cf2a1a = 'RequireInformationTool';
const $298e232207fb2253$export$32fdd722a8ead9f4 = 'HiringManagerTool';
const $298e232207fb2253$export$1b06fd861ab5ff79 = 'studio-trigger-solution-plan';
const $298e232207fb2253$export$7f87d37407a70a70 = 'studio-atlassian-studio-update-agent-draft';
const $298e232207fb2253$export$e118b34b65e65120 = 'studio-atlassian-workspace-update-draft-agent';
const $298e232207fb2253$export$1d1c24f8fb60d008 = 'UpdateAgentConfigurationTool';
const $298e232207fb2253$export$5f46fda2a8a95615 = 'jsm-invoke-orchestrator-agent';
const $298e232207fb2253$export$a1766d72cd6b3386 = 'jsm-atlassian-project-create-jsm-survey';
const $298e232207fb2253$export$898c044e7b2c7e3a = 'jsm-atlassian-project-create-form-template';
const $298e232207fb2253$export$d72e9b3d51df24a2 = 'jsm-atlassian-project-create-solution-composer-space';
const $298e232207fb2253$export$97632a370497b953 = 'jsm-atlassian-project-create-jsm-queue';
const $298e232207fb2253$export$d1d21bf838e2f79 = 'jsm-atlassian-project-create-jsm-queue-group';
const $298e232207fb2253$export$7343cca51c2f764f = 'jsm-atlassian-project-update-jsm-queue';
const $298e232207fb2253$export$263c9dbbd6f9736b = 'jsm-atlassian-project-update-jsm-queue-group';
const $298e232207fb2253$export$f72bc47d7a557fac = 'jsm-atlassian-project-update-request-type-groups';
const $298e232207fb2253$export$ccb0750b3728dfc8 = 'jsm-atlassian-request-type-update-workflow';
const $298e232207fb2253$export$b26feecb387f3cdd = 'jsm-create-sla-plugin';
const $298e232207fb2253$export$2ebc939020585965 = 'jsm-update-sla-plugin';
const $298e232207fb2253$export$c24d173ae081691 = 'jsm-atlassian-project-create-jsm-request-type';
const $298e232207fb2253$export$85f4644ed1882358 = 'jsm-atlassian-project-create-jsm-request-type-with-fields';
const $298e232207fb2253$export$a95d95d149961c0e = 'SuggestAndAddFieldsToRequestType';
const $298e232207fb2253$export$20f16b1101429bc = 'jsm-atlassian-jsm-kb-bulk-create-draft-topics';
const $298e232207fb2253$export$4c4ea6fd8cbe01a5 = 'jsm-atlassian-jsm-kb-validate-draft-articles';
const $298e232207fb2253$export$459b808fe2e5243c = 'studio-automation-trigger-rule-build';
const $298e232207fb2253$export$a812c5f6a163b49c = 'automation-platform-atlassian-automation-create-rule';
const $298e232207fb2253$export$7ec0908a542c881f = 'CreateAgentTool';
const $298e232207fb2253$export$f1de20d01116fc4e = 'rovo-publish-agent';
const $298e232207fb2253$export$5b672baa753f5e11 = 'jira-atlassian-plan-update-work-sources';
const $298e232207fb2253$export$cbc8657dfb60324e = 'jira-atlassian-plan-add-program-board';
const $298e232207fb2253$export$5eaeb9a94b1424d1 = 'jira-atlassian-plan-delete-program-board';
const $298e232207fb2253$export$aa0b02e94003e760 = 'jira-atlassian-plan-create-work-item';
const $298e232207fb2253$export$fc48d7aa308f4ddd = 'jira-atlassian-plan-set-release-enabled';
const $298e232207fb2253$export$82a76d32e0a5ed52 = 'jira-atlassian-plan-add-work-item-dependencies';
const $298e232207fb2253$export$a27ffbabb22373cc = 'jira-atlassian-plan-remove-work-item-dependencies';
const $298e232207fb2253$export$17ce344f9afefd3f = 'jira-atlassian-plan-create-release';
const $298e232207fb2253$export$a74dbdee1445f294 = 'jira-plan-add-program-board-plugin';
const $298e232207fb2253$export$d4f0a9e71dd5ecef = 'Jira-Plan-Delete-Program-Board-Plugin';
const $298e232207fb2253$export$c7bfe2c804ad4c7f = 'Jira-Plan-Create-Release-Plugin';
const $298e232207fb2253$export$b392dc810180e703 = 'store-recommendation-card';
const $298e232207fb2253$export$1d10a8f57c7c69ae = 'jira-ham-ai-insights-preview';
const $298e232207fb2253$export$37572672766b68ab = 'atlassian-team-atlassian-team-update-archive';
const $298e232207fb2253$export$88c32cc437966d51 = 'ScheduleRovoChatTool';
const $298e232207fb2253$export$a60c2f7f22cc5a42 = 'MultipleChoiceQuestionsTool';
const $298e232207fb2253$export$d4c7224b1c4ad942 = 'AgenticPlanTool';
const $298e232207fb2253$export$ef8aa45067b257a9 = [
    $298e232207fb2253$export$4017c867f2f7bb4,
    $298e232207fb2253$export$3409cf7709732f7a,
    $298e232207fb2253$export$28eab0a47cd4bdb7,
    $298e232207fb2253$export$7814024c83fb6ff0
];
const $298e232207fb2253$export$7056db6119e39543 = 'agentTrainingContext';
module.exports["ActionKeys"] = $298e232207fb2253$export$4081752c8da17394;
module.exports["FOCUS_CREATE_ASK_KEY"] = $298e232207fb2253$export$c5959ebd02278fb3;
module.exports["FOCUS_CREATE_ASK_ANTHROPIC_KEY"] = $298e232207fb2253$export$13a3c9f5b74f4587;
module.exports["ASK_QUESTION_KEY"] = $298e232207fb2253$export$52c76e2fb6c72799;
module.exports["ACTIONS_HIDING_FOOTER_BUTTONS"] = $298e232207fb2253$export$d3fc7569bcc4e4e7;
module.exports["ActionPredicateKeys"] = $298e232207fb2253$export$f4709e6eb43898ae;
module.exports["CUSTOM_SKILL_IS_TOOL_IDS"] = $298e232207fb2253$export$bc586be7fadebdbb;
module.exports["resolveActionKey"] = $298e232207fb2253$export$ccebfc8784baf74e;
module.exports["isActionKeyFromActionId"] = $298e232207fb2253$export$b35047323301aad6;
module.exports["CONFLUENCE_APPROVAL_ACTION_KEYS"] = $298e232207fb2253$export$83855c070e12d9d0;
module.exports["JIRA_FIND_ISSUES_KEY"] = $298e232207fb2253$export$4017c867f2f7bb4;
module.exports["JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY"] = $298e232207fb2253$export$d94c92560b8e6d9;
module.exports["JIRA_SMART_ISSUE_CREATE_BULK_KEY"] = $298e232207fb2253$export$c61d181fda8156c4;
module.exports["ADMINHUB_POLICY_CREATE_KEY"] = $298e232207fb2253$export$d4f6bcd6a31631e7;
module.exports["ADMINHUB_POLICY_UPDATE_KEY"] = $298e232207fb2253$export$197aaeb156d8188d;
module.exports["JSM_CREATE_REQUEST_KEY"] = $298e232207fb2253$export$ae7170c1349b8d03;
module.exports["JSM_CREATE_REQUEST_V2_KEY"] = $298e232207fb2253$export$bd97f2d43b42e54b;
module.exports["CREATE_REQUEST_KEY"] = $298e232207fb2253$export$ce5ab65c94ba90a5;
module.exports["JSM_CREATE_EMBEDDED_REQUEST_KEY"] = $298e232207fb2253$export$d8b6e8d910775d71;
module.exports["JIRA_ISSUE_TRANSITION_KEY"] = $298e232207fb2253$export$12df73851574d597;
module.exports["JIRA_EPICS_SUGGEST_KEY"] = $298e232207fb2253$export$3409cf7709732f7a;
module.exports["JIRA_ISSUE_DELETE_KEY"] = $298e232207fb2253$export$28eab0a47cd4bdb7;
module.exports["JIRA_ISSUE_MOVE_KEY"] = $298e232207fb2253$export$7814024c83fb6ff0;
module.exports["JIRA_ISSUE_ASSIGN_KEY"] = $298e232207fb2253$export$1621b7bb3a34aaf8;
module.exports["JIRA_VERSION_CREATE_KEY"] = $298e232207fb2253$export$5d140de35a141589;
module.exports["JIRA_VIEW_CREATE_AND_CONFIGURE_KEY"] = $298e232207fb2253$export$5930d4956edc85a0;
module.exports["JIRA_VIEW_SAVE_LIST_VIEW_CONFIG_KEY"] = $298e232207fb2253$export$104eac9150443c9c;
module.exports["CONFLUENCE_PAGE_CREATE_KEY"] = $298e232207fb2253$export$b34d7535a3731e6;
module.exports["CONFLUENCE_PAGE_COMMENT_KEY"] = $298e232207fb2253$export$5eead95dddb4d85e;
module.exports["CONFLUENCE_PAGE_ADD_LABEL_KEY"] = $298e232207fb2253$export$ea076e5315cd0441;
module.exports["IMAGE_SEARCH_KEY"] = $298e232207fb2253$export$4e69e2bf4f236f9;
module.exports["REQUIRE_INFORMATION_TOOL"] = $298e232207fb2253$export$6509c2efb7cf2a1a;
module.exports["HIRING_MANAGER_TOOL_KEY"] = $298e232207fb2253$export$32fdd722a8ead9f4;
module.exports["STUDIO_TRIGGER_SOLUTION_PLAN_KEY"] = $298e232207fb2253$export$1b06fd861ab5ff79;
module.exports["JSM_CREATE_SURVEY_KEY"] = $298e232207fb2253$export$a1766d72cd6b3386;
module.exports["JSM_CREATE_FORM_TEMPLATE_KEY"] = $298e232207fb2253$export$898c044e7b2c7e3a;
module.exports["JSM_CREATE_SOLUTION_COMPOSER_SPACE_KEY"] = $298e232207fb2253$export$d72e9b3d51df24a2;
module.exports["JSM_QUEUE_CREATE_KEY"] = $298e232207fb2253$export$97632a370497b953;
module.exports["JSM_QUEUE_GROUP_CREATE_KEY"] = $298e232207fb2253$export$d1d21bf838e2f79;
module.exports["JSM_QUEUE_UPDATE_KEY"] = $298e232207fb2253$export$7343cca51c2f764f;
module.exports["JSM_QUEUE_GROUP_UPDATE_KEY"] = $298e232207fb2253$export$263c9dbbd6f9736b;
module.exports["JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY"] = $298e232207fb2253$export$f72bc47d7a557fac;
module.exports["JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY"] = $298e232207fb2253$export$ccb0750b3728dfc8;
module.exports["JSM_SLA_CREATE_KEY"] = $298e232207fb2253$export$b26feecb387f3cdd;
module.exports["JSM_SLA_UPDATE_KEY"] = $298e232207fb2253$export$2ebc939020585965;
module.exports["JSM_REQUEST_TYPE_UPDATED_KEY"] = $298e232207fb2253$export$85f4644ed1882358;
module.exports["JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY"] = $298e232207fb2253$export$a95d95d149961c0e;
module.exports["JSM_CREATE_KB_TOPICS_KEY"] = $298e232207fb2253$export$20f16b1101429bc;
module.exports["JSM_CREATE_KB_ARTICLES_KEY"] = $298e232207fb2253$export$4c4ea6fd8cbe01a5;
module.exports["STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY"] = $298e232207fb2253$export$459b808fe2e5243c;
module.exports["ROVO_PUBLISH_AGENT_KEY"] = $298e232207fb2253$export$f1de20d01116fc4e;
module.exports["JIRA_PLANS_UPDATE_WORK_SOURCE_KEY"] = $298e232207fb2253$export$5b672baa753f5e11;
module.exports["JIRA_PLANS_ADD_PROGRAM_BOARD_KEY"] = $298e232207fb2253$export$cbc8657dfb60324e;
module.exports["JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY"] = $298e232207fb2253$export$5eaeb9a94b1424d1;
module.exports["JIRA_PLANS_CREATE_WORK_ITEM_KEY"] = $298e232207fb2253$export$aa0b02e94003e760;
module.exports["JIRA_PLANS_MANAGE_FEATURES_KEY"] = $298e232207fb2253$export$fc48d7aa308f4ddd;
module.exports["JIRA_PLANS_ADD_DEPENDENCY_KEY"] = $298e232207fb2253$export$82a76d32e0a5ed52;
module.exports["JIRA_PLANS_REMOVE_DEPENDENCY_KEY"] = $298e232207fb2253$export$a27ffbabb22373cc;
module.exports["JIRA_PLANS_CREATE_RELEASE_KEY"] = $298e232207fb2253$export$17ce344f9afefd3f;
module.exports["JIRA_PLANS_ADD_PROGRAM_BOARD_STRATUS_KEY"] = $298e232207fb2253$export$a74dbdee1445f294;
module.exports["JIRA_PLANS_DELETE_PROGRAM_BOARD_STRATUS_KEY"] = $298e232207fb2253$export$d4f0a9e71dd5ecef;
module.exports["JIRA_PLANS_CREATE_RELEASE_STRATUS_KEY"] = $298e232207fb2253$export$c7bfe2c804ad4c7f;
module.exports["STORE_RECOMMENDATION_ACTION_KEY"] = $298e232207fb2253$export$b392dc810180e703;
module.exports["JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY"] = $298e232207fb2253$export$1d10a8f57c7c69ae;
module.exports["ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY"] = $298e232207fb2253$export$37572672766b68ab;
module.exports["SCHEDULED_CHAT_KEY"] = $298e232207fb2253$export$88c32cc437966d51;
module.exports["AGENT_TRAINING_CONTEXT_KEY"] = $298e232207fb2253$export$7056db6119e39543;

});

parcelRegister("iW40i", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5edf756ec3878422$var$store = (0, $8s9DV.createStore)({
    name: 'chatUseMessages',
    initialState: {},
    actions: {
        setMessages: (conversationId, messages)=>({ setState: setState })=>{
                setState({
                    [conversationId]: messages
                });
            },
        getMessages: (conversationId)=>({ getState: getState })=>{
                return getState()[conversationId] ?? [];
            }
    }
});
const $5edf756ec3878422$export$d5c60118ea64ef24 = (0, $kBr4q.createHook)($5edf756ec3878422$var$store, {
    selector: (state, { conversationId: conversationId })=>state[conversationId] ?? []
});
const $5edf756ec3878422$export$fcbbecdca7d55350 = (0, $kBr4q.createActionsHook)($5edf756ec3878422$var$store);
module.exports["useChatMessages"] = $5edf756ec3878422$export$d5c60118ea64ef24;
module.exports["useChatMessagesActions"] = $5edf756ec3878422$export$fcbbecdca7d55350;

});

parcelRegister("c7So7", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $nStJY = parcelRequire("nStJY");


var $iDrrr = parcelRequire("iDrrr");


var $i7OAD = parcelRequire("i7OAD");


var $4jIXV = parcelRequire("4jIXV");


var $9yffN = parcelRequire("9yffN");


var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");

function $8def780e3a1ebdcf$export$17828fb10c7c5928(messages, messageId) {
    return messages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content.message.message.id === messageId);
}
function $8def780e3a1ebdcf$export$c5f84c389beb0191(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((action)=>(0, $i7OAD.isCreatableAction)(action) || (0, $9yffN.isJiraPreviewableAction)(action))) return msg;
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$551dda091e9d40ca(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((0, $i7OAD.isAIFCAction))) return msg;
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$6f9d326b409b8a89(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg)) return msg;
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$ae4c648272f0b05(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg) && msg.content.message.message.actions?.length) return msg.content.message.message.actions.some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
    }
    return false;
}
function $8def780e3a1ebdcf$export$cde501ceecd81c44(message, invocationId) {
    if (!message || !invocationId) return message;
    const actions = message.content.message.message.actions;
    if (!actions || actions.length < 2) return message;
    const index = actions.findIndex((action)=>action.invocationId === invocationId);
    if (index <= 0) return message;
    const reorderedActions = [
        actions[index],
        ...actions.slice(0, index),
        ...actions.slice(index + 1)
    ];
    // Clone only the path down to `actions`; everything else (notably the streamed action `data`) is
    // shared by reference so we don't deep-copy potentially large ADF on every card switch.
    const assistantMessage = {
        ...message.content.message.message,
        actions: reorderedActions
    };
    return {
        ...message,
        content: {
            ...message.content,
            message: {
                ...message.content.message,
                message: assistantMessage
            }
        }
    };
}
function $8def780e3a1ebdcf$export$2f146962db2122e6(message, invocationId) {
    const selectedAction = $8def780e3a1ebdcf$export$e3d25f9304ba048e(message, invocationId, (action)=>action.invocationId === invocationId);
    if (!message || !selectedAction) return undefined;
    const assistantMessage = {
        ...message.content.message.message,
        actions: [
            selectedAction
        ]
    };
    return {
        ...message,
        content: {
            ...message.content,
            message: {
                ...message.content.message,
                message: assistantMessage
            }
        }
    };
}
function $8def780e3a1ebdcf$export$e3d25f9304ba048e(message, invocationId, isEligible) {
    const actions = message?.content?.message?.message?.actions;
    const eligibleActions = isEligible ? actions?.filter(isEligible) : actions;
    const matched = invocationId ? eligibleActions?.find((action)=>action.invocationId === invocationId) : undefined;
    return matched ?? eligibleActions?.[0];
}
function $8def780e3a1ebdcf$export$921689ee3c142db7(message, invocationId) {
    return $8def780e3a1ebdcf$export$e3d25f9304ba048e(message, invocationId, (0, $i7OAD.isCreatableAction));
}
function $8def780e3a1ebdcf$export$1b968a6b473955a8(action) {
    const contentId = action?.data?.contentId;
    // always make it a string since the final response sometimes returns a number and re-renders the iframe.
    return contentId === undefined ? undefined : String(contentId);
}
function $8def780e3a1ebdcf$export$32f3c2791170494a(action) {
    return action?.data?.title;
}
function $8def780e3a1ebdcf$export$e839ab847bfd35fb(message, invocationId) {
    return $8def780e3a1ebdcf$export$1b968a6b473955a8($8def780e3a1ebdcf$export$921689ee3c142db7(message, invocationId));
}
function $8def780e3a1ebdcf$export$460905b2c4dc18c9(message) {
    return message?.content?.message?.message?.actions?.[0];
}
function $8def780e3a1ebdcf$export$4382776317fc294f(message, invocationId) {
    if (!message) return undefined;
    const actions = message?.content?.message?.message?.actions;
    const aifcAction = invocationId ? actions?.find((action)=>action.invocationId === invocationId && (0, $i7OAD.isAIFCAction)(action)) : actions?.find((0, $i7OAD.isAIFCAction));
    if (aifcAction) {
        const status = aifcAction?.status?.toLowerCase();
        if (status === 'preparing' || status === 'streaming') return status;
        // 'Planned' is the same as a final response. If we see it, assume streaming is complete.
        if (status === 'planned' || status === 'finished' || status === 'cancelled' || message.content.streamingComplete) return 'complete';
    }
    return undefined;
}
function $8def780e3a1ebdcf$export$b25ff5f60a2b12ee(message) {
    const policyActions = (message?.content.message.message.actions ?? []).filter((action)=>!!action && ((0, $4jIXV.isAdminhubPolicyCreateAction)(action) || (0, $4jIXV.isAdminhubPolicyUpdateAction)(action)));
    // The gate is read only once such an action exists, so products that never see one are never
    // exposed to it.
    if (policyActions.length === 0 || !(0, $iDrrr.fg)('adminhub-create-policy-with-rovo')) return undefined;
    const latestData = policyActions[policyActions.length - 1]?.data;
    return {
        count: policyActions.length,
        contentId: latestData?.contentId,
        revision: latestData?.revision
    };
}
function $8def780e3a1ebdcf$var$getStableMessageParts(message) {
    const action = message.content.message.message.actions?.find((0, $i7OAD.isCreatableAction));
    const actionData = action?.data;
    // We just pick the parts we care about directly from the message
    // We avoid ADF since that is streamed and changes all the time.
    return {
        messageId: message.content.message.message.id,
        streamingComplete: message.content.streamingComplete,
        // The visual block counts only arrive on the final payload, so refresh when they land.
        action: actionData ? (0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(actionData, [
            'contentId',
            'title',
            'mediaFileId',
            'imageBlocks',
            'mauiAppBlocks'
        ]) : undefined,
        status: action?.status,
        traceId: message.traceId,
        adminhubPolicy: $8def780e3a1ebdcf$export$b25ff5f60a2b12ee(message),
        ...(0, $iDrrr.fg)('aifc_request_id_analytics') ? {
            requestId: message.content.metadata?.request_id ?? message.content.message.message.message_metadata?.requestId
        } : {}
    };
}
function $8def780e3a1ebdcf$export$c90c71e0e0065a6(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))($8def780e3a1ebdcf$var$getStableMessageParts(a), $8def780e3a1ebdcf$var$getStableMessageParts(b));
}
module.exports["findMessageById"] = $8def780e3a1ebdcf$export$17828fb10c7c5928;
module.exports["findLastMessageWithCreateAction"] = $8def780e3a1ebdcf$export$c5f84c389beb0191;
module.exports["findLastMessageWithAIFCAction"] = $8def780e3a1ebdcf$export$551dda091e9d40ca;
module.exports["findLastAssistantMessage"] = $8def780e3a1ebdcf$export$6f9d326b409b8a89;
module.exports["isLatestActionMessageAskQuestion"] = $8def780e3a1ebdcf$export$ae4c648272f0b05;
module.exports["withSelectedActionFirst"] = $8def780e3a1ebdcf$export$cde501ceecd81c44;
module.exports["withOnlySelectedAction"] = $8def780e3a1ebdcf$export$2f146962db2122e6;
module.exports["resolvePreviewAction"] = $8def780e3a1ebdcf$export$921689ee3c142db7;
module.exports["getActionContentId"] = $8def780e3a1ebdcf$export$1b968a6b473955a8;
module.exports["getActionTitle"] = $8def780e3a1ebdcf$export$32f3c2791170494a;
module.exports["extractContentId"] = $8def780e3a1ebdcf$export$e839ab847bfd35fb;
module.exports["getFirstMessageAction"] = $8def780e3a1ebdcf$export$460905b2c4dc18c9;
module.exports["getAIFCActionStatus"] = $8def780e3a1ebdcf$export$4382776317fc294f;
module.exports["getAdminhubPolicyPreviewIdentity"] = $8def780e3a1ebdcf$export$b25ff5f60a2b12ee;
module.exports["areMessagesEqual"] = $8def780e3a1ebdcf$export$c90c71e0e0065a6;

});

parcelRegister("i7OAD", function(module, exports) {
// ============================================================================
// ACTIONS that are shared between Confluence and Jira
// ============================================================================

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");


var $4jIXV = parcelRequire("4jIXV");


var $3t6eX = parcelRequire("3t6eX");


var $eTCWv = parcelRequire("eTCWv");


var $aYC8J = parcelRequire("aYC8J");


var $9yffN = parcelRequire("9yffN");


var $1uJIC = parcelRequire("1uJIC");


var $8B0IE = parcelRequire("8B0IE");

const $5d644ffadb303a3b$export$992a8e659d5a1252 = (action)=>typeof action === 'object' && action !== null && 'key' in action;
const $5d644ffadb303a3b$export$74f7c5137689c9a9 = (action)=>(0, $4jIXV.isAdminhubPolicyCreateAction)(action) && (0, $iDrrr.fg)('adminhub-create-policy-with-rovo') || (0, $3t6eX.isArtifactPreviewAction)(action) || (0, $aYC8J.isConfluenceCreateNewAction)(action) || (0, $9yffN.isJiraCreatableAction)(action) || (0, $1uJIC.isJsmCreatableAction)(action) || (0, $aYC8J.isDynamicUiCreatableAction)(action) || (0, $aYC8J.isImageCreatableAction)(action) || (0, $eTCWv.isAvpPreviewCardAction)(action) || (0, $8B0IE.isRovoPublishAgentAction)(action);
const $5d644ffadb303a3b$export$8244c8e5412f2a57 = (message)=>(0, $aYC8J.isDynamicUiCreatableAction)(message) && !(0, $aYC8J.isDynamicUiUpdateActionData)(message.data) || (0, $aYC8J.isImageCreatableAction)(message) && !(0, $aYC8J.isImageUpdateActionData)(message.data);
const $5d644ffadb303a3b$export$95acec44a3c80403 = (action)=>(0, $4jIXV.isAdminhubPolicyUpdateAction)(action) && (0, $iDrrr.fg)('adminhub-create-policy-with-rovo') || (0, $aYC8J.isConfluenceUpdatableAction)(action) || (0, $9yffN.isJiraUpdatableAction)(action) || (0, $1uJIC.isJsmUpdatableAction)(action);
const $5d644ffadb303a3b$export$473ed8cdfdfcd6f4 = (action)=>$5d644ffadb303a3b$export$74f7c5137689c9a9(action) || $5d644ffadb303a3b$export$95acec44a3c80403(action);
const $5d644ffadb303a3b$export$a4e95791cb217646 = (action)=>{
    return (0, $aYC8J.getConfluenceContentType)(action) ?? (0, $9yffN.getJiraContentType)(action) ?? (0, $1uJIC.getJsmContentType)(action) ?? 'unknown';
};
const $5d644ffadb303a3b$export$29736db3162547c8 = (action)=>(0, $dw75i.ACTIONS_HIDING_FOOTER_BUTTONS).has(action.key);
const $5d644ffadb303a3b$export$83f1ae88eb290a18 = (action)=>action.key === (0, $dw75i.IMAGE_SEARCH_KEY);
const $5d644ffadb303a3b$export$154eb84770532af2 = (action)=>(0, $aYC8J.isConfluenceStreamAction)(action) || (0, $9yffN.isJiraStreamAction)(action) || (0, $1uJIC.isJsmStreamAction)(action) || (0, $eTCWv.isAvpStreamAction)(action) || $5d644ffadb303a3b$export$83f1ae88eb290a18(action) && (0, $iDrrr.fg)('rovo_chat_image_search_fe');
const $5d644ffadb303a3b$export$1382aef9948f8fc7 = (action)=>(0, $4jIXV.isAdminhubPolicyCreateAction)(action) && (0, $iDrrr.fg)('adminhub-create-policy-with-rovo') || (0, $aYC8J.isConfluencePreviewCardAction)(action) || (0, $9yffN.isJiraPreviewCardAction)(action) || (0, $1uJIC.isJsmPreviewCardAction)(action) || (0, $aYC8J.isDynamicUiCreatableAction)(action) || (0, $aYC8J.isImageCreatableAction)(action) || (0, $eTCWv.isAvpPreviewCardAction)(action);
const $5d644ffadb303a3b$export$681cf9ea58de88fd = (action, identifier)=>{
    if (!$5d644ffadb303a3b$export$992a8e659d5a1252(action)) return undefined;
    if ((0, $9yffN.isJiraAction)(action)) return (0, $9yffN.generateJiraReceiverId)(action);
    if ((0, $1uJIC.isJsmAction)(action) && (0, $iDrrr.fg)('surveys-aifc')) return (0, $1uJIC.generateJsmReceiverId)(action);
    return (0, $aYC8J.generateRovoReceiverId)(action, identifier ?? '');
};
const $5d644ffadb303a3b$export$ea699f0d7930d4d4 = ({ action: action, isContentPreviewSupported: isContentPreviewSupported })=>{
    const isAdminhubPolicyAction = (0, $4jIXV.isAdminhubPolicyCreateAction)(action) || (0, $4jIXV.isAdminhubPolicyUpdateAction)(action);
    if (isAdminhubPolicyAction && (0, $iDrrr.fg)('adminhub-create-policy-with-rovo')) return false;
    return !$5d644ffadb303a3b$export$154eb84770532af2({
        key: action.key
    }) && !(0, $9yffN.isJiraCreatableAction)({
        key: action.key
    }) && !(0, $1uJIC.isJsmCreatableAction)({
        key: action.key
    }) && !(0, $eTCWv.isAvpPreviewCardAction)({
        key: action.key
    });
};
function $5d644ffadb303a3b$export$d94ea083820ef679(messages, invocationId) {
    return messages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && !!msg.content.message.message.actions?.some((action)=>action.invocationId === invocationId));
}
module.exports["isCreatableAction"] = $5d644ffadb303a3b$export$74f7c5137689c9a9;
module.exports["isEphemeralCreateAction"] = $5d644ffadb303a3b$export$8244c8e5412f2a57;
module.exports["isUpdatableAction"] = $5d644ffadb303a3b$export$95acec44a3c80403;
module.exports["isAIFCAction"] = $5d644ffadb303a3b$export$473ed8cdfdfcd6f4;
module.exports["getAIFCContentType"] = $5d644ffadb303a3b$export$a4e95791cb217646;
module.exports["isActionHidingFooterButtons"] = $5d644ffadb303a3b$export$29736db3162547c8;
module.exports["isSupportedStreamAction"] = $5d644ffadb303a3b$export$154eb84770532af2;
module.exports["isPreviewCardAction"] = $5d644ffadb303a3b$export$1382aef9948f8fc7;
module.exports["generateRovoReceiverId"] = $5d644ffadb303a3b$export$681cf9ea58de88fd;
module.exports["findMessageByInvocationId"] = $5d644ffadb303a3b$export$d94ea083820ef679;

});

parcelRegister("4jIXV", function(module, exports) {

var $dw75i = parcelRequire("dw75i");

const $e985279cdbe5457d$export$d8f43c209a33f85c = (action)=>action.key === (0, $dw75i.ADMINHUB_POLICY_CREATE_KEY);
const $e985279cdbe5457d$export$56856f9e2151bcfc = (action)=>action.key === (0, $dw75i.ADMINHUB_POLICY_UPDATE_KEY);
module.exports["isAdminhubPolicyCreateAction"] = $e985279cdbe5457d$export$d8f43c209a33f85c;
module.exports["isAdminhubPolicyUpdateAction"] = $e985279cdbe5457d$export$56856f9e2151bcfc;

});

parcelRegister("3t6eX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");

const $3022ce6b55c84c76$export$e577cacd69ae6dc8 = (action)=>action.key === (0, $dw75i.ActionKeys).ArtifactCreate && (0, $iDrrr.fg)('rovo_artifacts_library_enabled');
module.exports["isArtifactPreviewAction"] = $3022ce6b55c84c76$export$e577cacd69ae6dc8;

});

parcelRegister("eTCWv", function(module, exports) {
const $3b90c63f679ea6c2$export$3e0063b4c9eccd95 = 'avp_chart_create';
function $3b90c63f679ea6c2$export$144269edab6271d9(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof d.dashboardAri === 'string' && typeof cd.chart === 'object' && cd.chart !== null && typeof cd.canvasLayout === 'object' && cd.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$2faa8f3a24d96e39 = 'avp_chart_delete';
function $3b90c63f679ea6c2$export$9f17310825a1a178(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.chartId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$a01e31e7aead77c1 = 'avp_chart_update';
function $3b90c63f679ea6c2$export$db13f09592330b3b(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    if (typeof d.dashboardAri !== 'string' || typeof d.chartId !== 'string') return false;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof cd.chart === 'object' && cd.chart !== null;
}
const $3b90c63f679ea6c2$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
const $3b90c63f679ea6c2$var$isAvpFilterExpressionPayload = (data)=>{
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && (d.filterExpression === null || typeof d.filterExpression === 'object' && d.filterExpression !== null);
};
const $3b90c63f679ea6c2$export$37d8bc8514392efa = 'avp_dashboard_create_filter';
function $3b90c63f679ea6c2$export$a21637e45432b3cd(data) {
    if (!$3b90c63f679ea6c2$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return d.expressionIds === undefined || $3b90c63f679ea6c2$var$isStringArray(d.expressionIds);
}
const $3b90c63f679ea6c2$export$1e6353bd95c91843 = 'avp_dashboard_delete_filter';
function $3b90c63f679ea6c2$export$9a3f223399a3708c(data) {
    if (!$3b90c63f679ea6c2$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return $3b90c63f679ea6c2$var$isStringArray(d.expressionIds);
}
const $3b90c63f679ea6c2$export$72caf49a260f725e = 'avp_dashboard_update_filter';
function $3b90c63f679ea6c2$export$c6efee5e04349169(data) {
    if (!$3b90c63f679ea6c2$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return typeof d.expressionId === 'string';
}
const $3b90c63f679ea6c2$export$e36a63f9bc6ec9d9 = 'avp_dashboard_remove_row';
function $3b90c63f679ea6c2$export$b8981fb8c2b2ceae(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.rowId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$e21300173aaa5a75 = 'avp_dashboard_remove_element';
function $3b90c63f679ea6c2$export$393c0a783fee1203(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.elementId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $3b90c63f679ea6c2$export$5860e19fc7aa5d00 = 'avp_dashboard_create';
function $3b90c63f679ea6c2$export$eca0d9c93fb8ccc3(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardUrl === 'string' && typeof d.dashboardAri === 'string';
}
// ============================================================================
// AVP ACTION CLASSIFICATION
// ============================================================================
const $3b90c63f679ea6c2$var$AVP_CREATABLE_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$3e0063b4c9eccd95,
    $3b90c63f679ea6c2$export$5860e19fc7aa5d00,
    $3b90c63f679ea6c2$export$37d8bc8514392efa
]);
const $3b90c63f679ea6c2$var$AVP_PREVIEW_CARD_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$5860e19fc7aa5d00
]);
const $3b90c63f679ea6c2$export$6b9e1da20a0f005c = (action)=>$3b90c63f679ea6c2$var$AVP_PREVIEW_CARD_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$var$AVP_DELETABLE_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$2faa8f3a24d96e39,
    $3b90c63f679ea6c2$export$e21300173aaa5a75,
    $3b90c63f679ea6c2$export$e36a63f9bc6ec9d9,
    $3b90c63f679ea6c2$export$1e6353bd95c91843
]);
const $3b90c63f679ea6c2$var$AVP_UPDATABLE_ACTION_KEYS = new Set([
    $3b90c63f679ea6c2$export$a01e31e7aead77c1,
    $3b90c63f679ea6c2$export$72caf49a260f725e
]);
const $3b90c63f679ea6c2$export$d69ccc6d462afdf8 = (action)=>$3b90c63f679ea6c2$var$AVP_CREATABLE_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$export$edc9f9dece97635 = (action)=>$3b90c63f679ea6c2$var$AVP_DELETABLE_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$export$a2d39e4b08e0e68d = (action)=>$3b90c63f679ea6c2$var$AVP_UPDATABLE_ACTION_KEYS.has(action.key);
const $3b90c63f679ea6c2$export$ebb904732b24f004 = (action)=>$3b90c63f679ea6c2$export$d69ccc6d462afdf8(action) || $3b90c63f679ea6c2$export$edc9f9dece97635(action) || $3b90c63f679ea6c2$export$a2d39e4b08e0e68d(action);
module.exports["AVP_CHART_CREATE_KEY"] = $3b90c63f679ea6c2$export$3e0063b4c9eccd95;
module.exports["isAvpChartCreateActionData"] = $3b90c63f679ea6c2$export$144269edab6271d9;
module.exports["AVP_CHART_DELETE_KEY"] = $3b90c63f679ea6c2$export$2faa8f3a24d96e39;
module.exports["isAvpChartDeleteActionData"] = $3b90c63f679ea6c2$export$9f17310825a1a178;
module.exports["AVP_CHART_UPDATE_KEY"] = $3b90c63f679ea6c2$export$a01e31e7aead77c1;
module.exports["isAvpChartUpdateActionData"] = $3b90c63f679ea6c2$export$db13f09592330b3b;
module.exports["AVP_FILTER_EXPRESSION_CREATE_KEY"] = $3b90c63f679ea6c2$export$37d8bc8514392efa;
module.exports["isAvpFilterExpressionCreateActionData"] = $3b90c63f679ea6c2$export$a21637e45432b3cd;
module.exports["AVP_FILTER_EXPRESSION_DELETE_KEY"] = $3b90c63f679ea6c2$export$1e6353bd95c91843;
module.exports["isAvpFilterExpressionDeleteActionData"] = $3b90c63f679ea6c2$export$9a3f223399a3708c;
module.exports["AVP_FILTER_EXPRESSION_UPDATE_KEY"] = $3b90c63f679ea6c2$export$72caf49a260f725e;
module.exports["isAvpFilterExpressionUpdateActionData"] = $3b90c63f679ea6c2$export$c6efee5e04349169;
module.exports["AVP_DASHBOARD_REMOVE_ROW_KEY"] = $3b90c63f679ea6c2$export$e36a63f9bc6ec9d9;
module.exports["isAvpDashboardRemoveRowActionData"] = $3b90c63f679ea6c2$export$b8981fb8c2b2ceae;
module.exports["AVP_DASHBOARD_REMOVE_ELEMENT_KEY"] = $3b90c63f679ea6c2$export$e21300173aaa5a75;
module.exports["isAvpDashboardRemoveElementActionData"] = $3b90c63f679ea6c2$export$393c0a783fee1203;
module.exports["AVP_DASHBOARD_CREATE_KEY"] = $3b90c63f679ea6c2$export$5860e19fc7aa5d00;
module.exports["isAvpDashboardCreateActionData"] = $3b90c63f679ea6c2$export$eca0d9c93fb8ccc3;
module.exports["isAvpPreviewCardAction"] = $3b90c63f679ea6c2$export$6b9e1da20a0f005c;
module.exports["isAvpStreamAction"] = $3b90c63f679ea6c2$export$ebb904732b24f004;

});

parcelRegister("9yffN", function(module, exports) {
// ============================================================================
// JIRA SMART ISSUE CREATE
// ============================================================================

var $dw75i = parcelRequire("dw75i");


var $4MASx = parcelRequire("4MASx");

const $da7c2fc593a3d043$export$5f099b7754a7652a = [
    (0, $dw75i.JIRA_FIND_ISSUES_KEY),
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_BULK_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_V2_KEY),
    (0, $dw75i.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $dw75i.JIRA_ISSUE_TRANSITION_KEY),
    (0, $dw75i.JIRA_EPICS_SUGGEST_KEY),
    (0, $dw75i.JIRA_ISSUE_DELETE_KEY),
    (0, $dw75i.JIRA_ISSUE_MOVE_KEY),
    (0, $dw75i.JIRA_ISSUE_ASSIGN_KEY),
    (0, $dw75i.JIRA_VERSION_CREATE_KEY),
    (0, $dw75i.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
];
const $da7c2fc593a3d043$export$29b82f3d15178d30 = new Set($da7c2fc593a3d043$export$5f099b7754a7652a);
const $da7c2fc593a3d043$export$211f4719f56285e9 = new Set([
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_BULK_KEY)
]);
const $da7c2fc593a3d043$export$d75519ce8257cbe3 = new Set([
    (0, $dw75i.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
]);
const $da7c2fc593a3d043$export$530aa0daf5811c30 = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && $da7c2fc593a3d043$export$29b82f3d15178d30.has(action?.['key']);
};
const $da7c2fc593a3d043$export$b4d5023312147fc4 = (action)=>$da7c2fc593a3d043$export$530aa0daf5811c30(action) && $da7c2fc593a3d043$export$211f4719f56285e9.has(action.key);
const $da7c2fc593a3d043$export$69c28e373f39b349 = (action)=>$da7c2fc593a3d043$export$530aa0daf5811c30(action) && $da7c2fc593a3d043$export$d75519ce8257cbe3.has(action.key);
const $da7c2fc593a3d043$export$b5050b797265a8be = (action)=>false;
const $da7c2fc593a3d043$export$a1a30289a72c78b1 = (action)=>false;
const $da7c2fc593a3d043$export$6fe601f4a243e8f4 = (action)=>{
    if (!$da7c2fc593a3d043$export$530aa0daf5811c30(action)) return undefined;
    if ($da7c2fc593a3d043$export$b4d5023312147fc4(action)) return 0, $4MASx.JIRA_SMART_CREATE_TABLE_CLIENT_ID;
    return undefined;
};
const $da7c2fc593a3d043$export$1643c639e4c073b8 = (action)=>{
    const actionKey = action.key;
    if ($da7c2fc593a3d043$export$211f4719f56285e9.has(actionKey)) return 'jira-issue-table';
    return undefined;
};
// ============================================================================
// JIRA PREVIEW CARDS
// ============================================================================
const $da7c2fc593a3d043$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $dw75i.JIRA_SMART_ISSUE_CREATE_BULK_KEY)
]);
const $da7c2fc593a3d043$export$4a1398b92436f797 = (action)=>$da7c2fc593a3d043$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJiraAction"] = $da7c2fc593a3d043$export$530aa0daf5811c30;
module.exports["isJiraCreatableAction"] = $da7c2fc593a3d043$export$b4d5023312147fc4;
module.exports["isJiraPreviewableAction"] = $da7c2fc593a3d043$export$69c28e373f39b349;
module.exports["isJiraUpdatableAction"] = $da7c2fc593a3d043$export$b5050b797265a8be;
module.exports["isJiraStreamAction"] = $da7c2fc593a3d043$export$a1a30289a72c78b1;
module.exports["generateJiraReceiverId"] = $da7c2fc593a3d043$export$6fe601f4a243e8f4;
module.exports["getJiraContentType"] = $da7c2fc593a3d043$export$1643c639e4c073b8;
module.exports["isJiraPreviewCardAction"] = $da7c2fc593a3d043$export$4a1398b92436f797;

});

parcelRegister("1uJIC", function(module, exports) {
// ============================================================================
// JSM CREATE SURVEY
// ============================================================================

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");


var $9Wwnb = parcelRequire("9Wwnb");


var $feawE = parcelRequire("feawE");

const $8b07e7ececb313be$export$4d5c499af23159fb = (0, $feawE.client)('jsm-queue-settings');





const $df0502af8f3c12f2$export$c1a656e72d7a4bcc = (0, $feawE.client)('jsm-request-type-settings');





const $abaaa1f0b0fee63a$export$bd769f5be4601367 = (0, $feawE.client)('jsm-sla-settings');



var $jNcTh = parcelRequire("jNcTh");


var $gFu06 = parcelRequire("gFu06");


var $EccDE = parcelRequire("EccDE");

const $f92035d15fc99246$var$JSM_EMBED_VIEW_MAP = {
    [(0, $dw75i.JSM_QUEUE_CREATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_QUEUE_UPDATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_QUEUE_GROUP_CREATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_QUEUE_GROUP_UPDATE_KEY)]: {
        clientId: (0, $8b07e7ececb313be$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $dw75i.JSM_REQUEST_TYPE_UPDATED_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $dw75i.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $dw75i.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $dw75i.JSM_SLA_CREATE_KEY)]: {
        clientId: (0, $abaaa1f0b0fee63a$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $dw75i.JSM_SLA_UPDATE_KEY)]: {
        clientId: (0, $abaaa1f0b0fee63a$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $dw75i.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)]: {
        clientId: (0, $df0502af8f3c12f2$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    }
};
const $f92035d15fc99246$export$fd2af7ce2e351879 = [
    (0, $dw75i.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $dw75i.JSM_CREATE_FORM_TEMPLATE_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_KEY),
    (0, $dw75i.JSM_CREATE_REQUEST_V2_KEY),
    (0, $dw75i.JSM_CREATE_SURVEY_KEY),
    (0, $dw75i.JSM_QUEUE_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_UPDATE_KEY),
    (0, $dw75i.JSM_QUEUE_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY),
    (0, $dw75i.JSM_SLA_CREATE_KEY),
    (0, $dw75i.JSM_SLA_UPDATE_KEY),
    (0, $dw75i.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
];
const $f92035d15fc99246$export$7b875f28b9805c0c = new Set($f92035d15fc99246$export$fd2af7ce2e351879);
const $f92035d15fc99246$export$3fcc5475955435c4 = new Set([
    (0, $dw75i.JSM_CREATE_SURVEY_KEY),
    (0, $dw75i.JSM_QUEUE_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_CREATE_KEY),
    (0, $dw75i.JSM_QUEUE_GROUP_UPDATE_KEY),
    (0, $dw75i.JSM_QUEUE_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY),
    (0, $dw75i.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY),
    (0, $dw75i.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
]);
const $f92035d15fc99246$var$isSolutionComposerV2ActionKey = (actionKey)=>actionKey === (0, $dw75i.JSM_CREATE_SOLUTION_COMPOSER_SPACE_KEY) && (0, $iDrrr.fg)('jsm_solution_composer_v2');
const $f92035d15fc99246$var$isKbFromScratchActionKey = (actionKey)=>(actionKey === (0, $dw75i.JSM_CREATE_KB_TOPICS_KEY) || actionKey === (0, $dw75i.JSM_CREATE_KB_ARTICLES_KEY)) && (0, $iDrrr.fg)('jsm_kb_from_scratch');
const $f92035d15fc99246$export$98885adfb17a807b = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && ($f92035d15fc99246$export$7b875f28b9805c0c.has(action?.['key']) || $f92035d15fc99246$var$isKbFromScratchActionKey(action?.['key']) || $f92035d15fc99246$var$isSolutionComposerV2ActionKey(action?.['key']));
};
const $f92035d15fc99246$export$29f39e9429d6b955 = (action)=>$f92035d15fc99246$export$98885adfb17a807b(action) && ($f92035d15fc99246$export$3fcc5475955435c4.has(action.key) || (0, $EccDE.isFormTemplateActionEnabled)(action.key) || $f92035d15fc99246$var$isKbFromScratchActionKey(action.key) || $f92035d15fc99246$var$isSolutionComposerV2ActionKey(action.key));
const $f92035d15fc99246$export$ae7904ebe7bd5bb0 = (action)=>false;
const $f92035d15fc99246$export$f4d25026329e5a91 = (action)=>false;
const $f92035d15fc99246$export$af2b121ccb8f1449 = (action)=>{
    if (!$f92035d15fc99246$export$98885adfb17a807b(action)) return undefined;
    if ((0, $iDrrr.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $f92035d15fc99246$var$JSM_EMBED_VIEW_MAP[action.key];
        if (embedView) return embedView.clientId;
    }
    if ($f92035d15fc99246$var$isKbFromScratchActionKey(action.key)) return 0, $9Wwnb.JSM_CREATE_KB_STAGING_AREA_CLIENT_ID;
    if ((0, $EccDE.isFormTemplateActionEnabled)(action.key)) return 0, $jNcTh.JSM_CREATE_FORM_TEMPLATE_CLIENT_ID;
    if ($f92035d15fc99246$export$29f39e9429d6b955(action)) return 0, $gFu06.JSM_CREATE_SURVEY_CLIENT_ID;
    return undefined;
};
const $f92035d15fc99246$export$292f03726a3f6528 = (action)=>{
    const actionKey = action.key;
    if ((0, $EccDE.isFormTemplateActionEnabled)(actionKey)) return 'jsm-create-form-template';
    if ((0, $iDrrr.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $f92035d15fc99246$var$JSM_EMBED_VIEW_MAP[actionKey];
        if (embedView) return embedView.contentType;
    }
    if ($f92035d15fc99246$export$3fcc5475955435c4.has(actionKey) || $f92035d15fc99246$var$isKbFromScratchActionKey(actionKey)) return 'jsm-create-survey';
    return undefined;
};
// ============================================================================
// JSM PREVIEW CARDS
// ============================================================================
const $f92035d15fc99246$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $dw75i.JSM_CREATE_FORM_TEMPLATE_KEY),
    (0, $dw75i.JSM_CREATE_SURVEY_KEY)
]);
const $f92035d15fc99246$export$c8683ba29b03d037 = (action)=>$f92035d15fc99246$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJsmAction"] = $f92035d15fc99246$export$98885adfb17a807b;
module.exports["isJsmCreatableAction"] = $f92035d15fc99246$export$29f39e9429d6b955;
module.exports["isJsmUpdatableAction"] = $f92035d15fc99246$export$ae7904ebe7bd5bb0;
module.exports["isJsmStreamAction"] = $f92035d15fc99246$export$f4d25026329e5a91;
module.exports["generateJsmReceiverId"] = $f92035d15fc99246$export$af2b121ccb8f1449;
module.exports["getJsmContentType"] = $f92035d15fc99246$export$292f03726a3f6528;
module.exports["isJsmPreviewCardAction"] = $f92035d15fc99246$export$c8683ba29b03d037;

});

parcelRegister("9Wwnb", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $c3f2915889576348$export$91e704c2411cb3f5 = (0, $feawE.client)('jsm-create-kb');
const $c3f2915889576348$export$ee04bc09e7068b43 = (0, $feawE.client)('jsm-create-kb-staging-area');
const $c3f2915889576348$export$c608186adcac93ad = (0, $feawE.client)('jsm-create-kb-card');
module.exports["JSM_CREATE_KB_CLIENT_ID"] = $c3f2915889576348$export$91e704c2411cb3f5;
module.exports["JSM_CREATE_KB_STAGING_AREA_CLIENT_ID"] = $c3f2915889576348$export$ee04bc09e7068b43;
module.exports["JSM_KB_CARD_CLIENT_ID"] = $c3f2915889576348$export$c608186adcac93ad;

});

parcelRegister("jNcTh", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $10851820f252f808$export$d570778e9983245b = (0, $feawE.client)('jsm-create-form-template');
module.exports["JSM_CREATE_FORM_TEMPLATE_CLIENT_ID"] = $10851820f252f808$export$d570778e9983245b;

});

parcelRegister("EccDE", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");

const $b7e486d9171209cb$export$7b7b61b130bdfb64 = (actionKey)=>actionKey === (0, $dw75i.JSM_CREATE_FORM_TEMPLATE_KEY) && (0, $iDrrr.fg)('soju-5536-forms-skill') && (0, $4o0zT.isExperimentEnabled)('rovo_chat_manage_forms_experiment');
module.exports["isFormTemplateActionEnabled"] = $b7e486d9171209cb$export$7b7b61b130bdfb64;

});

parcelRegister("8B0IE", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dw75i = parcelRequire("dw75i");

const $02ca661a865bd4ac$export$d34077789a42fc1e = (action)=>action.key === (0, $dw75i.ROVO_PUBLISH_AGENT_KEY) && (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential');
module.exports["isRovoPublishAgentAction"] = $02ca661a865bd4ac$export$d34077789a42fc1e;

});

parcelRegister("7weDN", function(module, exports) {

var $feawE = parcelRequire("feawE");

const $a62471d42b58f43f$var$ADMINHUB_POLICY_PREVIEW_CLIENT_ID_PREFIX = 'adminhub-policy-preview';
const $a62471d42b58f43f$export$4ae9331f1feccb77 = (conversationId, contentId)=>(0, $feawE.client)(`${$a62471d42b58f43f$var$ADMINHUB_POLICY_PREVIEW_CLIENT_ID_PREFIX}:${conversationId}:${contentId}`);
module.exports["getAdminhubPolicyPreviewClientId"] = $a62471d42b58f43f$export$4ae9331f1feccb77;

});

parcelRegister("5BnQI", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $5aQkY = parcelRequire("5aQkY");

const $e77caabe9b9901c7$export$7408169e457884aa = (conversationId)=>{
    const store = (0, $c6StJ.defaultRegistry).getStore((0, $5aQkY.selectedAgentDraftControllerStore));
    const selectedAgentIds = store.storeState.getState().selectedAgentIds[conversationId];
    // Snapshot before dismissing: each dismissal replaces the array held in the store.
    for (const agentId of [
        ...selectedAgentIds ?? []
    ])store.actions.removeSelectedAgentId(conversationId, agentId);
};
module.exports["clearSelectedAgentDraftOverride"] = $e77caabe9b9901c7$export$7408169e457884aa;

});

parcelRegister("74lv3", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");

const $70750a312b778707$export$a306aa2b8fa250a5 = ()=>(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_xstate_migration_jira');
module.exports["isAiXstateMigrationEnabled"] = $70750a312b778707$export$a306aa2b8fa250a5;

});

parcelRegister("gjWe2", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $bxkJA = parcelRequire("bxkJA");


var $bJKB2 = parcelRequire("bJKB2");


var $cOOC6 = parcelRequire("cOOC6");


var $aXdbm = parcelRequire("aXdbm");


var $3iEfv = parcelRequire("3iEfv");








var $437v8 = parcelRequire("437v8");

const $ce40fcaa8014688b$var$isRawEntityAnnotationsMessage = (value)=>typeof value === 'object' && value !== null && typeof value.sentence === 'string' && Array.isArray(value.entities);
const $ce40fcaa8014688b$var$normalisePersistedBatch = (batch)=>({
        ...batch,
        entities: batch.entities.map((entity)=>{
            // The persisted payload may use either casing; coalesce both.
            const raw = entity;
            return {
                ...entity,
                canonical_name: typeof entity.canonical_name === 'string' ? entity.canonical_name : typeof raw.canonicalName === 'string' ? raw.canonicalName : entity.mention,
                confidence_score: typeof entity.confidence_score === 'number' ? entity.confidence_score : typeof raw.confidenceScore === 'number' ? raw.confidenceScore : 0
            };
        })
    });
const $ce40fcaa8014688b$export$c2d613c9e2dd4e7d = (storeAssistant, messageMetadata)=>{
    if (!messageMetadata || !((0, $437v8.isPeopleEntityAnnotationEnabled)() || (0, $437v8.isInferredProjectEntityAnnotationEnabled)())) return;
    const rawAnnotations = messageMetadata.entity_annotations;
    if (!Array.isArray(rawAnnotations) || rawAnnotations.length === 0) return;
    const disableInferredProjectHistory = (0, $iDrrr.fg)('rovo_chat_ip_hover_history_disabled');
    const validBatches = [];
    for (const batch of rawAnnotations)if ($ce40fcaa8014688b$var$isRawEntityAnnotationsMessage(batch)) {
        const normalizedBatch = (0, $bxkJA.normalizeEntityAnnotationsMessage)($ce40fcaa8014688b$var$normalisePersistedBatch(batch));
        const entities = disableInferredProjectHistory ? normalizedBatch.entities.filter((entity)=>entity.type !== 'InferredProject') : normalizedBatch.entities;
        validBatches.push({
            ...normalizedBatch,
            entities: entities
        });
    }
    if (validBatches.length > 0) storeAssistant.entityAnnotationBatches = validBatches;
};



var $5XX4K = parcelRequire("5XX4K");


var $eTr6D = parcelRequire("eTr6D");


var $8bsmP = parcelRequire("8bsmP");


var $eK93A = parcelRequire("eK93A");

const $df6690dcbb70581e$export$31bb5ed5e2cc3184 = ({ latestMessages: latestMessages, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false, promptContextViewSource: promptContextViewSource = 'history' })=>{
    const messages = [];
    for (const message of latestMessages){
        if ((0, $bxkJA.isHumanMessage)(message)) {
            // Human messages should only have application/json+a2ui if they have sent an action
            // we skip this message as there is nothing to render but this is persisted for flexibility
            // there should be no cases where a human renders A2UI from their messages
            if (typeof message.content === 'object' && message.content !== null && 'data_parts_mime_type' in message.content && message.content.data_parts_mime_type === 'application/json+a2ui') continue;
            messages.push({
                ...(0, $cOOC6.createStoreHumanWithContent)(message),
                promptContextViewSource: promptContextViewSource
            });
        } else if ((0, $bxkJA.isStreamResponse)(message)) {
            if ((0, $iDrrr.fg)('rovo_chat_history_lift')) {
                const normalizedPresentation = (0, $8bsmP.normalizeFinalizedMessagePresentation)({
                    message: message,
                    options: {
                        shouldExtractA2UI: true,
                        shouldExtractActionableFollowUps: true,
                        shouldExtractDataSculptor: (0, $iDrrr.fg)('rovo_enable_data_sculptor'),
                        shouldExtractInlineLumina: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina'),
                        shouldExtractLegacyChartBoundaries: true,
                        shouldPreprocessDetails: shouldPreprocessDetails
                    }
                });
                if (normalizedPresentation.extractionCounts.legacyChart > 0) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'extracted',
                    actionSubject: 'vizPluginChartNonUnicode',
                    attributes: {
                        messageId: message.message.message.id.toString(),
                        conversationId: conversationId,
                        chartCount: normalizedPresentation.extractionCounts.legacyChart,
                        timestamp: new Date().toISOString()
                    }
                });
                const storeAssistant = (0, $bJKB2.createStoreAssistantWithContent)(normalizedPresentation.message);
                if (Object.keys(normalizedPresentation.markdownData).length > 0) storeAssistant.markdownData = normalizedPresentation.markdownData;
                storeAssistant.isHistorical = true;
                if (normalizedPresentation.agenticUiMessages) storeAssistant.agenticUiMessages = normalizedPresentation.agenticUiMessages;
                (0, $ce40fcaa8014688b$export$c2d613c9e2dd4e7d)(storeAssistant, message.message?.message?.message_metadata);
                // A row holding only update ops for a surface anchored elsewhere has nothing of its own to show.
                const row = (0, $eTr6D.foldA2UIHistoryRow)(storeAssistant);
                if (row) messages.push(row);
            } else {
                // Process boundary content for historical assistant messages
                let processedMessage = message;
                const markdownData = {};
                // When the backend returns structured content (A2UI messages), normalize it
                // back to a plain text string and extract data_parts for A2UI rendering. Must
                // happen BEFORE every step below: they all operate on string content only and
                // silently no-op on the structured object, which would leave the extracted
                // text unprocessed (raw `<details>`, unextracted boundaries).
                let extractedA2UIMessages;
                const a2uiResult = (0, $aXdbm.extractA2UIFromStructuredContent)(processedMessage.message?.message?.content);
                if (a2uiResult) {
                    processedMessage = {
                        ...processedMessage,
                        message: {
                            ...processedMessage.message,
                            message: {
                                ...processedMessage.message.message,
                                content: a2uiResult.textContent
                            }
                        }
                    };
                    extractedA2UIMessages = a2uiResult.a2uiMessages;
                }
                // Rewrite HTML `<details><summary>` blocks into the Rovo-native `▞…▚`
                // boundary before the existing extractor runs so historical messages
                // render identically to their streamed form. Must happen BEFORE the
                // expand extractor below (which consumes `▞…▚`).
                if (shouldPreprocessDetails) processedMessage = (0, $eK93A.preprocessStreamResponseDetails)(processedMessage);
                // Apply the same boundary content extraction logic as streaming messages
                if ((0, $iDrrr.fg)('rovo_enable_data_sculptor')) {
                    const sculptorMsg = (0, $5XX4K.extractMarkdownContent)({
                        streamMessage: processedMessage,
                        boundaryStart: '[^sculptor:start^]',
                        boundaryEnd: '[^sculptor:end^]',
                        replacementContent: '[^sculptor^]'
                    });
                    processedMessage = sculptorMsg.processedStreamMessage;
                    sculptorMsg.boundaryContents.forEach((content, index)=>{
                        markdownData[`sculptor-${index}`] = content;
                    });
                }
                const expandOpenTag = "\u259E";
                const expandCloseTag = "\u259A";
                const expandPlaceholder = '[^expand^]';
                const expandMsg = (0, $5XX4K.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: expandOpenTag,
                    boundaryEnd: expandCloseTag,
                    replacementContent: expandPlaceholder
                });
                processedMessage = expandMsg.processedStreamMessage;
                expandMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`expand-${index}`] = content;
                });
                const chartPlaceholder = '[^chart^]';
                // When processing conversation history, process both unicode and non-unicode tags
                // to handle previous conversations that used the non-unicode tag
                // Once di_chat_chart_tag_unicode is rolled out, chartMsg can be removed after 30 days
                let chartIndex = 0;
                const chartMsg = (0, $5XX4K.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: '[^chart:start^]',
                    boundaryEnd: '[^chart:end^]',
                    replacementContent: chartPlaceholder
                });
                processedMessage = chartMsg.processedStreamMessage;
                chartMsg.boundaryContents.forEach((content)=>{
                    markdownData[`chart-${chartIndex}`] = content;
                    chartIndex++;
                });
                if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'extracted',
                    actionSubject: 'vizPluginChartNonUnicode',
                    attributes: {
                        messageId: message?.message?.message?.id.toString(),
                        conversationId: conversationId,
                        chartCount: chartMsg.boundaryContents.length,
                        timestamp: new Date().toISOString()
                    }
                });
                const unicodeChartMsg = (0, $5XX4K.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: "\u25F4",
                    boundaryEnd: "\u25F6",
                    replacementContent: chartPlaceholder
                });
                processedMessage = unicodeChartMsg.processedStreamMessage;
                unicodeChartMsg.boundaryContents.forEach((content)=>{
                    markdownData[`chart-${chartIndex}`] = content;
                    chartIndex++;
                });
                if ((0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) {
                    const luminaMsg = (0, $5XX4K.extractMarkdownContent)({
                        streamMessage: processedMessage,
                        boundaryStart: "\u25D0",
                        boundaryEnd: "\u25D1",
                        replacementContent: '\n\n[^lumina^]\n\n'
                    });
                    processedMessage = luminaMsg.processedStreamMessage;
                    luminaMsg.boundaryContents.forEach((content, index)=>{
                        markdownData[`lumina-${index}`] = content;
                    });
                }
                // Extract actionable follow-ups so history-loaded messages render the
                // same as their streamed form. Without this, the raw `◈<followup>…`
                // marker renders literally when reopening a past conversation. No-ops
                // when the experiment is in the `control` cohort.
                processedMessage = (0, $3iEfv.extractActionableFollowUpsMarkdownData)({
                    streamMessage: processedMessage,
                    markdownData: markdownData
                });
                // Create StoreAssistant with processed boundary data
                const storeAssistant = (0, $bJKB2.createStoreAssistantWithContent)(processedMessage);
                if (Object.keys(markdownData).length > 0) storeAssistant.markdownData = markdownData;
                // Mark message as historical since it's loaded from conversation history
                storeAssistant.isHistorical = true;
                if (extractedA2UIMessages) storeAssistant.agenticUiMessages = extractedA2UIMessages;
                (0, $ce40fcaa8014688b$export$c2d613c9e2dd4e7d)(storeAssistant, message.message?.message?.message_metadata);
                // A row holding only update ops for a surface anchored elsewhere has nothing of its own to show.
                const row = (0, $eTr6D.foldA2UIHistoryRow)(storeAssistant);
                if (row) messages.push(row);
            }
        }
    }
    return messages;
};
module.exports["processConversationMessages"] = $df6690dcbb70581e$export$31bb5ed5e2cc3184;

});

parcelRegister("bJKB2", function(module, exports) {
const $2641735f46fe8ec3$export$bd3c429f5e3d2c3e = (content)=>({
        type: 'ASSISTANT',
        content: content
    });
module.exports["createStoreAssistantWithContent"] = $2641735f46fe8ec3$export$bd3c429f5e3d2c3e;

});

parcelRegister("cOOC6", function(module, exports) {
const $07ee5b55b0e8ec6c$export$fa05b63813f8a225 = (content)=>({
        type: 'HUMAN',
        content: content
    });
module.exports["createStoreHumanWithContent"] = $07ee5b55b0e8ec6c$export$fa05b63813f8a225;

});

parcelRegister("4vH8u", function(module, exports) {

var $6Bfyn = parcelRequire("6Bfyn");

const $9ca8138617329dd1$export$8b6420a9ad4c28a1 = (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX).replace(/-$/, '');
module.exports["ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY"] = $9ca8138617329dd1$export$8b6420a9ad4c28a1;

});

parcelRegister("f3OgL", function(module, exports) {
/**
 * Generic, dependency-free markdown stream parsing utilities.
 *
 * These utilities handle the extraction and processing of special-tag content
 * from streaming markdown text (e.g., `<lumina>...</lumina>`, `◴...◶`).
 * They operate on plain strings only — no conversation-assistant-specific
 * types or store dependencies.
 */ function $1e446058f30c9027$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const $1e446058f30c9027$export$1edc769cb607aa0f = (text, boundaryStart, boundaryEnd, replacementContent = '')=>{
    const boundaryContents = [];
    if (!text) return {
        processedText: text,
        boundaryContents: boundaryContents
    };
    // An empty boundaryEnd denotes an open-ended component: everything from the
    // start tag to the end of the message is captured (e.g. actionable follow-ups,
    // which have a start marker but no end marker).
    const regex = boundaryEnd === '' ? new RegExp(`${$1e446058f30c9027$var$escapeRegExp(boundaryStart)}([\\s\\S]*)$`, 'g') : new RegExp(`${$1e446058f30c9027$var$escapeRegExp(boundaryStart)}(.*?)${$1e446058f30c9027$var$escapeRegExp(boundaryEnd)}`, 'gs');
    let newText = text;
    let match;
    let found = false;
    while((match = regex.exec(text)) !== null){
        boundaryContents.push(match[1]);
        newText = newText.replace(match[0], replacementContent);
        found = true;
    }
    return {
        processedText: found ? newText : text,
        boundaryContents: boundaryContents
    };
};
const $1e446058f30c9027$export$c6f5269a29d1a6df = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let streamingMarkdownContent = '';
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    if (typeof text === 'string') {
        // An empty endTag denotes an open-ended component (start tag, no end tag):
        // content is captured until the stream ends, so a close tag is never matched
        // mid-stream. `text.includes('')` is always true, hence the explicit guard.
        const hasCloseTag = endTag !== '' && text.includes(endTag);
        if (hasCloseTag && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const [contentBeforeCloseTag, contentAfterCloseTag] = text.split(endTag);
            streamingMarkdownContent = contentBeforeCloseTag;
            processedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const [contentBeforeOpenTag, contentAfterOpenTag] = text.split(startTag);
            processedText = contentBeforeOpenTag + placeholderTag;
            streamingMarkdownContent = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            streamingMarkdownContent = text;
            processedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1e446058f30c9027$export$1fc44797755f1907 = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    return (text)=>{
        let processedText = text;
        let newCurrentLoadingKeys = {
            ...currentLoadingKeys
        };
        let newPreviousKeys = {
            ...previousKeys
        };
        let markdownData = null;
        let processedComponentType = null;
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] || null;
            const previousKey = previousKeys[component.key] || null;
            const result = $1e446058f30c9027$export$c6f5269a29d1a6df(processedText, currentLoadingKey, previousKey, component);
            if (result.markdownData) {
                processedText = result.processedText;
                newCurrentLoadingKeys[component.key] = result.currentLoadingKey;
                newPreviousKeys[component.key] = result.previousKey;
                markdownData = result.markdownData;
                processedComponentType = component.key;
                break; // Only process one component type per call
            }
        }
        currentLoadingKeys = newCurrentLoadingKeys;
        previousKeys = newPreviousKeys;
        return {
            processedText: processedText,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
const $1e446058f30c9027$export$87723f8a010c233f = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    let unprocessedText = '';
    if (typeof text === 'string') {
        // An empty endTag denotes an open-ended component (start tag, no end tag):
        // content is captured until the stream ends, so a close tag is never matched
        // mid-stream. `''.indexOf` returns 0, hence the explicit guard.
        const closeTagIndex = endTag === '' ? -1 : text.indexOf(endTag);
        if (closeTagIndex !== -1 && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const contentBeforeCloseTag = text.substring(0, closeTagIndex);
            const contentAfterCloseTag = text.substring(closeTagIndex + endTag.length);
            processedText = '';
            unprocessedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: contentBeforeCloseTag,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const openTagIndex = text.indexOf(startTag);
            const contentBeforeOpenTag = text.substring(0, openTagIndex);
            const contentAfterOpenTag = text.substring(openTagIndex + startTag.length);
            processedText = contentBeforeOpenTag + placeholderTag;
            unprocessedText = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: '',
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            // Mid-stream branch: no boundary in this chunk; the whole text is
            // streamed content for the active component.
            processedText = '';
            unprocessedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: text,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        unprocessedText: unprocessedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1e446058f30c9027$export$e234f678a7b6108d = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    const processRecursive = (text, markdownData)=>{
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] ?? null;
            const prevKey = previousKeys[component.key] ?? null;
            const result = $1e446058f30c9027$export$87723f8a010c233f(text, currentLoadingKey, prevKey, component);
            if (!result.markdownData) continue;
            const { key: key, content: content, loading: loading } = result.markdownData;
            currentLoadingKeys[component.key] = result.currentLoadingKey;
            previousKeys[component.key] = result.previousKey;
            const existing = markdownData[key];
            markdownData[key] = {
                content: (existing?.content ?? '') + content,
                loading: loading
            };
            if (result.unprocessedText) {
                const inner = processRecursive(result.unprocessedText, markdownData);
                return {
                    ...inner,
                    processedText: result.processedText + inner.processedText
                };
            }
            return {
                processedText: result.processedText,
                markdownData: markdownData
            };
        }
        // No component matched — return text unchanged.
        return {
            processedText: text,
            markdownData: markdownData
        };
    };
    return (text)=>{
        return processRecursive(text, {});
    };
};
module.exports["extractMarkdownText"] = $1e446058f30c9027$export$1edc769cb607aa0f;
module.exports["createMarkdownProcessor"] = $1e446058f30c9027$export$1fc44797755f1907;
module.exports["createMarkdownProcessorMultiTags"] = $1e446058f30c9027$export$e234f678a7b6108d;

});

parcelRegister("eTr6D", function(module, exports) {

var $7crhj = parcelRequire("7crhj");

const $807b4fd27969eb29$export$21b80d7df56b3918 = (row)=>{
    const a2uiMessages = row.agenticUiMessages ?? [];
    const isServerMarkedFolded = typeof row.content.message.message.message_metadata?.a2ui_folded_into === 'string';
    const firstCreateIndex = a2uiMessages.findIndex((0, $7crhj.isCreateSurface));
    if (!isServerMarkedFolded && (a2uiMessages.length === 0 || firstCreateIndex === 0)) return row;
    if (!isServerMarkedFolded && firstCreateIndex > 0) return {
        ...row,
        agenticUiMessages: a2uiMessages.slice(firstCreateIndex)
    };
    const textContent = row.content.message.message.content;
    const hasContent = typeof textContent === 'string' ? textContent.trim().length > 0 : true;
    const hasActions = (row.content.message.message.actions?.length ?? 0) > 0;
    if (!hasContent && !hasActions) return undefined;
    const { agenticUiMessages: _ignored, ...rest } = row;
    return rest;
};
module.exports["foldA2UIHistoryRow"] = $807b4fd27969eb29$export$21b80d7df56b3918;

});

parcelRegister("8bsmP", function(module, exports) {

var $6Bfyn = parcelRequire("6Bfyn");


var $4vH8u = parcelRequire("4vH8u");


var $aXdbm = parcelRequire("aXdbm");


var $5XX4K = parcelRequire("5XX4K");


var $eK93A = parcelRequire("eK93A");

const $70aedeea0dcf1043$var$cloneStreamResponse = (message)=>({
        ...message,
        message: {
            ...message.message,
            message: {
                ...message.message.message
            }
        }
    });
const $70aedeea0dcf1043$export$45f48bc1dd3f22b5 = ({ message: message, options: options })=>{
    let processedMessage = $70aedeea0dcf1043$var$cloneStreamResponse(message);
    const markdownData = {};
    const extractionCounts = {
        actionableFollowUps: 0,
        dataSculptor: 0,
        expand: 0,
        inlineLumina: 0,
        legacyChart: 0,
        unicodeChart: 0
    };
    // Structured A2UI content must be normalized to a plain text string before any of
    // the steps below — they all operate on string content only and silently no-op on
    // the structured object, which would leave the extracted text unprocessed (raw
    // `<details>`, unextracted boundaries). `shouldExtractA2UI` only decides whether the
    // data parts are surfaced for rendering, so the final-response path (which passes
    // false) still gets its text normalized.
    let agenticUiMessages;
    const a2uiResult = (0, $aXdbm.extractA2UIFromStructuredContent)(processedMessage.message.message.content);
    if (a2uiResult) {
        processedMessage.message.message.content = a2uiResult.textContent;
        if (options.shouldExtractA2UI) agenticUiMessages = a2uiResult.a2uiMessages;
    }
    if (options.shouldPreprocessDetails) processedMessage = (0, $eK93A.preprocessStreamResponseDetails)(processedMessage);
    if (options.shouldExtractDataSculptor) {
        const sculptorMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: '[^sculptor:start^]',
            boundaryEnd: '[^sculptor:end^]',
            replacementContent: '[^sculptor^]'
        });
        processedMessage = sculptorMsg.processedStreamMessage;
        sculptorMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`sculptor-${index}`] = content;
        });
        extractionCounts.dataSculptor = sculptorMsg.boundaryContents.length;
    }
    const expandOpenTag = "\u259E";
    const expandCloseTag = "\u259A";
    const expandPlaceholder = '[^expand^]';
    const expandMsg = (0, $5XX4K.extractMarkdownContent)({
        streamMessage: processedMessage,
        boundaryStart: expandOpenTag,
        boundaryEnd: expandCloseTag,
        replacementContent: expandPlaceholder
    });
    processedMessage = expandMsg.processedStreamMessage;
    expandMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`expand-${index}`] = content;
    });
    extractionCounts.expand = expandMsg.boundaryContents.length;
    let chartIndex = 0;
    if (options.shouldExtractLegacyChartBoundaries) {
        const chartMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: '[^chart:start^]',
            boundaryEnd: '[^chart:end^]',
            replacementContent: '[^chart^]'
        });
        processedMessage = chartMsg.processedStreamMessage;
        chartMsg.boundaryContents.forEach((content)=>{
            markdownData[`chart-${chartIndex}`] = content;
            chartIndex++;
        });
        extractionCounts.legacyChart = chartMsg.boundaryContents.length;
    }
    const unicodeChartMsg = (0, $5XX4K.extractMarkdownContent)({
        streamMessage: processedMessage,
        boundaryStart: "\u25F4",
        boundaryEnd: "\u25F6",
        replacementContent: '[^chart^]'
    });
    processedMessage = unicodeChartMsg.processedStreamMessage;
    unicodeChartMsg.boundaryContents.forEach((content)=>{
        markdownData[`chart-${chartIndex}`] = content;
        chartIndex++;
    });
    extractionCounts.unicodeChart = unicodeChartMsg.boundaryContents.length;
    if (options.shouldExtractInlineLumina) {
        const luminaMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: "\u25D0",
            boundaryEnd: "\u25D1",
            replacementContent: '\n\n[^lumina^]\n\n'
        });
        processedMessage = luminaMsg.processedStreamMessage;
        luminaMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`lumina-${index}`] = content;
        });
        extractionCounts.inlineLumina = luminaMsg.boundaryContents.length;
    }
    if (options.shouldExtractActionableFollowUps) {
        const followUpsMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedMessage,
            boundaryStart: (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_MARKER),
            boundaryEnd: '',
            replacementContent: `\n\n[^${(0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY)}^]\n\n`
        });
        processedMessage = followUpsMsg.processedStreamMessage;
        followUpsMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`${0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}-${index}`] = content;
        });
        extractionCounts.actionableFollowUps = followUpsMsg.boundaryContents.length;
    }
    return {
        agenticUiMessages: agenticUiMessages,
        extractionCounts: extractionCounts,
        markdownData: markdownData,
        message: processedMessage
    };
};
module.exports["normalizeFinalizedMessagePresentation"] = $70aedeea0dcf1043$export$45f48bc1dd3f22b5;

});

parcelRegister("lx3cN", function(module, exports) {

var $4m5jb = parcelRequire("4m5jb");


var $8OiFS = parcelRequire("8OiFS");


var $igOtY = parcelRequire("igOtY");








var $l6xCb = parcelRequire("l6xCb");

const $c5b446309c731371$export$82301f76a841b4dc = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addStoreChatItem, ({ message: message, conversationId: conversationIdParam })=>({ getState: getState }, { setMessages: setMessages, getMessages: getMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        setMessages(conversationId, [
            ...getMessages(conversationId),
            message
        ]);
    });






var $4o0zT = parcelRequire("4o0zT");


var $2yWJZ = parcelRequire("2yWJZ");

const $c455ea329737468a$export$f509fd4645870a6e = (args)=>{
    const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const authorNamedId = args.agentAuthorId ?? args.agentNamedId;
    const authorIdentityAccountId = args.agentAuthorIdentityAccountId?.trim() || undefined;
    return {
        type: 'ASSISTANT',
        ...args.entryPoint ? {
            entryPoint: args.entryPoint
        } : {},
        ...args.actionId ? {
            actionId: args.actionId
        } : {},
        content: {
            type: 'FINAL_RESPONSE',
            message: {
                message: {
                    role: 'ASSISTANT',
                    id: args.id,
                    conversation_channel_id: args.conversationId,
                    content: args.content,
                    time_created: new Date().toISOString(),
                    user_ari: 'unknown',
                    plugin_invocations: [],
                    ...args.agentAuthorId ? {
                        agent_author: {
                            id: args.agentAuthorId
                        }
                    } : {},
                    author: {
                        ...mentionAgentsEnabled ? {} : {
                            // Remove this named-id control branch with `rovo_chat_mention_agents`.
                            named_id: authorNamedId || (0, $2yWJZ.ROVO_AGENT_NAMED_ID)
                        },
                        name: 'unknown',
                        actor_type: 'AGENT',
                        ari: authorIdentityAccountId ?? null,
                        identity_account_id: authorIdentityAccountId,
                        id: args.agentAuthorId ?? 'unknown'
                    }
                }
            }
        }
    };
};


const $7b222e9f3b67e786$export$ce06e1b90807a0c0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addAssistantMessage, ({ id: id, content: content, conversationId: conversationIdParam, agentNamedId: agentNamedId, agentAuthorId: agentAuthorId, agentAuthorIdentityAccountId: agentAuthorIdentityAccountId, entryPoint: entryPoint, actionId: actionId })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const assistantMessageParams = {
            id: id,
            content: content,
            agentNamedId: agentNamedId,
            agentAuthorId: agentAuthorId,
            agentAuthorIdentityAccountId: agentAuthorIdentityAccountId,
            ...entryPoint ? {
                entryPoint: entryPoint
            } : {},
            ...actionId ? {
                actionId: actionId
            } : {},
            conversationId: conversationId
        };
        dispatch((0, $c5b446309c731371$export$82301f76a841b4dc)({
            message: (0, $c455ea329737468a$export$f509fd4645870a6e)(assistantMessageParams),
            conversationId: conversationId
        }));
    });






var $icBz6 = parcelRequire("icBz6");

const $371ae8b5b22d3b46$export$217edc90936e0581 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addAgentMessage, ({ conversationId: conversationId, agentNamedId: agentNamedId, content: content })=>({ dispatch: dispatch })=>{
        dispatch((0, $7b222e9f3b67e786$export$ce06e1b90807a0c0)({
            id: (0, $icBz6.generateId)(),
            content: content,
            conversationId: conversationId,
            agentNamedId: agentNamedId
        }));
    });










var $eBgZa = parcelRequire("eBgZa");

const $20d942c7fe0333b7$export$1824e64235e4b973 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addErrorMessage, ({ error: error, conversationId: conversationId, errorPrefix: errorPrefix })=>({ dispatch: dispatch })=>{
        dispatch((0, $c5b446309c731371$export$82301f76a841b4dc)({
            message: (0, $eBgZa.createStoreError)(error, errorPrefix),
            conversationId: conversationId
        }));
    });



var $irnO2 = parcelRequire("irnO2");











var $fjUOt = parcelRequire("fjUOt");

const $a9c77291ad58ec01$export$14aeb537f795ee1a = (messages, messageId, answerNowStatus)=>{
    return messages.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) return {
            ...chatItem,
            answerNowStatus: answerNowStatus
        };
        return chatItem;
    });
};


const $3e2d3625545c1ea9$export$d5b8fce20f45b1bf = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).answerNow, ({ conversationId: conversationIdParam, tmpMessageId: tmpMessageId, remoteMessageId: remoteMessageId })=>async ({ getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        // Helper to update conversation traces
        const updateConversationTrace = (traceMessage)=>{
            const state = getState();
            const conversation = state.conversations[conversationId];
            if (conversation) setState({
                conversations: {
                    ...state.conversations,
                    [conversationId]: {
                        ...conversation,
                        traces: [
                            {
                                messageContent: traceMessage
                            }
                        ]
                    }
                }
            });
        };
        // Verify the message exists and has answerNowStatus === AVAILABLE
        // Also prevents duplicate requests if status is already SWITCHING
        const messages = getMessages(conversationId);
        const targetMessage = messages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
        if (!targetMessage || !(0, $igOtY.isStoreAssistant)(targetMessage) || !(0, $igOtY.isAnswerNowAvailable)(targetMessage.answerNowStatus)) return;
        // Optimistic update: Set SWITCHING status first and update trace message
        const updatedMessages = (0, $a9c77291ad58ec01$export$14aeb537f795ee1a)(getMessages(conversationId), tmpMessageId, {
            type: (0, $igOtY.AnswerNowStatusType).SWITCHING
        });
        setMessages(conversationId, updatedMessages);
        updateConversationTrace('Generating answer now!');
        // Start experience tracking
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).ANSWER_NOW,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                remoteMessageId: remoteMessageId,
                tmpMessageId: tmpMessageId
            }
        });
        try {
            // Call the Answer Now API with the remote (BE-provided) message ID
            await assistanceService.answerNow(conversationId, remoteMessageId);
            // Only set SWITCHING_REQUESTED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $igOtY.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING) {
                const successMessages = (0, $a9c77291ad58ec01$export$14aeb537f795ee1a)(currentMessages, tmpMessageId, {
                    type: (0, $igOtY.AnswerNowStatusType).SWITCHING_REQUESTED
                });
                setMessages(conversationId, successMessages);
            }
            // Track success
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).ANSWER_NOW
            });
        } catch (error) {
            // Only set ERRORED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $igOtY.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $igOtY.AnswerNowStatusType).SWITCHING) {
                const erroredMessages = (0, $a9c77291ad58ec01$export$14aeb537f795ee1a)(currentMessages, tmpMessageId, {
                    type: (0, $igOtY.AnswerNowStatusType).ERRORED
                });
                setMessages(conversationId, erroredMessages);
                updateConversationTrace('Generating faster answer failed, continuing with current mode');
            }
            // Track failure
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).ANSWER_NOW,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    });












var $iDrrr = parcelRequire("iDrrr");





var $dw75i = parcelRequire("dw75i");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");





var $boScW = parcelRequire("boScW");








function $10538755bc091414$export$5ab2d78f2e4dba11(message, context) {
    if (!(0, $bxkJA.isActionExecutedSuccessfully)(message)) return 'errored';
    return (0, $bxkJA.isActionResolutionCancelled)(context) ? 'cancelled' : 'finished';
}



var $hHBvs = parcelRequire("hHBvs");


var $k1kN6 = parcelRequire("k1kN6");

function $c0cd6f2cbb67842d$export$af362cbb514e3d36(message) {
    const raw = message.message_metadata?.rRule;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}


function $0359aee38edfc454$export$dd847ca3d24d641(message) {
    const raw = message.message_metadata?.ruleIdUuid;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}






const $42430cf68e8e724f$export$39545431f64e8fd1 = ({ message: message, conversationId: conversationId, sourceMessageId: sourceMessageId, humanMessageId: humanMessageId, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    // The backend supplies this ID after persisting the schedule. A click or
    // a successful confirmation transport alone does not establish creation.
    const ruleIdUuid = (0, $0359aee38edfc454$export$dd847ca3d24d641)(message);
    if (!ruleIdUuid || !(0, $4o0zT.isExperimentEnabled)('rovo_chat_schedule_chat_skill_experiment')) return;
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'created',
        actionSubject: 'scheduledChat',
        attributes: {
            conversationId: conversationId,
            conversationChannelId: message.conversation_channel_id ?? conversationId,
            messageId: message.id,
            sourceMessageId: sourceMessageId,
            humanMessageId: humanMessageId,
            ruleIdUuid: // Count distinct rule IDs downstream to deduplicate replayed responses.
            ruleIdUuid
        }
    });
};









var $cWP9O = parcelRequire("cWP9O");

const $a0b2f7abaad194ec$export$ad76867f670ba93f = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionData, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, data: data })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        agentMessage.result.content.message.message.actions?.forEach((action)=>{
            if (action.invocationId === invocationId) action.data = {
                ...action.data,
                ...data
            };
        });
        updatedMessages[agentMessage.index] = agentMessage.result;
        setMessages(conversationId, updatedMessages);
    });














const $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, status: status, isReliabilityError: isReliabilityError })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        // Publish classification with the status so reliability observers see the same outcome.
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            ...(0, $iDrrr.fg)('rovo_update_work_item_reliability_errors_only') && isReliabilityError !== undefined && {
                content: {
                    ...agentMessage.result.content,
                    message: {
                        ...agentMessage.result.content.message,
                        message: {
                            ...agentMessage.result.content.message.message,
                            actions: agentMessage.result.content.message.message.actions?.map((action)=>action.invocationId === invocationId ? {
                                    ...action,
                                    isReliabilityError: isReliabilityError
                                } : action)
                        }
                    }
                }
            },
            invokedActions: {
                ...agentMessage.result.invokedActions,
                [invocationId]: status
            }
        };
        setMessages(conversationId, updatedMessages);
    });


const $6ebccb4cae0d59cc$export$11688a59b4c1bf2b = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).resolveConversationAction, ({ conversationId: conversationId, messageId: messageId, entryPoint: entryPoint, payload: payload, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false, skipExperienceTracking: skipExperienceTracking = false, analyticsAttributes: analyticsAttributes })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        let actionCallbackData;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const humanMessageId = (0, $k1kN6.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        const attributes = {
            conversationId: conversationId,
            resolution: payload.context.resolution,
            actionKey: payload.context.key
        };
        const fieldAnalyticsAttributes = (0, $iDrrr.fg)('rovo_uwi_field_analytics') && payload.context.key === (0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes && analyticsAttributes ? {
            ...analyticsAttributes,
            invocationId: payload.context.invocationId
        } : {};
        if (!skipExperienceTracking) experienceTracker.start({
            name: (0, $irnO2.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            id: conversationId,
            attributes: attributes
        });
        try {
            const { invocationId: invocationId } = payload.context;
            // Set actions loading state
            dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                status: 'started',
                ...(0, $iDrrr.fg)('rovo_update_work_item_reliability_errors_only') && payload.context.key === (0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes && {
                    // Clear a previous client-error classification before a retry.
                    isReliabilityError: true
                }
            }));
            const response = await assistanceService.resolveConversationAction(conversationId, payload);
            const { message: message } = response;
            dispatch((0, $a0b2f7abaad194ec$export$ad76867f670ba93f)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                data: payload.context.data
            }));
            const ruleIdUuidFromExecution = payload.context.key === (0, $dw75i.SCHEDULED_CHAT_KEY) && (0, $bxkJA.isAssistantMessage)(message) ? (0, $0359aee38edfc454$export$dd847ca3d24d641)(message) : undefined;
            const rRuleFromExecution = payload.context.key === (0, $dw75i.SCHEDULED_CHAT_KEY) && (0, $bxkJA.isAssistantMessage)(message) ? (0, $c0cd6f2cbb67842d$export$af362cbb514e3d36)(message) : undefined;
            if (ruleIdUuidFromExecution || rRuleFromExecution) {
                const previousData = payload.context.data;
                const harvested = {
                    ...ruleIdUuidFromExecution ? {
                        ruleIdUuid: ruleIdUuidFromExecution
                    } : {},
                    ...rRuleFromExecution ? {
                        rRule: rRuleFromExecution
                    } : {}
                };
                dispatch((0, $a0b2f7abaad194ec$export$ad76867f670ba93f)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: typeof previousData === 'object' && previousData !== null ? {
                        ...previousData,
                        ...harvested
                    } : harvested
                }));
            }
            if (payload.context.key === (0, $dw75i.SCHEDULED_CHAT_KEY) && ruleIdUuidFromExecution) (0, $42430cf68e8e724f$export$39545431f64e8fd1)({
                message: message,
                conversationId: conversationId,
                sourceMessageId: messageId,
                humanMessageId: humanMessageId,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
            const isMessageWithContent = !!message.content;
            // Display a new agent message from the response to reflect the change in chat history
            if ((0, $bxkJA.isAssistantMessage)(message) && (isMessageWithContent || (0, $bxkJA.isActionExecutedSuccessfully)(message))) {
                if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch((0, $7b222e9f3b67e786$export$ce06e1b90807a0c0)({
                    agentNamedId: message.author?.named_id,
                    content: message.content,
                    conversationId: conversationId,
                    id: message.id,
                    ...entryPoint ? {
                        entryPoint: entryPoint
                    } : {}
                }));
                actionCallbackData = actionContentProcessor?.(message) ?? undefined;
                dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    status: (0, $10538755bc091414$export$5ab2d78f2e4dba11)(message, payload.context)
                }));
                if ((0, $bxkJA.isActionExecutedSuccessfully)(message)) broadcastConfirmedActions?.(conversationId, [
                    payload.context
                ]);
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'success',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        ...fieldAnalyticsAttributes,
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            } else {
                dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: payload.context.invocationId,
                    status: 'errored'
                }));
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'error',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        ...fieldAnalyticsAttributes,
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            }
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            if (!skipExperienceTracking) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).RESOLVE_CONVERSATION_ACTION,
                error: normalizedError,
                attributes: attributes
            });
            trackAIMAUEvent({
                type: 'error',
                userGenerated: true,
                source: 'messageActionsResolver',
                subjectId: payload.context.resolution.type,
                singleInstrumentationID: messageId,
                ...(0, $iDrrr.fg)('rovo_chat_action_error_action_key') && {
                    attributes: {
                        actionKey: payload.context.key
                    }
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'rovoChatMessageAction',
                attributes: {
                    ...fieldAnalyticsAttributes,
                    recipientAgentNamedId: payload.context.recipient_agent_named_id,
                    actionKey: payload.context.key,
                    resolutionType: payload.context.resolution.type,
                    featureArea: featureArea,
                    humanMessageId: humanMessageId,
                    messageId: messageId
                }
            });
            dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored',
                ...(0, $iDrrr.fg)('rovo_update_work_item_reliability_errors_only') && payload.context.key === (0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes && {
                    isReliabilityError: (0, $8A2GO.isApiError)(error) ? (0, $boScW.is5xxHttpStatus)(error.errorAttributes.statusCode) : true
                }
            }));
            throw new (0, $hHBvs.MessageActionError)({
                message: `Message action error: ${normalizedError.message} for actionKey: ${payload.context.key}`,
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                actionKey: payload.context.key,
                cause: normalizedError
            });
        }
        if (!skipExperienceTracking) experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            attributes: attributes
        });
        return actionCallbackData;
    }, {
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});


const $8c8e302bbc2551a3$export$d5f51c6d14729a9d = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).bulkResolveConversationActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { experienceTracker: experienceTracker })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Execute all actions sequentially
        const actionCallbackResults = [];
        const successfulActions = [];
        let hasErrors = false;
        let successCount = 0;
        for (const payload of payloads){
            const result = await dispatch((0, $6ebccb4cae0d59cc$export$11688a59b4c1bf2b)({
                conversationId: conversationId,
                messageId: messageId,
                payload: payload,
                actionContentProcessor: actionContentProcessor,
                skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse,
                skipExperienceTracking: true
            }));
            actionCallbackResults.push(result);
            // Track success: result is defined means action succeeded
            if (result !== undefined) {
                successCount++;
                successfulActions.push(payload.context);
            } else if (!actionContentProcessor) // Action with no processor returns undefined on success
            successCount++;
            else // Action with processor returned undefined = failure
            hasErrors = true;
        }
        if (hasErrors) experienceTracker.fail({
            teamName: 'Rovo Chat',
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            error: new Error('Some bulk actions failed'),
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length,
                successCount: successCount,
                failureCount: payloads.length - successCount
            }
        });
        else experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        return actionCallbackResults;
    });





















const $5505ac2578341bfa$export$e99fa5687f622cbf = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).bulkResolveConversationUIActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const humanMessageId = (0, $k1kN6.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Set all invocation statuses to 'started'
        for (const payload of payloads)dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
            conversationId: conversationId,
            messageId: messageId,
            invocationId: payload.context.invocationId,
            status: 'started'
        }));
        try {
            const responses = await assistanceService.bulkResolveConversationUIActions(conversationId, messageId, {
                items: payloads
            });
            const actionCallbackResults = [];
            const successfulActions = [];
            let hasErrors = false;
            let successCount = 0;
            // Process each response paired with its corresponding payload
            for(let i = 0; i < payloads.length; i++){
                const payload = payloads[i];
                const response = responses[i];
                const { invocationId: invocationId } = payload.context;
                if (!response) {
                    // No response for this item - mark as errored
                    dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                    continue;
                }
                const { message: message } = response;
                dispatch((0, $a0b2f7abaad194ec$export$ad76867f670ba93f)({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: payload.context.data
                }));
                const isMessageWithContent = !!message.content;
                if ((0, $bxkJA.isAssistantMessage)(message) && (isMessageWithContent || (0, $bxkJA.isActionExecutedSuccessfully)(message))) {
                    if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch((0, $7b222e9f3b67e786$export$ce06e1b90807a0c0)({
                        agentNamedId: message.author?.named_id,
                        content: message.content,
                        conversationId: conversationId,
                        id: message.id
                    }));
                    const callbackData = actionContentProcessor?.(message) ?? undefined;
                    actionCallbackResults.push(callbackData);
                    dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: (0, $10538755bc091414$export$5ab2d78f2e4dba11)(message, payload.context)
                    }));
                    if ((0, $bxkJA.isActionExecutedSuccessfully)(message)) successfulActions.push(payload.context);
                    successCount++;
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'success',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                } else {
                    dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                }
            }
            // Broadcast all successful confirmed actions at once
            if (successfulActions.length > 0) broadcastConfirmedActions?.(conversationId, successfulActions);
            if (hasErrors) experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: new Error('Some bulk actions failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: successCount,
                    failureCount: payloads.length - successCount
                }
            });
            else experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length
                }
            });
            return actionCallbackResults;
        } catch (error) {
            // If the entire bulk request fails, mark all invocations as errored
            for (const payload of payloads)dispatch((0, $b96a5dd06ad67caa$export$b80b5fde5a0ebf6c)({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: error instanceof Error ? error : new Error('Bulk resolve failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: 0,
                    failureCount: payloads.length
                }
            });
            throw error;
        }
    });








const $1385698a2f418aa1$export$bc07ddf1de8d78e4 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).clearFollowUpMessages, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>!(0, $igOtY.isStoreFollowUp)(message));
        setMessages(conversationId, filteredMessages);
    });



var $6geN3 = parcelRequire("6geN3");

const $41db72a9378f94af$export$1562f8e01d4b447c = ({ conversationId: conversationId })=>({ dispatch: dispatch })=>{
        dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: null
            }
        }));
    };



var $djNSU = parcelRequire("djNSU");

/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $9kbTQ = parcelRequire("9kbTQ");


var $cXtTj = parcelRequire("cXtTj");








var $7td41 = parcelRequire("7td41");











var $lOO5l = parcelRequire("lOO5l");


var $gjWe2 = parcelRequire("gjWe2");


var $6MYo6 = parcelRequire("6MYo6");


var $c8Sl1 = parcelRequire("c8Sl1");

const $ac50e9856e9d0021$export$916d50c71d1097fc = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).createSeededConversation, (options)=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, getChatInitiator: getChatInitiator, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL,
            id: (0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        const createConversationOptions = options.rovoSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? {
            ...options,
            name: null
        } : options;
        const optimisticConversationName = options.name ?? (0, $7td41.generateConversationName)();
        const createdConversation = await assistanceService.createConversationChannel(createConversationOptions);
        const humanMessage = createdConversation.messages?.find((message)=>(0, $bxkJA.isHumanMessage)(message));
        const assistantMessage = createdConversation.messages?.find((message)=>(0, $bxkJA.isAssistantMessage)(message));
        const humanMessageId = humanMessage ? humanMessage.id : '';
        const assistantMessageId = assistantMessage ? assistantMessage.id : '';
        const conversationTags = createdConversation.tags ?? options.tags;
        // The header reads the displayed agent only from `conversation.agent.agent_id`,
        // so the chat-new/seeded flow must seed it from the known agent id (preferring a
        // backend-returned agent). Without this, a seeded conversation opened with a
        // specific agent shows default Rovo.
        const seededConversationAgent = (0, $6MYo6.resolveConversationSeedAgent)({
            backendAgent: createdConversation.agent,
            agentId: options.agentId,
            legacyAgent: createdConversation.agent
        });
        const seededConversationAgentFields = seededConversationAgent ? {
            agent: seededConversationAgent
        } : {};
        dispatch((0, $lOO5l.initializeConversationData)({
            conversationId: createdConversation.id,
            data: {
                id: createdConversation.id,
                name: createdConversation.name?.trim() || optimisticConversationName,
                timeCreated: createdConversation.time_created,
                status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                traces: [],
                sourceId: options.sourceId ?? undefined,
                // Front-end-only journey attribution; the service serializer ignores this field.
                rovoJourneyId: options.rovoJourneyId,
                sourceAgentId: options.agentId,
                agentVersion: options.agentVersion,
                resultAttributionContext: options.resultAttributionContext,
                // Set explicitly (including `undefined`) rather than conditionally spread:
                // `initializeConversationData` shallow-merges over any existing slot, so
                // omitting the key would let a stale entry point from a previous launch
                // leak onto this conversation and mis-attribute it.
                chatEntryPoint: options.chatEntryPoint,
                // Same reasoning: a stale 3P cohort would otherwise be mirrored onto this
                // conversation's events, including AI-MAU events the experiment does not own.
                thirdPartyPrompt: undefined,
                messages: [],
                ...seededConversationAgentFields,
                ...conversationTags !== undefined ? {
                    tags: conversationTags
                } : {},
                ...options.skipNextFetch ? {
                    skipNextFetch: true
                } : {},
                // Scope the seeded conversation to a Rovo Space when applicable so the
                // nav and landing page can immediately render it under the correct space.
                ...options.rovoSpaceId ? (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? {
                    rovoSpaceId: options.rovoSpaceId
                } : {} : {}
            }
        }));
        const chatInitiator = getChatInitiator();
        // Build synthetic ChatMessage[] from the seeded dialogues and pass directly to
        // processConversationMessages, which handles all boundary content extraction
        // (lumina, chart, expand, sculptor) consistently with fetchConversation —
        // without an extra getChat network call.
        const syntheticMessages = options.dialogues.flatMap((dialogue)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    messageId: humanMessageId,
                    interactionSource: 'movedOver',
                    followUpSource: options.followUpSource,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator,
                    conversationChannelId: createdConversation.id,
                    // Explicitly override a stale context default while PubSub waits for this
                    // seeded conversation to finish creating before updating the shared ref.
                    ...options.rovoJourneyId ? {
                        rovoJourneyId: options.rovoJourneyId
                    } : {}
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    messageId: assistantMessageId,
                    humanMessageId: humanMessageId,
                    pluginsInvoked: [],
                    hasSources: false,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator,
                    conversationChannelId: createdConversation.id
                }
            });
            // When mimeType is 'text/adf', parse the ADF JSON string into a DocNode
            // so encodeAdf's isAdfContent check can pass it through natively.
            let agentContent = dialogue.agent_message.content;
            if (dialogue.agent_message.mimeType === 'text/adf') try {
                agentContent = JSON.parse(dialogue.agent_message.content);
            } catch  {
            // If parsing fails, fall back to raw string content
            }
            // Use raw ChatMessage types (not createStoreHuman/createStoreAssistant) so that
            // processConversationMessages can apply all boundary content extraction
            // (lumina, chart, expand, sculptor) before producing the final StoreChatItem[].
            const humanMessage = {
                role: 'HUMAN',
                id: (0, $icBz6.generateId)(),
                content: dialogue.human_message.content,
                time_created: new Date().toISOString(),
                user_ari: 'unknown',
                plugin_invocations: [],
                isFromSeededConversation: true
            };
            const assistantStreamResponse = {
                type: 'FINAL_RESPONSE',
                message: {
                    message: {
                        role: 'ASSISTANT',
                        id: (0, $icBz6.generateId)(),
                        conversation_channel_id: createdConversation.id,
                        content: agentContent,
                        time_created: new Date().toISOString(),
                        user_ari: 'unknown',
                        plugin_invocations: [],
                        author: {
                            named_id: 'ai_mate_agent',
                            name: 'unknown',
                            actor_type: 'AGENT',
                            ari: null,
                            id: 'unknown'
                        }
                    }
                }
            };
            return [
                humanMessage,
                assistantStreamResponse
            ];
        });
        const processedMessages = (0, $gjWe2.processConversationMessages)({
            latestMessages: syntheticMessages,
            promptContextViewSource: 'original',
            conversationId: createdConversation.id,
            sendAnalyticsEvent: sendAnalyticsEvent
        });
        setMessages(createdConversation.id, processedMessages);
        if (options.mode && onNewConversationStartingWithSendMessage) // Initialize per-conversation mode before selection so the first render
        // cannot briefly fall back to default controls and context.
        onNewConversationStartingWithSendMessage(createdConversation.id, options.mode);
        // Commit the callback's React state updates before the selection below is dispatched;
        // otherwise the store update can reach subscribers first.
        (0, $9kbTQ.flushSync)(()=>{
            options.onConversationCreated?.(createdConversation.id);
        });
        if (options.selectConversation !== false) dispatch((0, $c8Sl1.setSelectedConversation)({
            conversationId: createdConversation.id
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        return createdConversation.id;
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
});






var $7eGGZ = parcelRequire("7eGGZ");





var $dTEBe = parcelRequire("dTEBe");





var $b2pOf = parcelRequire("b2pOf");

const $7ed06e45fa7d95fc$var$createConversationHydrationCoordinator = (scopeKey)=>{
    const pending = new Map();
    const removedWhilePending = new Set();
    return {
        scopeKey: scopeKey,
        getPending: (conversationId)=>pending.get(conversationId),
        setPending: (conversationId, request)=>pending.set(conversationId, request),
        clearPending: (conversationId, request)=>{
            if (pending.get(conversationId) === request) {
                pending.delete(conversationId);
                removedWhilePending.delete(conversationId);
            }
        },
        wasRemovedWhilePending: (conversationId)=>removedWhilePending.has(conversationId),
        markRemoved: (conversationId)=>{
            if (pending.has(conversationId)) removedWhilePending.add(conversationId);
        }
    };
};
const $7ed06e45fa7d95fc$var$coordinators = new WeakMap();
const $7ed06e45fa7d95fc$export$3f005b6e7a88ca32 = (assistanceService, scopeKey)=>{
    let scopedCoordinators = $7ed06e45fa7d95fc$var$coordinators.get(assistanceService);
    if (scopedCoordinators == null) {
        scopedCoordinators = new Map();
        $7ed06e45fa7d95fc$var$coordinators.set(assistanceService, scopedCoordinators);
    }
    const coordinator = scopedCoordinators.get(scopeKey) ?? $7ed06e45fa7d95fc$var$createConversationHydrationCoordinator(scopeKey);
    scopedCoordinators.set(scopeKey, coordinator);
    return coordinator;
};


const $77b987c9b91a6f83$export$53f4d2378049701e = ({ conversationId: conversationId, confirmedDeletion: confirmedDeletion, promptHistoryContext: promptHistoryContext })=>({ getState: getState, setState: setState }, props)=>{
        const { assistanceService: assistanceService, getConversationHydrationScopeKey: getConversationHydrationScopeKey, siteId: siteId } = props;
        const scopeKey = getConversationHydrationScopeKey?.();
        if (scopeKey != null) (0, $7ed06e45fa7d95fc$export$3f005b6e7a88ca32)(assistanceService, scopeKey).markRemoved(conversationId);
        const { conversations: conversations, promptHistory: promptHistory, currentConversationId: currentConversationId } = getState();
        const cleanup = confirmedDeletion && (0, $iDrrr.fg)('rovo-chat-ai-inbox');
        const { [conversationId]: conversation, ...otherConversations } = conversations;
        let updatedHistory;
        if (promptHistory && (cleanup || promptHistoryContext && promptHistory.requestToken === promptHistoryContext.requestToken)) {
            const removedSessionIds = new Set([
                ...promptHistory.removedSessionIds ?? [],
                conversationId,
                ...promptHistoryContext ? [
                    promptHistoryContext.sessionId
                ] : []
            ]);
            updatedHistory = {
                ...promptHistory,
                removedSessionIds: [
                    ...removedSessionIds
                ],
                items: promptHistory.items.filter(({ sessionId: sessionId })=>!removedSessionIds.has(sessionId))
            };
        }
        // Remove metadata and selection together, before abort callbacks can run.
        setState({
            conversations: otherConversations,
            ...cleanup && currentConversationId === conversationId ? {
                currentConversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
            } : {},
            ...updatedHistory ? {
                promptHistory: updatedHistory
            } : {}
        });
        if (!cleanup) return;
        const abort = conversation?.storeAbortController?.abort();
        const clearRuntimeCaches = ()=>{
            props.endReconnection(conversationId);
            props.setMessages(conversationId, []);
            props.unifiedTasksActions?.removeTasksForConversation?.(conversationId);
        };
        clearRuntimeCaches();
        // Replay can flush buffered messages before acknowledging cancellation.
        abort?.then(()=>{
            if (getConversationHydrationScopeKey?.() === scopeKey) clearRuntimeCaches();
        });
        (0, $b2pOf.persistRecentConversation)({
            type: 'conversation-deleted',
            siteId: siteId,
            conversationId: conversationId
        });
        const urlConversationId = (0, $dTEBe.getRovoParams)().conversationId;
        if (urlConversationId === conversationId) (0, $dTEBe.updatePageRovoParams)({
            conversationId: undefined
        }, {
            historyMode: 'replace'
        });
    };


const $f27a0f1ad9682674$export$64c838ca85b298d9 = ({ conversationId: conversationId })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        const { promptHistory: promptHistory, conversations: conversations } = getState();
        const promptHistoryContext = promptHistory ? {
            requestToken: promptHistory.requestToken,
            sessionId: conversations[conversationId]?.backendConversationId ?? conversationId
        } : undefined;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).CLEAR_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        await getState().conversations[conversationId]?.storeAbortController?.abort();
        try {
            await assistanceService.deleteChat(conversationId);
        } catch (error) {
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).CLEAR_CHAT,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
        // Remove the deleted conversation from the local store prior to refetching channels.
        // fetchConversationChannelsData preserves any local conversation whose ID is missing
        // from the API response (to keep optimistic / in-flight conversations alive). Without
        // this explicit removal, the just-deleted conversation would be treated as
        // "optimistic" and re-added to the store, causing it to reappear in the UI.
        dispatch((0, $77b987c9b91a6f83$export$53f4d2378049701e)({
            conversationId: conversationId,
            promptHistoryContext: promptHistoryContext,
            confirmedDeletion: true
        }));
        await dispatch((0, $7eGGZ.fetchConversationChannelsData)({
            reconcileFirstPage: true
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).CLEAR_CHAT
        });
    };






var $hlvTd = parcelRequire("hlvTd");


var $idzM5 = parcelRequire("idzM5");






var $8ssI02 = parcelRequire("8ssI02");

const $45b5e09b5dafafbe$export$a3fb5954226ada5d = ({ conversationId: conversationId, showErrorOnFailure: showErrorOnFailure = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, getConversationHydrationScopeKey: getConversationHydrationScopeKey, showFlag: showFlag, siteId: siteId })=>{
        if (!(0, $iDrrr.fg)('rovo-chat-ai-inbox')) return false;
        if (getState().conversations[conversationId]) return true;
        const requestScopeKey = getConversationHydrationScopeKey?.();
        if (requestScopeKey == null) return false;
        const conversationHydrationCoordinator = (0, $7ed06e45fa7d95fc$export$3f005b6e7a88ca32)(assistanceService, requestScopeKey);
        const existingRequest = conversationHydrationCoordinator.getPending(conversationId);
        const requestSiteId = siteId;
        const ownsRequest = existingRequest == null;
        const request = existingRequest ?? (async ()=>{
            const metadata = await assistanceService.fetchConversationMetadata(conversationId);
            const hydratedSiteId = getState().hydratedSiteId;
            if (getConversationHydrationScopeKey?.() !== requestScopeKey || hydratedSiteId !== undefined && hydratedSiteId !== requestSiteId || conversationHydrationCoordinator.wasRemovedWhilePending(conversationId)) return false;
            // Another store path populated the conversation while metadata was pending. Its
            // local messages, draft and newer navigation data are authoritative.
            if (getState().conversations[conversationId]) return true;
            if (metadata.id !== conversationId) return false;
            dispatch((0, $lOO5l.initializeConversationData)({
                conversationId: conversationId,
                data: (0, $8ssI02.mergeConversationWithNetworkPriority)(metadata)
            }));
            return getState().conversations[conversationId] != null;
        })();
        if (ownsRequest) conversationHydrationCoordinator.setPending(conversationId, request);
        try {
            return await request;
        } catch (error) {
            if (ownsRequest) (0, $hlvTd.logException)({
                name: 'ensureConversationMetadata',
                exception: error,
                tags: {
                    conversationId: conversationId,
                    scopeKey: conversationHydrationCoordinator.scopeKey
                }
            });
            if (showErrorOnFailure) showFlag?.((0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED);
            return false;
        } finally{
            if (ownsRequest) conversationHydrationCoordinator.clearPending(conversationId, request);
        }
    };


const $c09fde7241c81bcf$var$INITIAL_PROMPT_HISTORY_LIMIT = 100;
const $c09fde7241c81bcf$var$REFRESH_PROMPT_HISTORY_LIMIT = 25;
const $c09fde7241c81bcf$export$61feb9c9a0822fc5 = (scope)=>async ({ getState: getState, setState: setState }, { assistanceService: assistanceService, sendAnalyticsEvent: sendAnalyticsEvent })=>{
        const history = getState().promptHistory;
        const cached = history?.scope === scope ? history : undefined;
        // Claim this open synchronously: pending requests and failures must not retry on rerender.
        if (cached && !cached.needsRefresh) return;
        const pending = {
            scope: scope,
            needsRefresh: false,
            hasLoaded: cached?.hasLoaded ?? false,
            requestToken: {},
            items: cached?.items ?? [],
            ...cached?.removedSessionIds ? {
                removedSessionIds: cached.removedSessionIds
            } : {}
        };
        setState({
            promptHistory: pending
        });
        if (!assistanceService.getPromptHistory) {
            // Unsupported hosts have a successful empty cache, not an error or retry loop.
            setState({
                promptHistory: {
                    ...pending,
                    hasLoaded: true
                }
            });
            return;
        }
        try {
            const { items: items } = await assistanceService.getPromptHistory({
                limit: pending.hasLoaded ? $c09fde7241c81bcf$var$REFRESH_PROMPT_HISTORY_LIMIT : $c09fde7241c81bcf$var$INITIAL_PROMPT_HISTORY_LIMIT
            });
            const current = getState().promptHistory;
            if (current?.requestToken !== pending.requestToken) return;
            // New records win by message ID. Keep older items and establish ordering here, once.
            const itemsByMessageId = new Map([
                ...current.items,
                ...items
            ].map((item)=>[
                    item.messageId,
                    item
                ]));
            setState({
                promptHistory: {
                    ...current,
                    items: [
                        ...itemsByMessageId.values()
                    ].filter(({ sessionId: sessionId })=>!current.removedSessionIds?.includes(sessionId)).sort((a, b)=>b.createdAt - a.createdAt),
                    hasLoaded: true
                }
            });
        } catch (error) {
            // Retain cached and locally added items. A reset or explicit invalidation enables a retry.
            if (getState().promptHistory?.requestToken !== pending.requestToken || error instanceof Error && error.name === 'AbortError') return;
            sendAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'promptHistory',
                attributes: {
                    loadType: pending.hasLoaded ? 'refresh' : 'initial'
                }
            });
        }
    };


















var $jyZaR = parcelRequire("jyZaR");







const $c4abac6b845cca29$export$bb0ca99caffb8502 = (messages, messageId)=>{
    return messages.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message,
                        content: ''
                    }
                },
                streamingComplete: false
            }
        };
        return chatItem;
    });
};














const $287b89b445b82017$export$9c99f879b5701ba2 = (latestMessages)=>{
    if (!(0, $iDrrr.fg)('rovo_agent_versioning_enabled')) return undefined;
    for (const message of latestMessages)if ((0, $bxkJA.isStreamResponse)(message)) {
        const agentAuthor = message.message?.message?.agent_author;
        if (agentAuthor?.versionId || agentAuthor?.versionType) return {
            versionId: agentAuthor.versionId,
            versionType: agentAuthor.versionType,
            versionNumber: agentAuthor.versionNumber
        };
        return undefined;
    }
    return undefined;
};


const $4aa09818c3d4f0b5$export$a2ff1144002a6147 = (state, id)=>{
    return state.conversations[id];
};





const $56454c3864f9431b$export$ab93cd1ecacda8ec = (messages, conversation)=>{
    const assistantMessage = messages.find((message)=>(0, $igOtY.isStoreAssistant)(message));
    // the final fallback correctly selects an agent if a user cancels a session
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id ?? conversation?.agent?.agent_id;
};















const $95aa319c6be31138$export$3af2463ee5fae65d = ({ conversationId: conversationId, currentConversationId: currentConversationId, dispatch: dispatch, sendAnalyticsEvent: sendAnalyticsEvent, showFlag: showFlag })=>{
    const rovoParams = (0, $dTEBe.getRovoParams)();
    const isConversationIdInRovoParams = rovoParams?.conversationId === conversationId;
    const isCurrentConversation = currentConversationId === conversationId;
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'forbidden',
        actionSubject: 'rovoChatFetchConversation',
        attributes: {
            isConversationIdInRovoParams: isConversationIdInRovoParams
        }
    });
    dispatch((0, $77b987c9b91a6f83$export$53f4d2378049701e)({
        conversationId: conversationId
    }));
    if (isCurrentConversation) dispatch((0, $c8Sl1.setSelectedConversation)({
        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
    }));
    if (isConversationIdInRovoParams) (0, $dTEBe.updatePageRovoParams)({
        conversationId: undefined
    });
    showFlag?.((0, $idzM5.StoreErrorFlagId).CONVERSATION_FORBIDDEN);
};





const $4c477a4f1aee7cea$export$e3ef4b259ed70a56 = ({ conversationId: conversationId, metadata: metadata, dispatch: dispatch, onConversationSpacesHydrated: onConversationSpacesHydrated })=>{
    const spaces = metadata.spaces ?? [];
    const associatedSpace = spaces.at(0);
    if (!associatedSpace) return;
    dispatch((0, $6geN3.setConversationData)({
        conversationId: conversationId,
        data: {
            rovoSpaceId: associatedSpace.id
        }
    }));
    onConversationSpacesHydrated?.(conversationId, spaces);
};












const $b2d2dd6f47199a97$export$edaf28f02e88f53a = (conversationId)=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, onConversationSpacesHydrated: onConversationSpacesHydrated })=>{
        const conversation = getState().conversations[conversationId];
        const metadata = await assistanceService.fetchConversationMetadata(conversationId);
        const current = getState().conversations[conversationId];
        // Do not overwrite a newer selection or revive a conversation removed during the request.
        if (current?.status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat || current.agent !== conversation?.agent) return;
        if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_spaces_experiment')) (0, $4c477a4f1aee7cea$export$e3ef4b259ed70a56)({
            conversationId: conversationId,
            metadata: metadata,
            dispatch: dispatch,
            onConversationSpacesHydrated: onConversationSpacesHydrated
        });
        if (metadata.agent?.agent_id) dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                agent: metadata.agent,
                sourceAgentId: metadata.agent.agent_id
            }
        }));
    };





const $579e7cab04e6efec$export$767f5c1ef71cb70c = (latestMessages)=>{
    const lastMessage = latestMessages.at(-1);
    return lastMessage === undefined || (0, $bxkJA.isHumanMessage)(lastMessage);
};



var $1IZrU = parcelRequire("1IZrU");




const $d658c35e0bf26137$export$a36711287d720d2b = (error)=>error instanceof (0, $8A2GO.ApiError) && error.errorAttributes?.statusCode === 403;






var $3Cuhs = parcelRequire("3Cuhs");

const $d2bec76a2cf3a32e$export$78825c8f4b3c575c = (previousMessages, networkMessages)=>{
    // Only the contiguous run at the very end is eligible. A FOLLOW_UP stranded mid-transcript is
    // already an invariant violation; do not propagate it.
    let firstTrailingIndex = previousMessages.length;
    while(firstTrailingIndex > 0 && (0, $igOtY.isStoreFollowUp)(previousMessages[firstTrailingIndex - 1]))firstTrailingIndex--;
    const trailingFollowUps = previousMessages.slice(firstTrailingIndex);
    if (trailingFollowUps.length === 0) return networkMessages;
    // The server transcript must still end on an assistant turn...
    const lastNetworkMessage = networkMessages.at(-1);
    if (!lastNetworkMessage || !(0, $igOtY.isStoreAssistant)(lastNetworkMessage)) return networkMessages;
    // ...and it must be the same assistant message these follow-ups were generated for.
    const anchorMessageId = trailingFollowUps[0].agentMessageId ?? (0, $3Cuhs.getLastAgentMessageID)(previousMessages);
    if (!anchorMessageId || anchorMessageId !== (0, $3Cuhs.getLastAgentMessageID)(networkMessages)) return networkMessages;
    return [
        ...networkMessages,
        ...trailingFollowUps
    ];
};














/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing stream processing gates feature behavior from runtime flags. */ 









var $aYC8J = parcelRequire("aYC8J");


var $6xccU = parcelRequire("6xccU");







/**
 * The subset of @atlassian/conversation-assistant's SkillAttributes this package needs. Declared
 * locally (structurally compatible, not imported) to avoid a circular dependency, since
 * conversation-assistant depends on this package.
 */ const $23c21d37ccaaaaef$export$c32d31d35ce1fec4 = (skillsInvoked, pluginsInvoked, agentExternalConfigReference)=>[
        ...agentExternalConfigReference ? [
            agentExternalConfigReference
        ] : [],
        ...skillsInvoked.flatMap((skill)=>[
                skill.skillName,
                skill.minionId
            ].filter((value)=>Boolean(value))),
        ...Array.from(pluginsInvoked)
    ];



var $gDq7w = parcelRequire("gDq7w");

const $b313767b9a7bfd23$var$MCI_KR_VIEW_KEY_CONFIG_ENTRIES = Object.entries((0, $gDq7w.MCI_KR_VIEW_KEY_CONFIG));
const $b313767b9a7bfd23$export$98364b1a3d8542af = (identifiers)=>{
    const matchedEntries = identifiers.flatMap((identifier)=>$b313767b9a7bfd23$var$MCI_KR_VIEW_KEY_CONFIG_ENTRIES.filter(([key])=>identifier.includes(key)).map(([, entry])=>entry));
    if (matchedEntries.length === 0) return {};
    return {
        ...matchedEntries.some((entry)=>entry.countsTowardMciPlusKr) && {
            eligible_for_mci_plus_kr: 1
        },
        ...matchedEntries.some((entry)=>entry.countsTowardAiAdoptedKr) && {
            eligible_for_ai_adopted_kr: 1
        },
        service_or_ops: matchedEntries[0].serviceOrOps
    };
};


const $ed079ebed6bb7598$export$bb558012e0978515 = (skillsInvoked, pluginsInvoked, agentExternalConfigReference)=>(0, $b313767b9a7bfd23$export$98364b1a3d8542af)((0, $23c21d37ccaaaaef$export$c32d31d35ce1fec4)(skillsInvoked, pluginsInvoked, agentExternalConfigReference));









var $jTKfH = parcelRequire("jTKfH");


var $0Z0Rs = parcelRequire("0Z0Rs");


var $b6N3q = parcelRequire("b6N3q");




const $0ac98c0a880a830b$var$STREAM_TIMEOUT = Symbol('STREAM_TIMEOUT');
async function* $0ac98c0a880a830b$export$44aab448715585b6(stream, { timeoutMs: timeoutMs, onTimeout: onTimeout, isPaused: isPaused }) {
    // Kept outstanding across timer re-arms; calling `next()` again while one is
    // pending is illegal on a generator.
    let nextPromise;
    const reliableContracts = (0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts');
    let sourceFinished = false;
    try {
        while(true){
            if (!nextPromise) nextPromise = stream.next();
            let timeoutId;
            const timeout = new Promise((resolve)=>{
                timeoutId = setTimeout(()=>resolve($0ac98c0a880a830b$var$STREAM_TIMEOUT), timeoutMs);
            });
            let result;
            try {
                result = await Promise.race([
                    nextPromise,
                    timeout
                ]);
            } finally{
                clearTimeout(timeoutId);
                timeoutId = undefined;
            }
            if (result === $0ac98c0a880a830b$var$STREAM_TIMEOUT) {
                // Paused (e.g. reconnecting): re-arm with the same pending `next()`.
                if (isPaused?.()) continue;
                const error = onTimeout();
                // Clean up the source stream after timing out.
                const returnPromise = stream.return?.(undefined);
                sourceFinished = true;
                returnPromise?.catch(()=>undefined);
                if (error) throw error;
                return;
            }
            // Chunk arrived – advance to the next one.
            nextPromise = undefined;
            if (result.done) {
                sourceFinished = true;
                return;
            }
            yield result.value;
        }
    } finally{
        if (reliableContracts && !sourceFinished) // Forward early consumer exit (including errors) to the source. Never
        // await a return queued behind an outstanding next() that may be stalled.
        stream.return(undefined).catch(()=>undefined);
    }
}


const $c44f031f0678945d$export$3cdc20b361e6b93d = ({ conversationId: conversationId, messageId: messageId, traceId: traceId, error: error, failureMode: failureMode, reconnectAttempts: reconnectAttempts, attributes: attributes, recoveryOutcome: recoveryOutcome = 'completedAnswerPreserved', invalidatingEventType: invalidatingEventType })=>({
        eventType: 'operational',
        action: 'interrupted',
        actionSubject: 'rovoChatStream',
        attributes: {
            ...attributes,
            isDeepResearch: attributes?.isDeepResearch ?? null,
            thinkDeeperEnabled: attributes?.thinkDeeperEnabled ?? null,
            fastModeEnabled: attributes?.fastModeEnabled ?? null,
            conversationId: conversationId,
            messageId: messageId,
            traceId: traceId,
            phase: 'afterFinalResponse',
            recoveryOutcome: recoveryOutcome,
            ...invalidatingEventType ? {
                invalidatingEventType: invalidatingEventType
            } : {},
            failureMode: failureMode,
            reconnectAttempts: reconnectAttempts,
            errorName: error instanceof Error ? error.name : 'Unknown'
        }
    });









var $cbY7C = parcelRequire("cbY7C");

/**
 * Abort-aware sleep that resolves after `ms` or rejects early if the signal is aborted.
 * Falls back to a regular setTimeout when no signal is provided.
 */ const $e1432663f5f143d6$var$abortableSleep = (ms, signal)=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        let cleanup = ()=>{};
        const timer = setTimeout(()=>{
            cleanup();
            resolve();
        }, ms);
        if (signal) {
            const onAbort = ()=>{
                clearTimeout(timer);
                cleanup();
                reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            };
            cleanup = (0, $cbY7C.bind)(signal, {
                type: 'abort',
                listener: onAbort,
                options: {
                    once: true
                }
            });
        }
    });
/**
 * Resolves when the browser reports it is online.
 * Returns immediately if already online, otherwise waits for the 'online' event.
 * Rejects if the signal is aborted while waiting.
 * @returns true if it had to wait for the 'online' event, false if already online.
 * Useful to distinguish between "was offline and recovered" vs "was already online".
 */ const $e1432663f5f143d6$var$waitForOnline = (signal)=>{
    if (typeof navigator === 'undefined' || navigator.onLine) return Promise.resolve(false);
    return new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        const onOnline = ()=>{
            cleanup();
            resolve(true);
        };
        const onAbort = ()=>{
            cleanup();
            reject(signal?.reason ?? new DOMException('Aborted', 'AbortError'));
        };
        const unbindOnline = (0, $cbY7C.bind)(window, {
            type: 'online',
            listener: onOnline,
            options: {
                once: true
            }
        });
        const unbindAbort = signal ? (0, $cbY7C.bind)(signal, {
            type: 'abort',
            listener: onAbort,
            options: {
                once: true
            }
        }) : ()=>{};
        const cleanup = ()=>{
            unbindOnline();
            unbindAbort();
        };
    });
};
const $e1432663f5f143d6$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, jitter: jitter = false, minDelay: minDelay = 500, pauseWhileOffline: pauseWhileOffline = false, postOnlineDelay: postOnlineDelay = 0, errorFilter: errorFilter, signal: signal, onRetry: onRetry })=>{
    // Mutable counter shared across recursive calls so that resetRetries() can
    // reset it from within fn() without needing to re-enter the call stack.
    const counter = {
        retryCount: retryCount,
        delay: delay
    };
    const resetRetries = ()=>{
        counter.retryCount = 0;
        counter.delay = delay;
    };
    const attempt = async ()=>{
        try {
            return await fn(resetRetries);
        } catch (error) {
            if (errorFilter && !errorFilter(error)) throw error;
            if (counter.retryCount >= maxRetries) throw error;
            onRetry?.(counter.retryCount + 1, error);
            if (pauseWhileOffline) {
                const recoveredFromOffline = await $e1432663f5f143d6$var$waitForOnline(signal);
                if (recoveredFromOffline && postOnlineDelay > 0) await $e1432663f5f143d6$var$abortableSleep(postOnlineDelay, signal);
            }
            const effectiveDelay = typeof jitter === 'number' ? counter.delay + Math.random() * jitter : jitter ? Math.max(minDelay, Math.random() * counter.delay) : counter.delay;
            await $e1432663f5f143d6$var$abortableSleep(effectiveDelay, signal);
            counter.delay *= 2;
            counter.retryCount += 1;
            return attempt();
        }
    };
    return attempt();
};



var $hwHCO = parcelRequire("hwHCO");


var $bQxqB = parcelRequire("bQxqB");







const $7ccd7e68e8d56362$export$886a0387c1c465f5 = (error)=>{
    if (!error) return false;
    // Server-sent error chunks are wrapped as StreamErrorException and should be excluded
    if (error instanceof (0, $hwHCO.StreamErrorException)) return false;
    // Any ApiError (or object exposing errorAttributes.statusCode) comes from the HTTP layer, so exclude
    if (error instanceof (0, $8A2GO.ApiError) || error?.errorAttributes?.statusCode) return false;
    const message = error?.message;
    // When the backend terminates the stream abruptly we get a JSON parsing error, so we treat it as server-side
    // See onversation-assistant-service/src/services/assistance-service/read-json-stream/index.ts
    if (typeof message === 'string' && message.startsWith('Error Processing Stream Data')) return false;
    // Whatever remains is considered a client/network error
    return true;
};


const $0be159bbeccab38a$export$4eef7b24ec94bbe8 = (error)=>{
    if (error instanceof Error && error.name === 'AbortError') return false;
    // StreamGeneratorError wraps the original error as `cause` — check the underlying error
    if (error instanceof (0, $bQxqB.StreamGeneratorError)) return (0, $7ccd7e68e8d56362$export$886a0387c1c465f5)(error.cause ?? error);
    return (0, $7ccd7e68e8d56362$export$886a0387c1c465f5)(error);
};


const $bcd5e69edf2194aa$var$MAX_RECONNECT_ATTEMPTS = 5;
const $bcd5e69edf2194aa$var$RETRY_BASE_DELAY_MS = 1000;
const $bcd5e69edf2194aa$var$RECONNECT_JITTER_MS = 500;
const $bcd5e69edf2194aa$var$POST_ONLINE_DELAY_MS = 2000;
async function* $bcd5e69edf2194aa$export$a802bb7fa59dba39({ initialGenerator: initialGenerator, canReconnect: canReconnect, getReconnectGenerator: getReconnectGenerator, getEventId: getEventId, onBeforeFirstReconnect: onBeforeFirstReconnect, onReconnecting: onReconnecting, onReconnected: onReconnected, onFirstChunkAfterReconnect: onFirstChunkAfterReconnect, onStreamCompleted: onStreamCompleted, onStreamFailed: onStreamFailed, completion: completion, signal: signal, maxAttempts: maxAttempts = $bcd5e69edf2194aa$var$MAX_RECONNECT_ATTEMPTS, shouldContinueRetrying: shouldContinueRetrying, onReconnectFailure: onReconnectFailure }) {
    let currentGenerator = initialGenerator;
    let lastEventId;
    let reconnectCount = 0;
    let reconnectionAttempted = false;
    let awaitingFirstChunkAfterReconnect = false;
    const reliableContracts = (0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts');
    let settled = false;
    const preserveCompleted = (0, $iDrrr.fg)('rovo_chat_preserve_completed_response');
    const recoverAfterReconnectFailure = async (streamError, reconnectError, isStreamReadError = false, failureMode = 'reconnectUnsupported')=>{
        if (preserveCompleted && isStreamReadError && !signal?.aborted && (0, $0be159bbeccab38a$export$4eef7b24ec94bbe8)(streamError) && completion?.isProcessed()) {
            // Resume first so guard redactions and other post-final events can replay.
            // Only retain the answer once resume is unavailable or has failed.
            completion.onRecoveryExhausted({
                error: reconnectError ?? streamError,
                failureMode: failureMode,
                reconnectAttempts: reconnectCount
            });
            // Keeping an answer is not a successful reconnect. The completion callback
            // settles that experience separately from normal stream completion.
            settled = true;
            return true;
        }
        const recovered = await onReconnectFailure?.({
            streamError: streamError,
            reconnectError: reconnectError
        }) ?? false;
        if (recovered && reconnectionAttempted) {
            settled = true;
            onStreamCompleted?.();
        }
        return recovered;
    };
    try {
        while(true){
            let isReadingStream = true;
            try {
                for await (const chunk of currentGenerator){
                    isReadingStream = false;
                    if (signal?.aborted) return;
                    const eventId = getEventId(chunk);
                    if (eventId) lastEventId = eventId;
                    if (awaitingFirstChunkAfterReconnect) {
                        awaitingFirstChunkAfterReconnect = false;
                        onFirstChunkAfterReconnect?.();
                    }
                    yield chunk;
                    isReadingStream = true;
                }
                isReadingStream = false;
                if (reconnectionAttempted) {
                    if (reliableContracts && signal?.aborted) return;
                    settled = true;
                    onStreamCompleted?.();
                }
                return;
            } catch (error) {
                if (reliableContracts && settled) throw error;
                if (error instanceof (0, $hwHCO.StreamErrorException)) {
                    if (reconnectionAttempted && !reliableContracts) onStreamFailed?.(error);
                    throw error;
                }
                if (preserveCompleted && isReadingStream && !signal?.aborted && (0, $0be159bbeccab38a$export$4eef7b24ec94bbe8)(error)) completion?.onReadError?.({
                    error: error,
                    reconnectAttempts: reconnectCount
                });
                if (!(0, $0be159bbeccab38a$export$4eef7b24ec94bbe8)(error) || !canReconnect() || reconnectCount >= maxAttempts || signal?.aborted) {
                    if (await recoverAfterReconnectFailure(error, undefined, isReadingStream, reconnectCount >= maxAttempts ? 'budgetExhausted' : 'reconnectUnsupported')) return;
                    if (reconnectionAttempted && !reliableContracts) onStreamFailed?.(error);
                    throw error;
                }
                if (shouldContinueRetrying && !shouldContinueRetrying()) {
                    if (reconnectionAttempted && !reliableContracts) onStreamFailed?.(error);
                    throw error;
                }
                if (!reconnectionAttempted) {
                    onBeforeFirstReconnect?.({
                        streamError: error
                    });
                    reconnectionAttempted = true;
                }
                reconnectCount++;
                onReconnecting?.(reconnectCount, maxAttempts, lastEventId);
                try {
                    currentGenerator = await (0, $e1432663f5f143d6$export$4dfcad98182a1ece)({
                        fn: async ()=>getReconnectGenerator(lastEventId),
                        maxRetries: 2,
                        delay: $bcd5e69edf2194aa$var$RETRY_BASE_DELAY_MS,
                        jitter: $bcd5e69edf2194aa$var$RECONNECT_JITTER_MS,
                        pauseWhileOffline: true,
                        postOnlineDelay: $bcd5e69edf2194aa$var$POST_ONLINE_DELAY_MS,
                        errorFilter: (0, $0be159bbeccab38a$export$4eef7b24ec94bbe8),
                        signal: signal
                    });
                } catch (reconnectError) {
                    if (await recoverAfterReconnectFailure(error, reconnectError, isReadingStream, 'acquireFailed')) return;
                    throw reconnectError;
                }
                onReconnected?.();
                awaitingFirstChunkAfterReconnect = true;
            }
        }
    } catch (error) {
        // Includes failures acquiring a replacement generator, not only failures
        // while reading it. A started reconnect experience must settle exactly once.
        if (reliableContracts && reconnectionAttempted && !settled) {
            settled = true;
            onStreamFailed?.(error);
        }
        throw error;
    } finally{
        if (reliableContracts && reconnectionAttempted && !settled) {
            settled = true;
            onStreamFailed?.(signal?.reason ?? new DOMException('Stream consumer stopped', 'AbortError'));
        }
    }
}



var $iDdTC = parcelRequire("iDdTC");

const $2dbdac089e2a67e6$export$72bdd99dfc759d06 = (baseName, { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isRovoCustomAgent: isRovoCustomAgent })=>{
    if (isRovoCustomAgent) return `${baseName}.rovo-custom-agent`;
    if (deepResearchEnabled) return `${baseName}.deep-research`;
    if (thinkDeeperEnabled) return `${baseName}.think-deeper`;
    return baseName;
};


// Reconnection metrics
const $91c3421ad4d4e45f$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY = 'ai-mate.reconnect.time-to-connect-to-stream';
const $91c3421ad4d4e45f$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY = 'ai-mate.reconnect.time-to-first-chunk-received';
const $91c3421ad4d4e45f$export$924cdb4a6542ccd = {
    createTimeToConnectToStreamMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $2dbdac089e2a67e6$export$72bdd99dfc759d06)($91c3421ad4d4e45f$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY, params)
        });
    },
    createTimeToResumeStreamMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $2dbdac089e2a67e6$export$72bdd99dfc759d06)($91c3421ad4d4e45f$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY, params)
        });
    }
};


const $a7542f0d9855c517$export$4f5dbc9d3a9c9f98 = (params)=>{
    const timeToConnectToStreamMetrics = (0, $91c3421ad4d4e45f$export$924cdb4a6542ccd).createTimeToConnectToStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    const timeToResumeStreamMetrics = (0, $91c3421ad4d4e45f$export$924cdb4a6542ccd).createTimeToResumeStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    return {
        timeToConnectToStreamMetrics: timeToConnectToStreamMetrics,
        timeToResumeStreamMetrics: timeToResumeStreamMetrics
    };
};



var $kncFb = parcelRequire("kncFb");











var $gYfOr = parcelRequire("gYfOr");

/**
 * Actions whose content id is reported as `objectId` on message-level analytics events. Pages are
 * not listed because the editor plugin already reports `objectId` on its own `aiResult viewed`.
 */ const $20c23c34bf500923$var$OBJECT_ID_ACTION_KEYS = new Set([
    (0, $aYC8J.CONFLUENCE_AIFC_DATABASE_CREATE_KEY),
    (0, $aYC8J.CONFLUENCE_AIFC_DATABASE_UPDATE_KEY)
]);
const $20c23c34bf500923$export$d1543b5c7d96e050 = (actions)=>{
    const objectActions = actions?.filter((action)=>$20c23c34bf500923$var$OBJECT_ID_ACTION_KEYS.has(action.key)) ?? [];
    if (objectActions.length !== 1) return undefined;
    return (0, $gYfOr.getActionContentId)(objectActions[0]) || undefined;
};



var $8HiCX = parcelRequire("8HiCX");

const $448c18b127d2b815$export$ed5572b558d71438 = (ari)=>{
    if (!ari) return null;
    // see go/ari for possible values
    // Example:
    // ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
    // -> amplitude
    const ariParts = ari.split(':');
    if (ariParts.length < 3) return null;
    return ariParts[2];
};


const $9e2a091fd8de78fd$export$9de2c1973de15b05 = (sources)=>{
    if (!sources) return {};
    const citedProductList = {};
    sources.forEach((source)=>{
        const productName = (0, $448c18b127d2b815$export$ed5572b558d71438)(source.ari);
        if (productName) citedProductList[productName] = (citedProductList[productName] ?? 0) + 1;
    });
    return citedProductList;
};


const $748301a6da4ec55d$export$66fc5003b23b7a8c = (sources)=>{
    if (!sources) return {};
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};


const $e592fdf33e58fb71$var$serviceDeskSourceRegex = /https:\/\/[a-zA-Z0-9_.-]+\/servicedesk\/customer\//g;
const $e592fdf33e58fb71$export$b9ac6250c4aba7c6 = (pluginOutput)=>{
    return $e592fdf33e58fb71$var$serviceDeskSourceRegex.test(pluginOutput);
};



var $4eyID = parcelRequire("4eyID");




const $dc46cb9d819f569e$export$a0e3245ee56765fd = ({ messageActionKey: messageActionKey, messageActionData: messageActionData })=>{
    // WARNING: Changing the logic here can affect AIFC MAU and other AI metrics.
    // Please consult with the Create with Rovo team before making any changes.
    if (!messageActionKey) return undefined;
    if ((0, $aYC8J.isDynamicUiCreatableAction)({
        key: messageActionKey
    }) || (0, $aYC8J.isImageCreatableAction)({
        key: messageActionKey
    }) || (0, $aYC8J.isRemixGeneratedAction)(messageActionData)) return 'remix';
    if ((0, $aYC8J.isConfluenceCreatableAction)({
        key: messageActionKey
    })) // TODO All creatable actions should be as AIFC MAU here,
    // but we are temporarily changing this to Confluence only due to HOT-122605
    return 'AIFC';
    else if ((0, $aYC8J.isConfluencePageUpdateAction)({
        key: messageActionKey
    })) return 'Editor AI';
    else if ((0, $aYC8J.isConfluenceWhiteboardUpdateAction)({
        key: messageActionKey
    })) return 'Whiteboard AI';
    else if ((0, $aYC8J.isConfluenceSlidesUpdateAction)({
        key: messageActionKey
    })) return 'Slide AI';
    else if ((0, $aYC8J.isConfluenceDatabaseUpdateAction)({
        key: messageActionKey
    })) return 'Database AI';
    return undefined;
};


/**
 * Derives non-UGC authority attributes from the response's authority_ui_metadata.
 * Only counts, booleans, and the coarse level/confidence are emitted — never
 * source titles, expert names, URLs, or reasoning text. Gated on the
 * authoritative-answer feature flag.
 */ const $577cc8ea0ec76152$var$extractAuthorityMeta = (response)=>{
    if (!(0, $iDrrr.fg)('rovo_authoritative_answer_attribution')) return {
        hasAuthoritativeSources: false
    };
    const message = response.message?.message;
    // Top level for streaming responses; nested under message_metadata for history.
    const authorityUiMetadata = message?.authority_ui_metadata ?? message?.message_metadata?.authority_ui_metadata;
    if (!authorityUiMetadata) return {
        hasAuthoritativeSources: false
    };
    return {
        hasAuthoritativeSources: true,
        authorityLevel: authorityUiMetadata.authorityLevel,
        isHighlyAuthoritative: authorityUiMetadata.isHighlyAuthoritative ?? authorityUiMetadata.highlyAuthoritative ?? false,
        overallConfidence: authorityUiMetadata.overallConfidence,
        authoritativeSourceCount: authorityUiMetadata.sources?.length ?? 0,
        authoritativeExpertCount: authorityUiMetadata.domainExperts?.length ?? 0
    };
};
const $577cc8ea0ec76152$export$2244b7838be162ca = (response, skillSelectionSource, includeDynamicUIData)=>{
    const sources = response.message?.message?.sources;
    const pluginInvocations = response.message?.message?.plugin_invocations;
    const minionOutputs = response.message?.message?.minion_outputs;
    const actions = response.message?.message?.actions;
    const humanMessageId = response.message?.human_message?.id.toString();
    const pluginsInvoked = [];
    const skillsInvoked = [];
    let usesJsm = false;
    pluginInvocations?.forEach((pi)=>{
        if (pi.plugin_name) pluginsInvoked.push(pi.plugin_name);
        if (pi.plugin_output && (0, $e592fdf33e58fb71$export$b9ac6250c4aba7c6)(pi.plugin_output)) usesJsm = true;
    });
    const flatMinionOutputs = minionOutputs?.flat() ?? [];
    const executedStratusSkill = flatMinionOutputs.some((output)=>output.skill_type === 'STRATUS') ?? false;
    flatMinionOutputs.forEach((output)=>{
        pluginsInvoked.push(output.minion_id);
        const isExplicit = output.directly_invoked;
        skillsInvoked.push({
            minionId: output.minion_id,
            skillName: output.skill_alias,
            skillType: output.skill_type,
            invocationType: isExplicit ? 'explicit' : 'implicit',
            internalTools: output.internal_tools?.map((tool)=>({
                    name: tool.name,
                    isConsequential: tool.is_consequential
                })) ?? [],
            skillSelectionSource: isExplicit ? skillSelectionSource : undefined
        });
        if (output.minion_output && (0, $e592fdf33e58fb71$export$b9ac6250c4aba7c6)(output.minion_output)) usesJsm = true;
    });
    const requestId = response.metadata?.request_id ?? response.message?.message?.message_metadata?.requestId;
    return {
        ...(0, $iDrrr.fg)('aifc_request_id_analytics') && requestId ? {
            requestId: requestId
        } : {},
        humanMessageId: humanMessageId,
        citedProductList: (0, $9e2a091fd8de78fd$export$9de2c1973de15b05)(sources),
        connectorInfo: (0, $iDrrr.fg)('rovo_chat_connector_info_analytics') ? (0, $4eyID.extractConnectorInfo)(sources) : undefined,
        sourceProducts: (0, $748301a6da4ec55d$export$66fc5003b23b7a8c)(sources),
        ...(0, $0Z0Rs.getPeopleDataProviderAttributes)((0, $0Z0Rs.getPeopleDataProviders)(response.message?.message?.message_metadata?.people_data_providers)),
        hasSources: !!sources?.length,
        ...$577cc8ea0ec76152$var$extractAuthorityMeta(response),
        pluginsInvoked: pluginsInvoked,
        skillsInvoked: skillsInvoked,
        executedStratusSkill: executedStratusSkill,
        messageActions: actions?.map((action)=>action.key),
        messageDynamicUIData: includeDynamicUIData ? actions?.map((action)=>({
                dynamicUiType: action.data?.contentType,
                dynamicUiSubtype: action.data?.dynamicUiSubtype
            })) : undefined,
        invokedFrom: (0, $dc46cb9d819f569e$export$a0e3245ee56765fd)({
            messageActionKey: actions?.[0]?.key,
            messageActionData: actions?.[0]?.data
        }),
        visualBlockCounts: (0, $8HiCX.getMessageVisualBlockCounts)(actions),
        actionObjectId: (0, $20c23c34bf500923$export$d1543b5c7d96e050)(actions),
        responseSources: sources?.map((x)=>x.ari).filter(Boolean),
        usesJsm: usesJsm,
        scenarioId: response.message?.message?.scenario?.id,
        interactionModeExecuted: response.message?.message?.message_metadata?.interaction_mode_executed,
        agentExternalConfigReference: response.message?.message?.author?.external_config_reference ?? response.message?.message?.author?.named_id
    };
};



var $4BHwn = parcelRequire("4BHwn");




const $411a747b8da7f11a$export$2f438a4a7bbfabc = (interactionModeRequested)=>interactionModeRequested ? {
        interactionModeRequested: interactionModeRequested
    } : {};











const $7649098210feaae7$export$1864f06982795aa4 = (error, acquisitionError)=>{
    if (error instanceof (0, $hwHCO.StreamErrorException)) return error.detail.type === 'ERROR' && error.detail.message.status_code === 404 && error.detail.message.content.trim() === 'Message not found';
    // A required action or handler may also throw FetchError. Only accept the exact
    // failure recorded at the reconnect acquisition boundary, including its reader wrapper.
    const cause = error instanceof (0, $bQxqB.StreamGeneratorError) ? error.cause : error;
    return cause === acquisitionError && acquisitionError instanceof (0, $jTKfH.FetchError) && acquisitionError.errorAttributes.statusCode === 404;
};





const $faea2b1b99af6c44$export$5fdfb2e15ed7708a = async ({ conversationId: conversationId, messageId: messageId, getChat: getChat, capabilities: capabilities, isCurrent: isCurrent })=>{
    if (!isCurrent()) return {
        outcome: 'superseded'
    };
    let history;
    try {
        history = await getChat(conversationId, capabilities);
    } catch  {
        return {
            outcome: isCurrent() ? 'lookupFailed' : 'superseded'
        };
    }
    if (!isCurrent()) return {
        outcome: 'superseded'
    };
    const response = history.find((message)=>(0, $bxkJA.isStreamResponse)(message) && message.message.message.id === messageId);
    if (!response) return {
        outcome: 'missing'
    };
    switch(response.message.message.async_status){
        case 'SUCCESSFUL':
            return {
                outcome: 'recovered',
                response: response
            };
        case 'IN_PROGRESS':
            return {
                outcome: 'inProgress'
            };
        case 'FAILED':
            return {
                outcome: 'failed'
            };
        case 'CANCELLED':
            return {
                outcome: 'cancelled'
            };
        default:
            return {
                outcome: 'unknownState'
            };
    }
};





const $112200485e4c7f0b$export$680d2bb5b9579c57 = (chat)=>chat.map((message)=>{
        if ((0, $igOtY.isStoreAssistant)(message) && !message.content.streamingComplete) return {
            ...message,
            content: {
                ...message.content,
                streamingComplete: true
            },
            // Clear answerNowStatus when streaming completes (success, error, or abort)
            answerNowStatus: undefined
        };
        return message;
    });





















var $foVqg = parcelRequire("foVqg");







const $39d5e6d7f285ca24$export$bac56f3fc527f04b = (min, max)=>{
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
};



var $bkEBw = parcelRequire("bkEBw");
















const $dba47434e0afdee5$export$df3bbc746f48d870 = ({ chat: chat, messageId: messageId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>{
    // If the chat is empty, return it as is - prevents the 'in' of 'undefined' errors we were seeing
    // TODO: Take this into account with upcoming refactor
    if (!chat.length) return chat;
    const targetIndex = useIndex || (0, $4BHwn.findStoreMessageIndex)(chat, messageId);
    const targetStoreMessage = chat[targetIndex];
    if (targetIndex < 0 || !(0, $igOtY.isStoreMessage)(targetStoreMessage)) throw new Error(`Attempting to update a non StoreMessage (${updateType})`);
    if ((0, $fjUOt.getStoreMessageId)(targetStoreMessage) !== messageId) throw new Error(`Attempting to update a store message at the wrong index (${updateType})`);
    const newStoreMessage = updateFunction(targetStoreMessage);
    const newChat = [
        ...chat
    ];
    newChat.splice(targetIndex, 1, newStoreMessage);
    return newChat;
};


const $746b4e9283597e00$export$b59f7aedf84d58f7 = ({ chat: chat, promptId: promptId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>(0, $dba47434e0afdee5$export$df3bbc746f48d870)({
        chat: chat,
        messageId: promptId,
        updateFunction: (storeMessage)=>{
            if (!(0, $igOtY.isStoreAssistant)(storeMessage)) throw new Error(`Attempting to update a non StoreAssistant (${updateType})`);
            return updateFunction(storeMessage);
        },
        updateType: updateType,
        useIndex: useIndex
    });


const $ce5a795e167dd10b$export$13b6a4e4e3704011 = ({ chat: chat, messageId: messageId, actionPart: actionPart, useIndex: useIndex, actionUpdaterOverride: actionUpdaterOverride })=>{
    const findMessage = chat.findIndex((message)=>(0, $igOtY.isStoreAssistant)(message) && (0, $bkEBw.getId)(message.content) === messageId);
    const actionIndex = findMessage > 0 ? findMessage : chat.length - 1;
    const index = useIndex || actionIndex;
    return (0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: messageId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addActionPart)(storeAssistant.content, actionPart, actionUpdaterOverride)
                }
            }),
        updateType: 'Add Action Part',
        useIndex: index
    });
};






const $72779d19b192aa52$export$6e5609c05ab74cc7 = ({ chat: chat, answerId: answerId, answerPart: answerPart, useIndex: useIndex })=>(0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                }
            }),
        updateType: 'Add Answer Part',
        useIndex: useIndex
    });






const $ccf4709cceff6c1f$export$679615d953ba31c3 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, extraMarkdownData: extraMarkdownData, useIndex: useIndex })=>{
    return (0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>{
            const updatedMarkdownData = Object.entries(markdownData).reduce((acc, [key, { content: content, loading: loading }])=>{
                const loadingKey = `${key}-loading`;
                return {
                    ...acc,
                    [key]: (acc[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                };
            }, {
                ...storeAssistant.markdownData
            });
            return {
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: extraMarkdownData ? {
                    ...updatedMarkdownData,
                    ...extraMarkdownData
                } : updatedMarkdownData
            };
        },
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};





const $74367cc14df82300$export$8567b8b6b4d41b2f = (state, conversationId)=>state.conversations[conversationId]?.traces ?? [];


const $4cfff63bf4f4d4b6$export$d30a5acf6cceb893 = (getState, conversationId, updateCurrentConversation)=>{
    const currentTraces = (0, $74367cc14df82300$export$8567b8b6b4d41b2f)(getState(), conversationId);
    if (currentTraces.length > 0) updateCurrentConversation({
        traces: []
    });
};


const $e7b2fbfd93ff35fe$export$7c9d8a35c0d35149 = ({ conversationId: conversationId, messageId: messageId, redactedResponse: redactedResponse, getMessages: getMessages, setMessages: setMessages, getState: getState, updateCurrentConversation: updateCurrentConversation })=>{
    const chat = getMessages(conversationId) ?? [];
    // Prefer the assistant message that matches the redacted messageId; otherwise
    // fall back to the most recent assistant message (the current turn).
    let targetIdx = -1;
    for(let i = 0; i < chat.length; i++){
        const message = chat[i];
        if ((0, $igOtY.isStoreAssistant)(message)) {
            if (message.content?.message?.message?.id === messageId) {
                targetIdx = i;
                break;
            }
            targetIdx = i;
        }
    }
    if (targetIdx >= 0) {
        const target = chat[targetIdx];
        if ((0, $igOtY.isStoreAssistant)(target)) {
            const existingInnerMessage = target.content?.message?.message;
            const newChat = [
                ...chat
            ];
            newChat[targetIdx] = {
                ...target,
                redactedResponse: redactedResponse,
                content: {
                    ...target.content,
                    streamingComplete: true,
                    message: {
                        ...target.content.message,
                        message: {
                            ...existingInnerMessage ?? {},
                            content: ''
                        }
                    }
                }
            };
            setMessages(conversationId, newChat);
        }
    }
    // Drop any live "thinking" traces that streamed before the redacted response.
    (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
};




var $awqa1 = parcelRequire("awqa1");

const $f5f4d30a252f1f45$export$2104d43a09d33c2 = (streamMessage)=>({
        type: 'ERROR',
        message: streamMessage.message,
        millisOffset: streamMessage.millisOffset ?? 0,
        metadata: streamMessage.metadata ? {
            request_id: streamMessage.metadata.request_id
        } : null
    });



var $l5TuZ = parcelRequire("l5TuZ");


var $f3OgL = parcelRequire("f3OgL");





var $6Bfyn = parcelRequire("6Bfyn");


var $4vH8u = parcelRequire("4vH8u");

// PERMANENT: shared by legacy `◐…◑` streaming and typed Answer UI parts, so it stays when
// legacy marker parsing is removed. Slot N (`lumina-N`) belongs to the Nth `[^lumina^]`
// placeholder in the answer text.
const $57dd585bc16302d8$export$db72bf56b242e316 = 'lumina';
const $57dd585bc16302d8$export$92e3747dfa4143de = `\n\n[^${$57dd585bc16302d8$export$db72bf56b242e316}^]\n\n`;


const $bcd61a1d71eeba44$export$c37d58cb6fcaff84 = ()=>[
        {
            key: 'expand',
            startTag: "\u259E",
            endTag: "\u259A",
            placeholderTag: '[^expand^]',
            isEnabled: true
        },
        {
            key: 'chart',
            startTag: "\u25F4",
            endTag: "\u25F6",
            placeholderTag: '[^chart^]',
            isEnabled: true
        },
        {
            // LEGACY-INLINE-LUMINA: streaming parse of `◐…◑` markers, replaced by typed Answer
            // UI parts. The placeholder and slot keys it writes are shared and stay.
            key: (0, $57dd585bc16302d8$export$db72bf56b242e316),
            startTag: "\u25D0",
            endTag: "\u25D1",
            placeholderTag: (0, $57dd585bc16302d8$export$92e3747dfa4143de),
            isEnabled: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')
        },
        {
            // Actionable follow-up questions: a single start marker with no end marker —
            // everything after `◈` to the end of the message is the follow-ups payload.
            // An empty endTag tells the parser to capture to end-of-message.
            key: (0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY),
            startTag: (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_MARKER),
            endTag: '',
            placeholderTag: `\n\n[^${(0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY)}^]\n\n`,
            isEnabled: true
        }
    ];


const $94689fb12cc6f471$export$95c0abd604a2cca2 = (options)=>{
    // handles multiple tags in a single chunk (e.g. close tag + new open tag)
    // Returns markdownData as a MarkdownDataMap (keyed by component instance).
    const processor = (0, $f3OgL.createMarkdownProcessorMultiTags)((0, $bcd61a1d71eeba44$export$c37d58cb6fcaff84));
    // Optional <details>/<summary> rewriter that runs upstream of the
    // multi-tag extractor so the existing `▞…▚` boundary-driven `expand`
    // component picks them up. See createStreamMarkdownProcessor.
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $l5TuZ.createDetailsPreprocessor)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData
        };
    };
};















var $7crhj = parcelRequire("7crhj");

const $0a8e95b4b53343a1$var$readWrappedSurfaceId = (value)=>{
    if (value && typeof value === 'object') {
        const { surfaceId: surfaceId } = value;
        if (typeof surfaceId === 'string') return surfaceId;
    }
    return undefined;
};
const $0a8e95b4b53343a1$export$f05e22a6badb9277 = (a2uiMessage)=>{
    const wire = a2uiMessage;
    return $0a8e95b4b53343a1$var$readWrappedSurfaceId(wire.createSurface) ?? $0a8e95b4b53343a1$var$readWrappedSurfaceId(wire.updateComponents) ?? $0a8e95b4b53343a1$var$readWrappedSurfaceId(wire.updateDataModel) ?? $0a8e95b4b53343a1$var$readWrappedSurfaceId(wire.deleteSurface) ?? $0a8e95b4b53343a1$var$readWrappedSurfaceId(wire.surfaceUpdate) ?? $0a8e95b4b53343a1$var$readWrappedSurfaceId(wire.beginRendering) ?? (typeof wire.surfaceId === 'string' ? wire.surfaceId : undefined);
};


const $11b165b4e8e31cc9$var$A2UI_ACTION_MIME_TYPE = 'application/json+a2ui';
/** A HUMAN row whose content is an A2UI surface interaction, not a typed prompt. */ const $11b165b4e8e31cc9$var$isHumanA2UIActionRow = (message)=>{
    const content = message.content.content;
    return typeof content === 'object' && content !== null && content.data_parts_mime_type === $11b165b4e8e31cc9$var$A2UI_ACTION_MIME_TYPE;
};
const $11b165b4e8e31cc9$export$15cd60ec7967aece = (messages)=>{
    let activeSurfaceId;
    let activeAnchorId;
    let roundCreatedSurfaceId;
    let roundCreatedAnchorId;
    for (const message of messages){
        if (!(0, $igOtY.isStoreMessage)(message)) continue;
        if ((0, $igOtY.isStoreHuman)(message) && !$11b165b4e8e31cc9$var$isHumanA2UIActionRow(message)) {
            activeSurfaceId = undefined;
            activeAnchorId = undefined;
            roundCreatedSurfaceId = undefined;
            roundCreatedAnchorId = undefined;
            continue;
        }
        if (!(0, $igOtY.isStoreAssistant)(message)) continue;
        const messageId = (0, $fjUOt.getStoreMessageId)(message);
        for (const a2uiMessage of message.agenticUiMessages ?? []){
            if (!(0, $7crhj.isCreateSurface)(a2uiMessage)) continue;
            const surfaceId = (0, $0a8e95b4b53343a1$export$f05e22a6badb9277)(a2uiMessage);
            if (!surfaceId || surfaceId === roundCreatedSurfaceId || surfaceId === activeSurfaceId) continue;
            activeSurfaceId = roundCreatedSurfaceId;
            activeAnchorId = roundCreatedAnchorId;
            roundCreatedSurfaceId = surfaceId;
            roundCreatedAnchorId = messageId;
        }
    }
    const addressable = new Map();
    if (activeSurfaceId !== undefined && activeAnchorId !== undefined) addressable.set(activeSurfaceId, activeAnchorId);
    if (roundCreatedSurfaceId !== undefined && roundCreatedAnchorId !== undefined) addressable.set(roundCreatedSurfaceId, roundCreatedAnchorId);
    return addressable;
};



var $kNXXO = parcelRequire("kNXXO");








var $9vNm5 = parcelRequire("9vNm5");








const $7e78f67f943224e0$export$ed23852026f99b3a = (conversationId, messageId, getMessages, setMessages)=>{
    const currentMessages = getMessages(conversationId);
    const assistantMessage = currentMessages.find((msg)=>(0, $igOtY.isStoreAssistant)(msg) && (0, $fjUOt.getStoreMessageId)(msg) === messageId);
    if (assistantMessage && 'answerNowStatus' in assistantMessage && assistantMessage.answerNowStatus) setMessages(conversationId, (0, $a9c77291ad58ec01$export$14aeb537f795ee1a)(currentMessages, messageId, undefined));
};









const $02ab0ae749d3147d$export$92521734d156d091 = ({ messages: messages, streamMessage: streamMessage, assistantMessageId: assistantMessageId })=>{
    const id = streamMessage.metadata?.request_id ?? (streamMessage.sequence_id === undefined ? assistantMessageId : String(streamMessage.sequence_id));
    const creditDenial = {
        type: 'CREDIT_DENIAL',
        id: id,
        denial: streamMessage.denial
    };
    const messagesWithoutPendingAssistant = messages.filter((message)=>!(0, $igOtY.isStoreAssistant)(message) || (0, $fjUOt.getStoreMessageId)(message) !== assistantMessageId || message.content.message.message.content !== '');
    let currentTurnStartIndex = 0;
    for(let index = messagesWithoutPendingAssistant.length - 1; index >= 0; index--)if ((0, $igOtY.isStoreHuman)(messagesWithoutPendingAssistant[index])) {
        currentTurnStartIndex = index + 1;
        break;
    }
    const isDuplicate = messagesWithoutPendingAssistant.slice(currentTurnStartIndex).some((0, $igOtY.isStoreCreditDenial));
    return {
        messages: isDuplicate ? messagesWithoutPendingAssistant : [
            ...messagesWithoutPendingAssistant,
            creditDenial
        ],
        creditDenial: creditDenial,
        isDuplicate: isDuplicate
    };
};


const $18fb7f621464707a$export$fea28b9fcd5e3261 = ({ conversationId: conversationId, assistantMessageId: assistantMessageId, streamMessage: streamMessage, getState: getState, getMessages: getMessages, setMessages: setMessages, updateCurrentConversation: updateCurrentConversation, reportCreditDenial: reportCreditDenial, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    reportCreditDenial?.(streamMessage.denial);
    (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
    (0, $7e78f67f943224e0$export$ed23852026f99b3a)(conversationId, assistantMessageId, getMessages, setMessages);
    const result = (0, $02ab0ae749d3147d$export$92521734d156d091)({
        messages: getMessages(conversationId),
        streamMessage: streamMessage,
        assistantMessageId: assistantMessageId
    });
    setMessages(conversationId, result.messages);
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'received',
        actionSubject: 'aiCreditDenied',
        attributes: {
            scope: result.creditDenial.denial.scope,
            hasResetDate: result.creditDenial.denial.resetsAt != null,
            hasRequestMethod: result.creditDenial.denial.requestMethod != null,
            isDuplicate: result.isDuplicate
        }
    });
    (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'blocked');
};





const $ae4252d226847c94$export$cd9676874af9cd5a = (event, processedMessageId)=>{
    const message = (0, $bxkJA.isSSEMessage)(event) ? event.data : event;
    if ((0, $bxkJA.isStreamHeartbeat)(message) || (0, $bxkJA.isStreamAgenticUi)(event) || (0, $bxkJA.isStreamMemoryUpdate)(message)) return false;
    if ((0, $bxkJA.isConversationChannelDataMessage)(message)) return !processedMessageId || message.assistant_message_id !== processedMessageId;
    switch(message.type){
        case 'RESPONSE_REDACTION':
        case 'RESPONSE_BLOCKED':
        case 'ATTACHMENT_BLOCKED':
        case 'FOLLOW_UP_QUERIES':
        case 'ENTITY_ANNOTATIONS':
        case 'RECONNECT_SUPPORTED':
        case 'SPACE_SOURCE_RECOMMENDATIONS':
        case 'CONVERSATION_TITLE_UPDATED':
        case 'TASK_STATUS':
        case 'INTERACTION_CONCLUSION':
            return false;
        default:
            // Includes reasoning/research, another final response, and future event types.
            return true;
    }
};





const $56f85829c4193d6c$export$988e829359718a09 = (streamMessage)=>{
    if (typeof streamMessage !== 'object' || streamMessage === null || !('type' in streamMessage) || streamMessage.type !== 'AUTO_ACTION_APPROVAL') return {
        kind: 'not-auto-action-approval'
    };
    if (!(0, $bxkJA.isStreamAutoActionApproval)(streamMessage)) return {
        kind: 'malformed'
    };
    const { message: message, millisOffset: millisOffset } = streamMessage;
    const isFallback = message.status === 'AUTO_APPROVED_REQUIRES_HUMAN' || message.status === 'REQUIRES_HUMAN';
    return {
        kind: 'valid',
        trace: {
            messageTemplate: 'AUTO_ACTION_APPROVAL',
            messageContent: message.content || message.action_display_name,
            status: message.status === 'REVIEWING' ? 'loading' : 'success'
        },
        analytics: {
            action: isFallback ? 'fallback' : 'received',
            attributes: {
                status: message.status,
                source: message.source,
                riskCategory: message.risk_category,
                policyVersion: message.policy_version,
                latencyMs: millisOffset
            }
        }
    };
};


const $5a900e4ea4c7ba13$export$2de2f38c3a454c55 = ({ streamMessage: streamMessage, conversationId: conversationId, existingTraces: existingTraces, updateTraces: updateTraces, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    const result = (0, $56f85829c4193d6c$export$988e829359718a09)(streamMessage);
    if (result.kind === 'not-auto-action-approval') return false;
    if (result.kind === 'malformed') {
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'errored',
            actionSubject: 'autoActionApproval',
            actionSubjectId: 'rovoChatAutoActionApprovalStream',
            attributes: {
                conversationChannelId: conversationId,
                messageType: 'AUTO_ACTION_APPROVAL'
            }
        });
        return true;
    }
    updateTraces([
        ...existingTraces,
        result.trace
    ]);
    sendAnalyticsEvent({
        eventType: 'track',
        action: result.analytics.action,
        actionSubject: 'autoActionApproval',
        actionSubjectId: 'rovoChatAutoActionApprovalStream',
        attributes: {
            conversationChannelId: conversationId,
            ...result.analytics.attributes
        }
    });
    return true;
};





const $58a7ad1d26ac260e$var$isConversationTitleUpdatedMessage = (message)=>typeof message === 'object' && message !== null && 'type' in message && message.type === 'CONVERSATION_TITLE_UPDATED' && 'conversation_id' in message && typeof message.conversation_id === 'string' && 'name' in message && typeof message.name === 'string';
const $58a7ad1d26ac260e$export$51720276ffc29c92 = (streamMessage, conversationId, updateConversation)=>{
    if (!$58a7ad1d26ac260e$var$isConversationTitleUpdatedMessage(streamMessage) || !(0, $iDrrr.fg)('rovo_chat_live_conversation_titles')) return false;
    const name = streamMessage.name.trim();
    if (streamMessage.conversation_id === conversationId && name) updateConversation({
        name: name
    });
    return true;
};












const $0a4010078ae41b46$var$extractInteractionConclusion = (streamObj, streamMessage, defaultTransport)=>{
    if (typeof streamObj === 'object' && streamObj !== null && 'eventType' in streamObj && streamObj.eventType === 'INTERACTION_CONCLUSION') {
        const data = 'data' in streamObj ? streamObj.data : undefined;
        const normalizedInteractionConclusion = typeof data === 'object' && data !== null ? {
            ...data,
            type: 'INTERACTION_CONCLUSION'
        } : data;
        return (0, $bxkJA.isStreamInteractionConclusion)(normalizedInteractionConclusion) ? {
            kind: 'valid',
            transport: 'sse',
            value: normalizedInteractionConclusion
        } : {
            kind: 'invalid'
        };
    }
    if (typeof streamMessage === 'object' && streamMessage !== null && 'type' in streamMessage && streamMessage.type === 'INTERACTION_CONCLUSION') return (0, $bxkJA.isStreamInteractionConclusion)(streamMessage) ? {
        kind: 'valid',
        transport: defaultTransport,
        value: streamMessage
    } : {
        kind: 'invalid'
    };
    return {
        kind: 'not-present'
    };
};
const $0a4010078ae41b46$export$c68838490373407b = ({ streamObj: streamObj, streamMessage: streamMessage, conversationId: conversationId, answerIndex: answerIndex, requestId: requestId, defaultTransport: defaultTransport = 'direct', getMessages: getMessages, setMessages: setMessages, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    const extraction = $0a4010078ae41b46$var$extractInteractionConclusion(streamObj, streamMessage, defaultTransport);
    if (extraction.kind === 'not-present') return;
    if (extraction.kind !== 'valid') return;
    const interactionConclusion = extraction.value;
    const currentMessages = getMessages(conversationId);
    const targetMessage = currentMessages[answerIndex];
    if (!targetMessage || !(0, $igOtY.isStoreAssistant)(targetMessage) || targetMessage.interactionConclusionOutcome === interactionConclusion.message.outcome) return;
    const targetMessageId = (0, $fjUOt.getStoreMessageId)(targetMessage);
    setMessages(conversationId, (0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: currentMessages,
        promptId: targetMessageId,
        updateFunction: (storeMessage)=>({
                ...storeMessage,
                interactionConclusionOutcome: interactionConclusion.message.outcome
            }),
        updateType: 'Update Interaction Conclusion Outcome',
        useIndex: answerIndex
    }));
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'received',
        actionSubject: 'interactionConclusionSignal',
        attributes: {
            conversationChannelId: conversationId,
            hasBackendMessageId: Boolean(interactionConclusion.metadata?.message_id),
            outcome: interactionConclusion.message.outcome,
            requestId: requestId ?? interactionConclusion.metadata?.request_id,
            transport: extraction.transport
        }
    });
};












const $b66867d306226491$export$9c657fdfae6b2020 = (messages, messageId)=>{
    const assistantMessage = messages.find((chatItem)=>(0, $igOtY.isStoreAssistant)(chatItem) && (0, $bkEBw.getId)(chatItem.content) === messageId);
    if (!assistantMessage) return '';
    const content = assistantMessage.content.message.message.content;
    return typeof content === 'string' ? content : '';
};


const $ec372ef5c573e842$var$TEAMWORK_GRAPH_RENDER_MODE = 'TEAMWORK_GRAPH';
const $ec372ef5c573e842$export$5a07e6227eed9665 = ({ streamMessage: streamMessage, tmpAssistantMessageId: tmpAssistantMessageId, conversationId: conversationId, deepResearchEnabled: deepResearchEnabled, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, researchState: researchState })=>{
    let deepResearchInvoked = false;
    let twgTrace;
    if ((0, $bxkJA.isStreamResearchStart)(streamMessage) && // The same message_template is used for thinking deeper + deep research
    // so we need to check the specific trace message to differentiate them
    streamMessage.message.content === 'Starting deep research execution') deepResearchInvoked = true;
    // Implicit round detection for think deeper:
    // When answer content has accumulated (from ANSWER_PART messages) and new
    // research step information arrives, we know a new round is starting.
    // We retroactively create a research plan for the completed round using
    // the accumulated answer content, clear the streamed content, and increment
    // the round counter so subsequent steps are grouped under the new round.
    if (researchState.hasAccumulatedAnswerContent && (0, $bxkJA.isStreamResearchPayload)(streamMessage)) {
        // Read the accumulated answer content from the assistant message
        const accumulatedContent = (0, $b66867d306226491$export$9c657fdfae6b2020)(getMessages(conversationId), tmpAssistantMessageId);
        // Create a research plan for the completed round with the accumulated content
        addImplicitResearchPlan({
            messageId: tmpAssistantMessageId,
            content: accumulatedContent,
            roundId: researchState.clientRoundCounter
        });
        // Increment round counter for the new incoming steps
        researchState.clientRoundCounter++;
        // Clear the assistant message content so the new round starts fresh
        const clearedMessages = (0, $c4abac6b845cca29$export$bb0ca99caffb8502)(getMessages(conversationId), tmpAssistantMessageId);
        setMessages(conversationId, clearedMessages);
        // Reset tracking flags
        researchState.hasAccumulatedAnswerContent = false;
        resetHasReceivedAnswerPart({
            messageId: tmpAssistantMessageId
        });
    }
    if ((0, $bxkJA.isStreamResearchPayload)(streamMessage) || (0, $bxkJA.isStreamResponse)(streamMessage) || (0, $bxkJA.isStreamAnswerPart)(streamMessage) || (0, $bxkJA.isStreamReasoningPart)(streamMessage) || (0, $bxkJA.isStreamSkill)(streamMessage) || (0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) {
        // When implicit rounds are active, override roundId on research step messages
        // so they are grouped under the current client-managed round
        if (researchState.clientRoundCounter > 0 && (0, $bxkJA.isStreamResearchPayload)(streamMessage) && 'message' in streamMessage && 'roundId' in streamMessage.message) streamMessage.message.roundId = researchState.clientRoundCounter;
        processStreamResearch({
            messageId: tmpAssistantMessageId,
            streamMessage: streamMessage,
            isDeepResearch: deepResearchEnabled ?? false
        });
    }
    if ((0, $bxkJA.isStreamResearchStepTitle)(streamMessage) && streamMessage.message.renderMode === $ec372ef5c573e842$var$TEAMWORK_GRAPH_RENDER_MODE) twgTrace = {
        stepId: streamMessage.message.stepId,
        roundId: streamMessage.message.roundId,
        toolName: streamMessage.message.toolName,
        renderMode: streamMessage.message.renderMode
    };
    if ((0, $bxkJA.isStreamResearchPlan)(streamMessage)) processStreamResearch({
        messageId: tmpAssistantMessageId,
        streamMessage: streamMessage,
        isDeepResearch: deepResearchEnabled ?? false
    });
    // Track that answer content has accumulated so implicit round detection
    // can detect a new round starting when the next research payload arrives
    if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) researchState.hasAccumulatedAnswerContent = true;
    return {
        deepResearchInvoked: deepResearchInvoked,
        twgTrace: twgTrace
    };
};









var $3iEfv = parcelRequire("3iEfv");


var $5XX4K = parcelRequire("5XX4K");


var $8bsmP = parcelRequire("8bsmP");


var $eK93A = parcelRequire("eK93A");

const $d8a5551aed11b46f$export$82b32799d0ea512c = ({ streamMessage: streamMessage, messageId: messageId, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    if ((0, $iDrrr.fg)('rovo_chat_action_render_analytics')) {
        const actions = streamMessage.message.message.actions ?? [];
        actions.forEach((action, actionIndex)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'rovoChatMessageAction',
                attributes: {
                    analyticsVersion: 2,
                    conversationId: conversationId,
                    messageId: streamMessage.message.message.id?.toString() ?? messageId,
                    invocationId: action.invocationId,
                    actionKey: action.key,
                    resolvedActionKey: (0, $dw75i.resolveActionKey)(action),
                    actionStatus: action.status,
                    actionIndex: actionIndex,
                    receivedActionCount: actions.length
                }
            });
        });
    }
    if ((0, $iDrrr.fg)('rovo_chat_history_lift')) {
        const normalizedPresentation = (0, $8bsmP.normalizeFinalizedMessagePresentation)({
            message: streamMessage,
            options: {
                shouldExtractA2UI: false,
                shouldExtractActionableFollowUps: true,
                shouldExtractDataSculptor: (0, $iDrrr.fg)('rovo_enable_data_sculptor'),
                shouldExtractInlineLumina: (0, $iDrrr.fg)('rovo_chat_enable_inline_lumina'),
                shouldExtractLegacyChartBoundaries: false,
                shouldPreprocessDetails: shouldPreprocessDetails
            }
        });
        if (normalizedPresentation.extractionCounts.expand > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'viewed',
            actionSubject: 'expandComponent',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                expandCount: normalizedPresentation.extractionCounts.expand,
                timestamp: new Date().toISOString(),
                isFinalResponse: true
            }
        });
        if (normalizedPresentation.extractionCounts.unicodeChart > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'extracted',
            actionSubject: 'vizPluginChart',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                chartCount: normalizedPresentation.extractionCounts.unicodeChart,
                timestamp: new Date().toISOString()
            }
        });
        return {
            processedStreamMessage: normalizedPresentation.message,
            markdownData: normalizedPresentation.markdownData
        };
    } else {
        let processedStreamMessage = streamMessage;
        const markdownData = {};
        // Applies to the final-response path (non-streaming) and to reconnect replay.
        if (shouldPreprocessDetails) processedStreamMessage = (0, $eK93A.preprocessStreamResponseDetails)(processedStreamMessage);
        if ((0, $iDrrr.fg)('rovo_enable_data_sculptor')) {
            const dataSculptorMsg = (0, $5XX4K.extractMarkdownContent)({
                streamMessage: processedStreamMessage,
                boundaryStart: '[^sculptor:start^]',
                boundaryEnd: '[^sculptor:end^]',
                replacementContent: '[^sculptor^]'
            });
            processedStreamMessage = dataSculptorMsg.processedStreamMessage;
            dataSculptorMsg.boundaryContents.forEach((content, index)=>{
                markdownData[`sculptor-${index}`] = content;
            });
        }
        const expandOpenTag = "\u259E";
        const expandCloseTag = "\u259A";
        const expandPlaceholder = '[^expand^]';
        const expandMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedStreamMessage,
            boundaryStart: expandOpenTag,
            boundaryEnd: expandCloseTag,
            replacementContent: expandPlaceholder
        });
        processedStreamMessage = expandMsg.processedStreamMessage;
        expandMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`expand-${index}`] = content;
        });
        if (expandMsg?.boundaryContents && expandMsg.boundaryContents.length > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'viewed',
            actionSubject: 'expandComponent',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                expandCount: expandMsg.boundaryContents.length,
                timestamp: new Date().toISOString(),
                isFinalResponse: true
            }
        });
        const chartOpenTag = "\u25F4";
        const chartCloseTag = "\u25F6";
        const chartPlaceholder = '[^chart^]';
        const chartMsg = (0, $5XX4K.extractMarkdownContent)({
            streamMessage: processedStreamMessage,
            boundaryStart: chartOpenTag,
            boundaryEnd: chartCloseTag,
            replacementContent: chartPlaceholder
        });
        processedStreamMessage = chartMsg.processedStreamMessage;
        chartMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`chart-${index}`] = content;
        });
        if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
            eventType: 'track',
            action: 'extracted',
            actionSubject: 'vizPluginChart',
            attributes: {
                messageId: messageId,
                conversationId: conversationId,
                chartCount: chartMsg.boundaryContents.length,
                timestamp: new Date().toISOString()
            }
        });
        if ((0, $iDrrr.fg)('rovo_chat_enable_inline_lumina')) {
            const luminaMsg = (0, $5XX4K.extractMarkdownContent)({
                streamMessage: processedStreamMessage,
                boundaryStart: "\u25D0",
                boundaryEnd: "\u25D1",
                replacementContent: '\n\n[^lumina^]\n\n'
            });
            processedStreamMessage = luminaMsg.processedStreamMessage;
            luminaMsg.boundaryContents.forEach((content, index)=>{
                markdownData[`lumina-${index}`] = content;
            });
        }
        processedStreamMessage = (0, $3iEfv.extractActionableFollowUpsMarkdownData)({
            streamMessage: processedStreamMessage,
            markdownData: markdownData
        });
        return {
            processedStreamMessage: processedStreamMessage,
            markdownData: markdownData
        };
    }
};






const $387377d6766e3a79$export$60e170089d1b35dd = ({ chat: chat, answerId: answerId, content: content, useIndex: useIndex, humanMessageId: humanMessageId, markdownData: markdownData, traceId: traceId, onMessageIdChanged: onMessageIdChanged })=>(0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeMessage)=>{
            const oldId = (0, $fjUOt.getStoreMessageId)(storeMessage);
            const newId = content.message.message.id;
            if (oldId !== newId) onMessageIdChanged?.(oldId, newId);
            return {
                ...storeMessage,
                content: {
                    ...content,
                    streamingComplete: false
                },
                humanMessageId: humanMessageId,
                markdownData: markdownData,
                traceId: traceId
            };
        },
        updateType: 'Replace Answer Data',
        useIndex: useIndex
    });













const $1be9bdb2a16ed0f4$export$8fcd85fa3cc8529c = ({ messages: messages, incomingA2UIMessages: incomingA2UIMessages, createFallbackMessageId: createFallbackMessageId, addressable: addressable = (0, $11b165b4e8e31cc9$export$15cd60ec7967aece)(messages) })=>{
    const anchorIdExists = (anchorId)=>messages.some((message)=>(0, $igOtY.isStoreAssistant)(message) && (0, $fjUOt.getStoreMessageId)(message) === anchorId);
    if (![
        ...addressable.values()
    ].every(anchorIdExists)) {
        const fresh = (0, $11b165b4e8e31cc9$export$15cd60ec7967aece)(messages);
        addressable.clear();
        fresh.forEach((anchorId, surfaceId)=>addressable.set(surfaceId, anchorId));
    }
    const routedByAnchorId = new Map();
    for (const a2uiMessage of incomingA2UIMessages){
        const surfaceId = (0, $0a8e95b4b53343a1$export$f05e22a6badb9277)(a2uiMessage);
        const isCreate = (0, $7crhj.isCreateSurface)(a2uiMessage);
        let targetId = surfaceId !== undefined ? addressable.get(surfaceId) : undefined;
        if (targetId !== undefined && isCreate) continue;
        if (targetId === undefined) {
            if (!isCreate) continue;
            targetId = createFallbackMessageId;
            if (surfaceId) addressable.set(surfaceId, createFallbackMessageId);
        }
        const pending = routedByAnchorId.get(targetId);
        if (pending) pending.push(a2uiMessage);
        else routedByAnchorId.set(targetId, [
            a2uiMessage
        ]);
    }
    if (routedByAnchorId.size === 0) return messages;
    return messages.map((message)=>{
        if (!(0, $igOtY.isStoreAssistant)(message)) return message;
        const a2uiMessages = routedByAnchorId.get((0, $fjUOt.getStoreMessageId)(message));
        if (!a2uiMessages || a2uiMessages.length === 0) return message;
        return {
            ...message,
            agenticUiMessages: [
                ...message.agenticUiMessages ?? [],
                ...a2uiMessages
            ]
        };
    });
};







var $hNzKs = parcelRequire("hNzKs");

const $927c732e26323e49$export$de552dcf26f1e520 = (state, conversationId)=>{
    const creatorType = (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(state, conversationId)?.agent?.creator_type;
    if (creatorType === 'ROVO_DEV') return (0, $iDrrr.fg)('rovo_chat_jca_details_expands');
    return (0, $hNzKs.shouldPreprocessDetailsForCreatorType)(creatorType);
};





const $5bb7c976e002305a$export$ba29913b663b084c = ({ chat: chat, oldId: oldId, newId: newId, parentMessageId: parentMessageId, onMessageIdChanged: onMessageIdChanged })=>chat.map((message)=>{
        if ((0, $igOtY.isStoreHuman)(message) && message.content.id === oldId) {
            onMessageIdChanged?.(oldId, newId);
            return {
                ...message,
                promptContextMessageId: message.promptContextMessageId ?? oldId,
                content: {
                    ...message.content,
                    id: newId,
                    ...parentMessageId && {
                        parent_message_id: parentMessageId
                    }
                }
            };
        }
        return message;
    });


const $2b1590a070c92522$var$getStreamAgent = (messages, messageId)=>{
    const assistant = messages.find((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content?.message?.message?.id === messageId);
    const identity = assistant && (0, $igOtY.isStoreAssistant)(assistant) ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(assistant) : undefined;
    if (!identity) return undefined;
    return {
        id: identity.id,
        name: '',
        identityAccountId: identity.identityAccountId ?? null
    };
};
const $2b1590a070c92522$export$f74ad34bb7f49ad1 = async ({ generator: generator, messageId: messageId, conversationId: conversationId, isDeepResearch: isDeepResearch, isStagingArea: isStagingArea, answerIndex: answerIndex, traceId: traceId, getMessages: getMessages, setMessages: setMessages, reportCreditDenial: reportCreditDenial, processStreamResearch: processStreamResearch, getState: getState, updateCurrentConversation: updateCurrentConversation, sendAnalyticsEvent: sendAnalyticsEvent, onStreamEvent: onStreamEvent, getIsReplaying: getIsReplaying, reasoningChunkBuffer: reasoningChunkBuffer, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, onStreamEnd: onStreamEnd, onFinalResponse: onFinalResponse, onFinalResponseProcessed: onFinalResponseProcessed, onFinalResponseInvalidated: onFinalResponseInvalidated, onTaskStatusDraft: onTaskStatusDraft, onTaskStatusCompleted: onTaskStatusCompleted, onTodoSnapshot: onTodoSnapshot, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onHumanMessageIdReplaced: onHumanMessageIdReplaced })=>{
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    const shouldPreprocessDetails = (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId);
    const processStreamMarkdownMultiTag = (0, $94689fb12cc6f471$export$95c0abd604a2cca2)({
        shouldPreprocessDetails: shouldPreprocessDetails
    });
    let latestStreamMessage;
    let hasReceivedFinalResponse = false;
    // Research store state shared across stream messages
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    let requestId;
    let turnSurfaces;
    // Tracks whether we've already seeded `previousAccumulatedData` onto the
    // first live (non-replay) AIFC create action chunk after a reconnect. When the
    // overlap-fix gate suppresses replayed chunks, the editor never receives the accumulated
    // pre-reconnect content; we hand it over once via previousAccumulatedData so
    // the editor can seed its document before appending live deltas.
    let hasSeededPreviousAccumulatedData = false;
    try {
        for await (const streamObj of generator){
            const streamMessage = streamObj.data;
            if ((0, $bxkJA.isStreamAiCreditDenied)(streamMessage) && (0, $iDrrr.fg)('rovo_chat_credits')) {
                latestStreamMessage = streamMessage;
                onStreamEvent('chunk', streamMessage, streamObj.id);
                hasReceivedFinalResponse = true;
                onFinalResponse?.();
                (0, $18fb7f621464707a$export$fea28b9fcd5e3261)({
                    conversationId: conversationId,
                    assistantMessageId: messageId,
                    streamMessage: streamMessage,
                    getState: getState,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    updateCurrentConversation: updateCurrentConversation,
                    reportCreditDenial: reportCreditDenial,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                onFinalResponseProcessed?.();
                break;
            }
            if ((0, $ae4252d226847c94$export$cd9676874af9cd5a)(streamObj, messageId)) onFinalResponseInvalidated?.(streamObj.eventType ?? streamMessage.type ?? 'UNKNOWN');
            const streamAgent = (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') && ((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage) || (0, $bxkJA.isStreamActionComplete)(streamMessage) || (0, $bxkJA.isStreamActionClassification)(streamMessage)) ? $2b1590a070c92522$var$getStreamAgent(getMessages(conversationId), messageId) : undefined;
            latestStreamMessage = streamMessage;
            onStreamEvent('chunk', streamMessage, streamObj.id);
            if ((0, $58a7ad1d26ac260e$export$51720276ffc29c92)(streamMessage, conversationId, updateCurrentConversation)) continue;
            if ((0, $5a900e4ea4c7ba13$export$2de2f38c3a454c55)({
                streamMessage: streamMessage,
                conversationId: conversationId,
                existingTraces: getState().conversations[conversationId]?.traces ?? [],
                updateTraces: (traces)=>updateCurrentConversation({
                        traces: traces
                    }),
                sendAnalyticsEvent: sendAnalyticsEvent
            })) continue;
            // TRACE events are not handled in reconnect; drop early to skip
            // the remaining type-checks below.
            if ((0, $bxkJA.isStreamTrace)(streamMessage)) continue;
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!requestId && 'metadata' in streamMessage) requestId = streamMessage.metadata?.request_id ?? undefined;
            (0, $0a4010078ae41b46$export$c68838490373407b)({
                streamObj: streamObj,
                streamMessage: streamMessage,
                conversationId: conversationId,
                answerIndex: answerIndex,
                requestId: requestId,
                defaultTransport: 'sse',
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
            if ((0, $bxkJA.isStreamAgenticUi)(streamObj)) {
                const incomingA2UIMessages = streamObj.data.message.content;
                if (Array.isArray(incomingA2UIMessages)) {
                    turnSurfaces ?? (turnSurfaces = (0, $11b165b4e8e31cc9$export$15cd60ec7967aece)(getMessages(conversationId)));
                    setMessages(conversationId, (0, $1be9bdb2a16ed0f4$export$8fcd85fa3cc8529c)({
                        messages: getMessages(conversationId),
                        incomingA2UIMessages: incomingA2UIMessages,
                        createFallbackMessageId: messageId,
                        addressable: turnSurfaces
                    }));
                }
                continue;
            }
            // Buffer REASONING_PART during replay; bufferEvent returns false for
            // orphan chunks (no stepId) so they fall through.
            if (reasoningChunkBuffer && getIsReplaying?.() && (0, $bxkJA.isStreamReasoningPart)(streamMessage) && reasoningChunkBuffer.bufferEvent(streamMessage)) continue;
            /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $ec372ef5c573e842$export$5a07e6227eed9665)({
                streamMessage: streamMessage,
                tmpAssistantMessageId: messageId,
                conversationId: conversationId,
                deepResearchEnabled: isDeepResearch ?? false,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                researchState: researchState
            });
            /**
       * Task status processing
       */ if ((0, $bxkJA.isStreamTaskStatus)(streamMessage)) {
                const taskMessage = streamMessage.message;
                if (taskMessage.status === 'DRAFT') onTaskStatusDraft?.({
                    taskId: taskMessage.task_id,
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    messageId: messageId
                });
                else if (taskMessage.status === 'COMPLETED') onTaskStatusCompleted?.({
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    completionMessageId: messageId
                });
            }
            /**
       *  snapshot processing
       */ if ((0, $bxkJA.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            /**
       *  ANSWER_PART  processing
       */ if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                const result = processStreamMarkdownMultiTag(processedStreamMessage);
                processedStreamMessage = result.processedStreamMessage;
                if (Object.keys(result.markdownData).length > 0) {
                    hasMarkdownData = true;
                    setMessages(conversationId, (0, $ccf4709cceff6c1f$export$679615d953ba31c3)({
                        chat: getMessages(conversationId),
                        answerId: messageId,
                        answerPart: processedStreamMessage,
                        markdownData: result.markdownData,
                        useIndex: answerIndex
                    }));
                }
                if (!hasMarkdownData) setMessages(conversationId, (0, $72779d19b192aa52$export$6e5609c05ab74cc7)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    answerPart: processedStreamMessage,
                    useIndex: answerIndex
                }));
            }
            if ((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
                const updatedMessages = (0, $ce5a795e167dd10b$export$13b6a4e4e3704011)({
                    chat: getMessages(conversationId),
                    messageId: messageId,
                    actionPart: streamMessage,
                    useIndex: answerIndex,
                    // Mirror the live processor so replayed AIFC create chunks accumulate their primary
                    // field (e.g. adf) in the store instead of overwriting with the latest
                    // chunk. This is what makes the accumulated content available to seed
                    // previousAccumulatedData below.
                    actionUpdaterOverride: (0, $aYC8J.customActionUpdater)
                });
                if ((0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
                    const actionMessage = streamMessage.message;
                    setMessages(conversationId, [
                        ...updatedMessages,
                        {
                            type: 'ACTION_PREPARE',
                            action: actionMessage
                        }
                    ]);
                } else setMessages(conversationId, updatedMessages);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) {
                        // On the first live chunk after replay, hand the accumulated pre-reconnect
                        // content to the editor via previousAccumulatedData. The overlap-fix
                        // gate suppresses replayed chunks from the editor, so without this the
                        // editor has no way to reconstruct what streamed before the reconnect.
                        if (!hasSeededPreviousAccumulatedData && (0, $bxkJA.isStreamActionPart)(streamMessage)) {
                            const actionKey = streamMessage.message.key;
                            if ((0, $aYC8J.isAccumulatedAction)(actionKey)) {
                                const lastAction = (0, $kNXXO.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
                                const isAccumulatedActionType = (0, $aYC8J.getAccumulatedActionTypeGuard)(actionKey);
                                if (lastAction && isAccumulatedActionType(streamMessage.message.data)) {
                                    const primaryAccumulatedData = (0, $aYC8J.getPrimaryAccumulatedValue)(lastAction);
                                    if (primaryAccumulatedData?.value) {
                                        streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
                                        hasSeededPreviousAccumulatedData = true;
                                    }
                                }
                            }
                        }
                        processMessageStreamAction?.(messageId, streamMessage, streamAgent, traceId, requestId, undefined, {
                            singleInstrumentationId: messageId
                        });
                    } else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionPart',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: (0, $bxkJA.isStreamActionPart)(streamMessage) ? streamMessage.message?.key : 'prepare'
                            }
                        }
                    });
                } else processMessageStreamAction?.(messageId, streamMessage, streamAgent, traceId, requestId, undefined, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $bxkJA.isStreamActionComplete)(streamMessage)) {
                const actionMessage = streamMessage.message;
                setMessages(conversationId, [
                    ...getMessages(conversationId),
                    {
                        type: 'ACTION_COMPLETE',
                        action: actionMessage
                    }
                ]);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) processMessageStreamComplete?.(messageId, streamMessage, streamAgent, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                    else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionComplete',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: actionMessage?.key
                            }
                        }
                    });
                } else processMessageStreamComplete?.(messageId, streamMessage, streamAgent, traceId, requestId, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $bxkJA.isStreamActionClassification)(streamMessage)) // Only call during live phase. If ACTION_CLASSIFICATION arrives during
            // replay it means the editor already received it before disconnect.
            {
                if (!getIsReplaying?.()) processMessageStreamActionClassification?.(messageId, streamMessage, streamAgent, traceId, requestId, {
                    singleInstrumentationId: messageId
                });
            }
            /**
       * FINAL_RESPONSE processing
       */ if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                onFinalResponse?.();
                const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $d8a5551aed11b46f$export$82b32799d0ea512c)({
                    streamMessage: streamMessage,
                    messageId: messageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: shouldPreprocessDetails
                });
                setMessages(conversationId, (0, $387377d6766e3a79$export$60e170089d1b35dd)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                    ...(0, $iDrrr.fg)('aifc_trace_id_analytics') ? {
                        traceId: traceId
                    } : {}
                }));
                // Update the StoreHuman entry's ID from the temporary client-generated ID
                // to the real server-assigned ID. After a page reload this is a no-op because
                // the store already contains the real ID.
                if (humanMessageId) {
                    const currentHumanMessageId = (0, $k1kN6.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
                    if (currentHumanMessageId && currentHumanMessageId !== humanMessageId) setMessages(conversationId, (0, $5bb7c976e002305a$export$ba29913b663b084c)({
                        chat: getMessages(conversationId),
                        oldId: currentHumanMessageId,
                        newId: humanMessageId,
                        onMessageIdChanged: (oldId, newId)=>onHumanMessageIdReplaced?.(conversationId, oldId, newId)
                    }));
                }
                onFinalResponseProcessed?.();
            }
            /**
       * Response redaction processing (PRGD-488)
       *
       * On reconnect/replay the FINAL_RESPONSE above re-populates the unredacted answer
       * via replaceAnswerData, so a replayed RESPONSE_REDACTION must re-apply the clear:
       * stamp redactedResponse, blank the message content, and drop traces. The research
       * round content is cleared via processResearchStreamMessage above.
       */ if ((0, $bxkJA.isStreamResponseRedaction)(streamMessage)) {
                const redactingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    (0, $e7b2fbfd93ff35fe$export$7c9d8a35c0d35149)({
                        conversationId: conversationId,
                        messageId: messageId,
                        redactedResponse: streamMessage.message.redacted_response,
                        getMessages: getMessages,
                        setMessages: setMessages,
                        getState: getState,
                        updateCurrentConversation: updateCurrentConversation
                    });
                    // Clear the unredacted research-round content and settle the steps for this
                    // message (reconnect always uses the real server messageId).
                    processStreamResearch({
                        messageId: messageId,
                        streamMessage: streamMessage,
                        isDeepResearch: isDeepResearch ?? false
                    });
                }
            }
            /**
       * Follow up processing
       */ if ((0, $bxkJA.isFollowUpMessage)(streamMessage)) {
                const messages = getMessages(conversationId);
                const originatingAssistant = [
                    ...messages
                ].reverse().find((0, $igOtY.isStoreAssistant));
                const originatingAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && originatingAssistant ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistant) : undefined;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: streamMessage,
                        id: (0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                        ...originatingAgentIdentity ? {
                            originatingAgentIdentity: originatingAgentIdentity
                        } : {}
                    }
                ]);
            }
            /**
       * Action error processing
       */ if ((0, $bxkJA.isStreamActionError)(streamMessage)) {
                // Producers disagree on where the error text lives, so telemetry probes each known
                // location. Displayed copy keeps the original source so users see the same string.
                const actionError = new (0, $hwHCO.StreamErrorException)(streamMessage.message?.data?.message || (0, $awqa1.ACTION_EXECUTION_FAILED), {
                    detail: {
                        message: {
                            content: streamMessage.message?.data?.message || streamMessage.message?.data?.content || streamMessage.message?.content || (0, $awqa1.ACTION_EXECUTION_FAILED),
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: isStagingArea
                        }
                    },
                    traceId: traceId
                });
                throw actionError;
            }
            if ((0, $bxkJA.isStreamError)(streamMessage) || (0, $bxkJA.isStreamAiCreditDenied)(streamMessage)) {
                onStreamEvent('error', streamMessage, streamObj.id);
                const streamError = (0, $bxkJA.isStreamError)(streamMessage) ? streamMessage : (0, $f5f4d30a252f1f45$export$2104d43a09d33c2)(streamMessage);
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamError;
                throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
        // Drain any remaining buffered chunks and clear the periodic timer.
        //cancelReasoningFlush();
        onStreamEnd?.();
    } catch (error) {
        if (error instanceof (0, $hwHCO.StreamErrorException)) throw error;
        // Let timeout errors propagate unwrapped so the outer catch can handle them correctly.
        if (error instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) throw error;
        throw new (0, $bQxqB.StreamGeneratorError)((error instanceof Error ? error.message : undefined) ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, error);
    }
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse
    };
};


const $21db7e5b2ba4fca2$export$6f349e5fd508c97f = (onMergedEvent)=>{
    const buffers = new Map();
    const bufferEvent = (event)=>{
        const stepId = event.message.stepId;
        if (!stepId) return false;
        const existing = buffers.get(stepId);
        if (existing) {
            existing.chunks.push(event.message.content);
            existing.lastEvent = event;
        } else buffers.set(stepId, {
            chunks: [
                event.message.content
            ],
            lastEvent: event
        });
        return true;
    };
    const flush = ()=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [, { chunks: chunks, lastEvent: lastEvent }] of entries)onMergedEvent({
            ...lastEvent,
            message: {
                ...lastEvent.message,
                content: chunks.join('')
            }
        });
    };
    const flushFiltered = (predicate)=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [stepId, { chunks: chunks, lastEvent: lastEvent }] of entries){
            if (!predicate(stepId)) continue;
            onMergedEvent({
                ...lastEvent,
                message: {
                    ...lastEvent.message,
                    content: chunks.join('')
                }
            });
        }
    };
    return {
        bufferEvent: bufferEvent,
        flush: flush,
        flushFiltered: flushFiltered,
        size: ()=>buffers.size
    };
};





function $64525561cf381ad0$export$76ef465f684cfb18({ conversationId: conversationId, reconnectTimestamp: reconnectTimestamp, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, updateCurrentConversation: updateCurrentConversation, onFlush: onFlush }) {
    // Lazily initialised on first setMessages write — avoids copying the full
    // messages array upfront when multiple tabs reconnect simultaneously.
    // replayBuffering=true + replayBuffer=null → buffering, no write yet
    // replayBuffering=false + replayBuffer=null → flushed
    let replayBuffer = null;
    let replayBuffering = true;
    // Pre-seeded with { traces: [] } so flush always clears "Resuming response..."
    // even if no clearTracesIfNotEmpty call fires during replay.
    // null means flushed.
    let conversationPatch = {
        traces: []
    };
    // null means flushed.
    let researchQueue = [];
    // Per-step tracking for reconnect replay. Keyed by stepId.
    // stepTitleEvents: first STEP_TITLE seen (provides title + roundId).
    // stepCompletedEvents: last STEP_COMPLETED seen (marks step done).
    // Used by getCollapsedStepEvents() and getCompletedStepIds().
    const stepTitleEvents = new Map();
    const stepCompletedEvents = new Map();
    const trackStepEvent = (params)=>{
        const msg = params.streamMessage;
        if ((0, $bxkJA.isStreamResearchStepTitle)(msg) || (0, $bxkJA.isStreamResearchStepTitleShort)(msg)) {
            if (!stepTitleEvents.has(msg.message.stepId)) stepTitleEvents.set(msg.message.stepId, params);
        } else if ((0, $bxkJA.isStreamResearchStepCompleted)(msg)) stepCompletedEvents.set(msg.message.stepId, params);
    };
    const getCollapsedStepEvents = ()=>{
        const result = [];
        const allStepIds = new Set([
            ...Array.from(stepTitleEvents.keys()),
            ...Array.from(stepCompletedEvents.keys())
        ]);
        allStepIds.forEach((stepId)=>{
            const titleEvent = stepTitleEvents.get(stepId);
            const completedEvent = stepCompletedEvents.get(stepId);
            if (titleEvent) result.push(titleEvent);
            if (completedEvent) result.push(completedEvent);
        });
        return result;
    };
    const isBuffering = ()=>replayBuffering;
    const parseEventTime = (id)=>Number(id.split('-')[0]);
    const flush = ()=>{
        if (!isBuffering()) return;
        const buffered = replayBuffer;
        const patch = conversationPatch;
        const queued = researchQueue;
        // Mark flushed before dispatching so re-entrant calls go live.
        replayBuffering = false;
        replayBuffer = null;
        conversationPatch = null;
        researchQueue = null;
        if (buffered !== null) setMessages(conversationId, buffered);
        if (patch !== null) updateCurrentConversation(patch);
        // onFlush runs BEFORE the queued research dispatch so caller-side
        // buffers (e.g. reasoning chunks) populate step content first; the
        // collapse signals (ANSWER_PART, FINAL_RESPONSE) then fire on
        // already-populated steps, matching the source event order.
        onFlush?.();
        // react-sweet-state setState is synchronous — the research store reaches
        // its final state before React re-renders, giving one render with
        // researchCompleted=true and skipping intermediate spinner states.
        queued.forEach((params)=>processStreamResearch(params));
    };
    const batchedSetMessages = (convId, msgs)=>{
        if (replayBuffering && convId === conversationId) {
            replayBuffer = msgs;
            return;
        }
        setMessages(convId, msgs);
    };
    const batchedGetMessages = (convId)=>{
        if (replayBuffering && convId === conversationId) // Fall through to real store if no write has arrived yet.
        return replayBuffer ?? getMessages(convId);
        return getMessages(convId);
    };
    const batchedUpdateCurrentConversation = (patch)=>{
        if (conversationPatch !== null) {
            conversationPatch = {
                ...conversationPatch,
                ...patch
            };
            return;
        }
        updateCurrentConversation(patch);
    };
    const batchedProcessStreamResearch = (params)=>{
        if (researchQueue !== null) {
            if ((0, $bxkJA.isStreamResponse)(params.streamMessage)) {
                // Preserve ANSWER_PART if already queued so both hasReceivedAnswerPart
                // and researchCompleted are set at flush.
                const hasAnswerPart = researchQueue.some((p)=>(0, $bxkJA.isStreamAnswerPart)(p.streamMessage));
                researchQueue = hasAnswerPart ? [
                    ...researchQueue,
                    params
                ] : [
                    params
                ];
                return;
            }
            if ((0, $bxkJA.isStreamAnswerPart)(params.streamMessage)) {
                // Collapse to [STEP_TITLE, STEP_COMPLETED per step, ANSWER_PART] so
                // past rounds have steps in the store after flush — prevents "Rovo is
                // thinking" for completed rounds during mid-stream reload.
                researchQueue = [
                    ...getCollapsedStepEvents(),
                    params
                ];
                return;
            }
            trackStepEvent(params);
            researchQueue.push(params);
            return;
        }
        processStreamResearch(params);
    };
    async function* replayFlushGenerator(source) {
        let replayEventCount = 0;
        for await (const chunk of source){
            if (isBuffering() && chunk.id) {
                const eventTime = parseEventTime(chunk.id);
                if (!isNaN(eventTime) && eventTime >= reconnectTimestamp) flush();
            }
            // During replay, yield the event loop periodically to prevent the tab
            // from becoming unresponsive when processing large streams (e.g. 6K+ events).
            // This gives the browser a chance to handle user interactions and GC between batches.
            if (isBuffering()) {
                replayEventCount++;
                if (replayEventCount % 200 === 0) await new Promise((resolve)=>setTimeout(resolve, 0));
            }
            yield chunk;
        }
        // Stream ended while still in replay (response was complete on reconnect).
        flush();
    }
    return {
        wrapGenerator: replayFlushGenerator,
        batchedSetMessages: batchedSetMessages,
        batchedGetMessages: batchedGetMessages,
        batchedProcessStreamResearch: batchedProcessStreamResearch,
        batchedUpdateCurrentConversation: batchedUpdateCurrentConversation,
        getIsReplaying: isBuffering,
        getCompletedStepIds: ()=>new Set(stepCompletedEvents.keys())
    };
}




var $dxD6w = parcelRequire("dxD6w");

const $1206f352a14d8e9a$export$cb6128fc3a3c8081 = (getAssistantMessageId)=>{
    const abortController = new AbortController();
    let resolveAbort;
    const confirmAbort = ()=>{
        resolveAbort();
    };
    const abort = ()=>{
        abortController.abort();
        return new Promise((resolve)=>{
            resolveAbort = resolve;
        });
    };
    const storeAbortController = {
        abort: abort
    };
    if (getAssistantMessageId) (0, $dxD6w.activeAssistantMessageIds).register(storeAbortController, getAssistantMessageId);
    return {
        abortController: abortController,
        storeAbortController: storeAbortController,
        confirmAbort: confirmAbort
    };
};


const $f7ec02b36fd7102d$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
const $f7ec02b36fd7102d$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS = 120000;
const $f7ec02b36fd7102d$var$NO_FINAL_RESPONSE_ERROR_MESSAGE = 'The response took too long and timed out';
const $f7ec02b36fd7102d$export$d8454bf5b2ffdf29 = ({ conversationId: conversationId, messageId: messageId, answerIndex: _answerIndex, isDeepResearch: isDeepResearch, lastEventId: lastEventId, setConversationData: setConversationData, abortCurrentRequest: abortCurrentRequest, onComplete: onComplete })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, capabilities: capabilities, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, reportCreditDenial: reportCreditDenial, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, chatContextStoreActions: chatContextStoreActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, endReconnection: endReconnection, startReconnection: startReconnection, isReconnecting: isReconnecting, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onHumanMessageIdReplaced: onHumanMessageIdReplaced, unifiedTasksActions: unifiedTasksActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (abortCurrentRequest && currentConversation?.storeAbortController) currentConversation.storeAbortController.abort();
        // Skip reconnection if there is another operation in progress
        if (currentConversation?.storeAbortController && !abortCurrentRequest || isReconnecting(conversationId)) return;
        const recoverExpiredReplay = (0, $iDrrr.fg)('rovo_chat_expired_replay_recovery');
        const recoverySiteId = getState().hydratedSiteId;
        startReconnection(conversationId, messageId);
        const reconnectionPerformanceMetrics = (0, $a7542f0d9855c517$export$4f5dbc9d3a9c9f98)({
            isDeepResearchEnabled: isDeepResearch,
            thinkDeeperEnabled: false,
            fastModeEnabled: false
        });
        let totalAttempts = 0;
        const reconnectStartedAt = new Date().toISOString();
        // TODO not complete information, ideally the message in progress should indicate what was the requested mode even before message is completed
        const requestedModeAttributes = (0, $411a747b8da7f11a$export$2f438a4a7bbfabc)(isDeepResearch ? 'deep_research' : 'auto');
        const metrics = {
            // Reconnection metrics
            onReconnectStarted: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.start();
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    id: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: true
                    }
                });
                trackAIMAUEvent({
                    type: 'initiated',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: reconnectStartedAt,
                    attributes: requestedModeAttributes
                });
            },
            // Was able to connect to active stream
            onReconnectEstablished: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.stop();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.start();
            },
            onReconnectFailed: (error)=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                experienceTracker.fail({
                    teamName: 'Rovo Chat',
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        totalAttempts: totalAttempts
                    }
                });
                trackAIMAUEvent({
                    type: 'error',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectChunkReceived: ()=>{
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.stop();
            },
            onReconnectAborted: ()=>{
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'Aborted'
                });
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectSucceeded: ()=>{
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        totalAttempts: totalAttempts,
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: true
                    }
                });
                metrics.onAnswerDelivered();
            },
            onAnswerDelivered: ()=>{
                const invokedFrom = streamMeta?.invokedFrom;
                trackAIMAUEvent({
                    type: 'viewed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    citedProductList: streamMeta?.citedProductList ?? {},
                    connectorInfo: streamMeta?.connectorInfo,
                    sourceProducts: streamMeta?.sourceProducts ?? {},
                    pluginsInvoked: streamMeta?.pluginsInvoked,
                    skillsInvoked: streamMeta?.skillsInvoked,
                    executedStratusSkill: streamMeta?.executedStratusSkill,
                    responseSources: streamMeta?.responseSources,
                    usesJsm: streamMeta?.usesJsm,
                    messageActions: messageActions,
                    ...invokedFrom && (0, $4o0zT.isExperimentEnabled)('aifc_invokedfrom_on_reconnect') ? {
                        invokedFrom: invokedFrom
                    } : {},
                    conversationChannelId: conversationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...(0, $0Z0Rs.getPeopleDataProviderAttributes)(streamMeta?.peopleDataProviders ?? []),
                        ...((0, $iDrrr.fg)('aifc_request_id_analytics') || (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential')) && streamMeta?.requestId ? {
                            request_id: streamMeta.requestId
                        } : {},
                        ...((0, $iDrrr.fg)('aifc_trace_id_analytics') || (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential')) && generationTraceId ? {
                            traceID: generationTraceId
                        } : {},
                        ...streamMeta?.interactionModeExecuted ? {
                            interactionModeExecuted: streamMeta.interactionModeExecuted
                        } : {},
                        ...streamMeta?.visualBlockCounts,
                        ...streamMeta?.actionObjectId ? {
                            objectId: streamMeta.actionObjectId
                        } : {},
                        ...(0, $ed079ebed6bb7598$export$bb558012e0978515)(streamMeta?.skillsInvoked ?? [], streamMeta?.pluginsInvoked ?? [], streamMeta?.agentExternalConfigReference)
                    }
                });
                // Fire agentMessage received for funnel parity with processStream.
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'received',
                    actionSubject: 'agentMessage',
                    attributes: {
                        messageId: messageId,
                        humanMessageId: streamMeta?.humanMessageId,
                        conversationChannelId: conversationId,
                        pluginsInvoked: streamMeta?.pluginsInvoked ?? [],
                        // Non-UGC authoritative-answer descriptors (gated in extractStreamMeta).
                        ...streamMeta?.hasAuthoritativeSources ? {
                            hasAuthoritativeSources: true,
                            authorityLevel: streamMeta.authorityLevel,
                            isHighlyAuthoritative: streamMeta.isHighlyAuthoritative,
                            overallConfidence: streamMeta.overallConfidence,
                            authoritativeSourceCount: streamMeta.authoritativeSourceCount,
                            authoritativeExpertCount: streamMeta.authoritativeExpertCount
                        } : {},
                        citedProductList: streamMeta?.citedProductList,
                        sourceProducts: streamMeta?.sourceProducts,
                        has3pApps: Object.keys(streamMeta?.sourceProducts ?? {}).some((0, $6xccU.is3pApp)),
                        timestamp: new Date().toISOString(),
                        messageActions: streamMeta?.messageActions,
                        deepResearchEnabled: isDeepResearch ?? false,
                        initiator: 'rovoChat',
                        deepResearchInvoked: isDeepResearch ?? false,
                        scenarioId: streamMeta?.scenarioId,
                        isReconnect: true
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch(setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const cancelMessageStream = ()=>{
            assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: messageId
            }).catch((err)=>{
                (0, $hlvTd.logException)({
                    name: 'rovoCancelMessageStream',
                    exception: err,
                    tags: {
                        conversationId: conversationId,
                        messageId: messageId
                    }
                });
            });
        };
        const messages = getMessages(conversationId);
        const recoveryAnswerId = (0, $3Cuhs.getLastAgentMessageID)(messages);
        const answerIndex = _answerIndex ?? (0, $4BHwn.findStoreMessageIndex)(messages, messageId);
        const originalMessage = messages[answerIndex];
        // A reconnect response identifies a new HTTP request, not the originating generation.
        const generationTraceId = originalMessage && (0, $igOtY.isStoreAssistant)(originalMessage) ? originalMessage.traceId : undefined;
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1206f352a14d8e9a$export$cb6128fc3a3c8081)(()=>messageId);
        let traceId;
        let streamMeta;
        let isBackendCreationRequest = false;
        let messageActions;
        const currentLastEventId = lastEventId;
        let reconnectSucceeded = false;
        let replayAcquisitionError;
        const ownsReconnect = ()=>getState().conversations[conversationId]?.storeAbortController === storeAbortController;
        const isCurrentRecovery = ()=>{
            const state = getState();
            const latestAssistantId = (0, $3Cuhs.getLastAgentMessageID)(getMessages(conversationId));
            return !abortController.signal.aborted && getIsChatMounted() && ownsReconnect() && state.currentConversationId === conversationId && state.hydratedSiteId === recoverySiteId && latestAssistantId === recoveryAnswerId;
        };
        //** CONNECT TO STREAM (with retry) */
        try {
            metrics.onReconnectStarted();
            updateCurrentConversation({
                status: (0, $igOtY.CHAT_STORE_STATUS).typingResponse,
                traces: [
                    {
                        messageContent: 'Resuming response...',
                        status: 'loading'
                    }
                ],
                storeAbortController: storeAbortController
            });
            const reconnect = (eventId)=>assistanceService.reconnectToMessageStream({
                    conversationId: conversationId,
                    messageId: messageId,
                    lastEventId: eventId,
                    controller: abortController
                }).catch((error)=>{
                    if (recoverExpiredReplay && error instanceof (0, $jTKfH.FetchError) && error.errorAttributes.statusCode === 404) {
                        replayAcquisitionError = error;
                        traceId = error.errorAttributes.traceId ?? traceId;
                    }
                    throw error;
                });
            // Capture timestamp BEFORE the API call so that any live chunks
            // still in-flight during the round-trip are correctly identified
            // as live rather than replay.
            const reconnectTimestamp = Date.now();
            const { generator: initialGenerator, responseData: responseData } = await reconnect(currentLastEventId);
            traceId = responseData?.traceId;
            metrics.onReconnectEstablished();
            let hasProcessedFinalResponse = false;
            let preservedContext;
            let lastInvalidatingEventType;
            const wrappedGenerator = (0, $bcd5e69edf2194aa$export$a802bb7fa59dba39)({
                initialGenerator: initialGenerator,
                completion: {
                    isProcessed: ()=>hasProcessedFinalResponse,
                    onRecoveryExhausted: (context)=>{
                        preservedContext = {
                            conversationId: conversationId,
                            messageId: messageId,
                            traceId: traceId,
                            ...context,
                            attributes: {
                                isDeepResearch: isDeepResearch
                            }
                        };
                    },
                    onReadError: ({ error: error, reconnectAttempts: reconnectAttempts })=>{
                        if (hasReceivedFinalResponse && !hasProcessedFinalResponse && lastInvalidatingEventType) sendAnalyticsEvent((0, $c44f031f0678945d$export$3cdc20b361e6b93d)({
                            conversationId: conversationId,
                            messageId: messageId,
                            traceId: traceId,
                            error: error,
                            reconnectAttempts: reconnectAttempts,
                            recoveryOutcome: 'completionInvalidated',
                            invalidatingEventType: lastInvalidatingEventType,
                            attributes: {
                                isDeepResearch: isDeepResearch
                            }
                        }));
                    }
                },
                canReconnect: ()=>!abortController.signal.aborted,
                getReconnectGenerator: (eventId)=>reconnect(eventId).then((r)=>r.generator),
                getEventId: (chunk)=>chunk.id ? chunk.id : undefined,
                onReconnecting: (attempt, maxAttempts, eventId)=>{
                    totalAttempts = attempt;
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'retrying',
                        actionSubject: 'rovoChatReconnection',
                        attributes: {
                            conversationId: conversationId,
                            messageId: messageId,
                            isDeepResearch: isDeepResearch,
                            attempt: attempt,
                            maxAttempts: maxAttempts,
                            hasLastEventId: !!eventId
                        }
                    });
                    updateCurrentConversation({
                        traces: [
                            {
                                messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                                status: 'loading'
                            }
                        ]
                    });
                },
                onReconnected: ()=>{
                    metrics.onReconnectEstablished();
                },
                shouldContinueRetrying: ()=>{
                    if (!getIsChatMounted()) {
                        abortController.abort($f7ec02b36fd7102d$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                        return false;
                    }
                    return true;
                },
                signal: abortController.signal
            });
            // Batch store updates and chunk-merge REASONING_PART during replay;
            // both flushed together via onFlush at the replay→live boundary.
            const reasoningChunkBuffer = (0, $21db7e5b2ba4fca2$export$6f349e5fd508c97f)((mergedEvent)=>{
                processStreamResearch({
                    messageId: messageId,
                    streamMessage: mergedEvent,
                    isDeepResearch: isDeepResearch ?? false
                });
            });
            const { wrapGenerator: wrapGenerator, batchedSetMessages: batchedSetMessages, batchedGetMessages: batchedGetMessages, batchedProcessStreamResearch: batchedProcessStreamResearch, batchedUpdateCurrentConversation: batchedUpdateCurrentConversation, getIsReplaying: getIsReplaying, getCompletedStepIds: getCompletedStepIds } = (0, $64525561cf381ad0$export$76ef465f684cfb18)({
                conversationId: conversationId,
                reconnectTimestamp: reconnectTimestamp,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                updateCurrentConversation: updateCurrentConversation,
                // Use flushFiltered so reasoning chunks for already-completed steps
                // are dropped — this prevents spurious "Rovo is thinking" rounds
                // from appearing in the research expandable after reconnect replay.
                // Steps that are still in-progress (no STEP_COMPLETED seen) are
                // flushed normally so live streaming continues correctly.
                onFlush: ()=>reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId))
            });
            const isStreamTimeoutEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'isEnabled', false);
            const streamIdleTimeoutMs = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'timeoutMs', $f7ec02b36fd7102d$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS);
            // Tracks whether the stream completed its success path. Used to suppress
            // the timeout if a final response arrives in the same tick as the timer fires.
            let hasReceivedFinalResponse = false;
            const rawGenerator = wrapGenerator(wrappedGenerator);
            const generatorWithTimeout = isStreamTimeoutEnabled ? (0, $0ac98c0a880a830b$export$44aab448715585b6)(rawGenerator, {
                timeoutMs: streamIdleTimeoutMs,
                // Don't time out while offline – the reconnect layer waits for the
                // client to come back online, so timing out would lose the reconnect.
                isPaused: ()=>typeof navigator !== 'undefined' && !navigator.onLine,
                onTimeout: ()=>{
                    if (hasReceivedFinalResponse || abortController.signal.aborted) return undefined;
                    abortController.abort();
                    const timeoutError = new (0, $b6N3q.RovoChatStreamTimeoutError)($f7ec02b36fd7102d$var$NO_FINAL_RESPONSE_ERROR_MESSAGE, {
                        traceId: traceId
                    });
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'timedOut',
                        actionSubject: 'rovoChatStream',
                        attributes: {
                            conversationChannelId: conversationId,
                            experienceName: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                            timeoutMs: streamIdleTimeoutMs,
                            timeoutType: 'idle',
                            traceId: traceId
                        }
                    });
                    return timeoutError;
                }
            }) : rawGenerator;
            await (0, $2b1590a070c92522$export$f74ad34bb7f49ad1)({
                generator: generatorWithTimeout,
                traceId: (0, $iDrrr.fg)('aifc_trace_id_analytics') ? generationTraceId : traceId,
                messageId: messageId,
                conversationId: conversationId,
                answerIndex: answerIndex,
                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                isDeepResearch: isDeepResearch,
                getState: getState,
                setMessages: batchedSetMessages,
                getMessages: batchedGetMessages,
                reportCreditDenial: reportCreditDenial,
                processStreamResearch: batchedProcessStreamResearch,
                processMessageStreamAction: // skip batching for Stream Actions for now, since string accumulation is not guarnateed and vary based on the action type.
                // TODO: should be imrpoved in future snapshot event support.
                processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                onHumanMessageIdReplaced: onHumanMessageIdReplaced,
                sendAnalyticsEvent: sendAnalyticsEvent,
                updateCurrentConversation: batchedUpdateCurrentConversation,
                getIsReplaying: getIsReplaying,
                reasoningChunkBuffer: reasoningChunkBuffer,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                onStreamEnd: ()=>{
                    // Mirror onFlush: drop reasoning for completed steps.
                    reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId));
                },
                // Fired immediately when FINAL_RESPONSE arrives — sets the outer flag so
                // the timeout wrapper won't treat a same-tick timer fire as a real timeout.
                onFinalResponse: ()=>{
                    hasReceivedFinalResponse = true;
                },
                onFinalResponseInvalidated: (eventType)=>{
                    hasProcessedFinalResponse = false;
                    lastInvalidatingEventType = eventType;
                },
                onFinalResponseProcessed: ()=>{
                    hasProcessedFinalResponse = true;
                },
                onTaskStatusDraft: ({ taskId: taskId, title: title, updatedAt: updatedAt, messageId: msgId })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.createTaskFromStream({
                        conversationId: conversationId,
                        taskId: taskId,
                        title: title,
                        updatedAt: updatedAt,
                        messageId: msgId
                    });
                },
                onTaskStatusCompleted: ({ title: title, updatedAt: updatedAt, completionMessageId: completionMessageId })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskProgressState({
                        conversationId: conversationId,
                        progressState: 'Completed',
                        title: title,
                        updatedAt: updatedAt,
                        seekingCompletedAck: true,
                        completionMessageId: completionMessageId
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onStreamEvent: (event, streamMessage, eventId)=>{
                    if (event === 'chunk') {
                        metrics.onReconnectChunkReceived();
                        if (streamMessage && (0, $bxkJA.isStreamActionComplete)(streamMessage)) {
                            const isBackendCreationAction = (0, $aYC8J.isServerSideExecutionAction)(streamMessage.message);
                            isBackendCreationRequest || (isBackendCreationRequest = isBackendCreationAction);
                            if (isBackendCreationAction) messageActions = [
                                ...messageActions ?? [],
                                streamMessage.message.key
                            ];
                        }
                        if (streamMessage && (0, $bxkJA.isStreamResponse)(streamMessage)) {
                            streamMeta = (0, $577cc8ea0ec76152$export$2244b7838be162ca)(streamMessage);
                            if (!isBackendCreationRequest) messageActions = streamMeta.messageActions;
                        }
                    }
                    if (event === 'error') {
                        if ((0, $bxkJA.isStreamAUPError)(streamMessage)) {
                            reconnectSucceeded = true;
                            metrics.onReconnectSucceeded();
                        }
                    }
                }
            });
            if (abortController.signal.aborted) throw new DOMException('Reconnect aborted', 'AbortError');
            if (!hasReceivedFinalResponse) throw new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: traceId
            });
            if (preservedContext) {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'completedAnswerPreserved'
                });
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                sendAnalyticsEvent((0, $c44f031f0678945d$export$3cdc20b361e6b93d)(preservedContext));
                metrics.onAnswerDelivered();
            } else metrics.onReconnectSucceeded();
            onComplete?.({
                success: true,
                streamMeta: streamMeta
            });
        } catch (caughtError) {
            let error = caughtError;
            if (recoverExpiredReplay && (0, $7649098210feaae7$export$1864f06982795aa4)(error, replayAcquisitionError)) {
                const lookup = await (0, $faea2b1b99af6c44$export$5fdfb2e15ed7708a)({
                    conversationId: conversationId,
                    messageId: messageId,
                    capabilities: capabilities,
                    getChat: (id, requestedCapabilities)=>assistanceService.getChat(id, requestedCapabilities),
                    isCurrent: isCurrentRecovery
                });
                if (lookup.outcome === 'superseded') {
                    if (abortController.signal.aborted) confirmAbort();
                    metrics.onReconnectAborted();
                    return;
                }
                let recoveryOutcome = lookup.outcome;
                if (lookup.outcome === 'recovered') {
                    const response = lookup.response;
                    try {
                        const normalized = (0, $gjWe2.processConversationMessages)({
                            latestMessages: [
                                response
                            ],
                            conversationId: conversationId,
                            sendAnalyticsEvent: sendAnalyticsEvent,
                            shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
                        });
                        const restored = normalized.find((0, $igOtY.isStoreAssistant));
                        if (restored && restored.content.message.message.id === messageId && (0, $4BHwn.findStoreMessageIndex)(getMessages(conversationId), messageId) >= 0 && isCurrentRecovery()) {
                            const recoveredMeta = (0, $577cc8ea0ec76152$export$2244b7838be162ca)(response);
                            setMessages(conversationId, getMessages(conversationId).map((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.message.message.id === messageId ? {
                                    ...message,
                                    ...restored,
                                    humanMessageId: response.message.human_message?.id ?? message.humanMessageId
                                } : message));
                            processStreamResearch({
                                messageId: messageId,
                                streamMessage: response,
                                isDeepResearch: isDeepResearch ?? false
                            });
                            setMessages(conversationId, (0, $112200485e4c7f0b$export$680d2bb5b9579c57)(getMessages(conversationId)));
                            updateCurrentConversation((0, $jyZaR.clearStatus)({
                                lastAgentMessageStatus: 'SUCCESSFUL'
                            }));
                            streamMeta = recoveredMeta;
                            messageActions = recoveredMeta.messageActions;
                            reconnectSucceeded = true;
                        } else recoveryOutcome = 'notApplied';
                    } catch (processingError) {
                        // Keep required history-processing failures visible, rather than masking
                        // them with the earlier expired-stream error.
                        error = processingError;
                        recoveryOutcome = 'processingFailed';
                    }
                }
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'recoveryCompleted',
                    actionSubject: 'rovoChatStream',
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        traceId: traceId,
                        recoveryMethod: 'conversationRefresh',
                        recoveryTrigger: 'replayUnavailable',
                        recoveryOutcome: recoveryOutcome
                    }
                });
                if (reconnectSucceeded) {
                    // The answer was delivered from history; the live replay did not succeed.
                    reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                    reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                    experienceTracker.abort({
                        name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                        reason: 'recoveredFromConversation'
                    });
                    metrics.onAnswerDelivered();
                    onComplete?.({
                        success: true,
                        streamMeta: streamMeta
                    });
                    return;
                }
            }
            // Handle idle-stream timeout: abortController was already aborted inside onTimeout,
            // so check RovoChatStreamTimeoutError before the generic AbortError branch to distinguish
            // a timeout-triggered abort from a genuine user/system abort.
            if (error instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) {
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                // Cancel the upstream HTTP stream — the server is still open and nobody else will close it.
                cancelMessageStream();
                metrics.onReconnectFailed(error);
                if (isDeepResearch) markIncompleteResearchesErrored({
                    messageId: messageId
                });
                onComplete?.({
                    success: false,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) {
                confirmAbort();
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                metrics.onReconnectAborted();
                // Only cancel the message stream if the abort reason is not the chat unmounted reason
                if (abortController.signal.reason !== $f7ec02b36fd7102d$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED) cancelMessageStream();
                return;
            }
            if (!reconnectSucceeded) metrics.onReconnectFailed(error);
            if (isDeepResearch) markIncompleteResearchesErrored({
                messageId: messageId
            });
            onComplete?.({
                success: reconnectSucceeded,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        } finally{
            endReconnection(conversationId);
            // A history lookup adds an await point. A newer send owns its own status
            // and messages, so this old reconnect must not clear or complete them.
            if (!recoverExpiredReplay || ownsReconnect()) {
                updateCurrentConversation((0, $jyZaR.clearStatus)({}));
                setMessages(conversationId, (0, $112200485e4c7f0b$export$680d2bb5b9579c57)(getMessages(conversationId)));
            }
        }
    };





const $7a4a093d6dd23d1c$export$873fca975736004b = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).reconnectToInProgressStream, ({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, isDeepResearch: isDeepResearch, abortCurrentRequest: abortCurrentRequest, answerIndex: answerIndex, onComplete: onComplete })=>(0, $f7ec02b36fd7102d$export$d8454bf5b2ffdf29)({
        conversationId: conversationId,
        messageId: messageId,
        lastEventId: lastEventId,
        isDeepResearch: isDeepResearch,
        abortCurrentRequest: abortCurrentRequest,
        answerIndex: answerIndex,
        onComplete: onComplete,
        setConversationData: $6geN3.setConversationData
    }), {
    experienceName: ()=>(0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM
});






const $013a275e4d21eace$export$d22a0f57a9fae6c9 = ({ conversationId: conversationId, traces: traces, sourceAgentId: sourceAgentId })=>({ getState: getState, setState: setState })=>{
        const existing = getState().conversations[conversationId];
        if (!existing) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...existing,
                    status: (0, $igOtY.CHAT_STORE_STATUS).loadingChat,
                    messages: [],
                    traces: traces,
                    sourceAgentId: sourceAgentId
                }
            }
        });
    };












var $6Hbrh = parcelRequire("6Hbrh");

const $692b8c108a723517$export$505adb47a68d73e6 = ({ conversationId: conversationId, messages: messages })=>({ getState: getState }, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $iDrrr.fg)('rovo_chat_enable_tasks') || !unifiedTasksActions) return;
        const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        const lastAgentMsgId = (0, $3Cuhs.getLastAgentMessageID)(messages);
        if (activeTask && !(0, $igOtY.isTerminalTaskState)(activeTask.progressState) && lastAgentMsgId && activeTask.currentMessageId === lastAgentMsgId && (0, $6Hbrh.shouldRestoreMaxModeFromLastRequestedMode)(getState().conversations[conversationId]?.lastRequestedMode)) setReasoningMode(conversationId, 'task');
    };






const $b25327492a2eafbb$var$RUNNING_TURN_HISTORY_POLL_MS = 1000;
const $b25327492a2eafbb$var$RUNNING_TURN_HISTORY_POLL_LIMIT = 5;
const $b25327492a2eafbb$export$5c7afebc13b5b6d7 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).fetchConversation, ({ conversationId: conversationIdParam, messageIdSelectedForPreview: messageIdSelectedForPreview, skipIfConversationAlreadyLoaded: skipIfConversationAlreadyLoaded = false })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag, setReasoningMode: setReasoningMode, capabilities: capabilities, onConversationSpacesHydrated: onConversationSpacesHydrated })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const conversation = getState().conversations[conversationId];
        if (conversation?.status !== (0, $igOtY.CHAT_STORE_STATUS).idle || (0, $1IZrU.isEmptyConversation)(conversationId)) return;
        if (conversation.skipNextFetch) {
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    skipNextFetch: false
                }
            }));
            return;
        }
        if (skipIfConversationAlreadyLoaded && !messageIdSelectedForPreview && conversation.lastAgentMessageStatus !== 'FAILED' && (getMessages(conversationId).length > 0 || conversation.messages.length > 0)) return;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).FETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        if (conversation.storeAbortController) await conversation.storeAbortController?.abort();
        const messagesBeforeReload = getMessages(conversationId);
        dispatch((0, $013a275e4d21eace$export$d22a0f57a9fae6c9)({
            conversationId: conversationId,
            traces: messageIdSelectedForPreview ? [] : [
                {
                    messageContent: 'Reloading chat',
                    status: 'loading'
                }
            ],
            sourceAgentId: (0, $56454c3864f9431b$export$ab93cd1ecacda8ec)(getMessages(conversationId), (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId))
        }));
        let serviceChat;
        try {
            if ((0, $4o0zT.isExperimentEnabled)('jca-rovo-chat') && !conversation.agent?.creator_type) await dispatch((0, $b2d2dd6f47199a97$export$edaf28f02e88f53a)(conversationId));
            else if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_spaces_experiment')) assistanceService.fetchConversationMetadata(conversationId).then((metadata)=>(0, $4c477a4f1aee7cea$export$e3ef4b259ed70a56)({
                    conversationId: conversationId,
                    metadata: metadata,
                    dispatch: dispatch,
                    onConversationSpacesHydrated: onConversationSpacesHydrated
                })).catch(()=>undefined);
            serviceChat = await assistanceService.getChat(conversationId, capabilities);
            // Chat opened for a running turn can read history before the turn's rows exist and
            // would show an empty or frozen chat, so re-read until the IN_PROGRESS tail appears.
            // Stop when the conversation leaves the loading state: the fetch is then stale.
            let pollsLeft = (0, $iDrrr.fg)('rovo_chat_fetch_waits_for_running_turn') ? $b25327492a2eafbb$var$RUNNING_TURN_HISTORY_POLL_LIMIT : 0;
            while(pollsLeft-- > 0 && (0, $579e7cab04e6efec$export$767f5c1ef71cb70c)(serviceChat)){
                await new Promise((resolve)=>setTimeout(resolve, $b25327492a2eafbb$var$RUNNING_TURN_HISTORY_POLL_MS));
                if (getState().conversations[conversationId]?.status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) break;
                serviceChat = await assistanceService.getChat(conversationId, capabilities);
            }
        } catch (e) {
            if ((0, $bxkJA.isChannelNotFoundError)(e)) {
                //We succeed this event because in sendMessage, we create a new channel if we receive a 404 response
                // Users will not see this error, so exclude it from Sentry
                //This is a fix due to an incompatible BE API change
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'notFound',
                    actionSubject: 'rovoChatFetchConversation'
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_CHAT
                });
                if (getState().currentConversationId === conversationId) dispatch((0, $djNSU.createConversationOptimistically)({
                    sourceAgentId: (0, $56454c3864f9431b$export$ab93cd1ecacda8ec)(getMessages(conversationId), (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId))
                }));
                dispatch((0, $77b987c9b91a6f83$export$53f4d2378049701e)({
                    conversationId: conversationId
                }));
                return;
            }
            if ((0, $d658c35e0bf26137$export$a36711287d720d2b)(e)) {
                experienceTracker.fail({
                    teamName: 'Rovo Chat',
                    name: (0, $irnO2.ExperienceName).FETCH_CHAT,
                    error: e
                });
                (0, $95aa319c6be31138$export$3af2463ee5fae65d)({
                    conversationId: conversationId,
                    currentConversationId: getState().currentConversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                return;
            }
            throw e;
        }
        // There's a bug currently in the playwright pubsub test where when adding in a new
        // async function to sendMessageStream it causes the message to be dropped
        const status = getState().conversations[conversationId]?.status;
        if (status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) return;
        const latestMessages = serviceChat;
        const messages = (0, $gjWe2.processConversationMessages)({
            latestMessages: latestMessages,
            conversationId: conversationId,
            sendAnalyticsEvent: sendAnalyticsEvent,
            shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
        });
        const fetchedAgentVersion = (0, $287b89b445b82017$export$9c99f879b5701ba2)(latestMessages);
        dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                ...(0, $jyZaR.clearStatus)({
                    lastAgentMessageStatus: 'SUCCESSFUL'
                }),
                sourceAgentId: (0, $56454c3864f9431b$export$ab93cd1ecacda8ec)(getMessages(conversationId), (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId)),
                ...fetchedAgentVersion ? {
                    agentVersion: fetchedAgentVersion
                } : {}
            }
        }));
        // Check if the last message has async_status 'IN_PROGRESS' and reconnect to the stream
        const lastMessage = latestMessages.at(-1);
        const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
        if ((0, $bxkJA.isInProgressStreamResponse)(lastMessage)) {
            const messageId = lastMessage.message.message.id;
            // Clear the "Message is in progress" content of the last agent message
            const updatedMessages = (0, $c4abac6b845cca29$export$bb0ca99caffb8502)(messages, messageId);
            // Do not preserve follow-ups while reconnecting: the resumed stream emits its own
            // FOLLOW_UP_QUERIES part, so re-attaching here could duplicate the chips.
            setMessages(conversationId, updatedMessages);
            dispatch((0, $7a4a093d6dd23d1c$export$873fca975736004b)({
                conversationId: conversationId,
                messageId: messageId,
                isDeepResearch: isDeepResearch
            }));
        } else setMessages(conversationId, (0, $d2bec76a2cf3a32e$export$78825c8f4b3c575c)(messagesBeforeReload, messages));
        dispatch((0, $692b8c108a723517$export$505adb47a68d73e6)({
            conversationId: conversationId,
            messages: messages
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).FETCH_CHAT
        });
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).FETCH_CHAT
});









var $8fLSN = parcelRequire("8fLSN");

















const $7924d5732284eb54$export$6914a4ee7f8cbe2c = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).handleChatOpenPubsubAction, ({ conversationId: conversationId, agentId: agentId })=>async ({ getState: getState, dispatch: dispatch })=>{
        // IF convo id is the current chat
        // refetch the chat, do not create new one
        if (conversationId === getState().currentConversationId) {
            const shouldStoreChatNewAgentId = !!agentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $8fLSN.createProvisionalConversationAgent)(agentId);
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch((0, $b25327492a2eafbb$export$5c7afebc13b5b6d7)({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat already exist in conversation
        // switch to that convo -> and it will trigger refetch when ChatHistory is rendered
        if (getState().conversations[conversationId]) {
            const shouldStoreChatNewAgentId = !!agentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $8fLSN.createProvisionalConversationAgent)(agentId);
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch((0, $c8Sl1.setSelectedConversation)({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat does not exist yet
        // Create conversation optimistically, which will switch to that conversation
        // By switching conversation, it will render ChatHistory
        // ChatHistory will auto fetch the chat data
        // if not found during `sendMessage`, it will auto create one and retry when encountered `404`
        // Create conversation optimistically and store sourceAgentId
        const sourceAgentIdFromChatNew = agentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? agentId : undefined;
        dispatch((0, $djNSU.createConversationOptimistically)({
            id: conversationId,
            sourceAgentId: sourceAgentIdFromChatNew
        }));
    });



var $dHz2q = parcelRequire("dHz2q");


var $iWQjF = parcelRequire("iWQjF");









































const $b0af940bfa1b3612$export$b798bd7f9b4e76a0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).prefetchConversationMessages, ({ conversationId: conversationId, skipNextFetch: skipNextFetch = false, onStart: onStart, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag, capabilities: capabilities, onConversationSpacesHydrated: onConversationSpacesHydrated })=>{
        const conversation = getState().conversations[conversationId];
        // Bail without emitting if the conversation isn't selectable, is
        // in flight, or is already loaded
        if ((0, $1IZrU.isEmptyConversation)(conversationId) || !conversation || conversation.status !== (0, $igOtY.CHAT_STORE_STATUS).idle || conversation.messages.length > 0) return;
        onStart?.();
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).PREFETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        const messagesBeforeReload = getMessages(conversationId);
        dispatch((0, $013a275e4d21eace$export$d22a0f57a9fae6c9)({
            conversationId: conversationId,
            traces: [],
            sourceAgentId: conversation.sourceAgentId ?? ''
        }));
        try {
            if ((0, $4o0zT.isExperimentEnabled)('jca-rovo-chat') && !conversation.agent?.creator_type) await dispatch((0, $b2d2dd6f47199a97$export$edaf28f02e88f53a)(conversationId));
            else if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_spaces_experiment')) assistanceService.fetchConversationMetadata(conversationId).then((metadata)=>(0, $4c477a4f1aee7cea$export$e3ef4b259ed70a56)({
                    conversationId: conversationId,
                    metadata: metadata,
                    dispatch: dispatch,
                    onConversationSpacesHydrated: onConversationSpacesHydrated
                })).catch(()=>undefined);
            const serviceChat = await assistanceService.getChat(conversationId, capabilities);
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) // Something else (e.g. a user-initiated send or an explicit
            // `fetchConversation`) raced ahead; surrender the response.
            return;
            const messages = (0, $gjWe2.processConversationMessages)({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
            });
            const fetchedAgentVersion = (0, $287b89b445b82017$export$9c99f879b5701ba2)(serviceChat);
            // Mirror fetchConversation's reconnect check.
            const lastMessage = serviceChat.at(-1);
            const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
            const shouldReconnect = (0, $bxkJA.isInProgressStreamResponse)(lastMessage);
            if (shouldReconnect) {
                const messageId = lastMessage.message.message.id;
                const updatedMessages = (0, $c4abac6b845cca29$export$bb0ca99caffb8502)(messages, messageId);
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        ...(0, $jyZaR.clearStatus)({
                            lastAgentMessageStatus: 'SUCCESSFUL'
                        }),
                        sourceAgentId: (0, $56454c3864f9431b$export$ab93cd1ecacda8ec)(messages, (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId)),
                        ...fetchedAgentVersion ? {
                            agentVersion: fetchedAgentVersion
                        } : {}
                    }
                }));
                // Do not preserve follow-ups while reconnecting: the resumed stream emits its own
                // FOLLOW_UP_QUERIES part, so re-attaching here could duplicate the chips.
                setMessages(conversationId, updatedMessages);
                dispatch((0, $692b8c108a723517$export$505adb47a68d73e6)({
                    conversationId: conversationId,
                    messages: messages
                }));
                dispatch((0, $7a4a093d6dd23d1c$export$873fca975736004b)({
                    conversationId: conversationId,
                    messageId: messageId,
                    isDeepResearch: isDeepResearch
                }));
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).PREFETCH_CHAT
                });
                onSuccess?.();
                return;
            }
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    ...(0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    sourceAgentId: (0, $56454c3864f9431b$export$ab93cd1ecacda8ec)(messages, (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId)),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {},
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            }));
            setMessages(conversationId, (0, $d2bec76a2cf3a32e$export$78825c8f4b3c575c)(messagesBeforeReload, messages));
            dispatch((0, $692b8c108a723517$export$505adb47a68d73e6)({
                conversationId: conversationId,
                messages: messages
            }));
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).PREFETCH_CHAT
            });
            onSuccess?.();
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).PREFETCH_CHAT,
                error: normalizedError
            });
            if ((0, $d658c35e0bf26137$export$a36711287d720d2b)(error)) {
                (0, $95aa319c6be31138$export$3af2463ee5fae65d)({
                    conversationId: conversationId,
                    currentConversationId: getState().currentConversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                onError?.(normalizedError);
                return;
            }
            // Roll back warm loading state; do not set `skipNextFetch` on failure.
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: (0, $jyZaR.clearStatus)({})
            }));
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).PREFETCH_CHAT,
    actionErrorHandler: ()=>{
        // Errors are surfaced via `onError`; keep the silent warm path silent.
        return;
    }
});










const $6279909d4ebd325a$export$f9a3c275d8ffdac0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).removeMessage, ({ messageId: messageId, conversationId: conversationIdParam })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>{
            if ((0, $igOtY.isStoreError)(message) || (0, $igOtY.isStoreFollowUp)(message)) return message.id !== messageId;
            else if ((0, $igOtY.isStoreHuman)(message)) return message.content.id !== String(messageId);
            else return true;
        });
        setMessages(conversationId, filteredMessages);
    });




var $eQl6Z = parcelRequire("eQl6Z");







const $fef4f32b3ef3f920$export$1a0f0d45b9f5743b = ({ conversationId: conversationId, skipNextFetch: skipNextFetch })=>({ getState: getState, setState: setState })=>{
        const time = new Date().toISOString();
        // Register in conversations map
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId],
                    id: conversationId,
                    name: (0, $7td41.generateConversationName)(),
                    status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                    timeCreated: time,
                    lastMessageTimestamp: time,
                    traces: [],
                    messages: [],
                    lastMessageType: [],
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            },
            // Also set as active conversation
            currentConversationId: conversationId
        });
    };






var $ieeJu = parcelRequire("ieeJu");






















const $d153166f0ea80cab$export$d77ab4f31011f5b0 = (chat, messageId)=>chat.map((chatItem)=>{
        if ((0, $igOtY.isStoreAssistant)(chatItem) && (0, $fjUOt.getStoreMessageId)(chatItem) === messageId) return {
            ...chatItem,
            hasReceivedAnswerPart: undefined,
            content: {
                ...chatItem.content,
                streamingComplete: undefined
            }
        };
        return chatItem;
    });

















// Used to generate a unique `singleInstrumentationID` for tracking Question & Answer pairings
// before a response has been received from the server
const $2910c05405c27146$export$25a2389a84d1a0a0 = (timeStamp, conversationId)=>{
    // More detail on djb2 hash function https://theartincode.stanis.me/008-djb2/
    let hash = 5381;
    if (!timeStamp || !conversationId) return hash;
    const concat = conversationId + timeStamp;
    for(let i = 0; i < concat.length; i++)// Update the hash value
    hash = (hash << 5) + hash + concat.charCodeAt(i); // hash * 33 + c
    // Ensure the hash is a positive integer
    return hash >>> 0;
};


const $23567c2d6eaf1c81$export$eca740b13a7a3080 = (conversationId)=>String((0, $2910c05405c27146$export$25a2389a84d1a0a0)(new Date().toISOString(), conversationId));



















const $0b1976f4f4504448$var$A2UI_ACTION_MIME_TYPE = 'text/json';
const $0b1976f4f4504448$var$toStructuredActionContent = (action, hostMessageId)=>({
        data_parts_mime_type: 'application/json+a2ui',
        structured: true,
        data_parts: [
            {
                userAction: {
                    actionName: action.eventName,
                    context: {
                        ...action.context ?? action.dataModel ?? {},
                        assistantMessageId: hostMessageId
                    }
                }
            }
        ]
    });
const $0b1976f4f4504448$export$3c932f8ca2641253 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).sendA2UIAction, ({ action: action, hostMessageId: hostMessageId, conversationId: conversationIdParam, agentId: agentId, webSearchEnabled: webSearchEnabled, conciergeEnabled: conciergeEnabled, useCurrentBrowsingContext: useCurrentBrowsingContext, appFilters: appFilters, messageSources: messageSources })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        const insertsPendingTurnMessage = (0, $4o0zT.isExperimentEnabled)('rovo_chat_a2ui_demo_polish');
        const tmpAssistantMessageId = (0, $23567c2d6eaf1c81$export$eca740b13a7a3080)(conversationId);
        let activeAssistantMessageId = tmpAssistantMessageId;
        let hasInsertedTurnAssistantMessage = false;
        let hasTurnContent = false;
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1206f352a14d8e9a$export$cb6128fc3a3c8081)(()=>hasInsertedTurnAssistantMessage ? activeAssistantMessageId : undefined);
        let turnSurfaces;
        let agentMessageId;
        let requestId;
        let humanMessageId;
        let streamMeta;
        let initiatedTimestamp;
        let hasLoggedInitiated = false;
        let hasReceivedFinalResponse = false;
        const updateCurrentConversation = (data)=>{
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: data
            }));
        };
        const instrumentationId = ()=>agentMessageId ?? tmpAssistantMessageId;
        const trackInitiated = ()=>{
            if (hasLoggedInitiated) return;
            hasLoggedInitiated = true;
            trackAIMAUEvent({
                type: 'initiated',
                subjectId: messageSources?.interactionSource,
                proactive: false,
                userGenerated: true,
                timestamp: initiatedTimestamp,
                singleInstrumentationID: instrumentationId(),
                webSearchEnabled: webSearchEnabled,
                attributes: {
                    sendMessageReason: 'A2UI_ACTION',
                    actionName: action.eventName
                }
            });
        };
        const trackViewed = ()=>{
            trackAIMAUEvent({
                type: 'viewed',
                proactive: false,
                userGenerated: true,
                source: messageSources?.interactionSource,
                subjectId: messageSources?.followUpSource,
                messageId: agentMessageId,
                singleInstrumentationID: instrumentationId(),
                timestamp: new Date().toISOString(),
                webSearchEnabled: webSearchEnabled,
                citedProductList: streamMeta?.citedProductList ?? {},
                sourceProducts: streamMeta?.sourceProducts ?? {},
                connectorInfo: streamMeta?.connectorInfo,
                responseSources: streamMeta?.responseSources,
                usesJsm: streamMeta?.usesJsm,
                messageActions: streamMeta?.messageActions,
                messageDynamicUIData: streamMeta?.messageDynamicUIData,
                invokedFrom: streamMeta?.invokedFrom,
                pluginsInvoked: streamMeta?.pluginsInvoked,
                skillsInvoked: streamMeta?.skillsInvoked,
                executedStratusSkill: streamMeta?.executedStratusSkill,
                attributes: {
                    ...(0, $0Z0Rs.getPeopleDataProviderAttributes)(streamMeta?.peopleDataProviders ?? []),
                    sendMessageReason: 'A2UI_ACTION',
                    actionName: action.eventName,
                    /** Whether the response updated the surface only, without opening a message. */ surfaceOnlyResponse: !hasInsertedTurnAssistantMessage,
                    ...streamMeta?.interactionModeExecuted ? {
                        interactionModeExecuted: streamMeta.interactionModeExecuted
                    } : {}
                }
            });
        };
        const trackTerminal = (type)=>{
            trackInitiated();
            trackAIMAUEvent({
                type: type,
                userGenerated: true,
                messageId: requestId,
                subjectId: messageSources?.interactionSource,
                singleInstrumentationID: instrumentationId(),
                timestamp: new Date().toISOString(),
                webSearchEnabled: webSearchEnabled,
                attributes: {
                    sendMessageReason: 'A2UI_ACTION',
                    actionName: action.eventName
                }
            });
        };
        /** Inserts this turn's assistant message, once. */ const insertTurnAssistantMessage = ()=>{
            if (hasInsertedTurnAssistantMessage) return;
            hasInsertedTurnAssistantMessage = true;
            dispatch((0, $7b222e9f3b67e786$export$ce06e1b90807a0c0)({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                ...mentionAgentsEnabled ? {
                    agentAuthorId: agentId
                } : {
                    agentNamedId: agentId
                }
            }));
        };
        /**
   * Marks this turn's assistant message as holding reply text or a new surface, inserting
   * it if it is not there yet. A kept message is never removed.
   */ const keepTurnAssistantMessage = ()=>{
            hasTurnContent = true;
            insertTurnAssistantMessage();
        };
        /** Removes this turn's assistant message unless it was kept. */ const removeEmptyTurnAssistantMessage = ()=>{
            if (!insertsPendingTurnMessage || !hasInsertedTurnAssistantMessage || hasTurnContent) return;
            hasInsertedTurnAssistantMessage = false;
            setMessages(conversationId, getMessages(conversationId).filter((message)=>!(0, $igOtY.isStoreAssistant)(message) || (0, $fjUOt.getStoreMessageId)(message) !== tmpAssistantMessageId));
        };
        // Rewrites `<details>`/`<summary>` into the Rovo-native expand boundary — third-party
        // agents lean on it heavily. Built on the first chunk rather than here so the
        // conversation's agent metadata is settled by the time it decides.
        let markdownMultiTagProcessor = null;
        const getMarkdownMultiTagProcessor = ()=>{
            if (!markdownMultiTagProcessor) markdownMultiTagProcessor = (0, $94689fb12cc6f471$export$95c0abd604a2cca2)({
                shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
            });
            return markdownMultiTagProcessor;
        };
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource
                }
            });
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            // The host's completed-turn flags would otherwise keep the thinking indicator hidden.
            setMessages(conversationId, (0, $d153166f0ea80cab$export$d77ab4f31011f5b0)(getMessages(conversationId), hostMessageId));
            if (insertsPendingTurnMessage) insertTurnAssistantMessage();
            initiatedTimestamp = new Date().toISOString();
            const { generator: generator, responseData: responseData } = await assistanceService.sendMessageStream({
                conversationId: conversationId,
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing A2UI baseline: structured action content is adapted to the send pipeline's prompt type.
                message: $0b1976f4f4504448$var$toStructuredActionContent(action, hostMessageId),
                mimeType: $0b1976f4f4504448$var$A2UI_ACTION_MIME_TYPE,
                agentId: agentId,
                controller: abortController,
                storeMessage: false,
                citationsEnabled: true,
                webSearchEnabled: webSearchEnabled,
                conciergeEnabled: conciergeEnabled,
                useCurrentBrowsingContext: useCurrentBrowsingContext,
                appFilters: appFilters,
                optInSSEStream: true
            });
            for await (const streamObj of generator){
                const streamMessage = (0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                if ((0, $bxkJA.isStreamAgenticUi)(streamObj)) {
                    const agenticUiMessage = {
                        ...streamObj.data,
                        type: 'AGENTIC_UI'
                    };
                    const incomingA2UIMessages = agenticUiMessage.message.content;
                    if (Array.isArray(incomingA2UIMessages)) {
                        const a2uiMessages = incomingA2UIMessages;
                        turnSurfaces ?? (turnSurfaces = (0, $11b165b4e8e31cc9$export$15cd60ec7967aece)(getMessages(conversationId)));
                        const hasNewSurface = a2uiMessages.some((m)=>(0, $7crhj.isCreateSurface)(m) && !turnSurfaces?.has((0, $0a8e95b4b53343a1$export$f05e22a6badb9277)(m) ?? ''));
                        if (hasNewSurface) keepTurnAssistantMessage();
                        setMessages(conversationId, (0, $1be9bdb2a16ed0f4$export$8fcd85fa3cc8529c)({
                            messages: getMessages(conversationId),
                            incomingA2UIMessages: a2uiMessages,
                            createFallbackMessageId: tmpAssistantMessageId,
                            addressable: turnSurfaces
                        }));
                    }
                    continue;
                }
                if ((0, $58a7ad1d26ac260e$export$51720276ffc29c92)(streamMessage, conversationId, updateCurrentConversation)) continue;
                if ((0, $bxkJA.isConversationChannelDataMessage)(streamMessage)) {
                    agentMessageId = streamMessage.assistant_message_id;
                    trackInitiated();
                }
                // convo-ai streams an empty answer part with every A2A artifact, including an A2UI-only one.
                if ((0, $bxkJA.isStreamAnswerPart)(streamMessage) && (streamMessage.message.content || !((0, $4o0zT.isExperimentEnabled)('jira_ai_a2ui_skip_empty_answer_part') || insertsPendingTurnMessage))) {
                    keepTurnAssistantMessage();
                    const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = getMarkdownMultiTagProcessor()(streamMessage);
                    const hasMarkdownData = Object.keys(markdownData).length > 0;
                    setMessages(conversationId, hasMarkdownData ? (0, $ccf4709cceff6c1f$export$679615d953ba31c3)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: markdownData
                    }) : (0, $72779d19b192aa52$export$6e5609c05ab74cc7)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage
                    }));
                }
                if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                    hasReceivedFinalResponse = true;
                    requestId = streamMessage.metadata?.request_id ?? requestId;
                    streamMeta = (0, $577cc8ea0ec76152$export$2244b7838be162ca)(streamMessage, undefined, (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true));
                    humanMessageId = streamMeta.humanMessageId;
                    const finalResponseMessageId = streamMessage.message?.message?.id?.toString();
                    // Once `initiated` has been paired against an id, `viewed` has to carry the
                    // same one, so the final response only supplies it when nothing has fired yet.
                    if (!hasLoggedInitiated) agentMessageId = finalResponseMessageId ?? agentMessageId;
                    const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $d8a5551aed11b46f$export$82b32799d0ea512c)({
                        streamMessage: streamMessage,
                        messageId: finalResponseMessageId,
                        conversationId: conversationId,
                        sendAnalyticsEvent: sendAnalyticsEvent,
                        shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
                    });
                    /**
         * A reply whose text only arrives here still needs a message; one that
         * carried nothing but surface ops must not get one.
         */ if (processedStreamMessage.message?.message?.content) keepTurnAssistantMessage();
                    if (insertsPendingTurnMessage ? hasTurnContent : hasInsertedTurnAssistantMessage) setMessages(conversationId, (0, $387377d6766e3a79$export$60e170089d1b35dd)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: processedStreamMessage,
                        humanMessageId: humanMessageId,
                        markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                        traceId: responseData?.traceId,
                        onMessageIdChanged: (_oldId, newId)=>{
                            activeAssistantMessageId = newId;
                        }
                    }));
                }
                if ((0, $bxkJA.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are a valid outcome, so the experience still succeeds.
                    if ((0, $bxkJA.isStreamAUPError)(streamMessage)) experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION
                    });
                    throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: responseData?.traceId
                    });
                }
            }
        } catch (error) {
            if (error instanceof Error && error.name === 'AbortError') {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                    reason: 'Aborted'
                });
                confirmAbort();
                trackTerminal('dismissed');
                return;
            }
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                error: error instanceof Error ? error : new Error(String(error))
            });
            trackTerminal('error');
            throw error;
        } finally{
            removeEmptyTurnAssistantMessage();
            updateCurrentConversation((0, $jyZaR.clearStatus)({}));
            setMessages(conversationId, (0, $112200485e4c7f0b$export$680d2bb5b9579c57)(getMessages(conversationId)));
        }
        // A programmatic abort ends the generator cleanly rather than throwing.
        if (abortController.signal.aborted) {
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                reason: 'Aborted'
            });
            confirmAbort();
            trackTerminal('dismissed');
            return;
        }
        if (!hasReceivedFinalResponse) {
            const error = new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: undefined
            });
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION,
                error: error
            });
            trackTerminal('error');
            throw error;
        }
        trackInitiated();
        trackViewed();
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).SEND_A2UI_ACTION
        });
    });
















const $401ed0a05d5a948d$export$2250e3c2fe6e53e5 = (...args)=>({
        type: 'HUMAN',
        content: (0, $bkEBw.createHumanMessage)(...args)
    });


const $ccf70d20a8a5d0a4$export$9888dd09dd4e0151 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).addHumanMessage, ({ id: id, content: content, conversationId: conversationIdParam, isFromSeededConversation: isFromSeededConversation = false, requestId: requestId, fileUploads: fileUploads, displayContext: displayContext, followUpAgentIdentity: followUpAgentIdentity })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch((0, $c5b446309c731371$export$82301f76a841b4dc)({
            message: {
                ...(0, $401ed0a05d5a948d$export$2250e3c2fe6e53e5)(id, content, isFromSeededConversation, requestId, fileUploads, displayContext),
                ...followUpAgentIdentity ? {
                    followUpAgentIdentity: followUpAgentIdentity
                } : {}
            },
            conversationId: conversationId
        }));
    });










var $16g08 = parcelRequire("16g08");


/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing stream processing gates feature behavior from runtime flags. */ 
var $7TCQz = parcelRequire("7TCQz");


var $1hQ0e = parcelRequire("1hQ0e");





var $cha5E = parcelRequire("cha5E");








var $hq9Cp = parcelRequire("hq9Cp");





var $lUXDc = parcelRequire("lUXDc");








var $Ou0Zz = parcelRequire("Ou0Zz");






var $fCunh = parcelRequire("fCunh");


var $5XWbo = parcelRequire("5XWbo");








var $bQQtO = parcelRequire("bQQtO");













const $cf64faf992f18e85$var$getSelectedAgentIdForSend = (inputSelectedAgentIds, allowSelectedAgentOverride = false)=>{
    const activeSelectedAgentDraftId = inputSelectedAgentIds?.at(-1)?.trim();
    if (activeSelectedAgentDraftId && allowSelectedAgentOverride) return activeSelectedAgentDraftId;
    return undefined;
};
const $cf64faf992f18e85$export$4413981bab4da984 = ({ conversationAgent: conversationAgent, defaultAgent: defaultAgent, explicitAgentId: explicitAgentId, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields = false, inputSelectedAgentIds: inputSelectedAgentIds, allowSelectedAgentOverride: allowSelectedAgentOverride = false })=>{
    const mentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    if (!mentionAgentsExperimentEnabled) {
        // Preserve the former all-flags-off behavior for explicit caller-provided ids,
        // including empty and whitespace-only values.
        if (explicitAgentId !== undefined) {
            const isExplicitDefaultAgent = explicitAgentId === defaultAgent.id;
            return {
                routedSelectedAgentId: undefined,
                routingAgentId: explicitAgentId,
                agentIdForRequest: isExplicitDefaultAgent ? undefined : explicitAgentId,
                agentNamedIdForRequest: isExplicitDefaultAgent ? undefined : conversationAgent.named_id
            };
        }
        const shouldOmitConversationDefaultAgentRequestFields = omitConversationDefaultAgentRequestFields && conversationAgent.id === defaultAgent.id;
        return {
            routedSelectedAgentId: undefined,
            routingAgentId: conversationAgent.id,
            agentIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.id,
            agentNamedIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.named_id
        };
    }
    const normalizedExplicitAgentId = explicitAgentId || undefined;
    const routedSelectedAgentId = normalizedExplicitAgentId ? undefined : $cf64faf992f18e85$var$getSelectedAgentIdForSend(inputSelectedAgentIds, allowSelectedAgentOverride);
    const routingAgentId = normalizedExplicitAgentId ?? routedSelectedAgentId ?? conversationAgent.id;
    if (normalizedExplicitAgentId) return {
        routedSelectedAgentId: undefined,
        routingAgentId: routingAgentId,
        agentIdForRequest: normalizedExplicitAgentId
    };
    if (routedSelectedAgentId) return {
        routedSelectedAgentId: routedSelectedAgentId,
        routingAgentId: routingAgentId,
        agentIdForRequest: routedSelectedAgentId
    };
    return {
        routedSelectedAgentId: undefined,
        routingAgentId: routingAgentId,
        agentIdForRequest: conversationAgent.id
    };
};






var $2VSIF = parcelRequire("2VSIF");

/**
 * Minimal ADF shape needed to read a prompt's text. Typed structurally rather than importing the
 * ADF schema so this module stays dependency-free.
 */ /**
 * Nodes whose children are inline text runs. Every other node is a block, so its children each
 * start a new line — the prompt renderer splits on newlines to lay the prompt out, which would
 * otherwise run list items and paragraphs together.
 */ const $7e5b1b4e17adf7fb$var$INLINE_CONTAINERS = new Set([
    'paragraph',
    'heading'
]);
/** Concatenated text of every text node, preserving the prompt's line structure. */ const $7e5b1b4e17adf7fb$var$adfText = (node)=>{
    if (node.type === 'hardBreak') return '\n';
    if (node.text !== undefined) return node.text;
    const parts = (node.content ?? []).map($7e5b1b4e17adf7fb$var$adfText);
    return parts.join($7e5b1b4e17adf7fb$var$INLINE_CONTAINERS.has(node.type ?? '') ? '' : '\n');
};
const $7e5b1b4e17adf7fb$export$bd961bd04341d761 = (streamMessage)=>{
    const humanMessage = streamMessage.human_message;
    if (humanMessage?.content_mime_type === 'text/adf') try {
        const text = $7e5b1b4e17adf7fb$var$adfText(JSON.parse(humanMessage.content)).trim();
        if (text) return text;
    } catch  {
    // Unparseable ADF — fall back to the markdown prompt rather than dropping the redaction.
    }
    return streamMessage.redaction?.redacted_prompt;
};












const $548d18bad1818374$var$SEND_MESSAGE_METRICS_KEY = 'ai-mate.send-message';
const $548d18bad1818374$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY = 'ai-mate.time-to-first-answer-part';
const $548d18bad1818374$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY = 'ai-mate.time-to-first-action-part';
const $548d18bad1818374$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY = 'ai-mate.time-to-action-completion';
const $548d18bad1818374$export$1e4d1659c4209dbf = {
    createSendMessageMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $2dbdac089e2a67e6$export$72bdd99dfc759d06)($548d18bad1818374$var$SEND_MESSAGE_METRICS_KEY, params)
        });
    },
    createTimeToFirstAnswerPartMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $2dbdac089e2a67e6$export$72bdd99dfc759d06)($548d18bad1818374$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY, params)
        });
    },
    createTimeToFirstActionPartMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $2dbdac089e2a67e6$export$72bdd99dfc759d06)($548d18bad1818374$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY, params)
        });
    },
    createTimeToActionCompletionMetrics: (params)=>{
        return (0, $iDdTC.metrics).interaction({
            key: (0, $2dbdac089e2a67e6$export$72bdd99dfc759d06)($548d18bad1818374$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY, params)
        });
    }
};



var $l2exp = parcelRequire("l2exp");





const $462ad3e4f945b271$export$c9b02612b90eeb6c = (agentId)=>{
    if (!agentId) return false;
    return !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: agentId,
        agentNamedId: agentId
    });
};



var $6iQ4q = parcelRequire("6iQ4q");


var $jb3zd = parcelRequire("jb3zd");





var $Iv7dD = parcelRequire("Iv7dD");


var $bWtmp = parcelRequire("bWtmp");

const $6f034c45d985197a$var$JIRA_ISSUE_KEY_PATTERN = /^[A-Z][A-Z0-9_]*-\d+$/u;
const $6f034c45d985197a$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $6f034c45d985197a$var$normalizeIdentifier = (value)=>typeof value === 'string' ? value.trim().toUpperCase() || undefined : undefined;
const $6f034c45d985197a$var$getNormalizedSelectedIssues = (jiraViewContext)=>{
    const metadataIssues = Array.isArray(jiraViewContext.selectedIssuesMetadata) ? jiraViewContext.selectedIssuesMetadata.flatMap((value)=>{
        if (!$6f034c45d985197a$var$isRecord(value)) return [];
        const normalizedKey = $6f034c45d985197a$var$normalizeIdentifier(value.key);
        const identifier = normalizedKey ?? $6f034c45d985197a$var$normalizeIdentifier(value.id);
        if (!identifier) return [];
        return [
            {
                identifier: identifier,
                ...normalizedKey && $6f034c45d985197a$var$JIRA_ISSUE_KEY_PATTERN.test(normalizedKey) ? {
                    issueKey: normalizedKey
                } : {}
            }
        ];
    }) : [];
    const identifierIssues = Array.isArray(jiraViewContext.selectedIssueIdentifiers) ? jiraViewContext.selectedIssueIdentifiers.flatMap((value)=>{
        const identifier = $6f034c45d985197a$var$normalizeIdentifier(value);
        if (!identifier) return [];
        return [
            {
                identifier: identifier,
                ...$6f034c45d985197a$var$JIRA_ISSUE_KEY_PATTERN.test(identifier) ? {
                    issueKey: identifier
                } : {}
            }
        ];
    }) : [];
    const uniqueIssues = new Map();
    for (const issue of metadataIssues.length > 0 ? metadataIssues : identifierIssues)if (!uniqueIssues.has(issue.identifier)) uniqueIssues.set(issue.identifier, issue);
    return [
        ...uniqueIssues.values()
    ].sort((first, second)=>first.identifier < second.identifier ? -1 : first.identifier > second.identifier ? 1 : 0);
};
const $6f034c45d985197a$var$buildIssueUrl = (sourceUrl, issueKey)=>{
    if (!sourceUrl || !issueKey) return undefined;
    try {
        const issueUrl = new URL(sourceUrl);
        if (issueUrl.protocol !== 'http:' && issueUrl.protocol !== 'https:' || !issueUrl.hostname || issueUrl.username || issueUrl.password) return undefined;
        issueUrl.pathname = `/browse/${issueKey}`;
        issueUrl.search = '';
        issueUrl.hash = '';
        return issueUrl.toString();
    } catch  {
        return undefined;
    }
};
const $6f034c45d985197a$export$cec6d081aa41afce = (aiFeatureContext)=>{
    const jiraViewContext = aiFeatureContext?.jira_view_context;
    if (!$6f034c45d985197a$var$isRecord(jiraViewContext)) return undefined;
    const selectedIssues = $6f034c45d985197a$var$getNormalizedSelectedIssues(jiraViewContext);
    if (selectedIssues.length === 0) return undefined;
    const sourceUrl = typeof jiraViewContext.url === 'string' ? jiraViewContext.url : undefined;
    return {
        references: [
            {
                type: 'SELECTED_WORK',
                selected_work: {
                    ...sourceUrl !== undefined ? {
                        source_url: sourceUrl
                    } : {},
                    total_count: selectedIssues.length,
                    items: selectedIssues.slice(0, (0, $bWtmp.MAX_VISIBLE_SELECTED_WORK_ITEMS)).map((issue)=>{
                        const issueUrl = $6f034c45d985197a$var$buildIssueUrl(sourceUrl, issue.issueKey);
                        return {
                            identifier: issue.identifier,
                            issue_key: issue.issueKey,
                            ...issueUrl ? {
                                issue_url: issueUrl
                            } : {}
                        };
                    })
                }
            }
        ]
    };
};


const $7aee2421f1549c0a$export$6b58e85d865a8eef = (unifiedTasksActions)=>({
        createTaskFromStream: (args)=>unifiedTasksActions.createTaskFromStream(args),
        setTaskProgressState: (args)=>unifiedTasksActions.setTaskProgressState(args)
    });






var $gxA6a = parcelRequire("gxA6a");

const $57bd16fee4ca474b$export$4dbe3d442b9a6aec = ({ requestToken: requestToken, conversationId: conversationId, tmpHumanMessageId: tmpHumanMessageId })=>({ getState: getState, setState: setState }, { getMessages: getMessages })=>{
        const { promptHistory: promptHistory, conversations: conversations } = getState();
        const conversation = conversations[conversationId];
        if (!promptHistory || !requestToken || promptHistory.requestToken !== requestToken || !conversation) return;
        const sessionId = conversation.backendConversationId ?? conversationId;
        if (promptHistory.removedSessionIds?.some((id)=>id === conversationId || id === sessionId)) return;
        const message = getMessages(conversationId).find((item)=>(0, $igOtY.isStoreHuman)(item) && item.promptContextMessageId === tmpHumanMessageId);
        if (!message || !(0, $igOtY.isStoreHuman)(message) || message.content.id === tmpHumanMessageId || !message.content.id || message.redactedPrompt !== undefined || message.redactedByBlock || message.content.isFromSeededConversation) return;
        const displayText = (typeof message.content.content === 'string' ? message.content.content : (0, $gxA6a.extractPromptTextFromAdf)(message.content.content)).trim();
        const createdAt = Date.parse(message.content.time_created);
        if (!displayText || !Number.isFinite(createdAt)) return;
        const item = {
            messageId: message.content.id,
            sessionId: sessionId,
            displayText: displayText,
            truncated: false,
            isOpeningPrompt: true,
            createdAt: createdAt
        };
        setState({
            promptHistory: {
                ...promptHistory,
                hasLoaded: true,
                items: [
                    ...promptHistory.items.filter(({ messageId: messageId })=>messageId !== item.messageId),
                    item
                ].sort((a, b)=>b.createdAt - a.createdAt)
            }
        });
    };













var $jkAry = parcelRequire("jkAry");




const $129c50d8ba82d9d6$export$b043b11900276452 = ({ broadcastStreamStatus: broadcastStreamStatus, chatContextStoreActions: chatContextStoreActions, contentContextValue: contentContextValue, targetId: targetId, assistantMessageId: assistantMessageId, inlineRovoEditAttemptId: inlineRovoEditAttemptId, isExplicitUserCancellation: isExplicitUserCancellation })=>{
    return (status)=>{
        const cancellationMetadata = status === (0, $jb3zd.StreamLifecycleState).ABORTED && isExplicitUserCancellation?.() ? {
            isExplicitUserCancellation: true
        } : {};
        let contentTarget;
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            // Use targetId from sendMessage if provided, otherwise fall back to currentTargetId
            const activeTargetId = targetId ?? chatContextStoreActions.getCurrentTargetId();
            contentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
        } else contentTarget = chatContextStoreActions.getTarget(contentContextValue, targetId);
        // CCCEMAU-3764: stream data is routed to the editor for the current page even without a
        // registered content target (see `resolveEditorContentId`), for example a Remix started in
        // view mode on a classic page whose editor mounted mid-generation. A terminal broadcast has to
        // reach that same editor, or the `onStreamStart` side effects (disabled AI entry points) are
        // only undone by the bridge inactivity timeout. `send-context-ready` precedes any stream data,
        // so it keeps requiring a registered target.
        const fallbackPageId = !contentTarget && status !== (0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY ? (0, $jkAry.getCurrentPageId)() : undefined;
        broadcastStreamStatus?.(status, assistantMessageId, contentTarget ? {
            id: contentTarget.id,
            type: contentTarget.type,
            ...inlineRovoEditAttemptId && {
                inlineRovoEditAttemptId: inlineRovoEditAttemptId
            },
            ...cancellationMetadata
        } : fallbackPageId ? {
            id: fallbackPageId,
            type: 'page',
            ...inlineRovoEditAttemptId && {
                inlineRovoEditAttemptId: inlineRovoEditAttemptId
            },
            ...cancellationMetadata
        } : undefined);
        // An Ask Rovo edit on a whiteboard embed targets the board, which registers its own content
        // target, so the broadcast above reaches only the board. The page editor admitted the
        // attempt and holds the thinking state, so it needs the terminal status too or its next
        // `beginInlineRovoEdit` is rejected until a reload. `inlineRovoEditAttemptId` is only set
        // for an editor-owned inline edit, and the host ignores already-settled attempts.
        const ownerPageId = inlineRovoEditAttemptId && status !== (0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY && contentTarget?.type !== 'page' && !fallbackPageId && (0, $4o0zT.isExperimentEnabled)('cc_maui_whiteboard_inline_edit') ? (0, $jkAry.getCurrentPageId)() : undefined;
        if (ownerPageId) broadcastStreamStatus?.(status, assistantMessageId, {
            id: ownerPageId,
            type: 'page',
            inlineRovoEditAttemptId: inlineRovoEditAttemptId,
            ...cancellationMetadata
        });
    };
};











const $5b3e9b1b382cd3ec$export$145fa869c8c31e33 = ({ experienceTracker: experienceTracker, conversationId: conversationId, instrumentationId: instrumentationId, sendMessageExperienceName: sendMessageExperienceName, interactionSource: interactionSource, signal: signal, startTime: startTime = performance.now() })=>{
    const enabled = interactionSource === 'chatInput';
    let started = false;
    let trackedInvocationId;
    const callbackIds = new Map();
    let active = false;
    let receivedComplete = false;
    let unsubscribe;
    const name = (0, $irnO2.ExperienceName).REMIX_REGENERATE;
    const cleanup = ()=>{
        active = false;
        unsubscribe?.();
        signal.removeEventListener('abort', abort);
    };
    const abort = ()=>{
        if (active) experienceTracker.abort({
            name: name,
            reason: 'User cancelled chat remix edit'
        });
    };
    const fail = (error)=>{
        if (active) experienceTracker.fail({
            name: name,
            error: error
        });
    };
    const start = (invocationId, attributes)=>{
        if (!instrumentationId || started || signal.aborted) return;
        started = true;
        trackedInvocationId = invocationId;
        active = true;
        signal.addEventListener('abort', abort, {
            once: true
        });
        experienceTracker.start({
            name: name,
            id: instrumentationId,
            startTime: startTime,
            attributes: {
                ...attributes,
                isRemixRegenerate: true,
                editSource: 'chat',
                featureArea: 'remix',
                conversationChannelId: conversationId,
                instrumentationId: instrumentationId
            },
            onAbort: cleanup,
            onFailure: cleanup,
            onSuccess: cleanup
        });
        // Late-recognised edits missed the send-message start required by collect
        unsubscribe = experienceTracker.subscribe((event)=>{
            if (event.name !== sendMessageExperienceName || event.id !== conversationId) return;
            if (event.action === 'taskFail') fail(event.error);
            else if (event.action === 'taskAbort') {
                if (signal.aborted) abort();
                else fail(new Error(event.reason || 'send_message_aborted'));
            } else if (event.action === 'taskSuccess') {
                unsubscribe?.();
                if (active && !receivedComplete) experienceTracker.abort({
                    name: name,
                    reason: 'stream_completed_without_action_complete'
                });
            }
        });
    };
    return {
        fail: fail,
        process (streamMessage) {
            if (!enabled || !((0, $bxkJA.isStreamActionPrepare)(streamMessage) || (0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionComplete)(streamMessage))) return undefined;
            const { key: key, data: data, invocationId: invocationId } = streamMessage.message;
            const contentType = typeof data === 'object' && data !== null && 'contentType' in data ? data.contentType : undefined;
            let callbackId = callbackIds.get(invocationId);
            if (!callbackId) {
                if (key === (0, $aYC8J.DYNAMIC_UI_CREATE_KEY) && typeof data === 'object' && data !== null && 'previousMauiId' in data && typeof data.previousMauiId === 'string' && data.previousMauiId && (typeof contentType === 'string' || (0, $bxkJA.isStreamActionPrepare)(streamMessage) && contentType === undefined && (0, $aYC8J.isRemixGeneratedAction)(data)) && contentType !== 'diagram' && contentType !== 'whiteboard') start(invocationId, {
                    contentMauiId: data.previousMauiId,
                    remixType: contentType
                });
                else if (key === (0, $aYC8J.IMAGE_CREATE_KEY) && ((0, $aYC8J.isImageUpdateActionData)(data) || (0, $bxkJA.isStreamActionPrepare)(streamMessage) && (0, $aYC8J.isImageUpdatePrepareData)(data)) && data.previousMediaFileId) start(invocationId, {
                    mediaFileId: data.previousMediaFileId,
                    remixType: 'infographic'
                });
                else return undefined;
                if (!started || !instrumentationId) return undefined;
                // Untracked callbacks must not settle a later inline edit
                callbackId = invocationId === trackedInvocationId ? instrumentationId : `${instrumentationId}:${invocationId}`;
                callbackIds.set(invocationId, callbackId);
            }
            if (invocationId !== trackedInvocationId) return callbackId;
            receivedComplete || (receivedComplete = (0, $bxkJA.isStreamActionComplete)(streamMessage));
            if (active && typeof data === 'object' && data !== null) experienceTracker.updateAttributes({
                name: name,
                attributes: {
                    ...key === (0, $aYC8J.DYNAMIC_UI_CREATE_KEY) && typeof contentType === 'string' && {
                        remixType: contentType
                    },
                    ...'dynamicUiSubtype' in data && {
                        remixSubtype: data.dynamicUiSubtype
                    }
                }
            });
            return callbackId;
        }
    };
};



var $bMRok = parcelRequire("bMRok");












/**
 * Util function to determine the page context where Rovo chat is being used.
 *
 * This uses the existing context objects (editorContext, whiteboardContext, databaseContext)
 * and AI feature context to determine the surface, and falls back to the browser URL when no
 * context is available.
 *
 * This attribute is used on unified AI events (aiResult viewed, aiInteraction initiated)
 * to distinguish which surface Rovo chat was used on (e.g. edit page, view page, whiteboard, database).
 *
 * This is exported only for testing purposes.
 */ const $f14d784696e75101$export$1303843c2f44065a = ({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, aiFeatureContext: aiFeatureContext, browserUrl: browserUrl })=>{
    // Priority 1: Use existing context objects for reliable detection
    if (editorContext) return editorContext.isViewMode ? 'confluence-page-view' : 'confluence-page-edit';
    if (whiteboardContext) return whiteboardContext.isViewMode ? 'whiteboard-view' : 'whiteboard-edit';
    if (databaseContext) return 'database';
    if (aiFeatureContext?.jira_view_context) {
        const jiraContext = aiFeatureContext.jira_view_context;
        return typeof jiraContext.viewType === 'string' ? `jira-view-${jiraContext.viewType}` : 'jira-view';
    }
    // Priority 2: Fall back to URL-based detection when no context is available
    const url = browserUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (url.includes('/wiki/') && url.includes('/edit')) return 'confluence-page-edit';
    if (url.includes('/wiki/')) return 'confluence-page-view';
    if (url.includes('/whiteboard/')) return 'whiteboard';
    if (url.includes('/database/')) return 'database';
    return 'unknown';
};


/**
 * Util function to derive a generic view context attribute for analytics.
 *
 * Reads the AI feature context (populated by product-specific publishers, e.g. the Jira
 * Issue Navigator and Backlog views) and returns a flat record of scalar values that can
 * be attached to unified AI events (e.g. aiInteraction initiated) without leaking any
 * product-specific nested shape.
 *
 * Returns `undefined` when no known view context is available, in which case no
 * `viewContext` attribute is attached to the event.
 *
 * This is exported only for testing purposes.
 */ const $ac0e07e0dcb28459$export$20af16720c0f9c71 = ({ aiFeatureContext: aiFeatureContext })=>{
    if (!aiFeatureContext?.jira_view_context) return undefined;
    const jiraCtx = aiFeatureContext.jira_view_context;
    const ids = jiraCtx.selectedIssueIdentifiers;
    const projects = jiraCtx.projectIdentifiers;
    const filters = jiraCtx.filterIdentifiers;
    const jqlStrings = jiraCtx.jqlStrings;
    return {
        numberOfWorkItems: Array.isArray(ids) ? ids.length : 0,
        numberOfProjects: Array.isArray(projects) ? projects.length : 0,
        numberOfFilters: Array.isArray(filters) ? filters.length : 0,
        numberOfJqlStrings: Array.isArray(jqlStrings) ? jqlStrings.length : 0,
        viewType: typeof jiraCtx.viewType === 'string' ? jiraCtx.viewType : 'unknown'
    };
};



const $a2488f01d739616b$export$9f198c0729e6b053 = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled })=>{
    if (deepResearchEnabled) return 'deep_research';
    if (thinkDeeperEnabled || alphaExtendedThinkingMode) return 'think_deeper';
    if (taskModeEnabled) return 'max';
    if (fastModeEnabled) return 'fast';
    return 'auto';
};



const $b016bb6f9c6bc818$export$e26ccd8a2d744904 = (metrics)=>{
    let called = false;
    return (result, customData)=>{
        if (!called) {
            if (result === 'stop') metrics.stop({
                customData: customData
            });
            else metrics.cancel();
            called = true;
        }
    };
};


const $17f8fd46f090eaff$export$74253ae80f2bef05 = ({ creationContextParams: creationContextParams, messageSources: messageSources })=>{
    // A remix-create send originates from the remix menu (source === 'remix') and
    // is NOT a regenerate of an existing node (which uses inlineRovoFromRemix).
    const isRemixCreate = creationContextParams?.source === 'remix' && messageSources?.interactionSource !== 'inlineRovoFromRemix';
    if (!isRemixCreate) return {};
    return {
        isRemixCreate: true,
        contentMauiId: creationContextParams?.contentMauiId,
        mediaFileId: creationContextParams?.mediaFileId,
        remixType: creationContextParams?.dynamicUiType,
        remixSubtype: creationContextParams?.dynamicUiSubtype,
        ...creationContextParams?.experience ? {
            remixExperience: creationContextParams.experience
        } : {}
    };
};


const $00c83407afeee4cc$export$2632503e30ac5e44 = ({ creationContextParams: creationContextParams, messageSources: messageSources })=>{
    const interactionSource = messageSources?.interactionSource;
    const isInlineExistingNodeEdit = interactionSource === 'inlineRovoFromRemix';
    const isExplicitRemixEditExperience = creationContextParams?.experience === 'remix_edit' || creationContextParams?.experience === 'remix_custom';
    const isSharedEditInteractionSource = interactionSource === 'editor' || interactionSource === 'remixStagingArea';
    const isSharedEdit = creationContextParams?.source === 'remix' && (isExplicitRemixEditExperience || isSharedEditInteractionSource && Boolean(creationContextParams.contentMauiId || creationContextParams.mediaFileId));
    if (!isInlineExistingNodeEdit && !isSharedEdit) return {};
    return {
        isRemixRegenerate: true,
        ...isInlineExistingNodeEdit ? {
            remixRegenerateSource: 'inline-existing-node'
        } : {},
        editSource: interactionSource === 'editor' ? 'typeSwitcher' : 'rovoBar',
        contentMauiId: creationContextParams?.contentMauiId,
        mediaFileId: creationContextParams?.mediaFileId,
        remixType: creationContextParams?.dynamicUiType,
        remixSubtype: creationContextParams?.dynamicUiSubtype
    };
};



const $afd6bdca30ecbc92$export$dd1b85436e4b4f2d = (trackingAttributes)=>({
        ...(0, $411a747b8da7f11a$export$2f438a4a7bbfabc)(trackingAttributes.interactionModeRequested),
        ...trackingAttributes.aiFeatureName && {
            aiFeatureName: trackingAttributes.aiFeatureName
        }
    });


/**
 * Returns the given source-control value unless this send is actually routed by
 * a selected-agent override. Selected agents bring their own fixed source set,
 * but stale/whitespace selected-agent drafts and cross-surface handoffs that do
 * not use the draft must preserve the caller's source controls.
 * Exported for unit testing.
 */ function $d8e7db153f5f7161$export$7459a30868c458f({ routedSelectedAgentId: routedSelectedAgentId, value: value }) {
    return routedSelectedAgentId ? undefined : value;
}



var $5odSY = parcelRequire("5odSY");


var $9qJ1N = parcelRequire("9qJ1N");

const $86e81c25ee55514d$export$89a4ab1dea43d7ee = ({ conversationId: conversationId, taskMessage: taskMessage, messageId: messageId, target: target })=>{
    const executionSegments = (0, $9qJ1N.parseExecutionSegments)(taskMessage.execution_segments);
    switch(taskMessage.status){
        case 'DRAFT':
            target.createTaskFromStream({
                conversationId: conversationId,
                taskId: taskMessage.task_id,
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'COMPLETED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Completed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                seekingCompletedAck: true,
                completionMessageId: taskMessage.completion_message_id ?? messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'FAILED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Failed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'CANCELLED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Cancelled',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'RUNNING':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Running',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'AWAITING_ACTION_CONFIRMATION':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'AwaitingActionConfirmation',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        default:
            break;
    }
};



var $iEKWu = parcelRequire("iEKWu");





const $3026f86d03c99861$export$6944638c905cc63 = (additionalContext, source)=>source === 'quickFindChatIntentRouter' ? {
        ...additionalContext,
        searchBootstrapped: true
    } : additionalContext;



var $cC5sC = parcelRequire("cC5sC");


var $74lv3 = parcelRequire("74lv3");



































var $437v8 = parcelRequire("437v8");








const $cbc2db2fdddff710$export$a9ffe3cc687b4144 = (experienceTracker, reason, attributes)=>{
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        (0, $irnO2.ExperienceName).AIFC_MESSAGE
    ].forEach((experienceName)=>{
        experienceTracker.abort({
            name: experienceName,
            reason: reason,
            attributes: attributes
        });
    });
};


const $08fd19559950f700$export$a70b98ad4be3bac5 = (experienceTracker, experienceName, actionClassificationCount, actionCompleteCount, isBackendCreationRequest)=>{
    const attributes = {
        isBackendCreationRequest: isBackendCreationRequest,
        actionClassificationCount: actionClassificationCount,
        actionCompleteCount: actionCompleteCount
    };
    // Matches our condition for abortGenerateContentChildExperiences elsewhere, for callers that don't fallthrough
    // This gives us an explicit abort rather than a timeout
    if (actionClassificationCount > 0 && actionCompleteCount === 0) {
        experienceTracker.abort({
            name: experienceName,
            reason: 'stream_completed_without_action_complete',
            attributes: attributes
        });
        return;
    }
    if (!isBackendCreationRequest || // Not all FE requests provide action_classification, so a single complete is sufficient
    actionClassificationCount === actionCompleteCount) experienceTracker.succeed({
        name: experienceName,
        attributes: attributes
    });
    else experienceTracker.fail({
        name: experienceName,
        attributes: attributes,
        error: new Error('Action completion count did not match classifications')
    });
};




var $kc9aB = parcelRequire("kc9aB");


var $fC0nb = parcelRequire("fC0nb");



var $cgxs9 = parcelRequire("cgxs9");










const $35f48597532147ec$export$e3f334fc6effa531 = ({ chat: chat, answerId: answerId, useIndex: useIndex, memory: memory })=>(0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                memory: memory
            }),
        updateType: 'Add memory',
        useIndex: useIndex
    });






var $2g97a = parcelRequire("2g97a");

const $8ebe5aac085e0e04$export$1cdaa2c4089128bd = (chat, requestId)=>{
    const lastHumanMessage = (0, $2g97a.findLast)(chat, (0, $igOtY.isStoreHuman));
    // Skip if there is no last human message or if the requestId is already set
    if (!lastHumanMessage || !requestId || !!lastHumanMessage.content.requestId) return chat;
    const newHumanMessage = {
        ...lastHumanMessage,
        content: {
            ...lastHumanMessage.content,
            requestId: requestId
        }
    };
    const newChat = [
        ...chat
    ];
    newChat[newChat.lastIndexOf(lastHumanMessage)] = newHumanMessage;
    return newChat;
};










const $46ef359da629f1ab$var$SLOT_KEY_PREFIX = `${(0, $57dd585bc16302d8$export$db72bf56b242e316)}-`;
const $46ef359da629f1ab$var$toSlotKey = (slot)=>`${$46ef359da629f1ab$var$SLOT_KEY_PREFIX}${slot}`;
const $46ef359da629f1ab$var$isSlotKey = (key)=>key.startsWith($46ef359da629f1ab$var$SLOT_KEY_PREFIX);
const $46ef359da629f1ab$var$getSlotContent = (record)=>record.state === 'ready' ? record.content : '';
const $46ef359da629f1ab$export$ee4d42905bff12e4 = ({ onEventAfterClose: onEventAfterClose })=>{
    let nextSlot = 0;
    let closed = false;
    let hasReportedEventAfterClose = false;
    // Malformed typed events count too: they still mean RCS chose typed parts.
    let hasTypedEvents = false;
    // One key per legacy marker (a marker streamed over several chunks reuses its key),
    // recorded before any typed event too, since a legacy marker can arrive first.
    const parserLuminaKeys = new Set();
    const slots = new Map();
    // Kept after placement, so duplicate and close checks can use `content.has(partId)`.
    const content = new Map();
    const protocolErrors = {};
    const recordProtocolError = (error)=>{
        protocolErrors[error] = (protocolErrors[error] ?? 0) + 1;
    };
    const isAcceptingEvents = ()=>{
        if (!closed) {
            hasTypedEvents = true;
            return true;
        }
        if (!hasReportedEventAfterClose) {
            hasReportedEventAfterClose = true;
            onEventAfterClose();
        }
        return false;
    };
    const onUiPart = (event)=>{
        if (!isAcceptingEvents()) return null;
        if (!(0, $bxkJA.isStreamAnswerUiPart)(event)) {
            recordProtocolError('malformed_part');
            return null;
        }
        const partId = event.part_id;
        if (slots.has(partId)) {
            recordProtocolError('duplicate_part');
            return null;
        }
        const slot = nextSlot++;
        const payload = content.get(partId);
        slots.set(partId, slot);
        const slotKey = $46ef359da629f1ab$var$toSlotKey(slot);
        // The type guard doesn't check component_type, so it can be missing or not a string.
        const componentType = event.component_type;
        return {
            placeholder: (0, $57dd585bc16302d8$export$92e3747dfa4143de),
            markdownData: {
                [slotKey]: payload ? {
                    content: $46ef359da629f1ab$var$getSlotContent(payload),
                    loading: false
                } : {
                    content: '',
                    loading: true
                }
            },
            extraMarkdownData: typeof componentType === 'string' && componentType !== '' ? {
                [`${slotKey}-type`]: componentType
            } : {}
        };
    };
    const onUiContent = (event)=>{
        if (!isAcceptingEvents()) return null;
        if (!(0, $bxkJA.isStreamAnswerUiContent)(event)) {
            recordProtocolError('malformed_content');
            return null;
        }
        const partId = event.part_id;
        if (content.has(partId)) {
            recordProtocolError('duplicate_content');
            return null;
        }
        const record = event.state === 'ready' ? {
            state: 'ready',
            content: event.message.content
        } : {
            state: 'failed'
        };
        content.set(partId, record);
        const slot = slots.get(partId);
        if (slot === undefined) // Not an error: the payload waits until its part arrives.
        return null;
        return {
            key: $46ef359da629f1ab$var$toSlotKey(slot),
            content: $46ef359da629f1ab$var$getSlotContent(record),
            loading: false
        };
    };
    const onParserMarkdownData = (markdownData)=>{
        if (closed) return;
        for(const key in markdownData)if ($46ef359da629f1ab$var$isSlotKey(key)) parserLuminaKeys.add(key);
    };
    const close = (reason)=>{
        if (closed) return null;
        closed = true;
        if (hasTypedEvents && parserLuminaKeys.size > 0) protocolErrors.mixed_with_inline_markers = parserLuminaKeys.size;
        let partsWithoutPayload = 0;
        const slotUpdates = [];
        for (const [partId, slot] of slots){
            if (content.has(partId)) continue;
            partsWithoutPayload += 1;
            if (reason === 'aborted') slotUpdates.push({
                key: $46ef359da629f1ab$var$toSlotKey(slot),
                content: '',
                loading: false
            });
        }
        let payloadsWithoutPart = 0;
        for (const partId of content.keys())if (!slots.has(partId)) payloadsWithoutPart += 1;
        slots.clear();
        content.clear();
        parserLuminaKeys.clear();
        return {
            reason: reason,
            partsWithoutPayload: partsWithoutPayload,
            payloadsWithoutPart: payloadsWithoutPart,
            protocolErrors: {
                ...protocolErrors
            },
            slotUpdates: slotUpdates
        };
    };
    return {
        onUiPart: onUiPart,
        onUiContent: onUiContent,
        onParserMarkdownData: onParserMarkdownData,
        close: close
    };
};



const $4f6adf4ce39d49d0$export$9ab24f038484cfc7 = ({ chat: chat, answerId: answerId, updates: updates, useIndex: useIndex })=>{
    if (updates.length === 0) return chat;
    return (0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>{
            const markdownData = {
                ...storeAssistant.markdownData
            };
            for (const { key: key, content: content, loading: loading } of updates){
                markdownData[key] = content;
                markdownData[`${key}-loading`] = loading ? 'true' : 'false';
            }
            return {
                ...storeAssistant,
                markdownData: markdownData
            };
        },
        updateType: 'Set Answer UI Slots',
        useIndex: useIndex
    });
};


/**
 * Reports protocol errors, and parts still missing a payload at FINAL_RESPONSE (RCS
 * sends every payload before it). Missing payloads after an abort and unused payloads
 * are expected.
 */ const $46be802076879bb7$var$isAnswerUiPartsCloseAnomalous = (result)=>Object.keys(result.protocolErrors).length > 0 || result.reason === 'final' && result.partsWithoutPayload > 0;
const $46be802076879bb7$export$a383102dd028a1 = ({ conversationId: conversationId, getAnswerId: getAnswerId, answerIndex: answerIndex, getMessages: getMessages, setMessages: setMessages, onUiPartPlaced: onUiPartPlaced })=>{
    // Cards are additive, so a failed card write stops typed parts for this stream
    // instead of failing the text answer. Other stream writes aren't isolated: if they
    // fail, the answer is lost anyway.
    let disabled = false;
    const tracker = (0, $46ef359da629f1ab$export$ee4d42905bff12e4)({
        onEventAfterClose: ()=>{
            (0, $hlvTd.logException)({
                exception: new Error('Answer UI parts event received after the stream closed'),
                name: 'AnswerUiPartsProtocolError'
            });
        }
    });
    const reportClose = (closeResult)=>{
        if (!$46be802076879bb7$var$isAnswerUiPartsCloseAnomalous(closeResult)) return;
        const protocolErrorTags = {};
        for (const [error, count] of Object.entries(closeResult.protocolErrors))protocolErrorTags[`protocolError.${error}`] = String(count);
        (0, $hlvTd.logException)({
            exception: new Error('Answer UI parts stream closed with protocol errors or missing payloads'),
            name: 'AnswerUiPartsProtocolError',
            tags: {
                closeReason: closeResult.reason,
                partsWithoutPayload: String(closeResult.partsWithoutPayload),
                payloadsWithoutPart: String(closeResult.payloadsWithoutPart),
                ...protocolErrorTags
            }
        });
    };
    const tryWrite = (eventType, write)=>{
        try {
            write();
            return true;
        } catch (error) {
            disabled = true;
            (0, $hlvTd.logException)({
                exception: error,
                name: 'AnswerUiPartsStoreWriteError',
                tags: {
                    eventType: eventType
                }
            });
            return false;
        }
    };
    const handleStreamMessage = (streamMessage)=>{
        if (disabled) return false;
        // Bypasses the streaming parser: inside an open expand or follow-ups block the
        // placeholder would be captured as raw block text, so it wouldn't render as a card
        // but would still take a slot, shifting every later card. The card shows just after
        // the block instead. Not forwarded to promptStreamHook.onAnswerPart: it's
        // synthetic text, not model output.
        if (streamMessage.type === 'ANSWER_UI_PART') {
            const placement = tracker.onUiPart(streamMessage);
            const wrote = !!placement && tryWrite(streamMessage.type, ()=>setMessages(conversationId, (0, $ccf4709cceff6c1f$export$679615d953ba31c3)({
                    chat: getMessages(conversationId),
                    answerId: getAnswerId(),
                    answerPart: {
                        type: 'ANSWER_PART',
                        message: {
                            content: placement.placeholder,
                            role: 'ASSISTANT'
                        },
                        millisOffset: streamMessage.millisOffset
                    },
                    markdownData: placement.markdownData,
                    // Same write as the placeholder, so a loading card always has its type.
                    extraMarkdownData: placement.extraMarkdownData,
                    useIndex: answerIndex
                })));
            if (wrote) // Only once the card is in the store: this clears the thinking indicator.
            onUiPartPlaced();
            return wrote;
        }
        if (streamMessage.type === 'ANSWER_UI_CONTENT') {
            const slotUpdate = tracker.onUiContent(streamMessage);
            return !!slotUpdate && tryWrite(streamMessage.type, ()=>setMessages(conversationId, (0, $4f6adf4ce39d49d0$export$9ab24f038484cfc7)({
                    chat: getMessages(conversationId),
                    answerId: getAnswerId(),
                    updates: [
                        slotUpdate
                    ],
                    useIndex: answerIndex
                })));
        }
        return false;
    };
    // After a write failure, close reports would only restate it (payloads the tracker
    // never saw), so they're skipped.
    const onFinalResponse = ()=>{
        const closeResult = tracker.close('final');
        if (closeResult && !disabled) reportClose(closeResult);
    };
    const onStreamEnd = ()=>{
        const closeResult = tracker.close('aborted');
        if (!closeResult) return;
        if (!disabled) reportClose(closeResult);
        if (closeResult.slotUpdates.length === 0) return;
        // Still settle after a write failure, so cards placed before it don't stay loading.
        try {
            setMessages(conversationId, (0, $4f6adf4ce39d49d0$export$9ab24f038484cfc7)({
                chat: getMessages(conversationId),
                answerId: getAnswerId(),
                updates: closeResult.slotUpdates,
                useIndex: answerIndex
            }));
        } catch (error) {
            // Runs in `finally`: never mask the stream's own error. A failure after a
            // reported write failure is the same problem, so it isn't reported again.
            if (!disabled) (0, $hlvTd.logException)({
                exception: error,
                name: 'AnswerUiPartsAbortCleanupError'
            });
        }
    };
    return {
        handleStreamMessage: handleStreamMessage,
        observeParserMarkdownData: tracker.onParserMarkdownData,
        onFinalResponse: onFinalResponse,
        onStreamEnd: onStreamEnd
    };
};



var $gulpi = parcelRequire("gulpi");





var $042Lk = parcelRequire("042Lk");








var $cHkvP = parcelRequire("cHkvP");

function $a6228cb40d8c3db2$export$12e85b2979bdbb52(messages) {
    return (0, $cHkvP.getLastAssistantActions)(messages).some((action)=>(0, $aYC8J.isConfluenceCreatableAction)({
            key: action.key
        }) || (0, $aYC8J.isConfluenceUpdatableAction)({
            key: action.key
        }) || action.key === (0, $dw75i.CONFLUENCE_PAGE_CREATE_KEY));
}





/** Min response length (trimmed chars) worth offering a page for; filters trivial answers like "2". */ const $4907e9c8fcfc5bb2$export$7fd604660ea8b00b = 200;





function $e4f1bb76d5176be7$export$d8415dc9fe63acbe(messages, minLength = (0, $4907e9c8fcfc5bb2$export$7fd604660ea8b00b)) {
    const lastAssistant = (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreAssistant));
    const content = lastAssistant?.content?.message?.message?.content;
    if (content == null) // No assistant response yet — nothing to create a page from.
    return false;
    if (typeof content !== 'string') // Rich/structured content can't be cheaply measured — treat as substantive.
    return true;
    return content.trim().length >= minLength;
}


function $85a86afb88dde1c4$export$a5165b6c5017830(messages, productKey, isSmartCreationModalOpen = false) {
    if (productKey !== 'confluence' || !(0, $ieeJu.expValEquals)('confluence_fe_create_page_suggestion', 'isEnabled', true)) return false;
    // Already in a content-creation surface — the suggestion would be redundant.
    if (isSmartCreationModalOpen) return false;
    // An `ask_question` response is an interim clarifying step, not a final
    // answer, so there is nothing to "create a page from" yet — don't synthesize
    // the create-page follow-up for it.
    if ((0, $042Lk.lastAssistantHasAskQuestionAction)(messages)) return false;
    if (!(0, $e4f1bb76d5176be7$export$d8415dc9fe63acbe)(messages)) return false;
    return !(0, $a6228cb40d8c3db2$export$12e85b2979bdbb52)(messages);
}


function $4effe361fadab1cf$export$c2722b1ddbddcce5(messages, streamFollowUp, productKey, isSmartCreationModalOpen = false) {
    if (!(0, $85a86afb88dde1c4$export$a5165b6c5017830)(messages, productKey, isSmartCreationModalOpen)) return streamFollowUp;
    const existingFollowUps = streamFollowUp.message.follow_ups ?? [];
    if (existingFollowUps.some((f)=>f.text === (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT))) return streamFollowUp;
    return {
        ...streamFollowUp,
        message: {
            ...streamFollowUp.message,
            follow_ups: [
                ...existingFollowUps,
                {
                    type: 'SYNTHETIC',
                    text: (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT)
                }
            ]
        }
    };
}



const $9153b4ac17989006$export$94b1b79dc7d56f27 = ({ chat: chat, answerId: answerId, entityAnnotationBatch: entityAnnotationBatch })=>(0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                entityAnnotationBatches: [
                    ...storeAssistant.entityAnnotationBatches ?? [],
                    entityAnnotationBatch
                ]
            }),
        updateType: 'Append Entity Annotation Batch'
    });









const $e2cd33d1e2c5839a$export$23f1f8f522f4bdd = (config)=>{
    let armed = false;
    let firstChunkArrived = false;
    let timer;
    let stallCount = 0;
    const clearTimer = ()=>{
        if (timer !== undefined) {
            clearTimeout(timer);
            timer = undefined;
        }
    };
    const schedule = (stage)=>{
        clearTimer();
        const timeoutMs = config.baseMs;
        timer = setTimeout(()=>{
            stallCount += 1;
            config.sendAnalyticsEvent({
                eventType: 'track',
                action: 'timeout',
                actionSubject: 'rovoChatStream',
                attributes: {
                    stallCount: stallCount,
                    stage: stage,
                    timeoutMs: timeoutMs
                }
            });
            // Keep armed so we continue to detect subsequent stalls until chunks resume
            schedule('betweenChunks');
        }, timeoutMs);
    };
    return {
        arm: ()=>{
            if (armed) return;
            armed = true;
            // Start pre-first-chunk watchdog waiting for the first stream event
            schedule('newResponse');
        },
        onChunk: ()=>{
            if (!armed) return;
            if (firstChunkArrived === false) {
                firstChunkArrived = true;
                // After the first chunk, schedule timeout waiting for the next event
                schedule('firstGap');
                return;
            }
            // For subsequent chunks, re-arm the between-chunks watchdog
            schedule('betweenChunks');
        },
        stop: ()=>{
            clearTimer();
            armed = false;
        }
    };
};



















const $1dfaaa3b16fa6765$export$4c61fa3847049179 = (timeoutMs)=>{
    let resumeGraceUntil = 0;
    const browserDocument = (0, $1hQ0e.getDocument)();
    const browserWindow = browserDocument?.defaultView;
    const handleVisibilityChange = ()=>{
        if (browserDocument?.visibilityState === 'visible') resumeGraceUntil = Date.now() + timeoutMs;
    };
    browserDocument?.addEventListener('visibilitychange', handleVisibilityChange);
    browserWindow?.addEventListener('online', handleVisibilityChange);
    return {
        isPaused: ()=>{
            const isOffline = browserWindow?.navigator.onLine === false;
            const isHidden = browserDocument?.visibilityState === 'hidden';
            return isOffline || isHidden || Date.now() < resumeGraceUntil;
        },
        dispose: ()=>{
            browserDocument?.removeEventListener('visibilitychange', handleVisibilityChange);
            browserWindow?.removeEventListener('online', handleVisibilityChange);
        }
    };
};


const $b5a6b627405136a2$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
function $b5a6b627405136a2$export$29bad1ab941da7cb({ generator: generator, conversationId: conversationId, abortController: abortController, assistanceService: assistanceService, sendAnalyticsEvent: sendAnalyticsEvent, experienceTracker: experienceTracker, getMessageId: getMessageId, getRequestId: getRequestId, canReconnect: canReconnect, hasProcessedFinalResponse: hasProcessedFinalResponse, getInvalidatedFinalResponse: getInvalidatedFinalResponse, getState: getState, traceId: traceId, updateCurrentConversation: updateCurrentConversation, getIsChatMounted: getIsChatMounted, analyticsAttributes: analyticsAttributes, onBeforeFirstReconnect: callerOnBeforeFirstReconnect, onReconnecting: callerOnReconnecting, onReconnected: callerOnReconnected, onFirstChunkAfterReconnect: callerOnFirstChunkAfterReconnect, streamTimeout: streamTimeout }) {
    let totalAttempts = 0;
    let timeoutCount = 0;
    let recoveryStartedAt;
    let recoveryTrigger;
    let conversationRefreshOutcome;
    let perfMetrics;
    const getRecoveryAttributes = (recoveryOutcome)=>{
        const requestId = getRequestId?.();
        return {
            ...analyticsAttributes,
            conversationId: conversationId,
            messageId: getMessageId(),
            ...requestId !== undefined ? {
                requestId: requestId
            } : {},
            traceId: traceId,
            recoveryTrigger: recoveryTrigger,
            ...recoveryOutcome ? {
                recoveryOutcome: recoveryOutcome
            } : {},
            recoveryElapsedMs: recoveryStartedAt === undefined ? undefined : Math.max(0, Date.now() - recoveryStartedAt),
            timeoutCount: timeoutCount,
            streamTimeoutRecoveryEnabled: Boolean(streamTimeout)
        };
    };
    const cancelReconnectMetrics = ()=>{
        perfMetrics?.timeToConnectToStreamMetrics.cancel();
        perfMetrics?.timeToResumeStreamMetrics.cancel();
    };
    const timeoutPauseController = streamTimeout ? (0, $1dfaaa3b16fa6765$export$4c61fa3847049179)(streamTimeout.timeoutMs) : undefined;
    const wrapWithTimeout = (stream)=>streamTimeout ? (0, $0ac98c0a880a830b$export$44aab448715585b6)(stream, {
            timeoutMs: streamTimeout.timeoutMs,
            onTimeout: ()=>{
                const error = streamTimeout.onTimeout();
                if (error) timeoutCount++;
                return error;
            },
            isPaused: timeoutPauseController?.isPaused
        }) : stream;
    const reconnectableStream = (0, $bcd5e69edf2194aa$export$a802bb7fa59dba39)({
        initialGenerator: wrapWithTimeout(generator),
        canReconnect: ()=>!!getMessageId() && canReconnect(),
        completion: hasProcessedFinalResponse ? {
            isProcessed: hasProcessedFinalResponse,
            onReadError: ({ error: error, reconnectAttempts: reconnectAttempts })=>{
                const invalidatingEventType = getInvalidatedFinalResponse?.();
                if (invalidatingEventType) sendAnalyticsEvent((0, $c44f031f0678945d$export$3cdc20b361e6b93d)({
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    traceId: traceId,
                    error: error,
                    reconnectAttempts: reconnectAttempts,
                    recoveryOutcome: 'completionInvalidated',
                    invalidatingEventType: invalidatingEventType,
                    attributes: analyticsAttributes
                }));
            },
            onRecoveryExhausted: ({ error: error, failureMode: failureMode, reconnectAttempts: reconnectAttempts })=>{
                (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                cancelReconnectMetrics();
                if (reconnectAttempts > 0) experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'completedAnswerPreserved'
                });
                sendAnalyticsEvent((0, $c44f031f0678945d$export$3cdc20b361e6b93d)({
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    traceId: traceId,
                    error: error,
                    failureMode: failureMode,
                    reconnectAttempts: reconnectAttempts,
                    attributes: analyticsAttributes
                }));
            }
        } : undefined,
        getReconnectGenerator: (lastEventId)=>{
            const messageId = getMessageId();
            if (!messageId) return Promise.reject(new Error('Cannot reconnect: messageId is not available'));
            return assistanceService.reconnectToMessageStream({
                conversationId: conversationId,
                messageId: messageId,
                lastEventId: lastEventId,
                controller: abortController
            }).then((r)=>wrapWithTimeout(r.generator));
        },
        getEventId: (chunk)=>(0, $bxkJA.isSSEMessage)(chunk) && chunk.id ? chunk.id : undefined,
        onBeforeFirstReconnect: ({ streamError: streamError })=>{
            recoveryStartedAt = Date.now();
            recoveryTrigger = streamError instanceof (0, $b6N3q.RovoChatStreamTimeoutError) ? 'streamTimeout' : 'streamError';
            perfMetrics = (0, $a7542f0d9855c517$export$4f5dbc9d3a9c9f98)({
                isDeepResearchEnabled: analyticsAttributes?.isDeepResearch,
                thinkDeeperEnabled: analyticsAttributes?.thinkDeeperEnabled,
                fastModeEnabled: analyticsAttributes?.fastModeEnabled
            });
            perfMetrics.timeToConnectToStreamMetrics.start();
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                id: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: getRecoveryAttributes()
            });
            callerOnBeforeFirstReconnect?.();
        },
        onReconnecting: (attempt, maxAttempts, lastEventId)=>{
            totalAttempts = attempt;
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'retrying',
                actionSubject: 'rovoChatReconnection',
                attributes: {
                    attempt: attempt,
                    maxAttempts: maxAttempts,
                    hasLastEventId: !!lastEventId,
                    ...getRecoveryAttributes()
                }
            });
            updateCurrentConversation({
                traces: [
                    {
                        messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                        status: 'loading'
                    }
                ]
            });
            callerOnReconnecting?.(attempt, maxAttempts);
        },
        onReconnected: ()=>{
            perfMetrics?.timeToConnectToStreamMetrics.stop();
            perfMetrics?.timeToResumeStreamMetrics.start();
            callerOnReconnected?.();
        },
        onFirstChunkAfterReconnect: ()=>{
            perfMetrics?.timeToResumeStreamMetrics.stop();
            callerOnFirstChunkAfterReconnect?.();
        },
        onStreamCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    totalAttempts: totalAttempts,
                    ...getRecoveryAttributes(conversationRefreshOutcome === 'recovered' ? 'conversationRefresh' : 'streamReconnect')
                }
            });
        },
        onStreamFailed: (error)=>{
            cancelReconnectMetrics();
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                reason: 'Aborted',
                attributes: {
                    totalAttempts: totalAttempts,
                    ...getRecoveryAttributes('aborted')
                }
            });
            else experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                error: error instanceof Error ? error : new Error(String(error)),
                attributes: {
                    totalAttempts: totalAttempts,
                    ...getRecoveryAttributes(conversationRefreshOutcome === 'failed' ? 'exhausted' : 'failed')
                }
            });
        },
        onReconnectFailure: async ({ streamError: streamError, reconnectError: reconnectError })=>{
            if (abortController.signal.aborted || !(streamError instanceof (0, $b6N3q.RovoChatStreamTimeoutError))) return false;
            if (!streamTimeout?.onReconnectFailure) return false;
            conversationRefreshOutcome = 'failed';
            const recovered = await streamTimeout.onReconnectFailure(reconnectError ?? streamError);
            conversationRefreshOutcome = recovered ? 'recovered' : 'failed';
            return recovered;
        },
        shouldContinueRetrying: getIsChatMounted ? ()=>{
            if (!getIsChatMounted()) {
                abortController.abort($b5a6b627405136a2$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                return false;
            }
            return true;
        } : undefined,
        signal: abortController.signal
    });
    if (!timeoutPauseController) return reconnectableStream;
    return async function* streamWithTimeoutLifecycle() {
        try {
            yield* reconnectableStream;
        } finally{
            timeoutPauseController.dispose();
        }
    }();
}






function $3bd4037c0469b685$export$b323db724925d16f() {
    return {
        type: 'FOLLOW_UP_QUERIES',
        message: {
            follow_ups: [
                {
                    type: 'SYNTHETIC',
                    text: (0, $gulpi.CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT)
                }
            ]
        },
        millisOffset: 0
    };
}








const $a009f4a9a2158e28$export$4841ee9a7190fdf6 = {
    createDeadAirIntervalMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.dead-air-interval'
        });
    },
    createDeadAirMaxMetrics: ()=>{
        return (0, $iDdTC.metrics).interaction({
            key: 'ai-mate.dead-air-max'
        });
    }
};



var $cWJWG = parcelRequire("cWJWG");

const $6895c59b08828bb0$export$4a48e8ee48123078 = (config)=>{
    let previousMessageTimestamp = performance.now();
    let previousMessageTemplate;
    let previousMessageType;
    let maxDeadAirMs = 0;
    let totalDeadAirMs = 0;
    let maxPreviousMessageTemplate;
    let maxCurrentMessageTemplate;
    let maxPreviousMessageType;
    let maxCurrentMessageType;
    let deadAirIntervalsMs = [];
    const shouldIgnoreMessage = (message)=>{
        return (0, $bxkJA.isConversationChannelDataMessage)(message) || (0, $bxkJA.isStreamHeartbeat)(message) || // Counted by recordAnswerUiUpdate only if the Answer UI parts handler wrote them:
        // a payload before (or without) its part, duplicates, and events after a write
        // failure change nothing on screen.
        (0, $bxkJA.isStreamAnswerUiPart)(message) || (0, $bxkJA.isStreamAnswerUiContent)(message);
    };
    const shouldCountMessage = (message)=>{
        return (0, $bxkJA.isStreamResearchPayload)(message) || (0, $bxkJA.isStreamResearchPlan)(message) || (0, $bxkJA.isStreamTrace)(message) || (0, $bxkJA.isStreamThinkDeeperTriggered)(message) || (0, $bxkJA.isStreamAnswerPart)(message) || (0, $bxkJA.isStreamReasoningPart)(message) || (0, $bxkJA.isStreamActionPart)(message) || (0, $bxkJA.isStreamResponse)(message) || (0, $bxkJA.isFollowUpMessage)(message) || (0, $bxkJA.isStreamActionClassification)(message) || (0, $bxkJA.isStreamActionPrepare)(message) || (0, $bxkJA.isStreamActionComplete)(message) || (0, $bxkJA.isStreamActionError)(message) || (0, $bxkJA.isStreamError)(message) || (0, $bxkJA.isStreamTodoSnapshot)(message);
    };
    const getMessageTemplate = (message)=>{
        const nestedMessage = 'message' in message ? message.message : undefined;
        return nestedMessage && 'message_template' in nestedMessage ? nestedMessage.message_template : undefined;
    };
    const commonMetadata = {
        messageId: config.messageId,
        conversationId: config.conversationId,
        traceId: config.traceId,
        productKey: config.productKey,
        isExplicitDeepResearchEnabled: config.deepResearchEnabled,
        isExplicitThinkDeeperEnabled: config.thinkDeeperEnabled,
        isExplicitFastModeEnabled: config.fastModeEnabled,
        isWebSearchEnabled: config.webSearchEnabled,
        isAIFC: config.isAIFC,
        isExplicitThinkFasterEnabled: false,
        isImplicitThinkDeeper: false,
        hasSwitchedToFastThinking: false
    };
    const trackDeadAir = (deadAirMs, previousTemplate, currentTemplate, previousType, currentType)=>{
        const intervalMetric = (0, $a009f4a9a2158e28$export$4841ee9a7190fdf6).createDeadAirIntervalMetrics();
        const now = performance.now();
        intervalMetric.start({
            startTime: now - deadAirMs
        });
        intervalMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                previousMessageTemplate: previousTemplate ?? '',
                messageTemplate: currentTemplate ?? '',
                previousMessageType: previousType ?? '',
                messageType: currentType ?? ''
            }
        });
        totalDeadAirMs += deadAirMs;
        deadAirIntervalsMs.push(Math.round(deadAirMs)); // integer ms is enough accuray
        if (deadAirMs > maxDeadAirMs) {
            maxDeadAirMs = deadAirMs;
            maxPreviousMessageTemplate = previousTemplate;
            maxCurrentMessageTemplate = currentTemplate;
            maxPreviousMessageType = previousType;
            maxCurrentMessageType = currentType;
        }
    };
    const update = (streamMessage)=>{
        if (shouldIgnoreMessage(streamMessage)) return;
        if (!shouldCountMessage(streamMessage)) {
            config.sendAnalyticsEvent({
                eventType: 'operational',
                action: 'unrecognized',
                actionSubject: 'deadAirTrackerMessage',
                attributes: {
                    messageType: streamMessage.type ?? 'unknown',
                    messageTemplate: getMessageTemplate(streamMessage) ?? 'unknown',
                    conversationId: config.conversationId,
                    traceId: config.traceId
                }
            });
            return;
        }
        recordUpdate(streamMessage);
    };
    const recordUpdate = (streamMessage)=>{
        const currentTimestamp = performance.now();
        const currentTemplate = getMessageTemplate(streamMessage);
        if (currentTemplate === 'THINK_DEEPER_TRIGGERED') commonMetadata.isImplicitThinkDeeper = true;
        const currentMessageType = streamMessage.type;
        // Skip consecutive streaming messages (continuous token/content generation)
        // ANSWER_PART: Standard LLM response tokens
        // REASONING_PART: Think deeper extended reasoning phases (streamed thinking)
        // ACTION_PART: AIFC content generation chunks (whiteboards, documents, etc.)
        const isConsecutiveAnswerPart = previousMessageType === 'ANSWER_PART' && currentMessageType === 'ANSWER_PART';
        const isConsecutiveReasoningPart = previousMessageType === 'REASONING_PART' && currentMessageType === 'REASONING_PART';
        const isConsecutiveActionPart = previousMessageType === 'ACTION_PART' && currentMessageType === 'ACTION_PART';
        if (isConsecutiveAnswerPart || isConsecutiveReasoningPart || isConsecutiveActionPart) {
            previousMessageTimestamp = currentTimestamp;
            previousMessageTemplate = currentTemplate;
            previousMessageType = currentMessageType;
            return;
        }
        const deadAirMs = currentTimestamp - previousMessageTimestamp;
        // Skip negligible intervals (noise)
        if (!(0, $cWJWG.shouldExcludeInterval)(deadAirMs)) trackDeadAir(deadAirMs, previousMessageTemplate, currentTemplate, previousMessageType, currentMessageType);
        previousMessageTimestamp = currentTimestamp;
        previousMessageTemplate = currentTemplate;
        previousMessageType = currentMessageType;
    };
    const emitMaxDeadAir = ()=>{
        if (maxDeadAirMs === 0) return;
        const maxDeadAirMetric = (0, $a009f4a9a2158e28$export$4841ee9a7190fdf6).createDeadAirMaxMetrics();
        const now = performance.now();
        maxDeadAirMetric.start({
            startTime: now - maxDeadAirMs
        });
        maxDeadAirMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                maxDeadAirMs: maxDeadAirMs,
                totalDeadAirMs: Math.round(totalDeadAirMs),
                // integer ms is enough accuray
                deadAirIntervalsMs: JSON.stringify(deadAirIntervalsMs),
                previousMessageTemplate: maxPreviousMessageTemplate ?? '',
                messageTemplate: maxCurrentMessageTemplate ?? '',
                previousMessageType: maxPreviousMessageType ?? '',
                messageType: maxCurrentMessageType ?? ''
            }
        });
    };
    const complete = ()=>{
        emitMaxDeadAir();
    };
    const cancel = ()=>{
        emitMaxDeadAir();
    };
    return {
        update: update,
        recordAnswerUiUpdate: recordUpdate,
        complete: complete,
        cancel: cancel,
        resetTimestamp: ()=>{
            previousMessageTimestamp = performance.now();
        }
    };
};


const $a81109ab453d215f$export$9ac25e0768639c5d = (traces)=>{
    const messages = traces.map((trace)=>trace.messageContent);
    return traces.filter((trace, i)=>messages.lastIndexOf(trace.messageContent) === i);
};


const $d69dfb192d870466$export$69df77d21db987cc = (counts, batch)=>{
    let inferredProjectEntityAnnotationCount = counts.inferredProjectEntityAnnotationCount;
    let personEntityAnnotationCount = counts.personEntityAnnotationCount;
    for (const entity of batch.entities){
        if (entity.type === 'Person') personEntityAnnotationCount += 1;
        else if (entity.type === 'InferredProject') inferredProjectEntityAnnotationCount += 1;
    }
    return {
        inferredProjectEntityAnnotationCount: inferredProjectEntityAnnotationCount,
        personEntityAnnotationCount: personEntityAnnotationCount
    };
};
















const $2a6f93e9fee2ce65$var$WHITEBOARD_ACTION_KEYS = new Set([
    (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY),
    (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)
]);
const $2a6f93e9fee2ce65$var$DIAGRAM_UI_SUBTYPES = new Set([
    'flowchart',
    'mindmap'
]);
const $2a6f93e9fee2ce65$export$f3b7160b60840213 = (actionKey, source, dynamicUiSubtype)=>{
    if (actionKey && $2a6f93e9fee2ce65$var$WHITEBOARD_ACTION_KEYS.has(actionKey)) {
        if (source === 'remix') return `${actionKey}-maui`;
        if (dynamicUiSubtype && $2a6f93e9fee2ce65$var$DIAGRAM_UI_SUBTYPES.has(dynamicUiSubtype)) return `${actionKey}-diagram`;
    }
    return actionKey;
};





var $iqkMb = parcelRequire("iqkMb");


var $1jIs1 = parcelRequire("1jIs1");

const $2bb2c0e92fe02e4f$export$9f2ec1867195888b = (interactionSource)=>{
    if (interactionSource !== undefined && (0, $1jIs1.REMIX_INTERACTION_SOURCES).has(interactionSource)) return 'remix';
    if (interactionSource === (0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE)) return 0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE;
    return undefined;
};








const $f2c42700118b800b$export$a89606c68db527fb = (streamMessage)=>{
    return {
        messageContent: streamMessage.message?.content,
        messageTemplate: streamMessage.message?.message_template
    };
};










var $i7OAD = parcelRequire("i7OAD");











var $jr1ne = parcelRequire("jr1ne");


var $lwUDA = parcelRequire("lwUDA");


















const $7a7c8f4854868908$export$3353296bd53494e0 = 'ask_question - awaiting user response, cannot bound time';
const $7a7c8f4854868908$export$e28d5a20e5932c2 = 'non-confluence AIFC action returned';
const $7a7c8f4854868908$export$4d0618d7c44ba288 = ({ experienceTracker: experienceTracker, actions: actions = [], attributes: attributes })=>{
    const hasConfluenceAifcAction = actions.some((action)=>(0, $aYC8J.isConfluenceCreateNewAction)(action));
    const hasAskQuestionAction = actions.some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
    const hasOtherAifcAction = actions.some((action)=>(0, $i7OAD.isCreatableAction)(action));
    if (hasConfluenceAifcAction) return 'creating';
    if (!hasAskQuestionAction && !hasOtherAifcAction) return 'no-action';
    const reason = hasAskQuestionAction ? $7a7c8f4854868908$export$3353296bd53494e0 : $7a7c8f4854868908$export$e28d5a20e5932c2;
    experienceTracker.abort({
        name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        reason: reason,
        attributes: {
            ...attributes,
            aifcResponseActionClassification: hasAskQuestionAction ? 'ask-question' : 'other-aifc',
            aifcResponseActionKeys: actions.map((action)=>action.key)
        }
    });
    (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, reason, attributes);
    if (hasAskQuestionAction) (0, $lwUDA.abortPreviewCardRenderExperience)({
        experienceTracker: experienceTracker,
        reason: reason,
        terminalReason: 'awaiting-disambiguation',
        attributes: attributes
    });
    return 'aborted';
};






var $64wzj = parcelRequire("64wzj");

class $bc8b43680017f30e$export$17fb3253ebc25334 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.errorAttributes = {
            traceId: params.traceId ?? `NoActionInvoked-${(0, $64wzj.generateTraceId)()}`
        };
    }
}


// Only these classifications get the softer "no content" hint screen.
// Everything else (including missing or unknown) falls through to the error screen.
const $e3b868ed09efd836$var$ABORT_CLASSIFICATIONS = new Set([
    'BAD_USER_PROMPT',
    'GOOD_REPLY_NO_CREATE',
    'EXTERNAL_ERROR'
]);
const $e3b868ed09efd836$export$acbf6433e9af643f = (allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey, minionOutputs, experience)=>{
    // Some products do not require first response to be an action,
    // so exit early when we're not within Confluence
    if (productKey !== 'confluence') return true;
    // chat_edit is a global chat experience editing an existing page — not a CWR create flow.
    // A creatable action is not expected, so skip this validation entirely.
    if ((0, $iDrrr.fg)('confluence_aifc_new_live_page_chat_context') && experience === 'chat_edit') return true;
    const humanMessageCount = allMessages.filter((0, $igOtY.isStoreHuman)).length;
    // Only execute on the first human message within the staging area
    if (chatContextStoreActions.getIsStagingArea() && humanMessageCount === 1) {
        const firstAssistantResponse = allMessages.find((0, $igOtY.isStoreAssistant));
        const firstResponseActions = firstAssistantResponse?.content?.message?.message?.actions;
        // true when the response should have contained an action but did not
        let isMissingExpectedAction;
        if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes')) isMissingExpectedAction = (0, $7a7c8f4854868908$export$4d0618d7c44ba288)({
            experienceTracker: experienceTracker,
            actions: firstResponseActions,
            attributes: commonExperienceAttributes
        }) === 'no-action';
        else {
            const firstAction = firstResponseActions?.[0];
            const hasCreatableAction = firstAction ? (0, $i7OAD.isCreatableAction)(firstAction) : false;
            // An ask_question action is a valid first response (the agent is asking the user a
            // clarifying/disambiguation question), not a failed content creation. Treat it as
            // valid so the FINAL_RESPONSE is not misclassified as "no content created".
            const isAskQuestionAction = firstAction?.key === (0, $dw75i.ASK_QUESTION_KEY);
            isMissingExpectedAction = !hasCreatableAction && !isAskQuestionAction;
            // this experience has a timeout. since ask_question waits for the user, we cannot
            // bound the time. so we abort it now.
            // AIFC_GENERATE_CONTENT and its other sub experiences are intentionally left open.
            // content creation is still what we're waiting for, it just happens on a later turn.
            if (isAskQuestionAction) {
                const reason = 'ask_question - awaiting user response, cannot bound time';
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                    reason: reason,
                    attributes: commonExperienceAttributes
                });
                (0, $lwUDA.abortPreviewCardRenderExperience)({
                    experienceTracker: experienceTracker,
                    reason: reason,
                    terminalReason: 'awaiting-disambiguation',
                    attributes: commonExperienceAttributes
                });
            }
        }
        const authUrl = (0, $jr1ne.extractOutboundAuthLink)(firstAssistantResponse?.content?.message?.message?.content ?? '');
        // Experience handling for the scenario where there
        // should be an action returned but there was not
        if (isMissingExpectedAction) {
            // If authUrl is present, abort the experience
            if (authUrl) {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: 'authentication-required',
                    attributes: commonExperienceAttributes
                });
                (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, 'AIFC_GENERATE_CONTENT aborted - authentication required', commonExperienceAttributes);
            } else {
                // This error should have a user-friendly message, as it will be shown to the user.
                const noActionError = new (0, $bc8b43680017f30e$export$17fb3253ebc25334)("Something went wrong on Rovo's end. Please try sending your message again.", {
                    traceId: traceId
                });
                const hasConfluenceCreationTool = minionOutputs?.flat().some((output)=>output.minion_id === 'ConfluenceCreationTool');
                const messageMetadata = firstAssistantResponse?.content?.message?.message?.message_metadata;
                const orchestratorDepthLimitReached = messageMetadata?.orchestrator_depth_limit_reached ?? false;
                const orchestratorContextWindowUsage = messageMetadata?.orchestrator_context_window_usage;
                const classification = messageMetadata?.aifc_no_create_classification;
                const noContentCreatedAttributes = {
                    orchestratorContextWindowUsage: orchestratorContextWindowUsage,
                    orchestratorDepthLimitReached: orchestratorDepthLimitReached,
                    hasConfluenceCreationTool: hasConfluenceCreationTool,
                    noContentCreatedClassification: classification ?? 'NO_CLASSIFICATION_PROVIDED'
                };
                if (!classification || !$e3b868ed09efd836$var$ABORT_CLASSIFICATIONS.has(classification)) {
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                        error: noActionError,
                        attributes: {
                            ...commonExperienceAttributes,
                            ...noContentCreatedAttributes
                        }
                    });
                    (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, classification ?? 'NO_CLASSIFICATION_PROVIDED', commonExperienceAttributes);
                    const messages = getMessages(conversationId);
                    setMessages(conversationId, [
                        ...messages,
                        (0, $eBgZa.createStoreError)(noActionError)
                    ]);
                    sendMessageLatencyMetrics.cancel();
                    cancelStreamingMetrics();
                    return false;
                }
                // Abort: user prompt or external issue — nudge user to fix the problem
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: classification,
                    attributes: {
                        ...commonExperienceAttributes,
                        ...noContentCreatedAttributes
                    }
                });
                (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, classification, commonExperienceAttributes);
                // GOOD_REPLY_NO_CREATE is symptomatic of the user prompting non-creation, which we can also treat as a bad prompt
                const hintVariant = classification === 'EXTERNAL_ERROR' ? 'EXTERNAL_ERROR' : 'BAD_USER_INPUT';
                const messages = getMessages(conversationId);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'USAGE_HINT',
                        topic: 'NoActionInvokedError',
                        variant: hintVariant
                    }
                ]);
                return true;
            }
        }
    }
    return true;
};




const $86fda4fee88137f0$export$419ea2a7c4dc02c6 = (actions)=>Array.isArray(actions) && actions.some((action)=>action?.status === 'planned' || !!action?.confirmationMessage && action?.status !== 'started' && action?.status !== 'finished' && action?.status !== 'cancelled' && action?.status !== 'errored');





// The General Agent runtime UUID (DEFAULT_AGENT_UUID) doubles as the Solution Architect Agent
// runtime identity, which is currently the only agent with minion verification implemented. Minion
// verification analytics are gated to this identity (and the default named-id) for that reason.
const $21b951f90b04db4f$var$possible_agents = [
    (0, $2yWJZ.DEFAULT_AGENT_UUID),
    (0, $2yWJZ.DEFAULT_AGENT_NAMED_ID)
];
const $21b951f90b04db4f$var$MINION_VERIFICATION_ITEMS = [
    {
        alias: 'design-solution',
        minionId: 'SolutionArchitectMinion'
    },
    {
        alias: 'rovo-agent-builder',
        minionId: 'AgentBuilderMinion'
    },
    {
        alias: 'build-agent',
        minionId: 'AgentBuilderMinion'
    },
    {
        alias: 'build-automation',
        minionId: 'AutomationWorkflowBuilderMinion'
    }
];
const $21b951f90b04db4f$export$8bfbf77736e8f6e2 = ({ minionAlias: minionAlias, requestedSkills: requestedSkills, agentId: agentId, minionsOutput: minionsOutput, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    // Skill-routed requests do not promise legacy minion output, so verifying it would report false mismatches.
    if (!minionAlias || requestedSkills?.length) return;
    if (agentId && !$21b951f90b04db4f$var$possible_agents.includes(agentId)) return;
    $21b951f90b04db4f$var$MINION_VERIFICATION_ITEMS.forEach(({ alias: alias, minionId: minionId })=>{
        if (alias !== minionAlias) return;
        const hasAliasMatch = minionsOutput.some((output)=>output.minion_id === minionId);
        sendAnalyticsEvent({
            eventType: 'track',
            action: hasAliasMatch ? 'matched' : 'mismatched',
            actionSubject: 'aiMateMinionVerification',
            attributes: {
                name: minionId
            }
        });
    });
};





















var $6pP3y = parcelRequire("6pP3y");








var $xHMAX = parcelRequire("xHMAX");





var $hpOyG = parcelRequire("hpOyG");


var $1Tpom = parcelRequire("1Tpom");

const $f133b76f1d89ee64$export$3ba003c3111d103f = ()=>{
    const subExperienceCollect = (0, $hpOyG.collectAllWithSubExperienceAttributes)([
        (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER
    ]);
    return (events, experience)=>{
        // these experiences only run if the user chooses to open the preview while streaming is in progress. if they fail, bubble it up, but we dont rely on them for success/abort, because they may not even start
        (0, $1Tpom.failExperienceOnSubExperienceFail)((0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED, experience, events);
        (0, $1Tpom.failExperienceOnSubExperienceFail)((0, $irnO2.ExperienceName).PREVIEW_CONTENT, experience, events);
        subExperienceCollect(events, experience);
    };
};






var $1dlVf = parcelRequire("1dlVf");

const $69e9e652c7b59edc$export$95d2102da86339f1 = ({ experienceTracker: experienceTracker, conversationId: conversationId, rootExperienceName: rootExperienceName, commonExperienceAttributes: commonExperienceAttributes })=>{
    experienceTracker.start({
        name: rootExperienceName,
        id: conversationId,
        collect: (0, $1dlVf.createAifcExperienceCollect)(),
        attributes: commonExperienceAttributes
    });
    // Start AIFC_ALL_DATA_HANDLED - this replaces all explicit AIFC_UPDATE_CONTENT succeed/fail/abort calls
    // Product AIFC integration is responsible for succeeding this experience.
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        id: `${conversationId}-initial`,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
};














/**
 * Recorded when an action chunk carries no `status`, so that an absent status attribute can be
 * told apart from a stage that was never reached.
 */ const $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS = 'missing';
const $1f5f2c21ff9586f2$var$DEFAULT_PREVIEW_CARD_RENDER_TIMEOUT_MS = 60000;
const $1f5f2c21ff9586f2$var$IMAGE_CREATE_PREVIEW_CARD_RENDER_TIMEOUT_MS = 120000;
const $1f5f2c21ff9586f2$var$getPreviewCardRenderTimeout = (actionKey)=>actionKey === 'image-create' ? $1f5f2c21ff9586f2$var$IMAGE_CREATE_PREVIEW_CARD_RENDER_TIMEOUT_MS : $1f5f2c21ff9586f2$var$DEFAULT_PREVIEW_CARD_RENDER_TIMEOUT_MS;
const $1f5f2c21ff9586f2$export$baa645f348bcec07 = ({ editRequestId: editRequestId, streamMessage: streamMessage, conversationId: conversationId, tmpAssistantMessageId: tmpAssistantMessageId, traceId: traceId, productKey: productKey, deepResearchEnabled: deepResearchEnabled, storeUserMessages: storeUserMessages, streamActionInfo: streamActionInfo, trackingAttributes: trackingAttributes, experienceTracker: experienceTracker, chatContextStoreActions: chatContextStoreActions, getMessages: getMessages, setMessages: setMessages, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, promptStreamHook: promptStreamHook, openChat: openChat, messageSources: messageSources, creationContextParams: creationContextParams, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, isThirdPartyAgent: isThirdPartyAgent, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, extraMonitoringAttributes: extraMonitoringAttributes })=>{
    const isBackendCreationAction = (0, $bxkJA.isStreamMessageWithMessage)(streamMessage) && (0, $aYC8J.isServerSideExecutionAction)(streamMessage.message);
    const hasReceivedActionClassification = (0, $bxkJA.isStreamActionClassification)(streamMessage);
    const hasReceivedActionComplete = (0, $bxkJA.isStreamActionComplete)(streamMessage);
    const agent = agentId ? {
        id: agentId,
        name: agentName ?? '',
        identityAccountId: agentIdentityAccountId ?? null,
        namedId: agentNamedId,
        isThirdParty: isThirdPartyAgent
    } : undefined;
    let commonExperienceAttributes = {
        llmDebugLogsEnabled: storeUserMessages
    };
    if ((0, $bxkJA.isStreamActionClassification)(streamMessage)) {
        (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'working');
        promptStreamHook?.onActionClassification?.(streamMessage, tmpAssistantMessageId, conversationId);
        const actionKey = streamMessage.message.action_key;
        const actualContentType = (0, $i7OAD.getAIFCContentType)({
            key: actionKey
        });
        if (actualContentType === 'confluence-slide') {
            if ((0, $i7OAD.isCreatableAction)({
                key: actionKey
            })) (0, $Iv7dD.slidesAiEditLatency).classify(editRequestId, 'create');
            else if ((0, $i7OAD.isUpdatableAction)({
                key: actionKey
            })) (0, $Iv7dD.slidesAiEditLatency).classify(editRequestId, 'update');
        }
        commonExperienceAttributes = {
            ...commonExperienceAttributes,
            actionKey: actionKey,
            contentType: actualContentType,
            isStagingArea: chatContextStoreActions.getIsStagingArea(),
            humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
            product: productKey
        };
        if (trackingAttributes.forcedContentType) sendAnalyticsEvent({
            eventType: 'track',
            action: 'compared',
            actionSubject: 'forcedContentType',
            actionSubjectId: 'contentTypeMatch',
            attributes: {
                forcedContentType: trackingAttributes.forcedContentType,
                actualContentType: actualContentType,
                matched: actualContentType.endsWith(`-${trackingAttributes.forcedContentType}`),
                actionKey: actionKey
            }
        });
        const isUpdateAction = (0, $i7OAD.isUpdatableAction)({
            key: actionKey
        });
        if (isUpdateAction && (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1)) {
            const rootExperienceName = commonExperienceAttributes.isStagingArea ? (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT : (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT;
            (0, $69e9e652c7b59edc$export$95d2102da86339f1)({
                experienceTracker: experienceTracker,
                conversationId: conversationId,
                rootExperienceName: rootExperienceName,
                commonExperienceAttributes: commonExperienceAttributes
            });
        }
        const isCreateAction = (0, $i7OAD.isCreatableAction)({
            key: actionKey
        });
        if (isCreateAction) {
            // Remix diagrams are directly inserted into the editor or opened in Ephemeral Preview, so chat is not guaranteed or required to be open
            const isRemixDiagram = actionKey === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) && creationContextParams?.source === 'remix' && creationContextParams.dynamicUiType === 'diagram';
            const isGeneratingContentInChat = !isRemixDiagram || getIsChatMounted?.() || !(0, $4o0zT.isExperimentEnabled)('cc-cwr-fix-preview-card-experience-for-diagrams');
            const previewCardRenderTimeout = deepResearchEnabled ? undefined : $1f5f2c21ff9586f2$var$getPreviewCardRenderTimeout(actionKey);
            const previewCardRenderStartedAt = performance.now();
            if (isGeneratingContentInChat && (0, $iDrrr.fg)((0, $6pP3y.previewCardRenderLifecycle).featureGate)) (0, $6pP3y.previewCardRenderLifecycle).start({
                conversationId: conversationId,
                messageId: tmpAssistantMessageId,
                startedAtMs: previewCardRenderStartedAt,
                latencyBudgetMs: previewCardRenderTimeout
            });
            // initial prompt from staging area has its own AIFC_GENERATE_CONTENT experience - dont start this one
            if (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1) {
                if (isGeneratingContentInChat) experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                    id: conversationId,
                    collect: (0, $f133b76f1d89ee64$export$3ba003c3111d103f)(),
                    attributes: commonExperienceAttributes
                });
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                    id: conversationId,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
                if (isGeneratingContentInChat) experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                    id: conversationId,
                    timeout: previewCardRenderTimeout,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                        [(0, $irnO2.PreviewCardRenderStage).STARTED_AT]: previewCardRenderStartedAt
                    }
                });
                // Product AIFC integration is responsible for succeeding this experience.
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
                    id: conversationId,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
            } else {
                // update AIFC_GENERATE_CONTENT now that intent detection is complete. This experience starts as the user sends the message on the initial prompt screen
                experienceTracker.updateAttributes({
                    name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                    attributes: commonExperienceAttributes
                });
                experienceTracker.updateAttributes({
                    name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                    attributes: commonExperienceAttributes
                });
            }
        }
    }
    if ((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
        (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'editing');
        // Update action tracking info
        if (!streamActionInfo.isAction) {
            streamActionInfo.isAction = true;
            streamActionInfo.actionKey = streamMessage.message.key;
        }
        // track attribute for action prepare
        if ((0, $bxkJA.isStreamActionPrepare)(streamMessage) && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            const actionData = streamMessage.message.data;
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                attributes: {
                    dynamicUiSubtype: actionData?.dynamicUiSubtype
                }
            });
            // Remix flows skip ACTION_CLASSIFICATION and go straight to ACTION_PREPARE,
            // so we start PREVIEW_CARD_RENDER here for remix flows.
            // Only start when rovo chat is mounted/visible to the user.
            const isRemixObjectFlow = creationContextParams?.experience === 'remix_object';
            if (getIsChatMounted?.() && ((0, $aYC8J.isRemixGeneratedFlow)({
                key: streamMessage.message.key,
                data: streamMessage.message.data
            }) || isRemixObjectFlow)) {
                const remixActionKey = streamMessage.message.key;
                const actualContentType = (0, $i7OAD.getAIFCContentType)({
                    key: remixActionKey
                });
                const previewCardRenderTimeout = $1f5f2c21ff9586f2$var$getPreviewCardRenderTimeout(remixActionKey);
                const previewCardRenderStartedAt = performance.now();
                if ((0, $iDrrr.fg)((0, $6pP3y.previewCardRenderLifecycle).featureGate)) (0, $6pP3y.previewCardRenderLifecycle).start({
                    conversationId: conversationId,
                    messageId: tmpAssistantMessageId,
                    startedAtMs: previewCardRenderStartedAt,
                    latencyBudgetMs: previewCardRenderTimeout
                });
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                    id: conversationId,
                    timeout: previewCardRenderTimeout,
                    attributes: {
                        ...commonExperienceAttributes,
                        actionKey: remixActionKey,
                        isStagingArea: chatContextStoreActions.getIsStagingArea(),
                        humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
                        product: productKey,
                        featureArea: 'remix',
                        remixType: (0, $aYC8J.getDynamicUiType)(streamMessage.message),
                        contentType: actualContentType,
                        ...trackingAttributes.forcedContentType && {
                            aifcObjectType: trackingAttributes.forcedContentType
                        },
                        [(0, $irnO2.PreviewCardRenderStage).STARTED_AT]: previewCardRenderStartedAt
                    }
                });
            }
        }
        if ((0, $bxkJA.isStreamActionPart)(streamMessage)) {
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                attributes: {
                    [(0, $irnO2.PreviewCardRenderStage).ACTION_PART_AT]: performance.now(),
                    [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_PART_STATUS]: streamMessage.message.status ?? $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS
                }
            });
            if ((0, $iDrrr.fg)((0, $6pP3y.previewCardRenderLifecycle).featureGate)) (0, $6pP3y.previewCardRenderLifecycle).update({
                conversationId: conversationId,
                messageId: tmpAssistantMessageId,
                latestLifecycleStage: (0, $6pP3y.previewCardRenderLifecycle).stage.ACTION_PART
            });
            const actionData = streamMessage.message.data;
            stopInteractionMetricsTimeToFirstActionPart('stop', {
                actionType: 'action-part',
                conversationId: conversationId,
                actionPartKey: (0, $2a6f93e9fee2ce65$export$f3b7160b60840213)(streamMessage.message.key, creationContextParams?.source, actionData?.dynamicUiSubtype),
                interactionSource: messageSources?.interactionSource,
                remixType: creationContextParams?.dynamicUiType
            });
        }
        const actionKey = streamMessage.message.key;
        const lastAction = (0, $kNXXO.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
        if (lastAction && (0, $aYC8J.isAccumulatedAction)(actionKey)) {
            const isAccumulatedActionType = (0, $aYC8J.getAccumulatedActionTypeGuard)(actionKey);
            if (isAccumulatedActionType(streamMessage.message.data)) {
                const primaryAccumulatedData = (0, $aYC8J.getPrimaryAccumulatedValue)(lastAction);
                if (primaryAccumulatedData?.value) streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
            }
        }
        processMessageStreamAction?.(tmpAssistantMessageId, streamMessage, agent, traceId, trackingAttributes.requestId, undefined, {
            editRequestId: editRequestId,
            singleInstrumentationId: trackingAttributes.instrumentationId,
            // Forward the originating experience so the editor receiver
            // can auto-open the Post Stream Review "Review moment" only for inline edits.
            experience: creationContextParams?.experience,
            ...creationContextParams && {
                creationContextParams: creationContextParams
            },
            ...extraMonitoringAttributes && {
                extraMonitoringAttributes: extraMonitoringAttributes
            }
        });
        promptStreamHook?.onActionPart?.(streamMessage, tmpAssistantMessageId, conversationId, openChat);
        const updatedMessages = (0, $ce5a795e167dd10b$export$13b6a4e4e3704011)({
            chat: getMessages(conversationId),
            messageId: tmpAssistantMessageId,
            actionPart: streamMessage,
            actionUpdaterOverride: (0, $aYC8J.customActionUpdater)
        });
        if ((0, $bxkJA.isStreamActionPrepare)(streamMessage)) {
            const actionMessage = streamMessage.message;
            experienceTracker.updateAttributes({
                name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
                attributes: {
                    [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_PREPARE_STATUS]: actionMessage.status ?? $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS
                }
            });
            if ((0, $iDrrr.fg)((0, $6pP3y.previewCardRenderLifecycle).featureGate)) (0, $6pP3y.previewCardRenderLifecycle).update({
                conversationId: conversationId,
                messageId: tmpAssistantMessageId,
                latestLifecycleStage: (0, $6pP3y.previewCardRenderLifecycle).stage.ACTION_PREPARE
            });
            // Abort the remix-edit-existing UFO experience if the streamed action is not remix.
            if (!(0, $aYC8J.isRemixGeneratedFlow)(actionMessage)) (0, $irnO2.remixEditExistingExperience).abort({
                metadata: {
                    reason: 'non-remix-action'
                }
            });
            setMessages(conversationId, [
                ...updatedMessages,
                {
                    type: 'ACTION_PREPARE',
                    action: actionMessage
                }
            ]);
        } else setMessages(conversationId, updatedMessages);
    }
    if ((0, $bxkJA.isStreamActionClassification)(streamMessage) && streamMessage.message.metadata) // Send ACTION_CLASSIFICATION metadata to the Editor Rovo bridge
    processMessageStreamActionClassification?.(tmpAssistantMessageId, streamMessage, (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') ? agent : undefined, traceId, trackingAttributes.requestId, {
        singleInstrumentationId: trackingAttributes.instrumentationId
    });
    if ((0, $bxkJA.isStreamActionComplete)(streamMessage)) {
        // A doc action completed, but the turn isn't over — more actions or a trailing answer may
        // follow, and the write is still being applied. Keep the node active; `done` fires at the
        // final response (the true turn end).
        (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'editing');
        if (!trackingAttributes.invokedFrom && messageSources?.entryPoint === 'cwrBlankObject' && (0, $4o0zT.isExperimentEnabled)('aifc_invokedfrom_on_reconnect')) {
            const invokedFrom = (0, $dc46cb9d819f569e$export$a0e3245ee56765fd)({
                messageActionKey: streamMessage.message.key,
                messageActionData: streamMessage.message.data
            });
            if (invokedFrom) trackingAttributes.invokedFrom = invokedFrom;
        }
        promptStreamHook?.onActionComplete?.(streamMessage, tmpAssistantMessageId);
        processMessageStreamComplete?.(tmpAssistantMessageId, streamMessage, (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') || (0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_agent_attribution') ? agent : undefined, traceId, trackingAttributes.requestId, {
            editRequestId: editRequestId,
            singleInstrumentationId: trackingAttributes.instrumentationId,
            // Forward the originating experience so the editor receiver
            // can auto-open the Post Stream Review "Review moment" only for inline edits.
            experience: creationContextParams?.experience,
            ...creationContextParams && {
                creationContextParams: creationContextParams
            },
            ...extraMonitoringAttributes && {
                extraMonitoringAttributes: extraMonitoringAttributes
            },
            entryPoint: messageSources?.entryPoint,
            conversationChannelId: conversationId
        });
        const actionMessage = streamMessage.message;
        if ((0, $aYC8J.isPageDatabaseOrWhiteboardCreation)(actionMessage)) trackingAttributes.serverSideExecution = (0, $aYC8J.isServerSideExecutionAction)(actionMessage);
        if (actionMessage.key === (0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY) && (0, $4o0zT.isExperimentEnabled)('aifc_visual_block_attributes')) experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
            attributes: (0, $xHMAX.getGeneratedVisualBlockCounts)(actionMessage.data)
        });
        // Match the existing single-create analytics emitted after the Confluence page editor
        // applies its initial content. Backend-created pages bypass that editor path, so emit the
        // same event from their successful ACTION_COMPLETE instead. Keep this page-specific so
        // createdContentType remains accurate; content features are unavailable because no editor
        // document is applied on the frontend, while the backend response supplies the content ID.
        if (isBackendCreationAction && actionMessage.key === (0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY) && (0, $aYC8J.isConfluenceAIFCPageCreateActionData)(actionMessage.data)) sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'smartCreateContent',
            action: 'initialContentCreated',
            attributes: {
                ...(0, $iDrrr.fg)('aifc_request_id_analytics') && trackingAttributes.requestId ? {
                    request_id: trackingAttributes.requestId
                } : {},
                ...(0, $iDrrr.fg)('aifc_trace_id_analytics') && traceId ? {
                    traceID: traceId
                } : {},
                createdContentProduct: 'confluence',
                createdContentType: 'page',
                createdContentFeatures: undefined,
                createdContentMetadata: {
                    contentId: actionMessage.data.contentId
                }
            }
        });
        if (isBackendCreationAction) trackingAttributes.messageActions = [
            ...trackingAttributes.messageActions ?? [],
            actionMessage.key
        ];
        let messages = getMessages(conversationId);
        // Insert the completed action only when it isn't already on the message — those actions arrived
        // with no ACTION_PART chunks, so nothing has added them yet. When the action did stream,
        // re-running the accumulator on the completed snapshot would corrupt its accumulated content,
        // so leave it untouched.
        const { invocationId: invocationId } = actionMessage;
        const isActionAlreadyOnMessage = Boolean(invocationId && (0, $kNXXO.findLastAssistantAction)(messages, (action)=>action.invocationId === invocationId));
        if (!isActionAlreadyOnMessage) messages = (0, $ce5a795e167dd10b$export$13b6a4e4e3704011)({
            chat: messages,
            messageId: tmpAssistantMessageId,
            actionPart: streamMessage,
            // The completed action is a full snapshot, so replace rather than accumulate — this avoids
            // double-appending the primary document if a match is ever found.
            actionUpdaterOverride: (_prevAction, nextAction)=>nextAction
        });
        // Stamp the trace ID on this action's assistant message so feedback can report it.
        const messagesWithTraceId = traceId ? messages.map((msg)=>msg.type === 'ASSISTANT' && (0, $fjUOt.getStoreMessageId)(msg) === tmpAssistantMessageId ? {
                ...msg,
                traceId: traceId
            } : msg) : messages;
        setMessages(conversationId, [
            ...messagesWithTraceId,
            {
                type: 'ACTION_COMPLETE',
                action: actionMessage
            }
        ]);
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
            attributes: {
                [(0, $irnO2.PreviewCardRenderStage).ACTION_COMPLETE_AT]: performance.now(),
                [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_COMPLETE_STATUS]: streamMessage.message.status ?? $1f5f2c21ff9586f2$var$MISSING_ACTION_STATUS,
                // Sanity check that one message did not stream chunks under multiple action keys.
                [(0, $irnO2.PreviewCardRenderActionAttribute).ACTION_COMPLETE_KEY]: streamMessage.message.key
            }
        });
        if ((0, $iDrrr.fg)((0, $6pP3y.previewCardRenderLifecycle).featureGate)) (0, $6pP3y.previewCardRenderLifecycle).update({
            conversationId: conversationId,
            messageId: tmpAssistantMessageId,
            latestLifecycleStage: (0, $6pP3y.previewCardRenderLifecycle).stage.ACTION_COMPLETE
        });
        // Always succeed AIFC_MESSAGE from FINAL_RESPONSE instead for backend multi-create events, or when
        // the parity experiment is enabled to streamline frontend and backend handling.
        if (!(isBackendCreationAction || (0, $4o0zT.isExperimentEnabled)('cwr-fe-be-experience-analytics-streamline'))) // When enabled, action completion is handled from FINAL_RESPONSE for both frontend and
        // backend creation so the complete action set is known before the experience succeeds.
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).AIFC_MESSAGE
        });
    }
    return {
        hasReceivedActionClassification: hasReceivedActionClassification,
        hasReceivedActionComplete: hasReceivedActionComplete,
        isBackendCreationAction: isBackendCreationAction
    };
};










const $c7a5ce35f595c3fa$export$e884abe68ebbc0aa = ()=>{
    try {
        const messages = window.top?.__rovoStreamResponseMessages__ ?? [];
        return messages.join('\n');
    } catch  {
        // Ignore cross-origin frame access errors
        return '';
    }
};


const $6183d90d38791925$export$a50d66ef75a63fe5 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseOutput__ = (0, $c7a5ce35f595c3fa$export$e884abe68ebbc0aa);
    } catch  {
    // Ignore cross-origin frame access errors
    }
};


// Install `window.top.__rovoStreamResponseOutput__` at module load. This module is
// pulled into the runtime bundle because `processStream` imports the used
// `recordStreamMessage` binding below, so this top-level call is retained (the package
// is marked `sideEffects: ["*.compiled.css"]`, so a bare `import './x'` for effect would
// be tree-shaken away).
(0, $6183d90d38791925$export$a50d66ef75a63fe5)();
const $bd1b2048488e5a34$export$7d55b756f7f2ed43 = (message)=>{
    try {
        if (window.top) {
            if (!window.top.__rovoStreamResponseMessages__) window.top.__rovoStreamResponseMessages__ = [];
            const serialised = JSON.stringify(message);
            window.top.__rovoStreamResponseMessages__.push(serialised);
        }
    } catch  {
    // Ignore cross-origin frame access errors
    }
};




const $ff8723ce29790d95$export$e3d8e4fb1ec788d1 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseMessages__ = [];
    } catch  {
    // Ignore cross-origin frame access errors
    }
};





const $e4ff688b5b6293f1$var$normalizeId = (id)=>id?.trim() || undefined;
const $e4ff688b5b6293f1$export$aca28ba8bc28abea = ({ agentsOnlyEnabled: agentsOnlyEnabled, baseConversationAgentId: baseConversationAgentId, requestAgentId: requestAgentId, selection: selection })=>{
    const selectedAgentId = $e4ff688b5b6293f1$var$normalizeId(selection.agent_id);
    const baseAgentId = $e4ff688b5b6293f1$var$normalizeId(baseConversationAgentId);
    const requestedAgentId = $e4ff688b5b6293f1$var$normalizeId(requestAgentId);
    if (agentsOnlyEnabled && selectedAgentId !== undefined && selectedAgentId === baseAgentId) return {
        type: 'clear'
    };
    if (selectedAgentId) return {
        type: 'set',
        agent: {
            agent_id: selectedAgentId,
            agent_name: selection.agent_name ?? '',
            agent_named_id: selection.agent_named_id ?? '',
            identity_account_id: selection.agent_identity_account_id ?? undefined,
            creator_type: ''
        }
    };
    const isUserMentionTurn = requestedAgentId !== undefined && !(0, $2yWJZ.isDefaultRovoChat)({
        agentId: requestedAgentId
    }) && (!agentsOnlyEnabled || requestedAgentId !== baseAgentId);
    return isUserMentionTurn ? {
        type: 'preserve'
    } : {
        type: 'clear'
    };
};











const $822490bee3d17b8f$export$f279e50afd80e7d8 = ({ chat: chat, oldId: oldId, newId: newId })=>{
    const updatedChat = (0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: oldId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...storeAssistant.content,
                    message: {
                        ...storeAssistant.content.message,
                        message: {
                            ...storeAssistant.content.message.message,
                            id: newId
                        }
                    }
                }
            }),
        updateType: 'Update Store Assistant Message ID'
    });
    return updatedChat.map((message)=>(0, $igOtY.isStoreFollowUp)(message) && message.agentMessageId === oldId ? {
            ...message,
            agentMessageId: newId
        } : message);
};


const $4964ca4cf6fe5338$var$getStreamStats = ()=>{
    const stats = {
        totalChunks: 0,
        traceChunks: 0,
        answerChunks: 0,
        actionChunks: 0,
        researchChunks: 0,
        otherChunks: 0,
        firstChunkAt: undefined,
        lastChunkAt: undefined,
        sumInterChunkMs: 0,
        pluginsObserved: new Set()
    };
    const update = (streamMessage)=>{
        const now = performance.now();
        stats.totalChunks += 1;
        if (stats.firstChunkAt === undefined) stats.firstChunkAt = now;
        if (stats.lastChunkAt !== undefined) stats.sumInterChunkMs += now - stats.lastChunkAt;
        stats.lastChunkAt = now;
        if ((0, $bxkJA.isStreamTrace)(streamMessage)) stats.traceChunks += 1;
        else if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) stats.answerChunks += 1;
        else if ((0, $bxkJA.isStreamResearchPayload)(streamMessage)) stats.researchChunks += 1;
        else if ((0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage)) // Count action-related chunks (prepare/part)
        stats.actionChunks += 1;
        else // Count unknown chunks
        stats.otherChunks += 1;
        // Observe plugin names if present early (often only present on final response)
        const invocations = (0, $bxkJA.isStreamResponse)(streamMessage) ? streamMessage.message?.message?.plugin_invocations : [];
        if (Array.isArray(invocations)) invocations.forEach((p)=>p?.plugin_name && stats.pluginsObserved.add(p.plugin_name));
    };
    const getStats = ()=>{
        const avgGapMs = stats.totalChunks > 1 ? Math.round(stats.sumInterChunkMs / (stats.totalChunks - 1)) : 0;
        return {
            ...stats,
            pluginsObserved: Array.from(stats.pluginsObserved),
            averageGapMs: avgGapMs
        };
    };
    return {
        update: update,
        getStats: getStats
    };
};
const $4964ca4cf6fe5338$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS = 120000;
const $4964ca4cf6fe5338$var$NO_FINAL_RESPONSE_ERROR_MESSAGE = 'The response took too long and timed out';
const $4964ca4cf6fe5338$export$efb69f1fe7577739 = async ({ prompt: prompt, generator: generator, productKey: productKey, answerIndex: answerIndex, tmpHumanMessageId: tmpHumanMessageId, tmpAssistantMessageId: tmpAssistantMessageId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled, streamTracking: streamTracking, traceId: traceId, updateCurrentConversation: updateCurrentConversation, trackingAttributes: trackingAttributes, editRequestId: editRequestId, conversationId: conversationId, getState: getState, promptStreamHook: promptStreamHook, openChat: openChat, openChatOnError: openChatOnError, experienceTracker: experienceTracker, setMessages: setMessages, getMessages: getMessages, reportCreditDenial: reportCreditDenial, onSpaceSourceRecommendations: onSpaceSourceRecommendations, processStreamResearch: processStreamResearch, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced, containerOnHumanMessageIdReplaced: containerOnHumanMessageIdReplaced, updateResearchMessageId: updateResearchMessageId, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, broadcastStreamLifecycle: broadcastStreamLifecycle, sendMessageLatencyMetrics: sendMessageLatencyMetrics, cancelStreamingMetrics: cancelStreamingMetrics, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, streamActionInfo: streamActionInfo, trackAIMAUEvent: trackAIMAUEvent, messageSources: messageSources, additionalAnalyticAttributes: additionalAnalyticAttributes, unsupportedRemixNodeTypes: unsupportedRemixNodeTypes, hasLoggedInitiatedEvent: hasLoggedInitiatedEvent, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, viewDeadAirBroker: viewDeadAirBroker, minionAlias: minionAlias, requestedSkills: requestedSkills, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, isThirdPartyAgent: isThirdPartyAgent, creationContextParams: creationContextParams, supportsRemixTextResponse: supportsRemixTextResponse = false, storeUserMessages: storeUserMessages, skillSelectionSource: skillSelectionSource, assistanceService: assistanceService, abortController: abortController, getIsChatMounted: getIsChatMounted, metricsStartTime: metricsStartTime, onTaskStatusUpdate: onTaskStatusUpdate, onTodoSnapshot: onTodoSnapshot, onPromptRedacted: onPromptRedacted, onPromptBlocked: onPromptBlocked, onResponseRedacted: onResponseRedacted, onResponseBlocked: onResponseBlocked, onAttachmentBlocked: onAttachmentBlocked, recoverConversationAfterStreamTimeout: recoverConversationAfterStreamTimeout })=>{
    updateCurrentConversation({
        traces: []
    });
    const remixRegenerateRequestAttributes = (0, $00c83407afeee4cc$export$2632503e30ac5e44)({
        creationContextParams: creationContextParams,
        messageSources: messageSources
    });
    // Set to true when a guard event (PROMPT_REDACTION or PROMPT_BLOCKED) is received.
    // The backend always follows these events with an ERROR event to terminate the stream,
    // which should be treated as a successful end of the guard flow, not a real error.
    let guardEventReceived = false;
    const acknowledgedInlineEdits = new Set();
    let hasReceivedFinalResponse = false;
    let hasProcessedFinalResponse = false;
    let hasReceivedCreditDenial = false;
    let lastInvalidatingEventType;
    let recoveredAfterStreamTimeout = false;
    let hasReceivedPromptRedaction = false;
    let hasReceivedFollowUp = false;
    let turnSurfaces;
    let actionCompleteCount = 0;
    let actionClassificationCount = 0;
    let isBackendCreationRequest = false;
    let agentMessageId;
    let isReconnectSupported = false;
    // Guards against repeated metric switches if multiple REASONING_PART messages arrive.
    let hasAbortedForImplicitThinkDeeper = false;
    // Think-deeper metrics started when implicit think-deeper is detected mid-stream. Null otherwise.
    let implicitThinkDeeperSendMessageMetrics = null;
    let implicitThinkDeeperTimeToFirstAnswerPartMetrics = null;
    // The experience name for the reliability SLO when implicit think-deeper is detected. Null otherwise.
    let implicitThinkDeeperExperienceName = null;
    // Client-side implicit round tracking for think deeper.
    // Passed by reference into processResearchStreamMessage so state is shared.
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    // Lazily initialised on the first chunk: the conversation's agent metadata
    // is set by `createConversationOptimistically` which may run after this
    // function is defined but before the first chunk arrives.
    let processStreamMarkdownMultiTagInstance = null;
    const getShouldPreprocessDetails = ()=>(0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId);
    const getProcessStreamMarkdownMultiTag = ()=>{
        if (!processStreamMarkdownMultiTagInstance) processStreamMarkdownMultiTagInstance = (0, $94689fb12cc6f471$export$95c0abd604a2cca2)({
            shouldPreprocessDetails: getShouldPreprocessDetails()
        });
        return processStreamMarkdownMultiTagInstance;
    };
    const onAnswerActivity = ({ answerType: answerType, hasContent: hasContent })=>{
        stopInteractionMetricsTimeToFirstAnswerPart('stop', {
            answerType: answerType,
            conversationId: conversationId
        });
        // Stop the implicit think-deeper time-to-first-answer-part metric if active
        implicitThinkDeeperTimeToFirstAnswerPartMetrics?.stop({
            customData: {
                answerType: answerType,
                conversationId: conversationId
            }
        });
        // Clear Answer Now status when the answer starts
        // This handles the case where the stream starts answering without user clicking Answer Now
        (0, $7e78f67f943224e0$export$ed23852026f99b3a)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
        // Sometimes an ANSWER_PART arrives with empty content, which clears traces
        // prematurely and makes the live "thinking" steps flash and disappear. Skip the
        // clear for empty answer parts so traces persist until real content arrives.
        if (hasContent) {
            (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
            // Mark hasReceivedAnswerPart on the chat store message atomically with the
            // trace clear. This avoids a cross-store render gap (chat store vs research
            // store) where the thinking indicator would briefly re-appear.
            setMessages(conversationId, (getMessages(conversationId) ?? []).map((msg)=>{
                if (msg.type === 'ASSISTANT' && msg.content.message?.message?.id === tmpAssistantMessageId) return {
                    ...msg,
                    hasReceivedAnswerPart: true
                };
                return msg;
            }));
        }
    };
    const answerUiParts = (0, $cgxs9.isAnswerUiPartsEnabled)() ? (0, $46be802076879bb7$export$a383102dd028a1)({
        conversationId: conversationId,
        getAnswerId: ()=>tmpAssistantMessageId,
        answerIndex: answerIndex,
        getMessages: getMessages,
        setMessages: setMessages,
        onUiPartPlaced: ()=>onAnswerActivity({
                answerType: 'stream-answer-ui-part',
                hasContent: true
            })
    }) : null;
    let latestStreamMessage;
    const streamStats = $4964ca4cf6fe5338$var$getStreamStats();
    const peopleEntityHoverCardsEnabled = (0, $437v8.isPeopleEntityAnnotationEnabled)();
    const inferredProjectHoverCardsEnabled = (0, $437v8.isInferredProjectEntityAnnotationEnabled)();
    const entityAnnotationAnalyticsEnabled = peopleEntityHoverCardsEnabled || inferredProjectHoverCardsEnabled;
    let entityAnnotationCounts = {
        inferredProjectEntityAnnotationCount: 0,
        personEntityAnnotationCount: 0
    };
    // Between-chunks inactivity watchdog (logs once per stall, re-arms on chunks)
    const inactivity = (0, $e2cd33d1e2c5839a$export$23f1f8f522f4bdd)({
        baseMs: 90000,
        sendAnalyticsEvent: (event)=>{
            sendAnalyticsEvent({
                ...event,
                attributes: {
                    ...event.attributes,
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent
                }
            });
        }
    });
    // Dead air tracking - monitors gaps between meaningful stream messages
    const deadAirTracker = (0, $6895c59b08828bb0$export$4a48e8ee48123078)({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        deepResearchEnabled: deepResearchEnabled ?? false,
        thinkDeeperEnabled: thinkDeeperEnabled ?? false,
        fastModeEnabled: fastModeEnabled ?? false,
        webSearchEnabled: webSearchEnabled ?? false,
        isAIFC: streamActionInfo.isAction,
        sendAnalyticsEvent: sendAnalyticsEvent
    });
    viewDeadAirBroker?.start({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        reasoningMode: deepResearchEnabled ? 'deep-research' : thinkDeeperEnabled ? 'think-deeper' : fastModeEnabled ? 'fast' : 'auto',
        isAIFCEnabled: streamActionInfo.isAction,
        isWebSearchEnabled: webSearchEnabled ?? false
    });
    // Reset the stream response recording for a new stream session.
    // Recording is always enabled so that network responses can be captured by default.
    const canRecordStreamResponses = true;
    if (canRecordStreamResponses) (0, $ff8723ce29790d95$export$e3d8e4fb1ec788d1)();
    // Arm the inactivity watchdog
    inactivity?.arm();
    /*****************************
   *
   * Stream processing START
   *
   *****************************/ // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Preserve the existing timeout experiment while keeping this reliability change scoped.
    const isStreamTimeoutEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'isEnabled', false);
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Preserve the existing timeout experiment while keeping this reliability change scoped.
    const streamIdleTimeoutMs = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'timeoutMs', $4964ca4cf6fe5338$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS);
    const isStreamTimeoutRecoveryEnabled = isStreamTimeoutEnabled && (0, $4o0zT.isExperimentEnabled)('rovo_chat_stream_timeout_recovery');
    let lastStreamTimeoutError;
    let streamTimeoutCount = 0;
    const recoverAfterStreamTimeout = async (error)=>{
        const recovered = await recoverConversationAfterStreamTimeout?.(error) ?? false;
        if (!recovered) {
            (0, $Iv7dD.slidesAiEditLatency).markFailed(editRequestId);
            abortController.abort();
            return false;
        }
        hasReceivedFinalResponse = true;
        recoveredAfterStreamTimeout = true;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'recovered',
            actionSubject: 'rovoChatStream',
            attributes: {
                conversationChannelId: conversationId,
                experienceName: sendMessageExperienceNameCompiled,
                recoveryOutcome: 'conversationRefresh',
                recoveryMethod: 'conversationRefresh',
                requestId: trackingAttributes.requestId,
                timeoutCount: streamTimeoutCount,
                streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled,
                traceId: traceId
            }
        });
        return true;
    };
    const onStreamTimeout = ()=>{
        if (hasReceivedFinalResponse || guardEventReceived || abortController.signal.aborted) return undefined;
        const timeoutError = new (0, $b6N3q.RovoChatStreamTimeoutError)($4964ca4cf6fe5338$var$NO_FINAL_RESPONSE_ERROR_MESSAGE, {
            requestId: trackingAttributes.requestId,
            traceId: traceId
        });
        streamTimeoutCount++;
        if (isStreamTimeoutRecoveryEnabled) lastStreamTimeoutError = timeoutError;
        else {
            streamTracking?.fail(new Error($4964ca4cf6fe5338$var$NO_FINAL_RESPONSE_ERROR_MESSAGE));
            (0, $Iv7dD.slidesAiEditLatency).markFailed(editRequestId);
            abortController.abort();
        }
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'timedOut',
            actionSubject: 'rovoChatStream',
            attributes: {
                conversationChannelId: conversationId,
                experienceName: sendMessageExperienceNameCompiled,
                requestId: trackingAttributes.requestId,
                timeoutMs: streamIdleTimeoutMs,
                timeoutType: 'idle',
                timeoutCount: streamTimeoutCount,
                streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled,
                traceId: traceId
            }
        });
        return timeoutError;
    };
    const reconnectableStream = (0, $b5a6b627405136a2$export$29bad1ab941da7cb)({
        generator: generator,
        conversationId: conversationId,
        abortController: abortController,
        assistanceService: assistanceService,
        sendAnalyticsEvent: sendAnalyticsEvent,
        experienceTracker: experienceTracker,
        getMessageId: ()=>agentMessageId,
        getRequestId: ()=>trackingAttributes.requestId,
        canReconnect: ()=>!!(agentMessageId && isReconnectSupported),
        hasProcessedFinalResponse: ()=>hasProcessedFinalResponse,
        getInvalidatedFinalResponse: ()=>hasReceivedFinalResponse && !hasProcessedFinalResponse ? lastInvalidatingEventType : undefined,
        getState: getState,
        traceId: traceId,
        updateCurrentConversation: updateCurrentConversation,
        getIsChatMounted: getIsChatMounted,
        analyticsAttributes: {
            isDeepResearch: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            streamTimeoutMs: streamIdleTimeoutMs,
            streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled
        },
        onBeforeFirstReconnect: ()=>{
            const chat = getMessages(conversationId);
            const alreadySwapped = (0, $4BHwn.findStoreMessageIndex)(chat, agentMessageId) >= 0;
            if (!alreadySwapped) {
                setMessages(conversationId, (0, $822490bee3d17b8f$export$f279e50afd80e7d8)({
                    chat: chat,
                    oldId: tmpAssistantMessageId,
                    newId: agentMessageId
                }));
                if (tmpAssistantMessageId !== agentMessageId) updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
            }
            tmpAssistantMessageId = agentMessageId;
        },
        onReconnected: ()=>{
            inactivity?.arm();
        },
        onFirstChunkAfterReconnect: ()=>{
            deadAirTracker?.resetTimestamp();
        },
        streamTimeout: isStreamTimeoutEnabled && isStreamTimeoutRecoveryEnabled ? {
            timeoutMs: streamIdleTimeoutMs,
            onTimeout: onStreamTimeout,
            onReconnectFailure: recoverAfterStreamTimeout
        } : undefined
    });
    const streamToIterate = isStreamTimeoutEnabled && !isStreamTimeoutRecoveryEnabled ? (0, $0ac98c0a880a830b$export$44aab448715585b6)(reconnectableStream, {
        timeoutMs: streamIdleTimeoutMs,
        // Preserve the existing timeout experiment behavior outside the recovery treatment.
        isPaused: ()=>typeof navigator !== 'undefined' && !navigator.onLine,
        onTimeout: onStreamTimeout
    }) : reconnectableStream;
    let canCompleteRemixWithText = supportsRemixTextResponse;
    let isValidRemixTextResponse = false;
    let isCurrentRemixRegenerationStream = remixRegenerateRequestAttributes.isRemixRegenerate === true;
    // A superseded stream must not settle the next regeneration
    const unsubscribeRemixTrackers = canCompleteRemixWithText || isCurrentRemixRegenerationStream ? experienceTracker.subscribe((event)=>{
        if (event.name === (0, $irnO2.ExperienceName).REMIX_REGENERATE && event.action === 'taskStart') {
            canCompleteRemixWithText = false;
            isCurrentRemixRegenerationStream = false;
        }
    }) : undefined;
    try {
        for await (const streamObj of streamToIterate){
            const streamMessage = (0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
            if ((0, $bxkJA.isStreamAiCreditDenied)(streamMessage) && (0, $iDrrr.fg)('rovo_chat_credits')) {
                hasReceivedFinalResponse = true;
                hasProcessedFinalResponse = true;
                hasReceivedCreditDenial = true;
                (0, $18fb7f621464707a$export$fea28b9fcd5e3261)({
                    conversationId: conversationId,
                    assistantMessageId: tmpAssistantMessageId,
                    streamMessage: streamMessage,
                    getState: getState,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    updateCurrentConversation: updateCurrentConversation,
                    reportCreditDenial: reportCreditDenial,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                break;
            }
            if ((0, $ae4252d226847c94$export$cd9676874af9cd5a)(streamObj, agentMessageId)) {
                hasProcessedFinalResponse = false;
                lastInvalidatingEventType = ((0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.eventType : undefined) ?? streamMessage.type ?? 'UNKNOWN';
            }
            if ((0, $bxkJA.isStreamActionClassification)(streamMessage) || (0, $bxkJA.isStreamActionPrepare)(streamMessage) || (0, $bxkJA.isStreamActionPart)(streamMessage) || (0, $bxkJA.isStreamActionComplete)(streamMessage) || (0, $bxkJA.isStreamActionError)(streamMessage) || (0, $bxkJA.isStreamError)(streamMessage)) canCompleteRemixWithText = false;
            // Record the raw stream message for debugging purposes
            // This allows developers to copy/paste SSE responses for examples/tests
            if (canRecordStreamResponses) (0, $bd1b2048488e5a34$export$7d55b756f7f2ed43)(streamMessage);
            latestStreamMessage = streamMessage;
            deadAirTracker?.update(streamMessage);
            streamStats.update(streamMessage);
            // any chunk = proof of life
            inactivity?.onChunk();
            // Note: We do NOT skip stream messages during SWITCHING.
            // Stream processing continues normally until FAST_MODE_ENABLED is received,
            // at which point research steps are cleared and status is set to SWITCHED.
            if ((0, $58a7ad1d26ac260e$export$51720276ffc29c92)(streamMessage, conversationId, updateCurrentConversation)) continue;
            // Usually the first stream part
            if ((0, $bxkJA.isConversationChannelDataMessage)(streamMessage)) {
                agentMessageId = streamMessage.assistant_message_id;
                const streamConversationName = streamMessage.name?.trim();
                updateCurrentConversation({
                    ...streamConversationName ? {
                        name: streamConversationName
                    } : {},
                    lastMessageTimestamp: streamMessage.last_message_timestamp ?? new Date().toISOString(),
                    timeCreated: streamMessage.time_created,
                    ...streamMessage.scopes && {
                        scopes: streamMessage.scopes
                    }
                });
                trackingAttributes.instrumentationId = agentMessageId;
                trackingAttributes.messageId = agentMessageId;
                if (agentMessageId && agentMessageId !== tmpAssistantMessageId) {
                    const oldTmpId = tmpAssistantMessageId;
                    setMessages(conversationId, (0, $822490bee3d17b8f$export$f279e50afd80e7d8)({
                        chat: getMessages(conversationId),
                        oldId: oldTmpId,
                        newId: agentMessageId
                    }));
                    updateResearchMessageId({
                        messageId: oldTmpId,
                        newMessageId: agentMessageId
                    });
                    tmpAssistantMessageId = agentMessageId;
                    (onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced)?.(oldTmpId, agentMessageId);
                }
                trackingAttributes.invokedFrom = creationContextParams?.source === 'remix' ? 'remix' : (0, $2bb2c0e92fe02e4f$export$9f2ec1867195888b)(messageSources?.interactionSource);
                const remixNodeTypes = creationContextParams?.dynamicUiSource ? (0, $fC0nb.getTopLevelNodeTypes)(creationContextParams.dynamicUiSource.fullAdf, creationContextParams.dynamicUiSource.startLocalId ?? '', creationContextParams.dynamicUiSource.endLocalId ?? '') : undefined;
                const remixWordCount = creationContextParams?.dynamicUiSource?.fragmentAdf ? (0, $kc9aB.countFragmentWords)(creationContextParams.dynamicUiSource.fragmentAdf) : undefined;
                if (remixNodeTypes) trackingAttributes.remixNodeTypes = remixNodeTypes;
                if (unsupportedRemixNodeTypes) trackingAttributes.unsupportedRemixNodeTypes = unsupportedRemixNodeTypes;
                if (remixWordCount !== undefined) trackingAttributes.remixWordCount = remixWordCount;
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: streamMessage.last_message_timestamp,
                    singleInstrumentationID: agentMessageId,
                    deepResearchEnabled: deepResearchEnabled ?? false,
                    thinkDeeperEnabled: thinkDeeperEnabled ?? false,
                    fastModeEnabled: fastModeEnabled ?? false,
                    webSearchEnabled: webSearchEnabled ?? false,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    invokedFrom: trackingAttributes.invokedFrom,
                    attributes: {
                        ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                        ...additionalAnalyticAttributes && additionalAnalyticAttributes,
                        ...remixNodeTypes !== undefined && {
                            remixNodeTypes: remixNodeTypes
                        },
                        ...trackingAttributes.unsupportedRemixNodeTypes !== undefined && {
                            unsupportedRemixNodeTypes: trackingAttributes.unsupportedRemixNodeTypes
                        },
                        ...remixWordCount !== undefined && {
                            remixWordCount: remixWordCount
                        },
                        ...trackingAttributes.chatEntryPoint && {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        }
                    }
                });
                hasLoggedInitiatedEvent = true;
            } else if ((0, $bxkJA.isScopeDeterminedMessage)(streamMessage)) updateCurrentConversation({
                scopes: streamMessage.scopes
            });
            else if ((0, $bxkJA.isSpaceSourceRecommendationsMessage)(streamMessage)) // No analytics event here by design: this stream message only forwards
            // recommendations to the host via a generic callback. Surfacing/interaction
            // analytics are owned by the recommendations banner UI that consumes them.
            onSpaceSourceRecommendations?.(streamMessage.message.space_id, streamMessage.message.recommendations);
            else {
                const conversation = getState().conversations[getState().currentConversationId];
                if (conversation) {
                    if (conversation.status !== (0, $igOtY.CHAT_STORE_STATUS).typingResponse) updateCurrentConversation({
                        status: (0, $igOtY.CHAT_STORE_STATUS).typingResponse
                    });
                }
            }
            if ((0, $bxkJA.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
            // The agents-only rollout ignores Concierge selection from Rovo Chat so it cannot leave
            // a stale Concierge input hat behind.
            const currentConversation = getState().conversations[conversationId];
            const currentConversationAgentId = currentConversation?.agent?.agent_id;
            const isAgentConversation = currentConversationAgentId !== undefined && !(0, $2yWJZ.isDefaultRovoChat)({
                agentId: currentConversationAgentId
            });
            const isAgentConciergeAgentsOnlyEnabled = (0, $iDrrr.fg)('rovo_chat_agent_concierge_agents_only');
            if ((0, $iDrrr.fg)('rovo_chat_agent_concierge_ui_contract') && (!isAgentConciergeAgentsOnlyEnabled || isAgentConversation) && (0, $bxkJA.isStreamConciergeAgentSelected)(streamMessage)) {
                // A present agent_id means the concierge engaged a specialist → show the "Auto" hat.
                // An absent agent_id is a CLEAR signal, but there are two very different reasons for it:
                //   1. Genuine handback to the conversation's base agent → clear the stored Concierge
                //      agent so no stale "Auto" hat lingers.
                //   2. The user @-mentioned a specialist this turn, so concierge deliberately stood down
                //      (backend never ran evaluate(); its active specialist is only on hold). In this case
                //      we must PRESERVE the stored concierge agent so that when the user dismisses the
                //      mention hat, the "Auto" hat resumes — mirroring the backend's hold/resume behaviour.
                // In agents-only mode, only a request agent different from the conversation's base agent
                // is a mention override. Gate-off keeps the legacy non-default-agent behavior.
                const conciergeUpdate = (0, $e4ff688b5b6293f1$export$aca28ba8bc28abea)({
                    agentsOnlyEnabled: isAgentConciergeAgentsOnlyEnabled,
                    baseConversationAgentId: currentConversationAgentId,
                    requestAgentId: agentId,
                    selection: streamMessage.message
                });
                if (conciergeUpdate.type === 'set') {
                    updateCurrentConversation({
                        conciergeSelectedAgent: conciergeUpdate.agent
                    });
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'selected',
                        actionSubject: 'agentConciergeRouting',
                        attributes: {
                            isAgentsOnlyModeEnabled: isAgentConciergeAgentsOnlyEnabled
                        }
                    });
                } else if (conciergeUpdate.type === 'clear') {
                    // The base conversation agent needs no Auto hat. An absent agent remains a
                    // genuine handback unless a user mention temporarily suspended Concierge.
                    updateCurrentConversation({
                        conciergeSelectedAgent: undefined
                    });
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'handedBack',
                        actionSubject: 'agentConciergeRouting',
                        attributes: {
                            isAgentsOnlyModeEnabled: isAgentConciergeAgentsOnlyEnabled
                        }
                    });
                }
            }
            {
                const { deepResearchInvoked: deepResearchInvoked, twgTrace: twgTrace } = (0, $ec372ef5c573e842$export$5a07e6227eed9665)({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                if (deepResearchInvoked) trackingAttributes.deepResearchInvoked = true;
                if (twgTrace) {
                    var _trackingAttributes, _trackingAttributes1, _trackingAttributes2;
                    (_trackingAttributes = trackingAttributes).twgTraceStepIds ?? (_trackingAttributes.twgTraceStepIds = []);
                    (_trackingAttributes1 = trackingAttributes).twgTraceRoundIds ?? (_trackingAttributes1.twgTraceRoundIds = []);
                    (_trackingAttributes2 = trackingAttributes).twgTraceToolNames ?? (_trackingAttributes2.twgTraceToolNames = []);
                    if (!trackingAttributes.twgTraceStepIds.includes(twgTrace.stepId)) {
                        trackingAttributes.twgTraceStepIds.push(twgTrace.stepId);
                        trackingAttributes.twgTraceRoundIds.push(twgTrace.roundId);
                        if (twgTrace.toolName) trackingAttributes.twgTraceToolNames.push(twgTrace.toolName);
                        if (twgTrace.renderMode) {
                            var _trackingAttributes3;
                            (_trackingAttributes3 = trackingAttributes).twgTraceRenderModes ?? (_trackingAttributes3.twgTraceRenderModes = []);
                            trackingAttributes.twgTraceRenderModes.push(twgTrace.renderMode);
                        }
                    }
                }
            }
            // The backend autonomously triggered thinking mode (implicit think-deeper) even though
            // the user did not explicitly enable it. Cancel the auto-mode browser metrics so these
            // slow requests don't count against the <16s/<30s SLOs, and re-attribute them to the
            // think-deeper metrics instead.
            if (!thinkDeeperEnabled && !hasAbortedForImplicitThinkDeeper && (0, $bxkJA.isStreamThinkDeeperTriggered)(streamMessage)) {
                hasAbortedForImplicitThinkDeeper = true;
                // Cancel auto-mode metrics so they are not recorded in the SLOs
                stopInteractionMetricsTimeToFirstAnswerPart('cancel');
                sendMessageLatencyMetrics.cancel();
                // Re-attribute to think-deeper metrics (100s SLO target)
                implicitThinkDeeperSendMessageMetrics = (0, $548d18bad1818374$export$1e4d1659c4209dbf).createSendMessageMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics = (0, $548d18bad1818374$export$1e4d1659c4209dbf).createTimeToFirstAnswerPartMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperSendMessageMetrics.start({
                    startTime: metricsStartTime
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics.start({
                    startTime: metricsStartTime
                });
                // Abort the auto-mode reliability SLO experience and start the think-deeper one
                // so implicit think-deeper requests don't count against the auto-mode reliability SLO.
                implicitThinkDeeperExperienceName = (0, $irnO2.sendMessageExperienceName)({
                    thinkDeeperEnabled: true
                });
                experienceTracker.abort({
                    name: sendMessageExperienceNameCompiled,
                    reason: 'Re-attributed to think-deeper reliability SLO'
                });
                experienceTracker.start({
                    name: implicitThinkDeeperExperienceName,
                    id: conversationId,
                    startTime: metricsStartTime,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: trackingAttributes.interactionSource,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                    }
                });
            }
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!trackingAttributes.requestId && 'metadata' in streamMessage) trackingAttributes.requestId = streamMessage.metadata?.request_id ?? undefined;
            if ((0, $5a900e4ea4c7ba13$export$2de2f38c3a454c55)({
                streamMessage: streamMessage,
                conversationId: conversationId,
                existingTraces: (0, $74367cc14df82300$export$8567b8b6b4d41b2f)(getState(), conversationId),
                updateTraces: (traces)=>updateCurrentConversation({
                        traces: traces
                    }),
                sendAnalyticsEvent: sendAnalyticsEvent
            })) continue;
            if ((0, $bxkJA.isStreamResponse)(streamMessage)) trackingAttributes.interactionModeExecuted = (0, $iqkMb.getInteractionModeExecutedFromStreamResponse)(streamMessage);
            // Handle MEMORY_UPDATE trace messages - create a persistent StoreMemoryUpdate message
            if ((0, $bxkJA.isStreamMemoryUpdate)(streamMessage) && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
            (0, $cXtTj.default).getExperimentValue('memory_management_ux', 'isEnabled', false)) {
                const originalContent = streamMessage.message.content;
                const isMemoryTraceContentEmpty = !originalContent;
                let memoryContent = originalContent;
                let isMemoryContentAfterParsingEmpty = false;
                // Parse memory content: remove "Update memory:" prefix and trim
                if (memoryContent) {
                    memoryContent = memoryContent.replace(/^update\s+memory:\s*/i, '').trim();
                    isMemoryContentAfterParsingEmpty = !memoryContent;
                }
                const memoryUpdateMessage = {
                    type: 'MEMORY_UPDATE',
                    content: memoryContent || undefined // Use undefined instead of empty string
                };
                // Track memory update parsing events
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'parsed',
                    actionSubject: 'memoryUpdate',
                    attributes: {
                        isMemoryTraceContentEmpty: isMemoryTraceContentEmpty,
                        isMemoryContentAfterParsingEmpty: isMemoryContentAfterParsingEmpty,
                        conversationId: conversationId
                    }
                });
                setMessages(conversationId, (0, $35f48597532147ec$export$e3f334fc6effa531)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    memory: memoryUpdateMessage,
                    useIndex: answerIndex
                }));
            }
            // Usually the second stream part, before anything else occurs
            if ((0, $bxkJA.isStreamTrace)(streamMessage)) {
                if (!deepResearchEnabled) // we do not want traces that are not marked for deep research to be accumulated when starting research,
                // the ones that are marked are processed above in processResearchStreamMessage
                updateCurrentConversation({
                    traces: (0, $a81109ab453d215f$export$9ac25e0768639c5d)([
                        ...(0, $74367cc14df82300$export$8567b8b6b4d41b2f)(getState(), conversationId),
                        (0, $f2c42700118b800b$export$a89606c68db527fb)(streamMessage)
                    ])
                });
                promptStreamHook?.onTraceMessage?.(streamMessage, tmpAssistantMessageId, openChat);
                setMessages(conversationId, (0, $8ebe5aac085e0e04$export$1cdaa2c4089128bd)(getMessages(conversationId), trackingAttributes.requestId));
            }
            // Handle Answer Now fast mode traces for extended thinking
            // Answer Now feature - handle fast mode traces
            if ((0, $bxkJA.isStreamFastModeResponseAvailable)(streamMessage) && agentMessageId) // Fast mode response is available - show Answer Now button
            // Store both IDs in AVAILABLE status:
            // - tmpMessageId: for store operations (finding/updating the message)
            // - remoteMessageId: for the Answer Now API call
            setMessages(conversationId, (0, $a9c77291ad58ec01$export$14aeb537f795ee1a)(getMessages(conversationId), tmpAssistantMessageId, {
                type: (0, $igOtY.AnswerNowStatusType).AVAILABLE,
                tmpMessageId: tmpAssistantMessageId,
                remoteMessageId: agentMessageId
            }));
            if ((0, $bxkJA.isStreamFastModeEnabled)(streamMessage)) {
                // Fast mode has been enabled:
                // 1. Set status to SWITCHED (hides button)
                // 2. Clear research steps for this message
                setMessages(conversationId, (0, $a9c77291ad58ec01$export$14aeb537f795ee1a)(getMessages(conversationId), tmpAssistantMessageId, {
                    type: (0, $igOtY.AnswerNowStatusType).SWITCHED
                }));
                // Clear research steps when switching to fast mode
                clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
            }
            if ((0, $bxkJA.isStreamRemoveAnswerNow)(streamMessage)) (0, $7e78f67f943224e0$export$ed23852026f99b3a)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
            // isStreamResearchPlan is handled by processResearchStreamMessage (called earlier in this loop)
            const extraMonitoringAttributes = streamTracking?.process(streamMessage);
            const aifcActionResult = (0, $1f5f2c21ff9586f2$export$baa645f348bcec07)({
                extraMonitoringAttributes: extraMonitoringAttributes,
                editRequestId: editRequestId,
                streamMessage: streamMessage,
                conversationId: conversationId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                traceId: traceId,
                productKey: productKey,
                deepResearchEnabled: deepResearchEnabled,
                storeUserMessages: storeUserMessages,
                streamActionInfo: streamActionInfo,
                trackingAttributes: trackingAttributes,
                experienceTracker: experienceTracker,
                chatContextStoreActions: chatContextStoreActions,
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent,
                getIsChatMounted: getIsChatMounted,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                messageSources: messageSources,
                creationContextParams: creationContextParams,
                agentId: agentId,
                agentName: agentName,
                agentIdentityAccountId: agentIdentityAccountId,
                agentNamedId: agentNamedId,
                isThirdPartyAgent: isThirdPartyAgent,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart
            });
            if (aifcActionResult.hasReceivedActionClassification) actionClassificationCount += 1;
            if (aifcActionResult.hasReceivedActionComplete) actionCompleteCount += 1;
            isBackendCreationRequest || (isBackendCreationRequest = aifcActionResult.isBackendCreationAction);
            if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                const isEmptyAnswerPart = typeof streamMessage.message.content === 'string' && streamMessage.message.content.length === 0;
                onAnswerActivity({
                    answerType: 'stream-answer-part',
                    hasContent: !isEmptyAnswerPart
                });
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                const result = getProcessStreamMarkdownMultiTag()(processedStreamMessage);
                processedStreamMessage = result.processedStreamMessage;
                const markdownData = result.markdownData;
                // LEGACY-INLINE-LUMINA
                answerUiParts?.observeParserMarkdownData(markdownData);
                if (Object.keys(markdownData).length > 0) {
                    hasMarkdownData = true;
                    setMessages(conversationId, (0, $ccf4709cceff6c1f$export$679615d953ba31c3)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: markdownData,
                        useIndex: answerIndex
                    }));
                }
                promptStreamHook?.onAnswerPart?.(processedStreamMessage, tmpAssistantMessageId, conversationId, openChat);
                if (!hasMarkdownData) setMessages(conversationId, (0, $72779d19b192aa52$export$6e5609c05ab74cc7)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    answerPart: processedStreamMessage,
                    useIndex: answerIndex
                }));
            // hasAccumulatedAnswerContent tracking is handled by processResearchStreamMessage
            }
            if (answerUiParts?.handleStreamMessage(streamMessage)) deadAirTracker?.recordAnswerUiUpdate(streamMessage);
            if ((0, $bxkJA.isStreamEntityAnnotations)(streamMessage) && entityAnnotationAnalyticsEnabled) {
                const entityAnnotationBatch = (0, $bxkJA.normalizeEntityAnnotationsMessage)(streamMessage.message);
                const enabledEntities = entityAnnotationBatch.entities.filter((entity)=>entity.type === 'Person' && peopleEntityHoverCardsEnabled || entity.type === 'InferredProject' && inferredProjectHoverCardsEnabled);
                if (enabledEntities.length > 0) entityAnnotationCounts = (0, $d69dfb192d870466$export$69df77d21db987cc)(entityAnnotationCounts, {
                    ...entityAnnotationBatch,
                    entities: enabledEntities
                });
                setMessages(conversationId, (0, $9153b4ac17989006$export$94b1b79dc7d56f27)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    entityAnnotationBatch: entityAnnotationBatch
                }));
            }
            /**********************************************************
       *
       * FINAL_RESPONSE processing
       *
       **********************************************************/ if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                // The turn ended. If it returned an action still awaiting the user's confirmation
                // (e.g. rename-page's "Confirm / Cancel"), the run needs input; otherwise it is done.
                (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, (0, $86fda4fee88137f0$export$419ea2a7c4dc02c6)(streamMessage.message?.message?.actions) ? 'needs-input' : 'done');
                const shouldUseBackendCreationExperienceLifecycle = isBackendCreationRequest;
                // No completed actions falls through to abort this experience + others.
                if (shouldUseBackendCreationExperienceLifecycle && actionCompleteCount > 0) // Backend creation responses do not require opening a preview to reach a terminal state.
                (0, $08fd19559950f700$export$a70b98ad4be3bac5)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED, actionClassificationCount, actionCompleteCount, isBackendCreationRequest);
                // Always succeed AIFC_MESSAGE from FINAL_RESPONSE for backend multi-create events, or when
                // the parity experiment is enabled to streamline frontend and backend handling.
                if (actionCompleteCount > 0 && (shouldUseBackendCreationExperienceLifecycle || (0, $4o0zT.isExperimentEnabled)('cwr-fe-be-experience-analytics-streamline'))) (0, $08fd19559950f700$export$a70b98ad4be3bac5)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_MESSAGE, actionClassificationCount, actionCompleteCount, isBackendCreationRequest);
                const humanMessage = streamMessage?.message?.human_message;
                const humanMessageId = humanMessage?.id?.toString();
                const finalResponseAgentMessageId = streamMessage?.message?.message?.id.toString();
                agentMessageId = finalResponseAgentMessageId;
                // Record the backend-assigned conversation ID on the optimistic entry so the
                // space sidenav merge logic can dedupe between the local optimistic entry
                // (client UUID) and the API-returned entry (backend ID), and display the
                // correct name from the chat store rather than the timestamp fallback.
                const backendConversationId = streamMessage?.message?.message?.conversation_channel_id;
                if (backendConversationId) updateCurrentConversation({
                    backendConversationId: backendConversationId
                });
                const minionOrchestrationOutputs = streamMessage?.message?.message?.minion_outputs;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                // INVARIANT: updateResearchMessageId MUST be called before replaceAnswerData (and the
                // setMessages call that wraps it). Both stores must agree on the same messageId key
                // before React re-renders — if the chat store ID flips to finalResponseAgentMessageId first,
                // the next render will call getMessageResearchById(finalResponseAgentMessageId) and get undefined
                // because the research store is still keyed under tmpAssistantMessageId, causing
                // completed traces to disappear.
                //
                // Nothing between this call and replaceAnswerData below should read the research
                // store using tmpAssistantMessageId (markdown processing and clearTracesIfNotEmpty
                // above do not touch the research store after this point).
                if (tmpAssistantMessageId !== finalResponseAgentMessageId) updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: finalResponseAgentMessageId
                });
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $d8a5551aed11b46f$export$82b32799d0ea512c)({
                    streamMessage: streamMessage,
                    messageId: finalResponseAgentMessageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
                });
                // Capture whether the final answer contained inline Lumina blocks so it
                // can be reported on the `agentMessage received` event. The markdown
                // extractor stores those blocks under `lumina-*` keys in `markdownData`.
                // Joined (on messageId) against the `luminaComponent shown` render
                // event to detect Lumina that was returned by BE but never rendered.
                const inlineLuminaCount = Object.keys(markdownData).filter((key)=>key.startsWith('lumina-')).length;
                if (inlineLuminaCount > 0) {
                    trackingAttributes.hasLumina = true;
                    trackingAttributes.luminaType = 'inline';
                    trackingAttributes.luminaCount = inlineLuminaCount;
                }
                if (entityAnnotationAnalyticsEnabled) {
                    trackingAttributes.personEntityAnnotationCount = entityAnnotationCounts.personEntityAnnotationCount;
                    trackingAttributes.inferredProjectEntityAnnotationCount = entityAnnotationCounts.inferredProjectEntityAnnotationCount;
                }
                // Finish view dead air tracking before rendering final response
                // This ensures the last tracked interval is up to FINAL_RESPONSE arrival,
                // and any DOM updates from replaceAnswerData are not tracked
                viewDeadAirBroker?.finish('completed');
                promptStreamHook?.onFinalResponse?.(processedStreamMessage, tmpAssistantMessageId);
                setMessages(conversationId, (0, $387377d6766e3a79$export$60e170089d1b35dd)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                    traceId: traceId,
                    onMessageIdChanged: onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced
                }));
                if (entityAnnotationAnalyticsEnabled && finalResponseAgentMessageId) // Late annotation batches must target the ID stored by FINAL_RESPONSE.
                tmpAssistantMessageId = finalResponseAgentMessageId;
                answerUiParts?.onFinalResponse();
                if (humanMessageId) setMessages(conversationId, (0, $5bb7c976e002305a$export$ba29913b663b084c)({
                    chat: getMessages(conversationId),
                    oldId: tmpHumanMessageId,
                    newId: humanMessageId,
                    parentMessageId: humanMessage?.parent_message_id,
                    onMessageIdChanged: (oldId, newId)=>containerOnHumanMessageIdReplaced?.(conversationId, oldId, newId)
                }));
                const allMessages = getMessages(conversationId);
                const finalMessage = processedStreamMessage.message.message;
                if (finalMessage.actions?.length) canCompleteRemixWithText = false;
                isValidRemixTextResponse = canCompleteRemixWithText && !abortController.signal.aborted && !guardEventReceived && typeof finalMessage.content === 'string' && finalMessage.content.trim().length > 0;
                const isValidAction = isValidRemixTextResponse || (0, $e3b868ed09efd836$export$acbf6433e9af643f)(allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, {
                    llmDebugLogsEnabled: storeUserMessages
                }, productKey, minionOrchestrationOutputs, creationContextParams?.experience);
                if (!isValidAction) return {
                    hasReceivedFinalResponse: hasReceivedFinalResponse,
                    hasReceivedPromptRedaction: hasReceivedPromptRedaction,
                    hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                    guardEventReceived: guardEventReceived,
                    recoveredAfterStreamTimeout: recoveredAfterStreamTimeout,
                    streamTimeoutCount: streamTimeoutCount,
                    streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled,
                    assistantMessageId: finalResponseAgentMessageId
                };
                const finalActions = processedStreamMessage.message.message.actions || [];
                if (productKey === 'confluence' && (creationContextParams?.experience === 'inline_edit' || creationContextParams?.experience === 'chat_edit') && (0, $iDrrr.fg)('rovo-chat-ai-inbox') && (0, $74lv3.isAiXstateMigrationEnabled)() && !abortController.signal.aborted) // Final response is the acknowledgement signal; editor application may still be pending.
                for (const action of finalActions){
                    if (action.key !== 'aifc-adf-update' || action.status !== 'planned' || acknowledgedInlineEdits.has(action.invocationId)) continue;
                    acknowledgedInlineEdits.add(action.invocationId);
                    // Temporary mitigation (ROVOFE-4126): FINAL_RESPONSE can arrive before BE
                    // persists the action, causing a 404 and a failure message in history.
                    // Allow 5s for persistence; remove once BE guarantees save-before-response.
                    // This reduces the race but cannot guarantee persistence has finished.
                    setTimeout(()=>{
                        if (abortController.signal.aborted) return;
                        assistanceService.resolveConversationAction(conversationId, {
                            context: {
                                ...action,
                                messageId: finalResponseAgentMessageId,
                                resolution: {
                                    type: 'actioned'
                                }
                            }
                        }).catch((error)=>{
                            (0, $hlvTd.logException)({
                                exception: error,
                                name: 'InlineEditActionResolutionError'
                            });
                        });
                    }, 5000);
                }
                if (finalActions.length > 0) {
                    const firstActionData = finalActions[0]?.data;
                    stopInteractionMetricsTimeToActionCompletion('stop', {
                        conversationId: conversationId,
                        actionType: 'final-actions',
                        actionCount: finalActions.length,
                        actionKeys: finalActions.map((a)=>a.key),
                        actionPartKey: (0, $2a6f93e9fee2ce65$export$f3b7160b60840213)(streamActionInfo.actionKey, creationContextParams?.source, firstActionData?.dynamicUiSubtype),
                        interactionSource: messageSources?.interactionSource,
                        remixType: creationContextParams?.dynamicUiType
                    });
                } else stopInteractionMetricsTimeToActionCompletion('cancel');
                // Update tracking attributes from FINAL_RESPONSE using the shared extractor.
                const streamMeta = (0, $577cc8ea0ec76152$export$2244b7838be162ca)(streamMessage, skillSelectionSource, (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true));
                if (!hasLoggedInitiatedEvent) {
                    trackingAttributes.messageId = finalResponseAgentMessageId;
                    trackingAttributes.instrumentationId = finalResponseAgentMessageId;
                }
                trackingAttributes.humanMessageId = streamMeta.humanMessageId;
                trackingAttributes.hasSources = streamMeta.hasSources;
                trackingAttributes.hasAuthoritativeSources = streamMeta.hasAuthoritativeSources;
                // Only carry the detailed authority fields when authoritative sources are
                // present, matching the guarded spread in reconnectToInProgressStreamProvider
                // so the gate-off case does not populate trackingAttributes with undefined fields.
                if (streamMeta.hasAuthoritativeSources) {
                    trackingAttributes.authorityLevel = streamMeta.authorityLevel;
                    trackingAttributes.isHighlyAuthoritative = streamMeta.isHighlyAuthoritative;
                    trackingAttributes.overallConfidence = streamMeta.overallConfidence;
                    trackingAttributes.authoritativeSourceCount = streamMeta.authoritativeSourceCount;
                    trackingAttributes.authoritativeExpertCount = streamMeta.authoritativeExpertCount;
                }
                trackingAttributes.citedProductList = streamMeta.citedProductList;
                trackingAttributes.connectorInfo = streamMeta.connectorInfo;
                trackingAttributes.sourceProducts = streamMeta.sourceProducts;
                trackingAttributes.peopleDataProviders = streamMeta.peopleDataProviders;
                if (!shouldUseBackendCreationExperienceLifecycle) trackingAttributes.messageActions = streamMeta.messageActions;
                trackingAttributes.messageDynamicUIData = streamMeta.messageDynamicUIData;
                trackingAttributes.visualBlockCounts = streamMeta.visualBlockCounts;
                trackingAttributes.actionObjectId = streamMeta.actionObjectId;
                trackingAttributes.invokedFrom = streamMeta.invokedFrom ?? messageSources?.invokedFrom ?? trackingAttributes.invokedFrom;
                trackingAttributes.scenarioId = streamMeta.scenarioId;
                trackingAttributes.sources = streamMeta.responseSources;
                trackingAttributes.usesJsm = streamMeta.usesJsm;
                // Keep Set type for compatibility with downstream consumers that call Array.from()
                trackingAttributes.pluginsInvoked = new Set(streamMeta.pluginsInvoked);
                trackingAttributes.skillsInvoked = streamMeta.skillsInvoked;
                trackingAttributes.executedStratusSkill = streamMeta.executedStratusSkill;
                trackingAttributes.agentExternalConfigReference = streamMeta.agentExternalConfigReference;
                const flatMinionOutputs = minionOrchestrationOutputs?.flat() ?? [];
                // Analytics: Verify if minion alias matches minion id
                (0, $21b951f90b04db4f$export$8bfbf77736e8f6e2)({
                    minionAlias: minionAlias,
                    ...requestedSkills?.length ? {
                        requestedSkills: requestedSkills
                    } : {},
                    agentId: agentId,
                    minionsOutput: flatMinionOutputs,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                // Receipt alone is insufficient: hooks, validation, and store writes above
                // must finish before exhausted reconnect recovery can retain this answer.
                hasProcessedFinalResponse = true;
            }
            (0, $0a4010078ae41b46$export$c68838490373407b)({
                streamObj: streamObj,
                streamMessage: streamMessage,
                conversationId: conversationId,
                answerIndex: answerIndex,
                requestId: trackingAttributes.requestId,
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
            if ((0, $bxkJA.isStreamAgenticUi)(streamObj)) {
                const normalizedAgenticUiMessage = {
                    ...streamObj.data,
                    type: 'AGENTIC_UI'
                };
                const incomingA2UIMessages = normalizedAgenticUiMessage.message.content;
                if (Array.isArray(incomingA2UIMessages)) {
                    turnSurfaces ?? (turnSurfaces = (0, $11b165b4e8e31cc9$export$15cd60ec7967aece)(getMessages(conversationId)));
                    setMessages(conversationId, (0, $1be9bdb2a16ed0f4$export$8fcd85fa3cc8529c)({
                        messages: getMessages(conversationId),
                        incomingA2UIMessages: incomingA2UIMessages,
                        createFallbackMessageId: tmpAssistantMessageId,
                        addressable: turnSurfaces
                    }));
                }
            }
            if ((0, $bxkJA.isFollowUpMessage)(streamMessage)) {
                hasReceivedFollowUp = true;
                const messages = getMessages(conversationId);
                const originatingAssistant = [
                    ...messages
                ].reverse().find((0, $igOtY.isStoreAssistant));
                const originatingAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && originatingAssistant ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistant) : undefined;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                const augmentedFollowUp = (0, $4effe361fadab1cf$export$c2722b1ddbddcce5)(messages, streamMessage, productKey, chatContextStoreActions.getIsStagingArea());
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: augmentedFollowUp,
                        id: (0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                        ...originatingAgentIdentity ? {
                            originatingAgentIdentity: originatingAgentIdentity
                        } : {},
                        humanMessageId: trackingAttributes.humanMessageId
                    }
                ]);
            }
            /**
       * Task status processing
       */ if ((0, $bxkJA.isStreamTaskStatus)(streamMessage)) onTaskStatusUpdate?.(streamMessage);
            /**
       * Todo snapshot processing
       */ if ((0, $bxkJA.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            if ((0, $bxkJA.isStreamActionError)(streamMessage)) {
                (0, $Iv7dD.slidesAiEditLatency).markFailed(editRequestId);
                // Producers disagree on where the error text lives, so telemetry probes each known
                // location. Displayed copy keeps the original source so users see the same string.
                const displayedErrorMessage = streamMessage.message?.data?.message || (0, $awqa1.ACTION_EXECUTION_FAILED);
                const resolvedErrorMessage = streamMessage.message?.data?.message || streamMessage.message?.data?.content || streamMessage.message?.content || (0, $awqa1.ACTION_EXECUTION_FAILED);
                const actionError = new (0, $hwHCO.StreamErrorException)(displayedErrorMessage, {
                    detail: {
                        message: {
                            content: resolvedErrorMessage,
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: chatContextStoreActions.getIsStagingArea(),
                            productKey: productKey
                        }
                    },
                    traceId: traceId
                });
                // Opening chat on error can abort the inline stream
                if (isCurrentRemixRegenerationStream && !abortController.signal.aborted && !guardEventReceived) experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                    error: actionError,
                    attributes: {
                        conversationId: conversationId,
                        actionKey: streamMessage.message.key,
                        traceId: traceId
                    }
                });
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.key,
                    errorMessage: resolvedErrorMessage,
                    traceId: traceId
                });
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId,
                    traceId: traceId
                });
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: actionError,
                    attributes: {
                        conversationId: conversationId,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isDeepResearchEnabled: deepResearchEnabled,
                        isThinkDeeperEnabled: thinkDeeperEnabled,
                        isFastModeEnabled: fastModeEnabled,
                        isWebSearchEnabled: webSearchEnabled,
                        llmDebugLogsEnabled: storeUserMessages,
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        traceId: traceId,
                        ...remixRegenerateRequestAttributes
                    }
                });
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                    error: actionError,
                    attributes: {
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        llmDebugLogsEnabled: storeUserMessages,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        latestStreamMessageMillisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        latestStreamMessageType: latestStreamMessage?.type
                    }
                });
                const reason = streamActionInfo.isAction ? 'action_error_while_executing_action' : 'action_error_without_classification';
                for (const name of [
                    (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                    (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
                ])experienceTracker.fail({
                    name: name,
                    error: actionError,
                    attributes: {
                        productKey: productKey,
                        actionKey: streamActionInfo.actionKey,
                        reason: reason
                    }
                });
                throw actionError;
            }
            if ((0, $bxkJA.isStreamPromptRedaction)(streamMessage)) {
                // History eligibility must not depend on Guard UI controls.
                hasReceivedPromptRedaction = true;
                const redactingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — the stream continues with the actual response after redaction.
                onPromptRedacted?.(streamMessage);
            }
            if ((0, $bxkJA.isStreamReasoningPart)(streamMessage)) (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'thinking');
            if ((0, $bxkJA.isStreamPromptBlock)(streamMessage)) {
                const blockingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onPromptBlocked?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamResponseRedaction)(streamMessage)) {
                const redactingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    // Do NOT set guardEventReceived — stream continues after response redaction.
                    // Clear the unredacted answer + traces and stamp redactedResponse inline here,
                    // in the same batch, so no stale getMessages read can re-expose the content
                    // (PRGD-488).
                    (0, $e7b2fbfd93ff35fe$export$7c9d8a35c0d35149)({
                        conversationId: conversationId,
                        messageId: agentMessageId ?? tmpAssistantMessageId,
                        redactedResponse: streamMessage.message.redacted_response,
                        getMessages: getMessages,
                        setMessages: setMessages,
                        getState: getState,
                        updateCurrentConversation: updateCurrentConversation
                    });
                    // Clear the unredacted research-round content and settle the steps. Keyed on the
                    // FINAL_RESPONSE message id (agentMessageId): after FINAL_RESPONSE the research
                    // store is re-keyed to the server id via updateResearchMessageId.
                    processStreamResearch({
                        messageId: agentMessageId ?? tmpAssistantMessageId,
                        streamMessage: streamMessage,
                        isDeepResearch: deepResearchEnabled ?? false
                    });
                    onResponseRedacted?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamResponseBlock)(streamMessage)) {
                const blockingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onResponseBlocked?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamAttachmentBlock)(streamMessage)) {
                const blockingTypes = (0, $cXtTj.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $iDrrr.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onAttachmentBlocked?.(streamMessage);
                }
            }
            if ((0, $bxkJA.isStreamError)(streamMessage) || (0, $bxkJA.isStreamAiCreditDenied)(streamMessage)) {
                const streamError = (0, $bxkJA.isStreamError)(streamMessage) ? streamMessage : (0, $f5f4d30a252f1f45$export$2104d43a09d33c2)(streamMessage);
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamError.message.message_template,
                    errorMessage: streamError.message.content,
                    traceId: traceId
                });
                // If a guard event (PROMPT_REDACTION, PROMPT_BLOCKED, RESPONSE_BLOCKED, or ATTACHMENT_BLOCKED) was
                // already received, the backend always follows with an ERROR to terminate the stream.
                // Treat it as a normal end of the guard flow — break without throwing.
                if (guardEventReceived) {
                    // A guard block (prompt/response/attachment) is terminated by this backend error;
                    // surface it once here as the run's blocked state.
                    (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'blocked');
                    break;
                }
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamError;
                // AUP violations are still considered successful
                if ((0, $bxkJA.isStreamAUPError)(streamMessage)) {
                    experienceTracker.succeed({
                        name: sendMessageExperienceNameCompiled
                    });
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE
                    });
                    // [MAUI-1070] In the remix flow, treat an AUP violation as non-fatal:
                    // keep reading so the friendly response (streamed right after the guard)
                    // arrives instead of being discarded by the throw below. `onSafetyViolation`
                    // lets the editor-remix UI surface it (dismiss thinking bar, open chat).
                    // Scoped to `source === 'remix'`; other flows keep the existing throw.
                    if (creationContextParams?.source === 'remix') {
                        promptStreamHook?.onSafetyViolation?.(conversationId);
                        continue;
                    }
                }
                sendMessageLatencyMetrics.cancel();
                deadAirTracker?.cancel();
                viewDeadAirBroker?.finish('errored');
                cancelStreamingMetrics();
                promptStreamHook?.onError?.(streamError, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId,
                    traceId: traceId
                });
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                // A genuine error that actually terminates the run. Placed after the AUP remix path
                // above, which continues rather than throwing, so that path is not marked failed.
                (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, 'failed');
                throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
        if (lastStreamTimeoutError && !hasReceivedFinalResponse && !guardEventReceived && !await recoverAfterStreamTimeout(lastStreamTimeoutError)) throw lastStreamTimeoutError;
    } catch (error) {
        (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, abortController.signal.aborted ? 'cancelled' : 'failure');
        /* for await catch block */ const err = error instanceof Error ? error : new Error(String(error));
        streamTracking?.fail(err);
        if (err instanceof (0, $hwHCO.StreamErrorException)) throw err;
        if (err instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) {
            sendMessageLatencyMetrics.cancel();
            deadAirTracker?.cancel();
            viewDeadAirBroker?.finish('aborted');
            cancelStreamingMetrics();
            broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
            experienceTracker.fail({
                name: sendMessageExperienceNameCompiled,
                error: err,
                attributes: {
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabled,
                    llmDebugLogsEnabled: storeUserMessages,
                    productKey: productKey,
                    isStreamAction: streamActionInfo.isAction,
                    actionKey: streamActionInfo.actionKey,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                    requestId: trackingAttributes.requestId,
                    recoveryOutcome: isStreamTimeoutRecoveryEnabled ? 'exhausted' : 'notAttempted',
                    streamTimeoutCount: streamTimeoutCount,
                    streamTimeoutMs: streamIdleTimeoutMs,
                    streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled,
                    traceId: traceId,
                    ...remixRegenerateRequestAttributes
                }
            });
            throw err;
        }
        // this is for any errors that happening during processing the stream
        // e.g. BE terminates streaming suddenly
        sendMessageLatencyMetrics.cancel();
        deadAirTracker?.cancel();
        viewDeadAirBroker?.finish('aborted');
        cancelStreamingMetrics();
        if ((0, $7ccd7e68e8d56362$export$886a0387c1c465f5)(err)) {
            const isReconnectable = !!(agentMessageId && isReconnectSupported);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'rovoChatStream',
                attributes: {
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    isReconnectable: isReconnectable,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent,
                    error: err.message
                }
            });
        }
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
        // When reconnect attempt fails
        if (!deepResearchEnabled) {
            const reason = streamActionInfo.isAction ? 'stream_error_during_action' : 'stream_error_before_classification';
            for (const name of [
                (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
            ])experienceTracker.fail({
                name: name,
                error: err,
                attributes: {
                    productKey: productKey,
                    actionKey: streamActionInfo.actionKey,
                    reason: reason
                }
            });
        }
        throw new (0, $bQxqB.StreamGeneratorError)(err.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, err);
    } finally{
        unsubscribeRemixTrackers?.();
        inactivity?.stop();
        deadAirTracker?.complete();
        viewDeadAirBroker?.finish('completed');
        // The only cleanup on stop, idle timeout and stream error: processStream rethrows
        // and the send path then skips markStreamingMessagesAsComplete.
        answerUiParts?.onStreamEnd();
        // Safety net for the agent-run bridge: if the turn ended without settling (abort, timeout,
        // dropped request), clear the run so its node does not stay active. No-op on the normal
        // paths, which have already reached done / needs-input / a terminal state.
        (0, $9vNm5.endActiveAgentRun)(conversationId);
    }
    /**********************************************************
   *
   * Stream processing END
   *
   **********************************************************/ if (actionClassificationCount > 0 && actionCompleteCount === 0 && hasReceivedFinalResponse) // In the case ACTION_COMPLETE was never sent, it's likely that `AdfEditorMinion` early-exits with "no operations returned by LLM". So we abort the experiences rather than letting them timeout. This can potentially happen when LLM needs clarification.
    (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, 'stream_completed_without_action_complete', {
        actionKey: streamActionInfo.actionKey,
        productKey: productKey
    });
    if (!hasReceivedFollowUp && hasReceivedFinalResponse && !hasReceivedCreditDenial) {
        const messages = getMessages(conversationId);
        if ((0, $85a86afb88dde1c4$export$a5165b6c5017830)(messages, productKey, chatContextStoreActions.getIsStagingArea())) {
            const originatingAssistant = [
                ...messages
            ].reverse().find((0, $igOtY.isStoreAssistant));
            const originatingAgentIdentity = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') && originatingAssistant ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistant) : undefined;
            setMessages(conversationId, [
                ...messages,
                {
                    type: 'FOLLOW_UP',
                    content: (0, $3bd4037c0469b685$export$b323db724925d16f)(),
                    id: (0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000),
                    agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                    ...originatingAgentIdentity ? {
                        originatingAgentIdentity: originatingAgentIdentity
                    } : {},
                    humanMessageId: trackingAttributes.humanMessageId
                }
            ]);
        }
    }
    updateCurrentConversation({
        sourceAgentId: (0, $56454c3864f9431b$export$ab93cd1ecacda8ec)(getMessages(conversationId), (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId))
    });
    if (canCompleteRemixWithText && isValidRemixTextResponse && !abortController.signal.aborted && !guardEventReceived) experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
        attributes: {
            conversationId: conversationId,
            responseType: 'text'
        }
    });
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse,
        hasReceivedPromptRedaction: hasReceivedPromptRedaction,
        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
        hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper,
        implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics,
        implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName,
        guardEventReceived: guardEventReceived,
        recoveredAfterStreamTimeout: recoveredAfterStreamTimeout,
        streamTimeoutCount: streamTimeoutCount,
        streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled,
        assistantMessageId: hasReceivedFinalResponse && agentMessageId ? agentMessageId : tmpAssistantMessageId
    };
};








const $7f3fab340ef5b938$var$normalizeAgentId = (id)=>id === (0, $2yWJZ.ROVO_AGENT_NAMED_ID) ? (0, $2yWJZ.ROVO_AGENT_UUID) : id;
const $7f3fab340ef5b938$export$3e195448963cca75 = async ({ assistanceService: assistanceService, catalogAgentId: catalogAgentId, existingIdentityAccountId: existingIdentityAccountId })=>{
    if (existingIdentityAccountId) return existingIdentityAccountId;
    if (!catalogAgentId) return undefined;
    try {
        const normalizedCatalogAgentId = $7f3fab340ef5b938$var$normalizeAgentId(catalogAgentId);
        const agent = await assistanceService.getAgentDetails(normalizedCatalogAgentId);
        return $7f3fab340ef5b938$var$normalizeAgentId(agent.id) === normalizedCatalogAgentId ? agent.identity_account_id ?? undefined : undefined;
    } catch  {
        // Identity lookup must not prevent the user from generating their page.
        (0, $hlvTd.addSentryBreadcrumb)({
            message: 'Unable to resolve Create with Rovo agent identity'
        });
        return undefined;
    }
};





const $3f00b208cdf7b094$export$194fc39b7c9c983 = ({ resultAttributionContext: resultAttributionContext, routingAgentId: routingAgentId, messageSources: messageSources, additionalAnalyticAttributes: additionalAnalyticAttributes })=>{
    const sourceAgentId = resultAttributionContext?.sourceAgentId;
    const launchSource = resultAttributionContext?.launchSource;
    const entryPoint = (0, $4o0zT.isExperimentEnabled)('cc_contextual_agent_creation_v2') ? resultAttributionContext?.entryPoint : undefined;
    if (resultAttributionContext === undefined || launchSource === undefined && entryPoint === undefined) return {
        messageSources: messageSources,
        additionalAnalyticAttributes: additionalAnalyticAttributes
    };
    if (sourceAgentId !== undefined && sourceAgentId !== routingAgentId) return {
        messageSources: messageSources,
        additionalAnalyticAttributes: additionalAnalyticAttributes,
        shouldClearResultAttributionContext: true
    };
    const attributedMessageSources = {
        ...messageSources ?? {},
        ...launchSource !== undefined && messageSources?.followUpSource === undefined ? {
            followUpSource: launchSource
        } : {},
        ...entryPoint !== undefined && messageSources?.entryPoint === undefined ? {
            entryPoint: entryPoint
        } : {}
    };
    const attributedAdditionalAnalyticAttributes = launchSource ? {
        launchSource: launchSource,
        ...additionalAnalyticAttributes ?? {}
    } : additionalAnalyticAttributes;
    return {
        messageSources: attributedMessageSources,
        additionalAnalyticAttributes: attributedAdditionalAnalyticAttributes
    };
};




var $4u5Na = parcelRequire("4u5Na");


var $4KNZy = parcelRequire("4KNZy");

const $732002bd2dba0f68$var$getSendMessageExperienceName = (params)=>{
    if (params.isCustomRovoAgent) return (0, $irnO2.ExperienceName).SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (params.deepResearchEnabled) return (0, $irnO2.ExperienceName).SEND_DR_MESSAGE;
    if (params.thinkDeeperEnabled) return (0, $irnO2.ExperienceName).SEND_TD_MESSAGE;
    if (params.taskModeEnabled) return (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE;
    return (0, $irnO2.ExperienceName).SEND_MESSAGE;
};
const $732002bd2dba0f68$var$getInitialTrackingAttributes = (agentId, instrumentationId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, selectedCloudIds, template, forcedContentType)=>{
    return {
        pluginsInvoked: new Set(),
        skillsInvoked: [],
        executedStratusSkill: false,
        hasSources: false,
        hasAuthoritativeSources: false,
        messageId: '',
        humanMessageId: '',
        requestId: undefined,
        messageActions: [],
        messageDynamicUIData: [],
        invokedFrom: undefined,
        instrumentationId: instrumentationId,
        messageSentTimeStamp: new Date().toISOString(),
        citedProductList: {},
        sourceProducts: {},
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        taskModeEnabled: taskModeEnabled,
        webSearchEnabled: webSearchEnabled,
        interactionSource: messageSources?.interactionSource,
        followUpSource: messageSources?.followUpSource ?? 'none',
        // Assigned by the caller from `conversation.chatEntryPoint` once the conversation is known.
        chatEntryPoint: undefined,
        aiFeatureName: messageSources?.aiFeatureName,
        isFirstPrompt: isFirstPrompt,
        promptFeatures: (0, $l2exp.extractContentFeatures)(prompt),
        fileCount: files?.length ?? 0,
        appFilters: appFilters ?? [],
        appFilterCount: appFilters?.length ?? 0,
        selectedCloudIds: selectedCloudIds ?? [],
        selectedCloudIdCount: selectedCloudIds?.length ?? 0,
        template: template,
        deepResearchInvoked: false,
        forcedContentType: forcedContentType,
        interactionModeRequested: (0, $a2488f01d739616b$export$9f198c0729e6b053)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        }),
        twgTraceStepIds: [],
        twgTraceRoundIds: [],
        twgTraceToolNames: [],
        twgTraceRenderModes: []
    };
};
const $732002bd2dba0f68$var$getOptimisticMessageTypes = (deepResearchEnabled, webSearchEnabled)=>{
    const messageType = [];
    if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) {
        if (deepResearchEnabled) messageType.push('DEEP_RESEARCH');
        if (webSearchEnabled) messageType.push('WEB_SEARCH');
    }
    return {
        messageType: messageType
    };
};
const $732002bd2dba0f68$var$initLatencyMetrics = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, agentId: agentId })=>{
    const rovoCustomAgent = (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(agentId);
    const sendMessageLatencyMetrics = (0, $548d18bad1818374$export$1e4d1659c4209dbf).createSendMessageMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstAnswerPartLatencyMetrics = (0, $548d18bad1818374$export$1e4d1659c4209dbf).createTimeToFirstAnswerPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstActionPartLatencyMetrics = (0, $548d18bad1818374$export$1e4d1659c4209dbf).createTimeToFirstActionPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToActionCompletionLatencyMetrics = (0, $548d18bad1818374$export$1e4d1659c4209dbf).createTimeToActionCompletionMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const metricsStartTime = window.performance.now();
    sendMessageLatencyMetrics.start({
        startTime: metricsStartTime
    });
    timeToFirstAnswerPartLatencyMetrics.start({
        startTime: metricsStartTime
    });
    timeToFirstActionPartLatencyMetrics.start();
    timeToActionCompletionLatencyMetrics.start();
    const stopInteractionMetricsTimeToFirstAnswerPart = (0, $b016bb6f9c6bc818$export$e26ccd8a2d744904)(timeToFirstAnswerPartLatencyMetrics);
    const stopInteractionMetricsTimeToFirstActionPart = (0, $b016bb6f9c6bc818$export$e26ccd8a2d744904)(timeToFirstActionPartLatencyMetrics);
    const stopInteractionMetricsTimeToActionCompletion = (0, $b016bb6f9c6bc818$export$e26ccd8a2d744904)(timeToActionCompletionLatencyMetrics);
    const cancelStreamingMetrics = ()=>{
        stopInteractionMetricsTimeToFirstAnswerPart('cancel');
        stopInteractionMetricsTimeToFirstActionPart('cancel');
        stopInteractionMetricsTimeToActionCompletion('cancel');
    };
    return {
        sendMessageLatencyMetrics: sendMessageLatencyMetrics,
        timeToFirstAnswerPartLatencyMetrics: timeToFirstAnswerPartLatencyMetrics,
        timeToFirstActionPartLatencyMetrics: timeToFirstActionPartLatencyMetrics,
        timeToActionCompletionLatencyMetrics: timeToActionCompletionLatencyMetrics,
        stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
        stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
        stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
        cancelStreamingMetrics: cancelStreamingMetrics,
        metricsStartTime: metricsStartTime
    };
};
const $732002bd2dba0f68$var$deriveOptimisticAssistantAuthorIdentity = ({ messageAgentIdentity: messageAgentIdentity, messageRoutingAgentId: messageRoutingAgentId })=>{
    if (!messageAgentIdentity?.agentId) return {
        agentAuthorId: messageRoutingAgentId
    };
    return {
        agentAuthorId: messageAgentIdentity.agentId,
        agentAuthorIdentityAccountId: messageAgentIdentity.identityAccountId
    };
};
const $732002bd2dba0f68$var$hydrateStoreWithNewMessage = (dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, displayContext, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, messageRoutingAgentId, messageAgentIdentity, followUpAgentIdentity, agentVersion, entryPoint, getActiveAssistantMessageId, actionId)=>{
    const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1206f352a14d8e9a$export$cb6128fc3a3c8081)(getActiveAssistantMessageId);
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments')) (0, $2VSIF.setConversationCancelled)(conversationId, false);
    const updateCurrentConversation = (data)=>{
        dispatch(setConversationData({
            conversationId: conversationId,
            data: data
        }));
    };
    const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const retryAgentVersion = mentionAgentsEnabled && agentVersion?.versionType === 'DRAFT' && (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential') ? agentVersion : undefined;
    const followUpAgentIdentityWithVersion = followUpAgentIdentity && retryAgentVersion && !followUpAgentIdentity.agentVersion ? {
        ...followUpAgentIdentity,
        agentVersion: retryAgentVersion
    } : followUpAgentIdentity;
    const retryAgentIdentity = mentionAgentsEnabled && (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential') && messageAgentIdentity?.agentId ? {
        id: messageAgentIdentity.agentId,
        ...messageAgentIdentity.identityAccountId ? {
            identityAccountId: messageAgentIdentity.identityAccountId
        } : {},
        ...retryAgentVersion ? {
            agentVersion: retryAgentVersion
        } : {}
    } : undefined;
    const gatedFollowUpAgentIdentity = mentionAgentsEnabled ? followUpAgentIdentityWithVersion ?? retryAgentIdentity : undefined;
    const optimisticAssistantIdentity = mentionAgentsEnabled ? $732002bd2dba0f68$var$deriveOptimisticAssistantAuthorIdentity({
        messageAgentIdentity: messageAgentIdentity,
        messageRoutingAgentId: messageRoutingAgentId
    }) : {
        // Remove this named-id control branch with `rovo_chat_mention_agents` cleanup.
        agentNamedId: sourceAgentIdForTemporaryLocalConversation
    };
    updateCurrentConversation({
        status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
        storeAbortController: storeAbortController,
        lastMessageType: messageType,
        lastAgentMessageStatus: 'IN_PROGRESS'
    });
    dispatch(addHumanMessage({
        id: tmpHumanMessageId,
        content: prompt,
        conversationId: conversationId,
        fileUploads: files,
        displayContext: displayContext,
        ...gatedFollowUpAgentIdentity ? {
            followUpAgentIdentity: gatedFollowUpAgentIdentity
        } : {}
    }));
    dispatch(addAssistantMessage({
        id: tmpAssistantMessageId,
        content: '',
        conversationId: conversationId,
        ...optimisticAssistantIdentity,
        entryPoint: entryPoint,
        actionId: actionId
    }));
    dispatch(clearFollowUpMessages({
        conversationId: conversationId
    }));
    return {
        abortController: abortController,
        storeAbortController: storeAbortController,
        confirmAbort: confirmAbort,
        updateCurrentConversation: updateCurrentConversation
    };
};
const $732002bd2dba0f68$var$handleSendMessageServiceCallFailure = (error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages, remixRegenerateRequestAttributes)=>{
    const apiError = error instanceof (0, $8A2GO.ApiError) ? error : undefined;
    const normalizedError = error instanceof Error ? error : new Error(String(error));
    // Convert deep research related errors to DeepResearchError when deep research is enabled
    let convertedError = error;
    if (deepResearchEnabled) convertedError = new (0, $bMRok.DeepResearchError)(normalizedError.message, {
        traceId: apiError?.errorAttributes?.traceId,
        requestId: apiError?.errorAttributes?.requestId
    });
    // Returns bad request error because agent is deactivated or user has no permission
    const isAgentDeactivated = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
    const isNoAgentPermission = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN);
    if (isAgentDeactivated || isNoAgentPermission) {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: normalizedError,
            attributes: {
                conversationId: conversationId,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                ...remixRegenerateRequestAttributes
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                ...trackingAttributes.chatEntryPoint ? {
                    chatEntryPoint: trackingAttributes.chatEntryPoint
                } : {}
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: (0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes)
        });
        updateCurrentConversation({
            status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
            traces: [],
            errorCode: apiError?.errorAttributes.errorCode
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
        return;
    } else if (error instanceof Error && error.name === 'AbortError') {
        // Check if the abort was programmatic or not. `abortController.signal.aborted` is a readonly field that is only set to true when called programmatically
        // The browser can abort requests to free up resources & save power (esp. on background tabs). When it does this, it **does not** set `abortController.signal.aborted` to true
        const isProgrammaticAbort = abortController.signal.aborted;
        experienceTracker.abort({
            name: sendMessageExperienceNameCompiled,
            reason: 'Aborted',
            attributes: {
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                isProgrammaticAbort: isProgrammaticAbort
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                ...trackingAttributes.chatEntryPoint ? {
                    chatEntryPoint: trackingAttributes.chatEntryPoint
                } : {}
            }
        });
        trackAIMAUEvent({
            type: 'dismissed',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            subjectId: trackingAttributes.interactionSource,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: (0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes)
        });
        updateCurrentConversation((0, $jyZaR.clearStatus)({
            lastAgentMessageStatus: isProgrammaticAbort ? 'CANCELLED' : 'FAILED'
        }));
        (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
        clearMessageResearch({
            messageId: tmpAssistantMessageId
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ABORTED);
        confirmAbort();
        return;
    } else {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: normalizedError,
            attributes: {
                conversationId: conversationId,
                deepResearchEnabled: deepResearchEnabled,
                fastModeEnabled: fastModeEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                ...remixRegenerateRequestAttributes
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                ...trackingAttributes.chatEntryPoint ? {
                    chatEntryPoint: trackingAttributes.chatEntryPoint
                } : {}
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: (0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes)
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
        throw convertedError;
    }
};
/**
 * Compute the per-send routing identity for a send.
 *
 * Wraps `deriveAgentSendRequestIdentity` with the shared inputs (default agent,
 * explicit caller agent id, and the draft-only-on-chatInput override rule) so the
 * outer early-handler fallback and the inner per-send path stay in lockstep.
 *
 * With the experiment enabled, `conversationAgentForRequest` is the resolved canonical UUID:
 * Rovo for a new conversation or `conversation.agent.id` for a later turn. The control keeps
 * the legacy caller identity so its request shape is unchanged. See ai-mate AGENTS.md
 * "Rovo Chat agent identity, routing, and display".
 */ const $732002bd2dba0f68$var$deriveSendRoutingIdentity = ({ conversationAgentForRequest: conversationAgentForRequest, agentIdParam: agentIdParam, inputSelectedAgentIds: inputSelectedAgentIds, messageSources: messageSources, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields })=>(0, $cf64faf992f18e85$export$4413981bab4da984)({
        conversationAgent: conversationAgentForRequest,
        defaultAgent: (0, $6iQ4q.DEFAULT_AGENT),
        explicitAgentId: agentIdParam,
        omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields,
        inputSelectedAgentIds: inputSelectedAgentIds,
        // Selected-agent drafts only route from prompt surfaces that submit their own
        // selection snapshot. Cross-surface handoffs must not inherit the sidebar's draft.
        allowSelectedAgentOverride: messageSources?.interactionSource === 'chatInput' || messageSources?.interactionSource === 'editMessage'
    });
/**
 * Build the optimistic `conversation.agent` metadata used when a send creates the
 * conversation. Prefers the already-stored conversation agent, then the caller's
 * rich agent metadata when it matches the resolved conversation agent id, then a
 * provisional placeholder built from that id (the header hydrates the rest).
 *
 * A stored agent that is itself a provisional placeholder (blank `creator_type`,
 * seeded before backend metadata hydrated) does not shadow the caller's full
 * metadata for the same agent: consumers that read `creator_type` — notably the
 * `<details>` preprocessor gate — would otherwise treat a third-party agent as
 * first-party for the whole streamed turn.
 */ const $732002bd2dba0f68$var$buildOptimisticConversationAgent = ({ agent: agent, currentConversation: currentConversation, conversationAgentId: conversationAgentId })=>{
    const callerAgentConversationMetadata = agent?.id === conversationAgentId ? {
        agent_id: agent.id,
        agent_named_id: agent.external_config_reference ?? agent.named_id,
        agent_name: agent.name,
        creator_type: agent.creator_type,
        identity_account_id: agent.identity_account_id ?? undefined,
        is_default: agent.is_default,
        forge_url: agent.icon ?? undefined,
        execution_config: agent.execution_config
    } : undefined;
    const storedConversationAgent = currentConversation?.agent;
    if (storedConversationAgent?.creator_type) return storedConversationAgent;
    return callerAgentConversationMetadata ?? storedConversationAgent ?? (0, $8fLSN.createProvisionalConversationAgent)(conversationAgentId);
};
const $732002bd2dba0f68$export$9558791053c77c34 = ({ prompt: prompt, editRequestId: submittedEditRequestId, editSubmittedAt: editSubmittedAt, historySuggestionSubmission: historySuggestionSubmission, compositionDurationFromFirstInputMs: compositionDurationFromFirstInputMs, autoActionApprovalMode: autoActionApprovalMode, agent: agent, agentId: agentIdParam, agentName: agentNameParam, agentNamedId: agentNamedIdParam, agentIdentityAccountId: agentIdentityAccountIdParam, isThirdPartyAgent: isThirdPartyAgentParam, conversationId: conversationIdParam, storeUserMessages: storeUserMessages, messageSources: submittedMessageSources, files: files, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, webSearchEnabled: webSearchEnabled, conciergeEnabled: conciergeEnabled, sourceMode: sourceMode, appFilters: appFilters, selectedCloudIds: selectedCloudIds, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, excludePageContext: excludePageContext, spaceSourceCount: spaceSourceCount, productKey: productKey, source: source, promptStreamHook: promptStreamHook, onStreamLifecycle: onStreamLifecycle, creationContextParams: creationContextParams, additionalContextReceiverId: additionalContextReceiverId, unsupportedRemixNodeTypes: unsupportedRemixNodeTypes, additionalAnalyticAttributes: additionalAnalyticAttributes, contentContext: contentContext, writingStyleContext: writingStyleContext, minionAlias: minionAlias, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, onNewConversationIdAvailable: onNewConversationIdAvailable, contentId: contentId, inlineRovoEditAttemptId: inlineRovoEditAttemptId, openChat: openChat, openChatOnError: openChatOnError, agentVersion: agentVersion, spaceId: spaceId, searchArtifact: searchArtifact, skillSelectionSource: skillSelectionSource, skipEditorContext: skipEditorContext, editorContextFallback: editorContextFallback, shouldExtractConversationScopes: shouldExtractConversationScopes, browserDisplayContextActive: submittedBrowserDisplayContextActive, parentMessageId: parentMessageId, requestedSkills: requestedSkills, commentMentionContext: commentMentionContext, editRollback: editRollback, inputSelectedAgentIds: inputSelectedAgentIds, messageAgentIdentity: messageAgentIdentity, followUpAgentIdentity: followUpAgentIdentity, invokedByNodeLocalId: invokedByNodeLocalId, setConversationData: setConversationData, createConversationOptimistically: createConversationOptimistically, addHumanMessage: addHumanMessage, addAssistantMessage: addAssistantMessage, clearFollowUpMessages: clearFollowUpMessages, setSelectedConversation: setSelectedConversation, reconnectToInProgressStream: reconnectToInProgressStream })=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEventWithDefaults, chatContextStoreActions: chatContextStoreActions, trackAIMAUEvent: trackAIMAUEventWithDefaults, getMessages: getMessages, setMessages: setMessages, reportCreditDenial: reportCreditDenial, processStreamResearch: processStreamResearch, completeAllSteps: completeAllSteps, updateResearchMessageId: updateResearchMessageId, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, getChatInitiator: getChatInitiator, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastStreamStatus: broadcastStreamStatus, siteId: siteId, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage, onTempMessageIdReplaced: containerOnTempMessageIdReplaced, onHumanMessageIdReplaced: containerOnHumanMessageIdReplaced, browserContextSanitizer: browserContextSanitizer, getBrowserDisplayContextActive: getBrowserDisplayContextActive, viewDeadAirBroker: viewDeadAirBroker, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions, onSpaceSourceRecommendations: onSpaceSourceRecommendations, onPromptSent: onPromptSent })=>{
        const editAcceptedAt = (0, $iDrrr.fg)('rovo_slides_ai_edit_latency') ? performance.timeOrigin + performance.now() : undefined;
        const promptHistoryRequestToken = getState().promptHistory?.requestToken;
        const isPromptContextDisplayEnabled = (0, $iDrrr.fg)('rovo_chat_prompt_context_display_render');
        const isAgentConciergeAvailabilityEnabled = (0, $iDrrr.fg)('rovo_chat_agent_concierge_ui_contract') && (0, $iDrrr.fg)('rovo_chat_agent_concierge_personalization');
        const isAgentConciergeAgentsOnlyEnabled = (0, $iDrrr.fg)('rovo_chat_agent_concierge_agents_only');
        // Capture before a new conversation ID or asynchronous context work changes the composer.
        const browserDisplayContextActive = isPromptContextDisplayEnabled ? (submittedBrowserDisplayContextActive ?? getBrowserDisplayContextActive?.(conversationIdParam ?? getState().currentConversationId)) === true : undefined;
        const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        const implicitRovoAgentId = mentionAgentsEnabled ? (0, $2yWJZ.ROVO_AGENT_UUID) : (0, $2yWJZ.ROVO_AGENT_NAMED_ID);
        // Keep the legacy default-agent object available for all gate-off local behavior while
        // allowing gate-on sends with no caller agent to resolve from conversation state.
        const legacyAgent = agent ?? (0, $6iQ4q.DEFAULT_AGENT);
        const agentForCurrentSendMetadata = mentionAgentsEnabled ? agent : legacyAgent;
        const initialConversationForRouting = (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationIdParam ?? getState().currentConversationId);
        const conciergeSurfaceAgentId = agentIdParam ?? initialConversationForRouting?.agent?.agent_id ?? agent?.id;
        const shouldSendConciergeEnabled = conciergeEnabled === true && isAgentConciergeAvailabilityEnabled && (!isAgentConciergeAgentsOnlyEnabled || conciergeSurfaceAgentId !== undefined && !(0, $2yWJZ.isDefaultRovoChat)({
            agentId: conciergeSurfaceAgentId
        })) && await assistanceService.getAgentConciergeAvailability().then((response)=>response.toggleAvailable === true).catch(()=>false);
        const conversationAgentIdForRoutingFallback = (0, $8fLSN.resolveConversationAgentIdForRouting)({
            conversation: initialConversationForRouting,
            fallbackAgentId: mentionAgentsEnabled ? agent?.id ?? implicitRovoAgentId : legacyAgent.id
        });
        // `sourceAgentId` for the temporary local conversation; per-turn routing is computed by `deriveSendRoutingIdentity`.
        const sourceAgentIdForTemporaryLocalConversation = agentIdParam ?? (mentionAgentsEnabled ? agent?.id ?? implicitRovoAgentId : legacyAgent.id);
        const { messageType: messageType } = $732002bd2dba0f68$var$getOptimisticMessageTypes(deepResearchEnabled, webSearchEnabled);
        let pageContext;
        // Snapshot captured right before the optimistic add when `editRollback` is set,
        // so that a terminal failure can restore the conversation to its pre-edit state
        // by slicing back to this length and re-appending `editRollback.restoreMessages`.
        let rollbackSnapshot;
        const performEditRollback = ()=>{
            if (!editRollback || !rollbackSnapshot) return;
            const { conversationId: rollbackConvId, lengthBeforeOptimistic: lengthBeforeOptimistic } = rollbackSnapshot;
            const current = getMessages(rollbackConvId);
            setMessages(rollbackConvId, [
                ...current.slice(0, lengthBeforeOptimistic),
                ...editRollback.restoreMessages
            ]);
        };
        let editRequestId;
        const sendMessageFn = async ({ conversationId: conversationId, isRecoveredConversation: isRecoveredConversation = false })=>{
            if (source === 'agentMentionComment' && (0, $2VSIF.isConversationCancelled)(conversationId)) return;
            const getContentIdForAskQuestionAttributes = ()=>contentId === undefined ? undefined : String(contentId);
            const getResultAttributesForAskQuestion = ()=>{
                const confluenceContentId = getContentIdForAskQuestionAttributes();
                if (!confluenceContentId) return undefined;
                return (0, $lUXDc.getConfluenceResultAcceptanceAttributesForAskQuestion)({
                    messages: getMessages(conversationId),
                    contentId: confluenceContentId
                });
            };
            const currentConversation = (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId);
            // --- Attribution: merged into every analytics event fired below, for this send only. ---
            //
            // conversationChannelId is always attached. rovoJourneyId is attached only for the
            // five-event allowlist (enforced centrally by isRovoJourneyAllowlistedEvent), and is read
            // off `conversationId` specifically -- never the currently active conversation -- because
            // this send can resolve after the user has switched to a different conversation, and the
            // event must still attribute back to the conversation it actually belongs to.
            const getAttributionAttributes = (eventPayload)=>{
                const rovoJourneyId = (0, $Ou0Zz.isRovoJourneyAllowlistedEvent)(eventPayload) ? (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId)?.rovoJourneyId : undefined;
                return {
                    conversationChannelId: conversationId,
                    ...rovoJourneyId ? {
                        rovoJourneyId: rovoJourneyId
                    } : {}
                };
            };
            // Forwards to the real sendAnalyticsEvent, preserving arity: existing consumers and test
            // doubles distinguish a one-argument call from an explicit second `undefined` argument.
            const forwardAnalyticsEvent = (payload, options)=>{
                if (options === undefined) {
                    sendAnalyticsEventWithDefaults(payload);
                    return;
                }
                sendAnalyticsEventWithDefaults(payload, options);
            };
            // --- Decorated dispatchers. Everything below this point in the action calls these, not
            // the raw sendAnalyticsEventWithDefaults / trackAIMAUEventWithDefaults above. ---
            const sendAnalyticsEvent = (payload, options)=>{
                const eventPayload = (0, $7TCQz.isUIAnalyticsEvent)(payload) ? payload.payload : payload;
                const attributionAttributes = getAttributionAttributes(eventPayload ?? {});
                if ((0, $7TCQz.isUIAnalyticsEvent)(payload)) {
                    const attributedEvent = payload.update({
                        ...payload.payload ?? {},
                        attributes: {
                            ...payload.payload?.attributes ?? {},
                            ...attributionAttributes
                        }
                    }) ?? payload;
                    forwardAnalyticsEvent(attributedEvent, options);
                    return;
                }
                forwardAnalyticsEvent({
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        ...attributionAttributes
                    }
                }, options);
            };
            const trackAIMAUEvent = (event)=>{
                trackAIMAUEventWithDefaults({
                    ...event,
                    attributes: {
                        ...typeof event.attributes === 'object' && event.attributes !== null ? event.attributes : {},
                        ...getAttributionAttributes(event)
                    }
                });
            };
            const isCreateWithRovoSend = creationContextParams?.source === 'ai-first-creation' || creationContextParams?.source === 'chat-only-creation-modal' || creationContextParams?.experience === 'cwr' || creationContextParams?.experience === 'cwr_type' || creationContextParams?.experience === 'cwr_edit';
            // Resolve Space context before optimistic creation so the local chat-mode store and
            // backend request use the same source mode for entity-driven empty-chat launches.
            // CWR should not send within a space.
            const resolvedSpaceId = spaceId ?? (!isCreateWithRovoSend ? chatContextStoreActions.getAIFeatureContext()?.projectContext?.spaceId : undefined);
            const spaceScopedSourceMode = (0, $5odSY.getSpaceScopedSourceMode)({
                sourceMode: sourceMode,
                spaceId: resolvedSpaceId ?? currentConversation?.rovoSpaceId
            });
            const currentConversationAgentId = (0, $8fLSN.resolveConversationAgentIdForRouting)({
                conversation: currentConversation,
                fallbackAgentId: conversationAgentIdForRoutingFallback
            });
            const conversationAgentForOptimisticCreation = $732002bd2dba0f68$var$buildOptimisticConversationAgent({
                agent: agent,
                currentConversation: currentConversation,
                conversationAgentId: currentConversationAgentId
            });
            const { routedSelectedAgentId: routedSelectedAgentId, routingAgentId: messageRoutingAgentId, agentIdForRequest: agentIdForRequest, agentNamedIdForRequest: agentNamedIdForRequest } = $732002bd2dba0f68$var$deriveSendRoutingIdentity({
                conversationAgentForRequest: mentionAgentsEnabled ? {
                    id: agent?.id ?? currentConversationAgentId
                } : {
                    id: legacyAgent.id,
                    named_id: legacyAgent.named_id
                },
                agentIdParam: agentIdParam,
                inputSelectedAgentIds: inputSelectedAgentIds,
                messageSources: submittedMessageSources,
                omitConversationDefaultAgentRequestFields: !mentionAgentsEnabled
            });
            const { messageSources: messageSources } = (0, $3f00b208cdf7b094$export$194fc39b7c9c983)({
                resultAttributionContext: currentConversation?.resultAttributionContext,
                routingAgentId: messageRoutingAgentId,
                messageSources: submittedMessageSources,
                additionalAnalyticAttributes: undefined
            });
            const sendMessageExperienceNameCompiled = $732002bd2dba0f68$var$getSendMessageExperienceName({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                taskModeEnabled: taskModeEnabled,
                fastModeEnabled: fastModeEnabled,
                isCustomRovoAgent: (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(messageRoutingAgentId)
            });
            const resolvedAgentVersion = agentVersion ?? currentConversation?.agentVersion;
            if (currentConversation?.storeAbortController) // Silently aborting if there is another operation in progress
            return;
            const inlineSlidesEdit = creationContextParams?.experience === 'inline_edit' && creationContextParams?.contentTypes?.includes('slide');
            editRequestId ?? (editRequestId = (0, $Iv7dD.slidesAiEditLatency).begin({
                editRequestId: submittedEditRequestId,
                editSubmittedAt: inlineSlidesEdit ? editSubmittedAt : editAcceptedAt,
                inline: Boolean(inlineSlidesEdit),
                contentId: contentId,
                emit: (attributes)=>sendAnalyticsEventWithDefaults({
                        eventType: 'operational',
                        actionSubject: 'slidesAiEdit',
                        action: 'completed',
                        attributes: attributes
                    }, {
                        attributesMode: 'explicit'
                    })
            }));
            const tmpHumanMessageId = (0, $icBz6.generateId)();
            const tmpAssistantMessageId = (0, $23567c2d6eaf1c81$export$eca740b13a7a3080)(conversationId);
            let activeAssistantMessageId = tmpAssistantMessageId;
            let generator;
            let responseData;
            let hasLoggedInitiatedEvent = false;
            const isFirstPrompt = (0, $1IZrU.isEmptyConversation)(conversationId);
            const contentContextFromStore = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
            const contentContextValue = contentContext ?? contentContextFromStore;
            const isSitesSourceFilterEnabled = (0, $iDrrr.fg)((0, $5XWbo.ROVO_CHAT_SITES_SOURCE_FILTER_GATE));
            const selectedCloudIdsForGatedFeature = isSitesSourceFilterEnabled ? selectedCloudIds : undefined;
            let trackingAttributes = $732002bd2dba0f68$var$getInitialTrackingAttributes(messageRoutingAgentId, tmpAssistantMessageId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, selectedCloudIdsForGatedFeature, {
                templateId: creationContextParams?.templateInput?.templateId,
                templateType: creationContextParams?.templateInput?.templateType
            }, creationContextParams?.forcedContentType);
            // Read from the conversation so entry-point attribution persists across turns.
            trackingAttributes.chatEntryPoint = currentConversation?.chatEntryPoint;
            // Prepare fields for the temporary local conversation created before the backend returns one.
            const conversationAgentForTemporaryLocalConversation = mentionAgentsEnabled ? conversationAgentForOptimisticCreation : undefined;
            const conversationAgentFieldsForTemporaryLocalConversation = conversationAgentForTemporaryLocalConversation ? {
                agent: conversationAgentForTemporaryLocalConversation
            } : {};
            // Participant membership is backend-authoritative. We intentionally avoid
            // optimistic participant writes here because matching backend semantics would
            // require duplicating dedupe, edit/fork, branch-pruning, and multi-turn
            // recomputation rules in the frontend.
            if (isFirstPrompt) {
                conversationId = crypto.randomUUID();
                onNewConversationStartingWithSendMessage(conversationId, {
                    ...autoActionApprovalMode !== undefined ? {
                        autoActionApprovalMode: autoActionApprovalMode
                    } : {},
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    ...taskModeEnabled ? {
                        planModeEnabled: taskModeEnabled
                    } : {},
                    webSearchEnabled: webSearchEnabled,
                    // Agent Concierge (RSA-1436): carry the Concierge toggle across the
                    // placeholder -> real conversation migration. Without this the flag is
                    // dropped on the first send of a new conversation, which both hides the
                    // Concierge bubble and prevents the explicit Concierge opt-in from being sent.
                    conciergeEnabled: shouldSendConciergeEnabled,
                    sourceMode: spaceScopedSourceMode,
                    useCurrentPageContext: addCurrentPageAsContextUserPreference,
                    spaceSourceCount: spaceSourceCount,
                    appFilters: appFilters,
                    selectedCloudIds: selectedCloudIdsForGatedFeature ?? []
                });
                onNewConversationIdAvailable?.(conversationId);
                // Create the conversation with its initial identity; first-turn routing may
                // refine `conversation.agent` below.
                dispatch(createConversationOptimistically({
                    id: conversationId,
                    status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
                    sourceAgentId: currentConversation?.sourceAgentId ?? sourceAgentIdForTemporaryLocalConversation,
                    lastMessageType: messageType,
                    lastAgentMessageStatus: 'IN_PROGRESS',
                    resultAttributionContext: currentConversation?.resultAttributionContext,
                    chatEntryPoint: currentConversation?.chatEntryPoint,
                    // Immediately associate the optimistic conversation with the space.
                    ...resolvedSpaceId ? (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? {
                        rovoSpaceId: resolvedSpaceId
                    } : {} : {},
                    ...resolvedAgentVersion && (0, $iDrrr.fg)('rovo_agent_versioning_enabled') ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...conversationAgentFieldsForTemporaryLocalConversation
                }));
                // First-turn routing can refine display identity; keep `sourceAgentId` as history.
                const normalizedRoutingAgentId = messageRoutingAgentId || undefined;
                const provisionalRoutedConversationAgent = (0, $8fLSN.createProvisionalConversationAgent)(normalizedRoutingAgentId);
                const routedIdentityAccountId = messageAgentIdentity && messageAgentIdentity.agentId === normalizedRoutingAgentId ? messageAgentIdentity.identityAccountId : undefined;
                const routedConversationAgent = provisionalRoutedConversationAgent && routedIdentityAccountId ? {
                    ...provisionalRoutedConversationAgent,
                    identity_account_id: routedIdentityAccountId
                } : provisionalRoutedConversationAgent;
                if (mentionAgentsEnabled && routedConversationAgent && normalizedRoutingAgentId !== currentConversationAgentId) dispatch(setConversationData({
                    conversationId: conversationId,
                    data: {
                        agent: routedConversationAgent
                    }
                }));
            }
            (0, $b2pOf.persistRecentConversation)({
                type: 'message-sent',
                siteId: siteId,
                conversationId: conversationId,
                lastMessageSentAt: Date.now()
            });
            const { sendMessageLatencyMetrics: sendMessageLatencyMetrics, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, cancelStreamingMetrics: cancelStreamingMetrics, metricsStartTime: metricsStartTime } = $732002bd2dba0f68$var$initLatencyMetrics({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                agentId: messageRoutingAgentId
            });
            const remixRegenerateRequestAttributes = (0, $00c83407afeee4cc$export$2632503e30ac5e44)({
                creationContextParams: creationContextParams,
                messageSources: messageSources
            });
            const remixCreateRequestAttributes = (0, $17f8fd46f090eaff$export$74253ae80f2bef05)({
                creationContextParams: creationContextParams,
                messageSources: messageSources
            });
            experienceTracker.start({
                name: sendMessageExperienceNameCompiled,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource,
                    resendSource: messageSources?.resendSource,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                    ...remixRegenerateRequestAttributes,
                    ...remixCreateRequestAttributes
                }
            });
            const chatInitiator = getChatInitiator();
            const { isRemixFollowUp: isRemixFollowUp, lastAssistantMessageDynamicUiType: lastAssistantMessageDynamicUiType } = (()=>{
                const lastAction = (0, $kNXXO.findLastAssistantAction)(getMessages(conversationId), ()=>true);
                if (!lastAction || !(0, $aYC8J.isRemixGeneratedFlow)(lastAction)) return {
                    isRemixFollowUp: false,
                    lastAssistantMessageDynamicUiType: undefined
                };
                // BE stores dynamicUiType under `contentType` in action data
                const contentType = lastAction.data?.contentType;
                return {
                    isRemixFollowUp: true,
                    lastAssistantMessageDynamicUiType: contentType
                };
            })();
            let sendMessageContext;
            try {
                sendMessageContext = await (0, $cC5sC.populateSendMessageContext)(chatContextStoreActions, isFirstPrompt, source, prompt, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, contentId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixFollowUp, searchArtifact, additionalContextReceiverId, editorContextFallback, excludePageContext);
            } catch (error) {
                if (!(0, $bxkJA.isChannelNotFoundError)(error)) (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, 'failure');
                if (source === 'agentMentionComment' && (0, $2VSIF.isConversationCancelled)(conversationId)) {
                    sendMessageLatencyMetrics.cancel();
                    cancelStreamingMetrics();
                    return;
                }
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        deepResearchEnabled: deepResearchEnabled,
                        fastModeEnabled: fastModeEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        webSearchEnabled: webSearchEnabled,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        failureSource: 'populateSendMessageContext',
                        ...remixRegenerateRequestAttributes
                    }
                });
                // Note: We don't track error in error event as discussed here:
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/341408/overview#comment-2004687398
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return;
            }
            // Context loading is asynchronous; Stop may have arrived while it was in progress.
            if (source === 'agentMentionComment' && (0, $2VSIF.isConversationCancelled)(conversationId)) {
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return;
            }
            // For right panel chat, creationContextParams is undefined but experience is computed
            // in populateSendMessageContext. Populate creationContextParams so there's a single
            // source of truth for experience downstream (e.g. processStream validation).
            const effectiveCreationContextParams = (0, $iDrrr.fg)('confluence_aifc_new_live_page_chat_context') && !creationContextParams && sendMessageContext.computedExperience ? {
                experience: sendMessageContext.computedExperience
            } : creationContextParams;
            let aiFeatureContextForBackend = sendMessageContext.aiFeatureContext;
            if (isCreateWithRovoSend && sendMessageContext.aiFeatureContext?.projectContext) {
                const { spaceId: _spaceId, ...projectContextWithoutSpaceId } = sendMessageContext.aiFeatureContext.projectContext;
                aiFeatureContextForBackend = {
                    ...sendMessageContext.aiFeatureContext,
                    projectContext: projectContextWithoutSpaceId
                };
            }
            const hasAttachedAnyContext = addCurrentPageAsContextUserPreference === true && Boolean(sendMessageContext.editorContext || sendMessageContext.whiteboardContext || sendMessageContext.slidesContext || sendMessageContext.databaseContext || sendMessageContext.browserContext || sendMessageContext.dashboardEditorContext || sendMessageContext.dashboardContext || sendMessageContext.aiFeatureContext || sendMessageContext.jiraWorkflowContext);
            const attachedSourceCount = (spaceSourceCount ?? 0) + (hasAttachedAnyContext ? 1 : 0);
            const storeState = chatContextStoreActions.getAllContext();
            trackingAttributes.contextProvided = Object.entries(storeState).reduce((acc, [key, value])=>{
                acc[key] = Boolean(value);
                return acc;
            }, {});
            trackingAttributes.contextProvided.editorContext = Boolean(sendMessageContext.editorContext);
            trackingAttributes.contextProvided.whiteboardContext = Boolean(sendMessageContext.whiteboardContext);
            trackingAttributes.contextProvided.slidesContext = Boolean(sendMessageContext.slidesContext);
            trackingAttributes.contextProvided.databaseContext = Boolean(sendMessageContext.databaseContext);
            trackingAttributes.contextProvided.browserContext = Boolean(sendMessageContext.browserContext);
            trackingAttributes.contextProvided.dashboardContext = Boolean(sendMessageContext.dashboardContext);
            trackingAttributes.contextProvided.aiFeatureContext = Boolean(sendMessageContext.aiFeatureContext);
            trackingAttributes.contextProvided.jiraWorkflowContext = Boolean(sendMessageContext.jiraWorkflowContext);
            trackingAttributes.contextProvided.domContext = Boolean(sendMessageContext.browserContext?.context?.htmlBody);
            trackingAttributes.contextProvided.selectionContext = Boolean(sendMessageContext.browserContext?.context?.selection?.content);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    ...remixCreateRequestAttributes.remixExperience ? {
                        remixExperience: remixCreateRequestAttributes.remixExperience
                    } : {},
                    timestamp: undefined,
                    messageId: trackingAttributes.humanMessageId,
                    ...historySuggestionSubmission?.getAttributes(),
                    ...compositionDurationFromFirstInputMs !== undefined ? {
                        compositionDurationFromFirstInputMs: compositionDurationFromFirstInputMs
                    } : {},
                    interactionSource: trackingAttributes.interactionSource,
                    resendSource: messageSources?.resendSource,
                    followUpSource: trackingAttributes.followUpSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    maxModeEnabled: trackingAttributes.taskModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    contextProvided: trackingAttributes.contextProvided,
                    initiator: chatInitiator,
                    isFirstPrompt: trackingAttributes.isFirstPrompt,
                    promptFeatures: trackingAttributes.promptFeatures,
                    fileCount: trackingAttributes.fileCount,
                    appFilters: trackingAttributes.appFilters,
                    appFilterCount: trackingAttributes.appFilterCount,
                    attachedSourceCount: attachedSourceCount,
                    ...isSitesSourceFilterEnabled ? {
                        selectedCloudIds: trackingAttributes.selectedCloudIds,
                        selectedCloudIdCount: trackingAttributes.selectedCloudIdCount
                    } : {},
                    has3pApps: trackingAttributes.appFilters?.some((app)=>(0, $6xccU.is3pApp)(app.friendlyName)),
                    template: trackingAttributes.template,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    ...requestedSkills?.length ? {
                        requestedSkills: requestedSkills
                    } : {},
                    conversationChannelId: conversationId
                }
            });
            if (editRollback && !rollbackSnapshot) rollbackSnapshot = {
                conversationId: conversationId,
                lengthBeforeOptimistic: getMessages(conversationId).length
            };
            // Seed the agent-run-state correlation now that the run's conversationId is final and
            // streaming has not started. Prefer the value threaded through the auto-send flow; fall
            // back to the stash set at chat-new time (the draft → manual-send path). No-op for
            // non-mention runs. Always consume the stash so a stale value can't leak into a later send.
            const stashedInvocationLocalId = (0, $9vNm5.consumeAgentRunInvocation)();
            const runInvokedByNodeLocalId = invokedByNodeLocalId ?? stashedInvocationLocalId;
            if (runInvokedByNodeLocalId) (0, $9vNm5.beginAgentRun)(conversationId, runInvokedByNodeLocalId);
            const optimisticSelectedWorkDisplayContext = isPromptContextDisplayEnabled ? (0, $6f034c45d985197a$export$cec6d081aa41afce)(sendMessageContext.aiFeatureContext) : undefined;
            const shouldResolveOptimisticBrowserContext = isPromptContextDisplayEnabled && !optimisticSelectedWorkDisplayContext && sendMessageContext.useCurrentBrowsingContext === true && browserDisplayContextActive === true;
            const optimisticBrowserUrl = shouldResolveOptimisticBrowserContext ? (0, $bQQtO.resolveMessageStreamBrowserUrl)({
                browserContext: sendMessageContext.browserContext,
                browserContextSanitizer: browserContextSanitizer,
                product: assistanceService.getConfig().product
            }).browserUrl : undefined;
            const isOptimisticBrowserUrlBlocklisted = Boolean(optimisticBrowserUrl && browserContextSanitizer?.isBlocklisted(optimisticBrowserUrl));
            const optimisticDisplayContext = optimisticSelectedWorkDisplayContext ?? (optimisticBrowserUrl && optimisticBrowserUrl !== 'NO-URL' && !isOptimisticBrowserUrlBlocklisted ? {
                references: [
                    {
                        type: 'BROWSER_URL',
                        browser_url: optimisticBrowserUrl
                    }
                ]
            } : undefined);
            const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort, updateCurrentConversation: updateCurrentConversation } = $732002bd2dba0f68$var$hydrateStoreWithNewMessage(dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, optimisticDisplayContext, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, messageRoutingAgentId, messageAgentIdentity, followUpAgentIdentity, resolvedAgentVersion, messageSources?.entryPoint, ()=>activeAssistantMessageId, messageSources?.actionId);
            const chatRemixEditTracking = (0, $5b3e9b1b382cd3ec$export$145fa869c8c31e33)({
                experienceTracker: experienceTracker,
                startTime: metricsStartTime,
                conversationId: conversationId,
                instrumentationId: trackingAttributes.instrumentationId,
                sendMessageExperienceName: sendMessageExperienceNameCompiled,
                interactionSource: messageSources?.interactionSource,
                signal: abortController.signal
            });
            const handleTempMessageIdReplaced = (oldId, newId)=>{
                activeAssistantMessageId = newId;
                (onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced)?.(oldId, newId);
            };
            const clearRetainedUserSubmission = (0, $4KNZy.userSubmissionLifecycle).recordLatestUserSubmission({
                conversationId: conversationId,
                humanMessageId: tmpHumanMessageId
            }, {
                abortSignal: abortController.signal
            });
            if (editRequestId) abortController.signal.addEventListener('abort', ()=>(0, $Iv7dD.slidesAiEditLatency).end(editRequestId, 'cancelled'), {
                once: true
            });
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Broadcast stream status to content targets for state sharing
            const broadcastToContent = (0, $129c50d8ba82d9d6$export$b043b11900276452)({
                broadcastStreamStatus: broadcastStreamStatus,
                chatContextStoreActions: chatContextStoreActions,
                contentContextValue: contentContextValue,
                targetId: contentId,
                assistantMessageId: tmpAssistantMessageId,
                inlineRovoEditAttemptId: inlineRovoEditAttemptId,
                isExplicitUserCancellation: ()=>(0, $4u5Na.explicitUserCancellations).has(storeAbortController)
            });
            const broadcastStreamLifecycle = (status)=>{
                broadcastToContent(status);
                if (status === (0, $jb3zd.StreamLifecycleState).ABORTED) // Covers both pre-stream and mid-stream aborts, so the inline input box
                // stops waiting on a turn that was stopped elsewhere (e.g. from Rovo Chat).
                promptStreamHook?.onAbort?.(tmpAssistantMessageId, inlineRovoEditAttemptId);
                onStreamLifecycle?.({
                    status: status,
                    conversationId: conversationId,
                    turnId: tmpAssistantMessageId,
                    assistantMessageId: activeAssistantMessageId,
                    humanMessageId: trackingAttributes.humanMessageId || tmpHumanMessageId
                });
            };
            broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).SEND_CONTEXT_READY);
            // Initialize action tracking
            let streamActionInfo = {
                isAction: false
            };
            const streamAgentId = (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') && mentionAgentsEnabled && followUpAgentIdentity ? followUpAgentIdentity.id : messageRoutingAgentId;
            // Avoid attributing a routed specialist's edits to the default agent while metadata loads.
            const existingIdentityAccountId = agentIdentityAccountIdParam ?? (agentForCurrentSendMetadata?.id === streamAgentId ? agentForCurrentSendMetadata.identity_account_id : undefined);
            // Overlap requests, but resolve attribution before consuming generated-content steps.
            let agentIdentityRequest;
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_agent_attribution') && productKey === 'confluence' && isCreateWithRovoSend) {
                const matchingFollowUpIdentityAccountId = followUpAgentIdentity?.id === streamAgentId ? followUpAgentIdentity.identityAccountId : undefined;
                agentIdentityRequest = (0, $7f3fab340ef5b938$export$3e195448963cca75)({
                    assistanceService: assistanceService,
                    catalogAgentId: streamAgentId,
                    existingIdentityAccountId: existingIdentityAccountId ?? matchingFollowUpIdentityAccountId
                });
            }
            // Create message stream
            try {
                // Derive page context for analytics from the available context objects
                pageContext = (0, $f14d784696e75101$export$1303843c2f44065a)({
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    databaseContext: sendMessageContext.databaseContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    browserUrl: sendMessageContext.browserContext?.context?.browserUrl
                });
                // `contentId` is an optional, caller-supplied `SendMessageParams` field: only the
                // inline input box (`bridge-api/handlers`) and the staging-area flows pass one. The
                // chat input and the pubsub/agent-mention routes leave it undefined, so requiring it
                // here suppressed the callback on the sidebar surfaces this exists for. It is passed
                // through as optional payload instead, and consumers that need content identity
                // resolve it from their own product context.
                if (onPromptSent && (0, $cXtTj.default).getExperimentValue('platform_teflon_chat_on_prompt_sent', 'isEnabled', false) && typeof pageContext === 'string' && pageContext !== 'unknown') {
                    sendAnalyticsEvent({
                        eventType: 'operational',
                        action: 'onPromptSentInvoked',
                        actionSubject: 'aiMate',
                        attributes: {
                            pageContext: pageContext
                        }
                    });
                    const promptContentId = contentId;
                    const promptPageContext = pageContext;
                    Promise.resolve().then(()=>onPromptSent({
                            pageContext: promptPageContext,
                            contentId: promptContentId,
                            agentIdentityAccountId: agentForCurrentSendMetadata?.identity_account_id ?? undefined
                        })).catch((error)=>{
                        sendAnalyticsEvent({
                            eventType: 'operational',
                            action: 'onPromptSentError',
                            actionSubject: 'aiMate',
                            attributes: {
                                failureReason: 'callbackRejected',
                                errorName: error instanceof Error ? error.name : undefined,
                                pageContext: pageContext
                            }
                        });
                    });
                }
                trackingAttributes.pageContext = pageContext;
                trackingAttributes.viewContext = (0, $ac0e07e0dcb28459$export$20af16720c0f9c71)({
                    aiFeatureContext: sendMessageContext.aiFeatureContext
                });
                trackingAttributes.invokedFrom = (0, $dc46cb9d819f569e$export$a0e3245ee56765fd)({
                    messageActionKey: streamActionInfo?.actionKey
                });
                // Check if the Jira refresh experiment is enabled but default is set to `true` to pass all non-Jira products
                // Omit caller source controls only for sends routed by `routedSelectedAgentId`;
                // see `getSourceControlValueForBackend`.
                const webSearchEnabledForBackend = (0, $d8e7db153f5f7161$export$7459a30868c458f)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: webSearchEnabled
                });
                const appFiltersForBackend = (0, $d8e7db153f5f7161$export$7459a30868c458f)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: appFilters
                });
                const selectedCloudIdsForBackend = (0, $d8e7db153f5f7161$export$7459a30868c458f)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: selectedCloudIdsForGatedFeature
                });
                const sourceModeForBackend = (0, $d8e7db153f5f7161$export$7459a30868c458f)({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: spaceScopedSourceMode
                });
                // Experiment-on requests are UUID-only. Remove the control-only named-id request
                // field with `rovo_chat_mention_agents` cleanup.
                const isFollowUpSend = mentionAgentsEnabled && followUpAgentIdentity !== undefined;
                const agentIdForBackend = isFollowUpSend ? followUpAgentIdentity.id : agentIdForRequest;
                const agentNamedIdForBackend = mentionAgentsEnabled ? undefined : agentNamedIdForRequest;
                const streamRequest = assistanceService.sendMessageStream({
                    message: prompt,
                    autoActionApprovalMode: autoActionApprovalMode,
                    agentId: agentIdForBackend,
                    ...mentionAgentsEnabled ? {} : {
                        agentNamedId: agentNamedIdForBackend
                    },
                    controller: abortController,
                    conversationId: conversationId,
                    storeMessage: storeUserMessages,
                    citationsEnabled: true,
                    fileIds: files?.map((file)=>file.id),
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    planModeEnabled: taskModeEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabledForBackend,
                    sourceMode: sourceModeForBackend,
                    appFilters: appFiltersForBackend?.map((app)=>app.source),
                    selectedCloudIds: selectedCloudIdsForBackend,
                    ...minionAlias && (0, $cha5E.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false) ? {
                        minionAliasConfig: {
                            stratus_config: {
                                minion_alias: minionAlias
                            }
                        }
                    } : {},
                    browserContext: sendMessageContext.browserContext,
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    slidesContext: sendMessageContext.slidesContext,
                    databaseContext: sendMessageContext.databaseContext,
                    additionalContext: (0, $3026f86d03c99861$export$6944638c905cc63)(sendMessageContext.additionalContext, source),
                    writingStyleContext: writingStyleContext,
                    aiFeatureContext: aiFeatureContextForBackend,
                    jiraWorkflowContext: sendMessageContext.jiraWorkflowContext,
                    dashboardContext: sendMessageContext.dashboardContext,
                    dashboardEditorContext: sendMessageContext.dashboardEditorContext,
                    artifactContext: sendMessageContext.artifactContext,
                    useCurrentBrowsingContext: sendMessageContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer,
                    optInToDeepResearchV2: true,
                    optInThinkDeeperMessages: true,
                    optInAnsNow: true,
                    optInNewToolTraces: true,
                    optInNewTeamworkTraceIcons: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26'),
                    optInSSEStream: true,
                    ...resolvedAgentVersion ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...resolvedSpaceId ? {
                        spaceId: resolvedSpaceId
                    } : {},
                    capabilities: capabilities,
                    shouldExtractConversationScopes: shouldExtractConversationScopes,
                    ...browserDisplayContextActive !== undefined ? {
                        browserDisplayContextActive: browserDisplayContextActive
                    } : {},
                    parentMessageId: parentMessageId,
                    requestedSkills: requestedSkills,
                    ...commentMentionContext ? {
                        commentMentionContext: commentMentionContext
                    } : {},
                    // Agent Concierge (RSA-1436): Concierge is an explicit opt-in mode. It is
                    // off by default and runs only when the plus-menu toggle is enabled.
                    ...shouldSendConciergeEnabled ? {
                        conciergeEnabled: true
                    } : {}
                });
                // Finalize at dispatch using the snapshot's stable typeaheadDraftId. The backend
                // humanMessageId is not available yet; agentMessage received correlates it below.
                historySuggestionSubmission?.finalize('sent');
                const result = await streamRequest;
                generator = result.generator;
                responseData = result.responseData;
            } catch (error) {
                if (!(0, $bxkJA.isChannelNotFoundError)(error)) (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, 'failure');
                clearRetainedUserSubmission();
                if (// An abort is reported to the inline input box via `onAbort`, not as an error.
                !(error instanceof Error && error.name === 'AbortError')) promptStreamHook?.onError?.(error, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                performEditRollback();
                $732002bd2dba0f68$var$handleSendMessageServiceCallFailure(error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages, remixRegenerateRequestAttributes);
                return;
            }
            const streamAgentIdentityAccountId = agentIdentityRequest ? await agentIdentityRequest : existingIdentityAccountId;
            // Inline callers supply inline_edit; the outbound context resolves the selected image
            const requestCreationContext = sendMessageContext.additionalContext.creationContext;
            let selectedBlockType = requestCreationContext.dynamicUiType;
            if ((selectedBlockType === undefined || selectedBlockType === null) && Array.isArray(requestCreationContext.blocks)) selectedBlockType = requestCreationContext.blocks[0];
            const isRemixEdit = productKey === 'confluence' && requestCreationContext.source === 'remix' && requestCreationContext.experience === 'remix_edit';
            const isRemixImageEdit = isRemixEdit && Boolean(requestCreationContext.mediaFileId) && (requestCreationContext.dynamicUiType === 'image' || requestCreationContext.dynamicUiType === 'infographic');
            const isRemixMauiEdit = isRemixEdit && typeof requestCreationContext.contentMauiId === 'string' && requestCreationContext.contentMauiId.trim().length > 0 && (selectedBlockType === 'chart' || selectedBlockType === 'visual-aid');
            const { hasReceivedFinalResponse: hasReceivedFinalResponse, hasReceivedPromptRedaction: hasReceivedPromptRedaction, hasLoggedInitiatedEvent: hasLoggedInitiatedEventForStream, hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper, implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics, implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName, guardEventReceived: wasGuardTerminated, assistantMessageId: assistantMessageId, recoveredAfterStreamTimeout: recoveredAfterStreamTimeout, streamTimeoutCount: streamTimeoutCount, streamTimeoutRecoveryEnabled: streamTimeoutRecoveryEnabled } = await (0, $4964ca4cf6fe5338$export$efb69f1fe7577739)({
                streamTracking: {
                    fail: chatRemixEditTracking.fail,
                    process: (message)=>{
                        const chatRemixInstrumentationId = chatRemixEditTracking.process(message);
                        return chatRemixInstrumentationId ? {
                            chatRemixInstrumentationId: chatRemixInstrumentationId
                        } : undefined;
                    }
                },
                editRequestId: editRequestId,
                prompt: prompt,
                generator: generator,
                productKey: productKey,
                answerIndex: answerIndex,
                tmpHumanMessageId: tmpHumanMessageId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                deepResearchEnabled: deepResearchEnabled,
                webSearchEnabled: webSearchEnabled,
                sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled,
                traceId: responseData?.traceId,
                updateCurrentConversation: updateCurrentConversation,
                trackingAttributes: trackingAttributes,
                conversationId: conversationId,
                getState: getState,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                openChatOnError: openChatOnError,
                experienceTracker: experienceTracker,
                setMessages: setMessages,
                getMessages: getMessages,
                reportCreditDenial: reportCreditDenial,
                processStreamResearch: processStreamResearch,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamError: processMessageStreamError,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                onSpaceSourceRecommendations: onSpaceSourceRecommendations,
                containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced,
                containerOnHumanMessageIdReplaced: containerOnHumanMessageIdReplaced,
                updateResearchMessageId: updateResearchMessageId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                chatContextStoreActions: chatContextStoreActions,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
                stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
                stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
                broadcastStreamLifecycle: broadcastStreamLifecycle,
                sendMessageLatencyMetrics: sendMessageLatencyMetrics,
                cancelStreamingMetrics: cancelStreamingMetrics,
                onTempMessageIdReplacedOverride: handleTempMessageIdReplaced,
                streamActionInfo: streamActionInfo,
                trackAIMAUEvent: trackAIMAUEvent,
                messageSources: messageSources,
                additionalAnalyticAttributes: additionalAnalyticAttributes,
                unsupportedRemixNodeTypes: unsupportedRemixNodeTypes,
                hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                clearMessageResearch: clearMessageResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                viewDeadAirBroker: viewDeadAirBroker,
                requestedSkills: requestedSkills,
                creationContextParams: effectiveCreationContextParams,
                supportsRemixTextResponse: isRemixImageEdit || isRemixMauiEdit,
                minionAlias: minionAlias && (0, $cha5E.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false) ? minionAlias : assistanceService.getConfig().minionAlias,
                agentId: streamAgentId,
                agentNamedId: (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') || (0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments') ? agentNamedIdParam || (agentForCurrentSendMetadata?.id === streamAgentId ? agentForCurrentSendMetadata.external_config_reference ?? agentForCurrentSendMetadata.named_id : undefined) : undefined,
                agentName: agentNameParam ?? (agentForCurrentSendMetadata?.id === streamAgentId ? agentForCurrentSendMetadata.name : undefined),
                agentIdentityAccountId: streamAgentIdentityAccountId,
                // Same guard as the name/identity: only classify the routed agent, so an
                // unhydrated default agent does not flip the telepointer to the third-party treatment.
                isThirdPartyAgent: isThirdPartyAgentParam ?? (agentForCurrentSendMetadata?.id === streamAgentId && agentForCurrentSendMetadata.creator_type ? (0, $hq9Cp.isForgeAgentByCreatorType)(agentForCurrentSendMetadata.creator_type) : undefined),
                storeUserMessages: storeUserMessages,
                skillSelectionSource: skillSelectionSource,
                assistanceService: assistanceService,
                abortController: abortController,
                getIsChatMounted: getIsChatMounted,
                metricsStartTime: metricsStartTime,
                recoverConversationAfterStreamTimeout: async ()=>{
                    const timedOutMessageId = trackingAttributes.messageId;
                    if (!timedOutMessageId) return false;
                    abortController.abort('stream-timeout-conversation-refresh');
                    updateCurrentConversation((0, $jyZaR.clearStatus)({}));
                    await dispatch((0, $b25327492a2eafbb$export$5c7afebc13b5b6d7)({
                        conversationId: conversationId
                    }));
                    return getMessages(conversationId).some((message)=>(0, $igOtY.isStoreAssistant)(message) && message.isHistorical === true && message.content.message?.message?.id === timedOutMessageId);
                },
                onTaskStatusUpdate: (streamMessage)=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    (0, $86e81c25ee55514d$export$89a4ab1dea43d7ee)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $7aee2421f1549c0a$export$6b58e85d865a8eef)(unifiedTasksActions)
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onPromptBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    // A blocked prompt still shows the user's prompt redacted (same treatment as a
                    // PROMPT_REDACTION); the block message renders below it, and `redactedByBlock`
                    // suppresses the "Redacted by your organization" row so only the block message
                    // states the enforcement.
                    const blockedPromptText = (0, $7e5b1b4e17adf7fb$export$bd961bd04341d761)(streamMessage);
                    let lastHumanIdx = -1;
                    withoutPlaceholder.forEach((m, i)=>{
                        if ((0, $igOtY.isStoreHuman)(m)) lastHumanIdx = i;
                    });
                    if (blockedPromptText && lastHumanIdx !== -1) withoutPlaceholder[lastHumanIdx] = {
                        ...withoutPlaceholder[lastHumanIdx],
                        redactedPrompt: blockedPromptText,
                        redactedByBlock: true
                    };
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onPromptRedacted: (streamMessage)=>{
                    // Only update the human message with the redacted prompt.
                    // Keep the assistant placeholder — the stream continues with the actual response.
                    const chat = getMessages(conversationId);
                    let lastHumanIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $igOtY.isStoreHuman)(m)) lastHumanIdx = i;
                    });
                    if (lastHumanIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastHumanIdx] = {
                        ...chat[lastHumanIdx],
                        redactedPrompt: streamMessage.message.redacted_prompt
                    };
                    setMessages(conversationId, newChat);
                },
                // onResponseRedacted store mutation (set redactedResponse + clear content + traces)
                // now runs inside processStream via applyResponseRedactionToMessage, so it happens
                // in the same batch and cannot be re-populated by a stale getMessages read (PRGD-488).
                onResponseBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onAttachmentBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                }
            }).finally(clearRetainedUserSubmission);
            if (recoveredAfterStreamTimeout) {
                experienceTracker.succeed({
                    name: sendMessageExperienceNameCompiled,
                    attributes: {
                        conversationId: conversationId,
                        recoveryMethod: 'conversationRefresh',
                        recoveryOutcome: 'conversationRefresh',
                        requestId: trackingAttributes.requestId,
                        streamTimeoutCount: streamTimeoutCount,
                        streamTimeoutRecoveryEnabled: streamTimeoutRecoveryEnabled,
                        traceId: responseData?.traceId
                    }
                });
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).COMPLETED);
                sendMessageLatencyMetrics.stop({
                    customData: messageSources?.interactionSource ? {
                        interactionSource: messageSources.interactionSource
                    } : undefined
                });
                return;
            }
            hasLoggedInitiatedEvent = hasLoggedInitiatedEventForStream;
            if (promptHistoryRequestToken && (isFirstPrompt || isRecoveredConversation) && hasReceivedFinalResponse && !hasReceivedPromptRedaction && !wasGuardTerminated && !abortController.signal.aborted) dispatch((0, $57bd16fee4ca474b$export$4dbe3d442b9a6aec)({
                requestToken: promptHistoryRequestToken,
                conversationId: conversationId,
                tmpHumanMessageId: tmpHumanMessageId
            }));
            // TODO: This should be behind the !aborted logic, but due to a bug in the BE service, aborted requests
            // will client connection with the server yet still complete in the background. This results in the UI showing
            // no message updates, until reload when the actual resolved message can be sesen.
            // Once that is fixed, we can place this behind the !aborted logic.
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    // messageId must remain the ID received from the server in the FINAL_RESPONSE
                    // in order to map correctly to our event funnel, e.g `agentMessage received` -> `agentResponse content copied`
                    messageId: trackingAttributes.messageId,
                    humanMessageId: trackingAttributes.humanMessageId,
                    // Bridge the dispatch-time typeahead snapshot to backend-assigned message IDs.
                    ...historySuggestionSubmission?.getAttributes().typeaheadDraftId ? {
                        typeaheadDraftId: historySuggestionSubmission.getAttributes().typeaheadDraftId
                    } : {},
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    requestId: trackingAttributes.requestId,
                    hasSources: trackingAttributes.hasSources,
                    // Non-UGC authoritative-answer descriptors, populated during the
                    // stream (gated on rovo_authoritative_answer_attribution).
                    ...trackingAttributes.hasAuthoritativeSources ? {
                        hasAuthoritativeSources: true,
                        authorityLevel: trackingAttributes.authorityLevel,
                        isHighlyAuthoritative: trackingAttributes.isHighlyAuthoritative,
                        overallConfidence: trackingAttributes.overallConfidence,
                        authoritativeSourceCount: trackingAttributes.authoritativeSourceCount,
                        authoritativeExpertCount: trackingAttributes.authoritativeExpertCount
                    } : {},
                    citedProductList: trackingAttributes.citedProductList,
                    connectorInfo: trackingAttributes.connectorInfo,
                    sourceProducts: trackingAttributes.sourceProducts,
                    has3pApps: Object.keys(trackingAttributes.sourceProducts ?? {}).some((0, $6xccU.is3pApp)),
                    timestamp: new Date().toISOString(),
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    initiator: chatInitiator,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    scenarioId: trackingAttributes.scenarioId,
                    // Lumina content descriptors (see trackingAttributes.hasLumina).
                    // Joined on messageId against the
                    // `luminaComponent shown` render event to detect Lumina returned
                    // by the backend but never rendered.
                    ...trackingAttributes.hasLumina ? {
                        hasLumina: true,
                        luminaType: trackingAttributes.luminaType,
                        luminaCount: trackingAttributes.luminaCount
                    } : {},
                    ...trackingAttributes.personEntityAnnotationCount !== undefined || trackingAttributes.inferredProjectEntityAnnotationCount !== undefined ? {
                        personEntityAnnotationCount: trackingAttributes.personEntityAnnotationCount,
                        inferredProjectEntityAnnotationCount: trackingAttributes.inferredProjectEntityAnnotationCount
                    } : {}
                }
            });
            (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, abortController.signal.aborted ? 'cancelled' : hasReceivedFinalResponse ? 'success' : 'failure');
            const wasProgrammaticallyAborted = abortController.signal.aborted;
            updateCurrentConversation((0, $jyZaR.clearStatus)({
                lastAgentMessageStatus: wasProgrammaticallyAborted ? 'CANCELLED' : 'SUCCESSFUL'
            }));
            setMessages(conversationId, (0, $112200485e4c7f0b$export$680d2bb5b9579c57)(getMessages(conversationId)));
            if (abortController.signal.aborted) {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                        ...trackingAttributes.chatEntryPoint ? {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        } : {}
                    }
                });
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    subjectId: trackingAttributes.interactionSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    attributes: {
                        ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                        ...messageSources?.entryPoint && {
                            entryPoint: messageSources.entryPoint
                        }
                    }
                });
                confirmAbort();
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ABORTED);
                // Call the cancel API if we have a message ID
                if (trackingAttributes.messageId) assistanceService.cancelMessageStream({
                    conversationId: conversationId,
                    messageId: trackingAttributes.messageId
                }).catch((error)=>{
                    // Log but don't throw - the abort is already happening
                    (0, $hlvTd.logException)({
                        name: 'rovoCancelMessageStream',
                        exception: error,
                        tags: {
                            conversationId: conversationId,
                            messageId: trackingAttributes.messageId
                        }
                    });
                });
                // For implicit think-deeper, the auto-mode experience was already aborted inside processStream;
                // abort the re-attributed think-deeper experience instead.
                experienceTracker.abort({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $irnO2.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled,
                    reason: 'Aborted',
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isProgrammaticAbort: true // always true because we're within abortController.signal.aborted (further explained in similar abort for AbortError case)
                    }
                });
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                    reason: 'stream aborted'
                });
                completeAllSteps({
                    messageId: assistantMessageId
                });
                return;
            } else {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes),
                        ...trackingAttributes.chatEntryPoint ? {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        } : {}
                    }
                });
                //If we're done processing the stream and no answer part has been processed, then it means that the BE is hanging. Throw an error
                if (!hasReceivedFinalResponse && !wasGuardTerminated) {
                    const agentDetails = await assistanceService.getAgentDetails(messageRoutingAgentId);
                    if (agentDetails.deactivated) {
                        // If agent is deactivated, throw correct error
                        const agentError = new (0, $kncFb.NoFinalResponseError)('The selected agent may no longer be available.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: agentError,
                            attributes: {
                                conversationId: conversationId,
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                                traceId: responseData?.traceId,
                                ...remixRegenerateRequestAttributes
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes)
                            }
                        });
                        updateCurrentConversation({
                            status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
                            traces: []
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                        return;
                    } else {
                        // Agent is active, BE hanging
                        const timeoutError = new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: timeoutError,
                            attributes: {
                                conversationId: conversationId,
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                                traceId: responseData?.traceId,
                                ...remixRegenerateRequestAttributes
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...(0, $afd6bdca30ecbc92$export$dd1b85436e4b4f2d)(trackingAttributes)
                            }
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).ERRORED);
                        throw timeoutError;
                    }
                }
                /**
       * IMPORTANT: CRITICAL ANALYTICS EVENT
       *
       * This event is essential for business metrics and monitoring.
       *
       * DO NOT MODIFY the structure, content, or emission logic of this event without:
       *   - Careful review of potential impacts on data quality, privacy, and business reporting.
       *   - Explicit approval from both analytics and security stakeholders.
       *
       * Reference: Incident HOT-120175 (UGC page title and URLs leak)
       * Event Registry: https://data-portal.internal.atlassian.com/analytics/registry/68936?tabIndex=Details
       */ const responseDynamicUiData = trackingAttributes.messageDynamicUIData?.find(({ dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype })=>dynamicUiType || dynamicUiSubtype);
                const dynamicUiType = creationContextParams?.dynamicUiType ?? sendMessageContext?.editorContext?.dynamicUiType ?? responseDynamicUiData?.dynamicUiType;
                const dynamicUiSubtype = creationContextParams?.dynamicUiSubtype ?? responseDynamicUiData?.dynamicUiSubtype;
                const conversationForResultAttribution = (0, $4aa09818c3d4f0b5$export$a2ff1144002a6147)(getState(), conversationId) ?? currentConversation;
                const resultAttributionAnalytics = (0, $3f00b208cdf7b094$export$194fc39b7c9c983)({
                    resultAttributionContext: conversationForResultAttribution?.resultAttributionContext,
                    routingAgentId: messageRoutingAgentId,
                    messageSources: messageSources,
                    additionalAnalyticAttributes: additionalAnalyticAttributes
                });
                if (resultAttributionAnalytics.shouldClearResultAttributionContext) dispatch(setConversationData({
                    conversationId: conversationId,
                    data: {
                        resultAttributionContext: undefined
                    }
                }));
                trackAIMAUEvent({
                    type: 'viewed',
                    subjectId: resultAttributionAnalytics.messageSources?.followUpSource,
                    messageId: trackingAttributes.messageId,
                    source: resultAttributionAnalytics.messageSources?.interactionSource,
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    invokedFrom: trackingAttributes.invokedFrom,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    citedProductList: trackingAttributes.citedProductList,
                    connectorInfo: trackingAttributes.connectorInfo,
                    sourceProducts: trackingAttributes.sourceProducts,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    skillsInvoked: trackingAttributes.skillsInvoked,
                    executedStratusSkill: trackingAttributes.executedStratusSkill,
                    responseSources: trackingAttributes.sources,
                    usesJsm: trackingAttributes.usesJsm,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    conversationChannelId: conversationId,
                    scenarioId: trackingAttributes.scenarioId,
                    pageContext: trackingAttributes.pageContext,
                    attributes: {
                        ...(0, $0Z0Rs.getPeopleDataProviderAttributes)(trackingAttributes.peopleDataProviders ?? []),
                        ...skillSelectionSource === 'scheduledChatIdea' && {
                            skillSelectionSource: skillSelectionSource
                        },
                        ...((0, $iDrrr.fg)('aifc_request_id_analytics') || (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential')) && trackingAttributes.requestId ? {
                            request_id: trackingAttributes.requestId
                        } : {},
                        ...((0, $iDrrr.fg)('aifc_trace_id_analytics') || (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential')) && responseData?.traceId ? {
                            traceID: responseData?.traceId
                        } : {},
                        ...trackingAttributes.actionObjectId ? {
                            objectId: trackingAttributes.actionObjectId
                        } : {},
                        ...(0, $iEKWu.interactionModeExecutedAttributes)(trackingAttributes.interactionModeExecuted),
                        ...dynamicUiType && {
                            dynamicUiType: dynamicUiType
                        },
                        ...dynamicUiSubtype && {
                            dynamicUiSubtype: dynamicUiSubtype
                        },
                        ...trackingAttributes.serverSideExecution !== undefined && {
                            serverSideExecution: trackingAttributes.serverSideExecution
                        },
                        isTabVisible: (0, $1hQ0e.getDocument)()?.visibilityState === 'visible',
                        ...trackingAttributes.visualBlockCounts,
                        ...resultAttributionAnalytics.additionalAnalyticAttributes && resultAttributionAnalytics.additionalAnalyticAttributes,
                        ...getResultAttributesForAskQuestion() ?? {},
                        ...creationContextParams?.dynamicUiSource && {
                            remixNodeTypes: trackingAttributes.remixNodeTypes,
                            ...trackingAttributes.unsupportedRemixNodeTypes !== undefined && {
                                unsupportedRemixNodeTypes: trackingAttributes.unsupportedRemixNodeTypes
                            },
                            ...trackingAttributes.remixWordCount !== undefined && {
                                remixWordCount: trackingAttributes.remixWordCount
                            }
                        },
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        },
                        ...resultAttributionAnalytics.messageSources?.entryPoint && {
                            entryPoint: resultAttributionAnalytics.messageSources.entryPoint
                        },
                        ...trackingAttributes.chatEntryPoint && {
                            chatEntryPoint: trackingAttributes.chatEntryPoint
                        },
                        ...(0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26') && trackingAttributes.twgTraceStepIds && trackingAttributes.twgTraceStepIds.length > 0 && {
                            twgTraceShown: true,
                            twgTraceStepIds: trackingAttributes.twgTraceStepIds,
                            twgTraceRoundIds: trackingAttributes.twgTraceRoundIds,
                            twgTraceToolNames: trackingAttributes.twgTraceToolNames,
                            ...trackingAttributes.twgTraceRenderModes && trackingAttributes.twgTraceRenderModes.length > 0 && {
                                twgTraceRenderModes: trackingAttributes.twgTraceRenderModes
                            }
                        },
                        ...(0, $ed079ebed6bb7598$export$bb558012e0978515)(trackingAttributes.skillsInvoked, trackingAttributes.pluginsInvoked, trackingAttributes.agentExternalConfigReference)
                    }
                });
                // Experience is aborted in `abortRequests`
                // For implicit think-deeper, succeed the re-attributed think-deeper reliability SLO instead
                experienceTracker.succeed({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $irnO2.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled
                });
                // Broadcast that the stream has completed successfully
                broadcastStreamLifecycle((0, $jb3zd.StreamLifecycleState).COMPLETED);
                if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
                {
                    if (getState().currentConversationId !== conversationId) dispatch(setConversationData({
                        conversationId: conversationId,
                        data: {
                            readStatus: false
                        }
                    }));
                }
            }
            // For implicit think-deeper, stop the re-attributed think-deeper metric instead
            if (!hasAbortedForImplicitThinkDeeper) sendMessageLatencyMetrics.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
            else implicitThinkDeeperSendMessageMetrics?.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
        };
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        try {
            await sendMessageFn({
                conversationId: conversationId
            });
        } catch (error) {
            if (!(0, $bxkJA.isChannelNotFoundError)(error)) (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, 'failure');
            if ((0, $bxkJA.isChannelNotFoundError)(error)) {
                const createdChannel = await assistanceService.createConversationChannel().catch((retryError)=>{
                    (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, 'failure');
                    throw retryError;
                });
                onNewConversationIdAvailable?.(createdChannel.id);
                setState({
                    conversations: {
                        ...getState().conversations,
                        [createdChannel.id]: {
                            id: createdChannel.id,
                            name: createdChannel.name ?? (0, $7td41.generateConversationName)(),
                            timeCreated: createdChannel.time_created,
                            status: (0, $igOtY.CHAT_STORE_STATUS).idle,
                            traces: [],
                            messages: [],
                            ...createdChannel.agent && (0, $iDrrr.fg)('rovo_chat_chat_history_refresh') ? {
                                agent: createdChannel.agent
                            } : {}
                        }
                    }
                });
                setMessages(createdChannel.id, []);
                dispatch(setSelectedConversation({
                    conversationId: createdChannel.id
                }));
                await sendMessageFn({
                    conversationId: createdChannel.id,
                    isRecoveredConversation: true
                }).catch((retryError)=>{
                    (0, $Iv7dD.slidesAiEditLatency).end(editRequestId, 'failure');
                    throw retryError;
                });
            } else {
                performEditRollback();
                throw error;
            }
        } finally{
            // Submitted drafts have left the editor. Close discarded/failed pre-dispatch
            // attempts too; a dispatched submission has already finalized idempotently.
            historySuggestionSubmission?.finalize('cleared');
        }
    };








const $7c8a1ce87ec5e959$export$465cb47180de50f0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).sendMessage, (props)=>(0, $732002bd2dba0f68$export$9558791053c77c34)({
        ...props,
        setConversationData: $6geN3.setConversationData,
        createConversationOptimistically: $djNSU.createConversationOptimistically,
        addHumanMessage: $ccf70d20a8a5d0a4$export$9888dd09dd4e0151,
        addAssistantMessage: $7b222e9f3b67e786$export$ce06e1b90807a0c0,
        clearFollowUpMessages: $1385698a2f418aa1$export$bc07ddf1de8d78e4,
        setSelectedConversation: $c8Sl1.setSelectedConversation,
        reconnectToInProgressStream: $7a4a093d6dd23d1c$export$873fca975736004b
    }), {
    experienceName: (args)=>(0, $16g08.getSendMessageExperienceName)({
            deepResearchEnabled: args[0]?.deepResearchEnabled,
            thinkDeeperEnabled: args[0]?.thinkDeeperEnabled,
            taskModeEnabled: args[0]?.taskModeEnabled,
            fastModeEnabled: args[0]?.fastModeEnabled
        }),
    getRateLimitState: (args)=>({
            isDeepResearchAttempt: args[0]?.deepResearchEnabled
        }),
    getErrorEntryPoint: (args)=>args[0]?.messageSources?.entryPoint
});












var $6yl1r = parcelRequire("6yl1r");







const $c9d9af54b6d3dfed$var$wasAskQuestionConfirmed = (confirmedTools)=>confirmedTools.tools.some((tool)=>tool.key === (0, $dw75i.ASK_QUESTION_KEY) && tool.resolution?.type !== 'cancelled');
function $c9d9af54b6d3dfed$export$f741cf20db76dafd({ actions: actions, confirmedTools: confirmedTools }) {
    if (!$c9d9af54b6d3dfed$var$wasAskQuestionConfirmed(confirmedTools)) return {};
    return {
        disambiguationUsedOnCreation: (actions ?? []).some((action)=>(0, $aYC8J.isConfluenceCreatableAction)({
                key: action.key
            })),
        disambiguationUsedOnEdit: (actions ?? []).some((action)=>(0, $aYC8J.isConfluenceUpdatableAction)({
                key: action.key
            }))
    };
}















































var $eHZQi = parcelRequire("eHZQi");


var $4tJut = parcelRequire("4tJut");








var $1YDZA = parcelRequire("1YDZA");


var $9MJ4r = parcelRequire("9MJ4r");


var $jUUpp = parcelRequire("jUUpp");

const $7129583fe1d7779b$var$UNKNOWN_TOOL_ID = 'UNKNOWN_TOOL_ID';
const $7129583fe1d7779b$var$buildBaseToolAttribute = ({ toolId: toolId, toolKey: toolKey, toolDefinitionSource: toolDefinitionSource })=>({
        toolId: toolId ?? $7129583fe1d7779b$var$UNKNOWN_TOOL_ID,
        toolKey: (0, $jUUpp.redactToolKeyForPii)({
            toolDefinitionSource: toolDefinitionSource,
            key: toolKey
        }),
        toolDefinitionSource: toolDefinitionSource ?? null
    });
const $7129583fe1d7779b$export$376e622a1b976e6e = (confirmedTools)=>confirmedTools.tools.map((tool)=>({
            ...$7129583fe1d7779b$var$buildBaseToolAttribute({
                toolId: tool.tool_id,
                toolKey: tool.key,
                toolDefinitionSource: tool.tool_source
            }),
            resolutionType: tool.resolution?.type ?? 'UNKNOWN_RESOLUTION_TYPE'
        }));










const $ab7f520530423da1$export$4287833726c64095 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    const { key: key, content: content, loading: loading } = markdownData;
    const loadingKey = `${key}-loading`;
    return (0, $746b4e9283597e00$export$b59f7aedf84d58f7)({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $bkEBw.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: {
                    ...storeAssistant.markdownData,
                    [key]: (storeAssistant.markdownData?.[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                }
            }),
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};





















const $86bc580e83e9fcdd$export$f0a9473b2d3b8f30 = (options)=>{
    // We pass a lazy supplier so the processor reads current feature flag values on each call.
    // createMarkdownProcessor keeps state (currentLoadingKeys / previousKeys) across calls,
    // while components are re-evaluated every invocation to reflect live flag values.
    const processor = (0, $f3OgL.createMarkdownProcessor)((0, $bcd61a1d71eeba44$export$c37d58cb6fcaff84));
    // Per-message preprocessor that rewrites HTML `<details><summary>` blocks
    // into the Rovo-native `▞…▚` boundary before they reach the component
    // extractor. Maintains its own cross-chunk buffer so partial tags spanning
    // chunk boundaries resolve correctly. The caller decides whether to enable
    // it (typically gated on 3P agents via
    // `shouldPreprocessDetailsForConversation`).
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $l5TuZ.createDetailsPreprocessor)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData, processedComponentType: processedComponentType } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
















var $bFeyZ = parcelRequire("bFeyZ");











const $e6392bd977910c84$export$1f61e0220f5a1fe3 = ({ tools: tools })=>tools.some((tool)=>{
        const args = tool.data.arguments;
        return tool.key === (0, $dw75i.ASK_QUESTION_KEY) && tool.resolution?.type === 'confirmed' && typeof args === 'object' && args !== null && 'questions' in args && Array.isArray(args.questions) && args.questions.some((question)=>typeof question === 'object' && question !== null && 'skipped' in question && question.skipped === false);
    });









const $fc09dcf08c415191$export$b083249d02c2e498 = ({ messages: messages, confirmedTools: confirmedTools, isStagingArea: isStagingArea, productKey: productKey })=>{
    if (productKey !== 'confluence' || !isStagingArea) return false;
    const wasAskQuestionAnswered = confirmedTools.tools.some((tool)=>tool.key === (0, $dw75i.ASK_QUESTION_KEY) && tool.resolution?.type !== 'cancelled');
    if (!wasAskQuestionAnswered) return false;
    const humanMessageCount = messages.filter((0, $igOtY.isStoreHuman)).length;
    if (humanMessageCount !== 1) return false;
    const confirmedMessage = messages.filter((0, $igOtY.isStoreAssistant)).find((message)=>String(message.content?.message?.message?.id) === confirmedTools.message_id);
    if (!confirmedMessage) return false;
    return confirmedMessage.content?.message?.message?.actions?.some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY)) ?? false;
};










const $1176649d0a5ed8f2$export$32a54ad404e10819 = async (chatContextStoreActions, isFirstPrompt, addCurrentPageAsContextUserPreference, contentContextValue, productKey, sendAnalyticsEvent, isEmptyStagingArea, creationContextParams, additionalContextReceiverId)=>{
    let effectiveCreationContextParams = creationContextParams;
    if (effectiveCreationContextParams === undefined && isEmptyStagingArea) effectiveCreationContextParams = {
        experience: 'cwr'
    };
    const context = await (0, $cC5sC.populateSendMessageContext)(chatContextStoreActions, isEmptyStagingArea || isFirstPrompt, undefined, undefined, addCurrentPageAsContextUserPreference, contentContextValue, effectiveCreationContextParams, productKey, sendAnalyticsEvent, undefined, undefined, undefined, undefined, undefined, additionalContextReceiverId);
    return {
        editorContext: context.editorContext,
        whiteboardContext: context.whiteboardContext,
        slidesContext: context.slidesContext,
        databaseContext: context.databaseContext,
        dashboardEditorContext: context.dashboardEditorContext,
        browserContext: context.browserContext,
        additionalContext: context.additionalContext,
        aiFeatureContext: context.aiFeatureContext,
        jiraWorkflowContext: context.jiraWorkflowContext,
        dashboardContext: context.dashboardContext,
        useCurrentBrowsingContext: context.useCurrentBrowsingContext
    };
};













var $5iFVe = parcelRequire("5iFVe");

const $339231c97276ebc7$export$adbe0936e6d82480 = ({ messages: messages, originatingMessage: originatingMessage, recipientAgentId: recipientAgentId, conversation: conversation })=>{
    const recipientId = (0, $2yWJZ.trimToUndefined)(recipientAgentId);
    if (!recipientId) return undefined;
    if (originatingMessage) {
        const { id: messageId, agent_author: agentAuthor } = originatingMessage.content.message.message;
        if ((0, $2yWJZ.trimToUndefined)(agentAuthor?.id) === recipientId && (agentAuthor?.versionId || agentAuthor?.versionType)) return {
            versionId: agentAuthor.versionId,
            versionType: agentAuthor.versionType
        };
        const requestAgentIdentity = (0, $5iFVe.findPreviousByTypeFromId)({
            messages: messages,
            messageId: messageId,
            searchType: 'HUMAN'
        })?.followUpAgentIdentity;
        if (requestAgentIdentity?.id === recipientId && requestAgentIdentity.agentVersion?.versionType === 'DRAFT') return requestAgentIdentity.agentVersion;
    }
    const conversationAgentId = (0, $2yWJZ.trimToUndefined)(conversation?.agent?.agent_id ?? conversation?.sourceAgentId);
    return conversationAgentId === recipientId ? conversation?.agentVersion : undefined;
};

















const $818a9d135eec7bf6$export$7ebb0e028855aeb0 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, tools: tools, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedInvokedActions = {
            ...agentMessage.result.invokedActions
        };
        for (const tool of tools){
            const resolvedStatus = status === 'fromResolution' ? tool.resolution?.type === 'cancelled' ? 'cancelled' : 'finished' : status;
            updatedInvokedActions[tool.invocation_id] = resolvedStatus;
        }
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: updatedInvokedActions
        };
        setMessages(conversationId, updatedMessages);
    });



const $3fbe59e6722fdc18$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS = 120000;
const $3fbe59e6722fdc18$var$NO_FINAL_RESPONSE_ERROR_MESSAGE = 'The response took too long and timed out';
const $3fbe59e6722fdc18$export$a520ca869831c96e = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).sendMessageConfirmedTools, ({ conversationId: conversationIdParam, agentId: agentId, confirmed_tools: confirmed_tools, messageSources: messageSources, storeUserMessages: storeUserMessages = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, conciergeEnabled: conciergeEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, includeAIFeatureContext: includeAIFeatureContext, agentVersion: agentVersion, actionedAnalyticsAttributes: actionedAnalyticsAttributes, resolutionType: resolutionType, onResponseComplete: onResponseComplete, productKey: productKey, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, browserContextSanitizer: browserContextSanitizer, hasStagedContent: hasStagedContent, creationContextParams: creationContextParams })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, chatContextStoreActions: chatContextStoreActions, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, trackAgentEvent: trackAgentEvent, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, clearMessageResearch: clearMessageResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onTempMessageIdReplaced: onTempMessageIdReplaced, broadcastConfirmedActions: broadcastConfirmedActions })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const mentionAgentsEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
        const confirmedToolsExperienceName = taskModeEnabled ? (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE : (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE;
        // Set when AIFC_GENERATE_CONTENT is restarted because this send answers an ask_question from the
        // first request in the AIFC modal (cwr-ask-question-reliability-fixes). The restarted
        // experience must be ended on every terminal path of this send.
        let hasRestartedAifcGenerateContent = false;
        const abortRestartedAifcGenerateContent = (reason)=>{
            if (!hasRestartedAifcGenerateContent) return;
            hasRestartedAifcGenerateContent = false;
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                reason: reason
            });
            (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, reason);
        };
        const failRestartedAifcGenerateContent = (error, childAbortReason = 'AIFC_GENERATE_CONTENT failed - confirmed tools request failed')=>{
            if (!hasRestartedAifcGenerateContent) return;
            hasRestartedAifcGenerateContent = false;
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
                error: error
            });
            (0, $cbc2db2fdddff710$export$a9ffe3cc687b4144)(experienceTracker, childAbortReason);
        };
        // Collection of callbacks for experience and performance tracking
        const expAndPerfTrackers = {
            start: ()=>{
                experienceTracker.start({
                    name: confirmedToolsExperienceName,
                    id: conversationId,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: messageSources?.interactionSource
                    }
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.start();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.start();
            },
            firstAnswerPartReceived: ()=>{
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            succeed: ()=>{
                experienceTracker.succeed({
                    name: confirmedToolsExperienceName
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
            },
            aupError: ()=>{
                experienceTracker.succeed({
                    name: confirmedToolsExperienceName
                });
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            agentDeactivated: ({ error: error })=>{
                experienceTracker.fail({
                    name: confirmedToolsExperienceName,
                    error: error
                });
                if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes')) failRestartedAifcGenerateContent(error);
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            abort: ()=>{
                experienceTracker.abort({
                    name: confirmedToolsExperienceName,
                    reason: 'Aborted'
                });
                if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes')) abortRestartedAifcGenerateContent('Aborted');
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            fail: ({ error: error, attributes: attributes })=>{
                experienceTracker.fail({
                    name: confirmedToolsExperienceName,
                    error: error,
                    attributes: attributes
                });
                if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes')) failRestartedAifcGenerateContent(error);
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $4tJut.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            }
        };
        const requestedModeAttributes = (0, $411a747b8da7f11a$export$2f438a4a7bbfabc)((0, $a2488f01d739616b$export$9f198c0729e6b053)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        }));
        let peopleDataProviders = [];
        const trackingAttributes = {
            isRovoCustomAgent: (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(agentId),
            sendMessageReason: 'TOOLS_CONFIRMATION',
            aiFeatureName: messageSources?.aiFeatureName,
            invokedFrom: messageSources?.invokedFrom
        };
        // Source executed mode from the originating assistant message (the one this
        // confirmed-tools action is being executed against). `confirmed_tools.message_id`
        // is the assistant message id whose tool calls the user just confirmed.
        const messages = getMessages(conversationId);
        const originatingAssistantMessage = messages.find((item)=>(0, $igOtY.isStoreAssistant)(item) && item.content?.message?.message?.id === confirmed_tools.message_id);
        const shouldRouteActionToHistoricalAgent = mentionAgentsEnabled && (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential');
        const conversation = getState().conversations[conversationId];
        const resolvedAgentVersion = agentVersion ?? (shouldRouteActionToHistoricalAgent ? (0, $339231c97276ebc7$export$adbe0936e6d82480)({
            messages: messages,
            originatingMessage: originatingAssistantMessage,
            recipientAgentId: agentId,
            conversation: conversation
        }) : conversation?.agentVersion);
        const interactionModeExecutedFromOriginatingAssistantMessage = (0, $bFeyZ.getInteractionModeExecutedFromStoreAssistant)(originatingAssistantMessage);
        const isCancelled = resolutionType === 'cancelled';
        const tools = (0, $7129583fe1d7779b$export$376e622a1b976e6e)(confirmed_tools);
        const mciKrIdentifiers = tools.map((tool)=>tool.toolKey).filter((value)=>Boolean(value));
        const agentAnalyticsAttributes = {
            touchPoint: 'chatSendMessageConfirmedTools',
            tools: tools
        };
        // Collection of callbacks for analytics tracking
        const analyticsTrackers = {
            /**
     * There are 2 AIMAU events here, because in resumption we're doing 2 things
     * 1. We're confirming the previous tools result
     * 2. And the confirmation triggers a LLM chat streaming
     */ initiated: ({ timestamp: timestamp })=>{
                const actionKey = (0, $jUUpp.redactToolKeyForPii)({
                    toolDefinitionSource: confirmed_tools.tools[0]?.tool_source,
                    key: confirmed_tools.tools[0]?.key
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'actioned',
                    actionResult: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    proactive: false,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    ...!isCancelled && (0, $iDrrr.fg)('rovo_chat_link_source_product_analytics') && {
                        sourceProduct: (0, $9MJ4r.getThirdPartySourceProductFromActionKey)(actionKey)
                    },
                    attributes: {
                        ...(0, $6yl1r.isPlanWorkItemTechChangesEnabled)() || (0, $iDrrr.fg)('jira-ai-agents-improvements') || (0, $iDrrr.fg)('rovo_uwi_field_analytics') && actionKey === (0, $dw75i.ActionKeys).UpdateWorkItemAllFieldTypes ? actionedAnalyticsAttributes : {},
                        ...interactionModeExecutedFromOriginatingAssistantMessage ? {
                            interactionModeExecuted: interactionModeExecutedFromOriginatingAssistantMessage
                        } : {},
                        ...actionKey ? {
                            actionKey: actionKey
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    },
                    // override the messageId to the confirmed_tools.message_id and not what's in trackingAttributes,
                    // because action is on the original message not this message
                    messageId: confirmed_tools.message_id
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: timestamp,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        ...((0, $6yl1r.isPlanWorkItemTechChangesEnabled)() || (0, $iDrrr.fg)('jira-ai-agents-improvements')) && actionedAnalyticsAttributes
                    }
                });
            },
            aborted: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'dismissed',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionStreamStopped',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            },
            viewed: ({ actions: actions })=>{
                const askQuestionAttributes = (0, $c9d9af54b6d3dfed$export$f741cf20db76dafd)({
                    actions: actions,
                    confirmedTools: confirmed_tools
                });
                const actionObjectId = (0, $20c23c34bf500923$export$d1543b5c7d96e050)(actions);
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'viewed',
                    proactive: false,
                    userGenerated: true,
                    source: messageSources?.interactionSource,
                    messageId: trackingAttributes.messageId,
                    subjectId: messageSources?.followUpSource,
                    citedProductList: {},
                    sourceProducts: {},
                    conversationChannelId: conversationId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...(0, $0Z0Rs.getPeopleDataProviderAttributes)(peopleDataProviders),
                        ...((0, $iDrrr.fg)('aifc_request_id_analytics') || (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential')) && trackingAttributes.requestId ? {
                            request_id: trackingAttributes.requestId
                        } : {},
                        ...((0, $iDrrr.fg)('aifc_trace_id_analytics') || (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential')) && responseData?.traceId ? {
                            traceID: responseData?.traceId
                        } : {},
                        ...actionObjectId ? {
                            objectId: actionObjectId
                        } : {},
                        ...askQuestionAttributes ?? {},
                        ...(0, $8HiCX.getMessageVisualBlockCounts)(actions),
                        ...trackingAttributes.interactionModeExecuted ? {
                            interactionModeExecuted: trackingAttributes.interactionModeExecuted
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        },
                        ...trackingAttributes.personEntityAnnotationCount !== undefined || trackingAttributes.inferredProjectEntityAnnotationCount !== undefined ? {
                            personEntityAnnotationCount: trackingAttributes.personEntityAnnotationCount,
                            inferredProjectEntityAnnotationCount: trackingAttributes.inferredProjectEntityAnnotationCount
                        } : {},
                        ...(0, $ed079ebed6bb7598$export$bb558012e0978515)([], mciKrIdentifiers, trackingAttributes.agentExternalConfigReference)
                    }
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultViewed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        scenarioId: trackingAttributes.scenarioId
                    }
                });
            },
            error: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'error',
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.requestId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $462ad3e4f945b271$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultError',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: data
            }));
        };
        let hasReceivedFinalResponse = false;
        let generator;
        let responseData;
        let hasLoggedInitiatedEvent = false;
        // Hoisted so it is accessible in the catch block for clearMessageResearch
        let tmpAssistantMessageId = (0, $23567c2d6eaf1c81$export$eca740b13a7a3080)(conversationId);
        let activeAssistantMessageId = tmpAssistantMessageId;
        // Preserve the cancellation comparison independently of late-annotation ID updates.
        let cancellationComparisonMessageId = tmpAssistantMessageId;
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $1206f352a14d8e9a$export$cb6128fc3a3c8081)(()=>activeAssistantMessageId);
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments')) (0, $2VSIF.setConversationCancelled)(conversationId, false);
        // Reconnect state — populated once we receive the conversation channel data message
        let agentMessageId;
        let finalResponseActions;
        let isReconnectSupported = false;
        let streamTimeoutCount = 0;
        let streamTimeoutMs;
        let streamTimeoutRecoveryEnabled = false;
        const getStreamTimeoutFailureAttributes = (recoveryOutcome)=>({
                conversationId: conversationId,
                ...recoveryOutcome ? {
                    recoveryOutcome: recoveryOutcome
                } : {},
                requestId: trackingAttributes.requestId,
                streamTimeoutCount: streamTimeoutCount,
                streamTimeoutMs: streamTimeoutMs,
                streamTimeoutRecoveryEnabled: streamTimeoutRecoveryEnabled,
                traceId: responseData?.traceId
            });
        const handleAbort = ()=>{
            expAndPerfTrackers.abort();
            confirmAbort();
            clearMessageResearch({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.aborted();
            // Call the cancel API to stop backend processing
            if (trackingAttributes.messageId && trackingAttributes.messageId !== cancellationComparisonMessageId) assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: trackingAttributes.messageId
            }).catch(()=>{
                // Log but don't throw - the abort is already happening
                (0, $hlvTd.addSentryBreadcrumb)({
                    message: 'Failed to cancel message stream after abort in sendMessageConfirmedTools',
                    data: {
                        conversationId: conversationId,
                        messageId: trackingAttributes.messageId
                    }
                });
            });
        };
        try {
            expAndPerfTrackers.start();
            if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes') && resolutionType !== 'cancelled' && (0, $fc09dcf08c415191$export$b083249d02c2e498)({
                messages: getMessages(conversationId),
                confirmedTools: confirmed_tools,
                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                productKey: productKey
            })) {
                (0, $eHZQi.startAifcGenerateContentExperiences)({
                    experienceTracker: experienceTracker,
                    conversationId: conversationId,
                    attributes: {
                        product: productKey,
                        isRestartedAfterAskQuestion: true
                    }
                });
                hasRestartedAifcGenerateContent = true;
            }
            // change the conversation status
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            if (unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) {
                // Optimistic update goes directly to the tasks store. Explicitly clears
                // current_step / result_summary / error_message so the row resets to a
                // fresh "now running" state.
                const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
                if (activeTask?.taskId) unifiedTasksActions.setTaskProgressState({
                    taskId: activeTask.taskId,
                    progressState: 'Running',
                    title: activeTask.title ?? '',
                    updatedAt: new Date().toISOString(),
                    currentStep: null,
                    resultSummary: null,
                    errorMessage: null
                });
            }
            // Only add assistant message
            dispatch((0, $7b222e9f3b67e786$export$ce06e1b90807a0c0)({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                ...mentionAgentsEnabled ? {
                    agentAuthorId: agentId
                } : {
                    agentNamedId: agentId
                },
                ...messageSources?.entryPoint ? {
                    entryPoint: messageSources.entryPoint
                } : {}
            }));
            dispatch((0, $1385698a2f418aa1$export$bc07ddf1de8d78e4)({
                conversationId: conversationId
            }));
            trackingAttributes.messageId = tmpAssistantMessageId;
            trackingAttributes.instrumentationId = tmpAssistantMessageId;
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Build the same full request context that `sendMessage` sends (creationContext +
            // page/whiteboard/slides/database/dashboard/browser/jira context) so the backend
            // routes tool confirmation through the same code paths as a regular send.
            // Derived to mirror a regular follow-up send: existing conversation
            // (`isFirstPrompt: false`) with content context resolved from the staging-area
            // signal. Failures degrade gracefully to the slim context below.
            let fullConfirmedToolsContext;
            try {
                const isFirstPrompt = (0, $1IZrU.isEmptyConversation)(conversationId);
                const contentContextValue = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
                const isEmptyStagingArea = contentContextValue === 'staging-area' && hasStagedContent === false;
                const applyHostContext = creationContextParams !== undefined && confirmed_tools.tools.some((tool)=>tool.key === (0, $dw75i.ASK_QUESTION_KEY) && (tool.resolution?.type === 'confirmed' || tool.resolution?.type === 'cancelled')) && (0, $iDrrr.fg)('adminhub-create-policy-with-rovo');
                fullConfirmedToolsContext = await (0, $1176649d0a5ed8f2$export$32a54ad404e10819)(chatContextStoreActions, isFirstPrompt, addCurrentPageAsContextUserPreference, contentContextValue, productKey, sendAnalyticsEvent, isEmptyStagingArea, applyHostContext ? creationContextParams : undefined, applyHostContext && (0, $e6392bd977910c84$export$1f61e0220f5a1fe3)(confirmed_tools) ? (0, $1YDZA.getPolicyPreviewReceiverId)(conversationId, messages) : undefined);
            } catch (error) {
                (0, $hlvTd.addSentryBreadcrumb)({
                    message: 'Failed to populate full context for sendMessageConfirmedTools; falling back to slim context',
                    data: {
                        conversationId: conversationId
                    }
                });
            }
            const originatingAgentIdentity = originatingAssistantMessage ? (0, $foVqg.deriveFollowUpSendAgentIdentity)(originatingAssistantMessage) : undefined;
            const streamAgentId = (0, $iDrrr.fg)('confluence_rovo_update_feedback_agent_filter') ? agentId ?? originatingAgentIdentity?.id : agentId;
            // Overlap requests, but resolve attribution before consuming generated-content steps.
            let agentIdentityRequest;
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_cwr_agent_attribution') && productKey === 'confluence' && chatContextStoreActions.getIsStagingArea()) {
                const existingIdentityAccountId = originatingAgentIdentity?.id === streamAgentId ? originatingAgentIdentity?.identityAccountId : undefined;
                agentIdentityRequest = (0, $7f3fab340ef5b938$export$3e195448963cca75)({
                    assistanceService: assistanceService,
                    catalogAgentId: streamAgentId,
                    existingIdentityAccountId: existingIdentityAccountId
                });
            }
            // Call the BE endpoint
            trackingAttributes.initiatedTimestamp = new Date().toISOString();
            const response = await assistanceService.sendMessageConfirmedTools({
                conversationId: conversationId,
                agentId: agentId,
                confirmed_tools: confirmed_tools,
                controller: abortController,
                optInSSEStream: true,
                storeMessage: storeUserMessages,
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                conciergeEnabled: conciergeEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                ...taskModeEnabled ? {
                    planModeEnabled: taskModeEnabled
                } : {},
                ...includeAIFeatureContext && {
                    aiFeatureContext: fullConfirmedToolsContext ? fullConfirmedToolsContext.aiFeatureContext : chatContextStoreActions.getAIFeatureContext()
                },
                ...fullConfirmedToolsContext ? {
                    editorContext: fullConfirmedToolsContext.editorContext,
                    whiteboardContext: fullConfirmedToolsContext.whiteboardContext,
                    slidesContext: fullConfirmedToolsContext.slidesContext,
                    databaseContext: fullConfirmedToolsContext.databaseContext,
                    dashboardEditorContext: fullConfirmedToolsContext.dashboardEditorContext,
                    browserContext: fullConfirmedToolsContext.browserContext,
                    additionalContext: fullConfirmedToolsContext.additionalContext,
                    // aiFeatureContext is intentionally NOT spread here — it stays owned by the
                    // `includeAIFeatureContext` guard above so callers that opt out are respected.
                    jiraWorkflowContext: fullConfirmedToolsContext.jiraWorkflowContext,
                    dashboardContext: fullConfirmedToolsContext.dashboardContext,
                    useCurrentBrowsingContext: fullConfirmedToolsContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer
                } : {},
                ...resolvedAgentVersion ? {
                    agentVersion: resolvedAgentVersion
                } : {},
                optInToDeepResearchV2: true,
                optInThinkDeeperMessages: true,
                optInAnsNow: true,
                optInNewToolTraces: true,
                optInNewTeamworkTraceIcons: (0, $iDrrr.fg)('rovo_chat_enable_twg_trace_team26'),
                capabilities: capabilities
            });
            generator = response.generator;
            responseData = response.responseData;
            // Update action invocation statuses based on the confirmed_tools payload
            if ((0, $iDrrr.fg)('rovo_chat_enable_tasks') || (0, $iDrrr.fg)('fe_jira_admin_agent_eap') || (0, $iDrrr.fg)('jira_ai_repo_selection_chat_store_fix')) dispatch((0, $818a9d135eec7bf6$export$7ebb0e028855aeb0)({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'fromResolution'
            }));
            /**
     * --------
     * Stream processing START
     * --------
     */ updateCurrentConversation({
                status: (0, $igOtY.CHAT_STORE_STATUS).typingResponse
            });
            // Research store state shared across stream messages
            const researchState = {
                clientRoundCounter: 0,
                hasAccumulatedAnswerContent: false
            };
            const processStreamMarkdown = (0, $86bc580e83e9fcdd$export$f0a9473b2d3b8f30)();
            const peopleEntityHoverCardsEnabled = (0, $437v8.isPeopleEntityAnnotationEnabled)();
            const inferredProjectHoverCardsEnabled = (0, $437v8.isInferredProjectEntityAnnotationEnabled)();
            const entityAnnotationAnalyticsEnabled = peopleEntityHoverCardsEnabled || inferredProjectHoverCardsEnabled;
            let entityAnnotationCounts = {
                inferredProjectEntityAnnotationCount: 0,
                personEntityAnnotationCount: 0
            };
            // Tracks whether an AIFC action has started streaming. Mutated in place by
            // processAifcActionStreamMessage.
            const streamActionInfo = {
                isAction: false
            };
            let actionClassificationCount = 0;
            let actionCompleteCount = 0;
            let isBackendCreationRequest = false;
            const isStreamTimeoutEnabled = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'isEnabled', false);
            const streamIdleTimeoutMs = (0, $cXtTj.default).getExperimentValue('rovo_chat_hung_stream_timeout', 'timeoutMs', $3fbe59e6722fdc18$var$ROVO_CHAT_STREAM_IDLE_TIMEOUT_MS);
            const isStreamTimeoutRecoveryEnabled = isStreamTimeoutEnabled && (0, $4o0zT.isExperimentEnabled)('rovo_chat_stream_timeout_recovery');
            streamTimeoutMs = streamIdleTimeoutMs;
            streamTimeoutRecoveryEnabled = isStreamTimeoutRecoveryEnabled;
            const onStreamTimeout = ()=>{
                if (hasReceivedFinalResponse || abortController.signal.aborted) return undefined;
                if (!isStreamTimeoutRecoveryEnabled) abortController.abort();
                const timeoutError = new (0, $b6N3q.RovoChatStreamTimeoutError)($3fbe59e6722fdc18$var$NO_FINAL_RESPONSE_ERROR_MESSAGE, {
                    requestId: trackingAttributes.requestId,
                    traceId: responseData?.traceId
                });
                streamTimeoutCount++;
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'timedOut',
                    actionSubject: 'rovoChatStream',
                    attributes: {
                        conversationChannelId: conversationId,
                        experienceName: confirmedToolsExperienceName,
                        requestId: trackingAttributes.requestId,
                        timeoutMs: streamIdleTimeoutMs,
                        timeoutType: 'idle',
                        timeoutCount: streamTimeoutCount,
                        streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled,
                        traceId: responseData?.traceId
                    }
                });
                return timeoutError;
            };
            const reconnectableStream = (0, $b5a6b627405136a2$export$29bad1ab941da7cb)({
                getState: getState,
                generator: generator,
                conversationId: conversationId,
                abortController: abortController,
                assistanceService: assistanceService,
                sendAnalyticsEvent: sendAnalyticsEvent,
                experienceTracker: experienceTracker,
                getMessageId: ()=>agentMessageId,
                getRequestId: ()=>trackingAttributes.requestId,
                canReconnect: ()=>!!(agentMessageId && isReconnectSupported),
                updateCurrentConversation: updateCurrentConversation,
                getIsChatMounted: getIsChatMounted,
                analyticsAttributes: {
                    isDeepResearch: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    fastModeEnabled: fastModeEnabled,
                    streamTimeoutMs: streamIdleTimeoutMs,
                    streamTimeoutRecoveryEnabled: isStreamTimeoutRecoveryEnabled
                },
                onBeforeFirstReconnect: ()=>{
                    if (agentMessageId) {
                        const chat = getMessages(conversationId);
                        const alreadySwapped = (0, $4BHwn.findStoreMessageIndex)(chat, agentMessageId) >= 0;
                        if (!alreadySwapped) {
                            // Swap the tmp message ID → real agent message ID in the
                            // message store so addAnswerPart/replaceAnswerData ID
                            // validation doesn't throw on the replayed stream chunks.
                            setMessages(conversationId, (0, $822490bee3d17b8f$export$f279e50afd80e7d8)({
                                chat: chat,
                                oldId: tmpAssistantMessageId,
                                newId: agentMessageId
                            }));
                            updateResearchMessageId({
                                messageId: tmpAssistantMessageId,
                                newMessageId: agentMessageId
                            });
                        }
                        // Reassign so subsequent processResearchStreamMessage calls
                        // and addAnswerPart/replaceAnswerData use the real agent
                        // message ID as the key.
                        tmpAssistantMessageId = agentMessageId;
                        cancellationComparisonMessageId = agentMessageId;
                        activeAssistantMessageId = agentMessageId;
                    }
                },
                streamTimeout: isStreamTimeoutEnabled && isStreamTimeoutRecoveryEnabled ? {
                    timeoutMs: streamIdleTimeoutMs,
                    onTimeout: onStreamTimeout
                } : undefined
            });
            const streamToIterate = isStreamTimeoutEnabled && !isStreamTimeoutRecoveryEnabled ? (0, $0ac98c0a880a830b$export$44aab448715585b6)(reconnectableStream, {
                timeoutMs: streamIdleTimeoutMs,
                // Preserve the existing timeout experiment behavior outside the recovery gate.
                isPaused: ()=>typeof navigator !== 'undefined' && !navigator.onLine,
                onTimeout: onStreamTimeout
            }) : reconnectableStream;
            const streamAgentIdentityAccountId = agentIdentityRequest ? await agentIdentityRequest : undefined;
            for await (const streamObj of streamToIterate){
                const streamMessage = (0, $bxkJA.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                (0, $0a4010078ae41b46$export$c68838490373407b)({
                    streamObj: streamObj,
                    streamMessage: streamMessage,
                    conversationId: conversationId,
                    answerIndex: answerIndex,
                    requestId: trackingAttributes.requestId,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $ec372ef5c573e842$export$5a07e6227eed9665)({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                if ((0, $58a7ad1d26ac260e$export$51720276ffc29c92)(streamMessage, conversationId, updateCurrentConversation)) continue;
                /**
       * Conversation channel data processing (usually the first stream part)
       */ if ((0, $bxkJA.isConversationChannelDataMessage)(streamMessage)) {
                    agentMessageId = streamMessage.assistant_message_id;
                    trackingAttributes.instrumentationId = agentMessageId;
                    trackingAttributes.messageId = agentMessageId;
                    analyticsTrackers.initiated({
                        timestamp: trackingAttributes.initiatedTimestamp
                    });
                    hasLoggedInitiatedEvent = true;
                    // Update the research store with the real message ID once we have it
                    updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: agentMessageId
                    });
                }
                /**
       * Reconnect support detection
       */ if ((0, $bxkJA.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
                if ((0, $5a900e4ea4c7ba13$export$2de2f38c3a454c55)({
                    streamMessage: streamMessage,
                    conversationId: conversationId,
                    existingTraces: getState().conversations[conversationId]?.traces ?? [],
                    updateTraces: (traces)=>updateCurrentConversation({
                            traces: traces
                        }),
                    sendAnalyticsEvent: sendAnalyticsEvent
                })) continue;
                /**
       * Trace processing
       */ if ((0, $bxkJA.isStreamTrace)(streamMessage)) {
                    if (!trackingAttributes.requestId) trackingAttributes.requestId = streamMessage.metadata?.request_id;
                    updateCurrentConversation({
                        traces: (0, $a81109ab453d215f$export$9ac25e0768639c5d)([
                            ...getState().conversations[conversationId]?.traces ?? [],
                            (0, $f2c42700118b800b$export$a89606c68db527fb)(streamMessage)
                        ])
                    });
                }
                /**
       * AIFC action processing — streams generated content into the page via the
       * editor bridge and emits AIFC experiences. Shared with the send-message
       * flow.
       */ const aifcActionResult = (0, $1f5f2c21ff9586f2$export$baa645f348bcec07)({
                    streamMessage: streamMessage,
                    conversationId: conversationId,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    traceId: responseData?.traceId,
                    productKey: productKey,
                    deepResearchEnabled: deepResearchEnabled,
                    storeUserMessages: storeUserMessages,
                    streamActionInfo: streamActionInfo,
                    trackingAttributes: trackingAttributes,
                    experienceTracker: experienceTracker,
                    chatContextStoreActions: chatContextStoreActions,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    getIsChatMounted: getIsChatMounted,
                    processMessageStreamAction: processMessageStreamAction,
                    processMessageStreamComplete: processMessageStreamComplete,
                    processMessageStreamActionClassification: processMessageStreamActionClassification,
                    promptStreamHook: undefined,
                    openChat: undefined,
                    messageSources: messageSources,
                    creationContextParams: undefined,
                    agentId: streamAgentId,
                    agentName: undefined,
                    agentIdentityAccountId: streamAgentIdentityAccountId ?? null,
                    stopInteractionMetricsTimeToFirstActionPart: ()=>{}
                });
                if (aifcActionResult.hasReceivedActionClassification) actionClassificationCount += 1;
                if (aifcActionResult.hasReceivedActionComplete) actionCompleteCount += 1;
                isBackendCreationRequest || (isBackendCreationRequest = aifcActionResult.isBackendCreationAction);
                /**
       * Answer part processing
       */ if ((0, $bxkJA.isStreamAnswerPart)(streamMessage)) {
                    expAndPerfTrackers.firstAnswerPartReceived();
                    (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                    let processedStreamMessage = streamMessage;
                    const processedStreamResult = processStreamMarkdown(processedStreamMessage);
                    processedStreamMessage = processedStreamResult.processedStreamMessage;
                    if (processedStreamResult.markdownData) setMessages(conversationId, (0, $ab7f520530423da1$export$4287833726c64095)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: processedStreamResult.markdownData,
                        useIndex: answerIndex
                    }));
                    else setMessages(conversationId, (0, $72779d19b192aa52$export$6e5609c05ab74cc7)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        useIndex: answerIndex
                    }));
                }
                if ((0, $bxkJA.isStreamEntityAnnotations)(streamMessage) && entityAnnotationAnalyticsEnabled) {
                    const entityAnnotationBatch = (0, $bxkJA.normalizeEntityAnnotationsMessage)(streamMessage.message);
                    const enabledEntities = entityAnnotationBatch.entities.filter((entity)=>entity.type === 'Person' && peopleEntityHoverCardsEnabled || entity.type === 'InferredProject' && inferredProjectHoverCardsEnabled);
                    if (enabledEntities.length > 0) entityAnnotationCounts = (0, $d69dfb192d870466$export$69df77d21db987cc)(entityAnnotationCounts, {
                        ...entityAnnotationBatch,
                        entities: enabledEntities
                    });
                    setMessages(conversationId, (0, $9153b4ac17989006$export$94b1b79dc7d56f27)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        entityAnnotationBatch: entityAnnotationBatch
                    }));
                }
                /**
       * Final response processing
       */ if ((0, $bxkJA.isStreamResponse)(streamMessage)) {
                    peopleDataProviders = (0, $0Z0Rs.getPeopleDataProviders)(streamMessage.message?.message?.message_metadata?.people_data_providers);
                    // A confirmed-tools turn either resolves (→ done) or ends returning an action
                    // awaiting the user's confirmation (→ needs-input).
                    (0, $9vNm5.notifyAgentRunStateForConversation)(conversationId, (0, $86fda4fee88137f0$export$419ea2a7c4dc02c6)(streamMessage.message?.message?.actions) ? 'needs-input' : 'done');
                    trackingAttributes.interactionModeExecuted = streamMessage.message?.message?.message_metadata?.interaction_mode_executed;
                    hasReceivedFinalResponse = true;
                    const shouldUseBackendCreationExperienceLifecycle = isBackendCreationRequest;
                    const hasActionClassificationOrCompletion = actionClassificationCount > 0 || actionCompleteCount > 0;
                    if (shouldUseBackendCreationExperienceLifecycle && hasActionClassificationOrCompletion) // Backend creation responses do not require opening a preview to reach a terminal state.
                    (0, $08fd19559950f700$export$a70b98ad4be3bac5)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED, actionClassificationCount, actionCompleteCount, isBackendCreationRequest);
                    // Always succeed AIFC_MESSAGE from FINAL_RESPONSE for backend multi-create events, or when
                    // the parity experiment is enabled to streamline frontend and backend handling.
                    // This is otherwise only succeeded in processAifcActionStreamMessage.
                    if (hasActionClassificationOrCompletion && (shouldUseBackendCreationExperienceLifecycle || (0, $4o0zT.isExperimentEnabled)('cwr-fe-be-experience-analytics-streamline'))) (0, $08fd19559950f700$export$a70b98ad4be3bac5)(experienceTracker, (0, $irnO2.ExperienceName).AIFC_MESSAGE, actionClassificationCount, actionCompleteCount, isBackendCreationRequest);
                    const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                    const finalAgentMessageId = streamMessage?.message?.message?.id.toString();
                    (0, $42430cf68e8e724f$export$39545431f64e8fd1)({
                        message: streamMessage.message.message,
                        conversationId: conversationId,
                        sourceMessageId: confirmed_tools.message_id,
                        humanMessageId: humanMessageId,
                        sendAnalyticsEvent: sendAnalyticsEvent
                    });
                    (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                    const { processedStreamMessage: processedFinalMessage, markdownData: markdownData } = (0, $d8a5551aed11b46f$export$82b32799d0ea512c)({
                        streamMessage: streamMessage,
                        messageId: finalAgentMessageId,
                        conversationId: conversationId,
                        sendAnalyticsEvent: sendAnalyticsEvent
                    });
                    setMessages(conversationId, (0, $387377d6766e3a79$export$60e170089d1b35dd)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: processedFinalMessage,
                        useIndex: answerIndex,
                        humanMessageId: humanMessageId,
                        markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                        traceId: responseData?.traceId,
                        onMessageIdChanged: (oldId, newId)=>{
                            activeAssistantMessageId = newId;
                            onTempMessageIdReplaced?.(oldId, newId);
                        }
                    }));
                    // Update the research store key so rounds persist after the message ID changes
                    if (finalAgentMessageId && finalAgentMessageId !== tmpAssistantMessageId) updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: finalAgentMessageId
                    });
                    if (entityAnnotationAnalyticsEnabled && finalAgentMessageId) // Late annotation batches must target the ID stored by FINAL_RESPONSE.
                    tmpAssistantMessageId = finalAgentMessageId;
                    trackingAttributes.humanMessageId = humanMessageId;
                    if (entityAnnotationAnalyticsEnabled) {
                        trackingAttributes.personEntityAnnotationCount = entityAnnotationCounts.personEntityAnnotationCount;
                        trackingAttributes.inferredProjectEntityAnnotationCount = entityAnnotationCounts.inferredProjectEntityAnnotationCount;
                    }
                    finalResponseActions = streamMessage.message.message?.actions;
                    if (!shouldUseBackendCreationExperienceLifecycle) trackingAttributes.messageActions = finalResponseActions?.map((action)=>action.key);
                    const finalResponseAction = finalResponseActions?.[0];
                    trackingAttributes.invokedFrom = (0, $dc46cb9d819f569e$export$a0e3245ee56765fd)({
                        messageActionKey: finalResponseAction?.key,
                        messageActionData: finalResponseAction?.data
                    }) ?? trackingAttributes.invokedFrom;
                    trackingAttributes.scenarioId = streamMessage.message.message?.scenario?.id;
                    trackingAttributes.agentExternalConfigReference = streamMessage.message.message?.author?.external_config_reference;
                    if (!hasLoggedInitiatedEvent) {
                        trackingAttributes.messageId = finalAgentMessageId;
                        trackingAttributes.instrumentationId = finalAgentMessageId;
                    }
                }
                /**
       * Follow up processing
       */ if ((0, $bxkJA.isFollowUpMessage)(streamMessage)) {
                    const messages = getMessages(conversationId);
                    (0, $4cfff63bf4f4d4b6$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, [
                        ...messages,
                        {
                            type: 'FOLLOW_UP',
                            content: streamMessage,
                            id: (0, $39d5e6d7f285ca24$export$bac56f3fc527f04b)(0, 1000000),
                            agentMessageId: (0, $3Cuhs.getLastAgentMessageID)(messages),
                            humanMessageId: trackingAttributes.humanMessageId
                        }
                    ]);
                }
                /**
       * Task status processing
       */ if ((0, $bxkJA.isStreamTaskStatus)(streamMessage)) {
                    if (unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) (0, $86e81c25ee55514d$export$89a4ab1dea43d7ee)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $7aee2421f1549c0a$export$6b58e85d865a8eef)(unifiedTasksActions)
                    });
                }
                /**
       * Todo snapshot processing
       */ if ((0, $bxkJA.isStreamTodoSnapshot)(streamMessage)) {
                    if (unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: streamMessage.message.todos
                        }
                    });
                }
                /**
       * Error processing
       */ if ((0, $bxkJA.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are still considered successful
                    if ((0, $bxkJA.isStreamAUPError)(streamMessage)) expAndPerfTrackers.aupError();
                    throw new (0, $hwHCO.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: response.responseData?.traceId
                    });
                }
            }
        } catch (error) {
            const isAgentDeactivated = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
            const isNoAgentPermission = error instanceof (0, $8A2GO.ApiError) && error.errorAttributes.errorCode?.includes((0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN);
            if (isAgentDeactivated || isNoAgentPermission) {
                expAndPerfTrackers.agentDeactivated({
                    error: error
                });
                updateCurrentConversation({
                    status: (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError,
                    traces: [],
                    errorCode: error.errorAttributes.errorCode
                });
                // Mark all confirmed tool actions as errored
                if ((0, $iDrrr.fg)('rovo_chat_enable_tasks')) dispatch((0, $818a9d135eec7bf6$export$7ebb0e028855aeb0)({
                    conversationId: conversationId,
                    messageId: confirmed_tools.message_id,
                    tools: confirmed_tools.tools,
                    status: 'errored'
                }));
                !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                    timestamp: trackingAttributes.initiatedTimestamp
                });
                analyticsTrackers.error();
                return;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                handleAbort();
                return;
            }
            // Mark all confirmed tool actions as errored
            if ((0, $iDrrr.fg)('rovo_chat_enable_tasks')) dispatch((0, $818a9d135eec7bf6$export$7ebb0e028855aeb0)({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'errored'
            }));
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            expAndPerfTrackers.fail({
                error: normalizedError,
                attributes: error instanceof (0, $b6N3q.RovoChatStreamTimeoutError) ? getStreamTimeoutFailureAttributes(streamTimeoutRecoveryEnabled ? 'failed' : 'notAttempted') : undefined
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        } finally{
            updateCurrentConversation((0, $jyZaR.clearStatus)({}));
            setMessages(conversationId, (0, $112200485e4c7f0b$export$680d2bb5b9579c57)(getMessages(conversationId)));
            // Safety net for the agent-run bridge: clear a run left in flight by an abort or
            // dropped request so its node does not stay active. No-op once settled.
            (0, $9vNm5.endActiveAgentRun)(conversationId);
        }
        /**
   * --------
   * Stream processing END
   * --------
   */ // Handle programmatic abort — the generator may exit cleanly without throwing AbortError
        // when the abort controller is signalled. Check the signal to detect this case.
        if (abortController.signal.aborted) {
            handleAbort();
            return;
        }
        // if stream finishes without FINAL_RESPONSE, BE is hanging
        if (!hasReceivedFinalResponse) {
            const error = new (0, $kncFb.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: responseData?.traceId
            });
            const timeoutAttributes = streamTimeoutCount > 0 ? getStreamTimeoutFailureAttributes() : undefined;
            experienceTracker.fail({
                name: confirmedToolsExperienceName,
                error: error,
                ...timeoutAttributes ? {
                    attributes: timeoutAttributes
                } : {}
            });
            if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes')) failRestartedAifcGenerateContent(error);
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        }
        if ((0, $4o0zT.isExperimentEnabled)('cwr-ask-question-reliability-fixes') && hasRestartedAifcGenerateContent) {
            // Same validation as the first response (see handleStagingAreaActionValidation), but
            // instrumentation only - no UI change when no AIFC action was returned.
            const result = (0, $7a7c8f4854868908$export$4d0618d7c44ba288)({
                experienceTracker: experienceTracker,
                actions: finalResponseActions,
                attributes: {
                    product: productKey
                }
            });
            if (result === 'aborted') hasRestartedAifcGenerateContent = false;
            else if (result === 'no-action') failRestartedAifcGenerateContent(new (0, $bc8b43680017f30e$export$17fb3253ebc25334)("Something went wrong on Rovo's end. Please try sending your message again.", {
                traceId: responseData?.traceId
            }), 'NO_ACTION_AFTER_ASK_QUESTION');
        }
        onResponseComplete?.();
        !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
            timestamp: trackingAttributes.initiatedTimestamp
        });
        analyticsTrackers.viewed({
            actions: finalResponseActions
        });
        expAndPerfTrackers.succeed();
        // Re-emit the confirmed-action broadcast that the legacy resolveConversationAction
        // path used to send, so content-bridge subscribers (e.g. Jira Plans) still refresh
        // after tools are confirmed via the resumption flow. See use-rovo-confirmed-actions.
        if ((0, $iDrrr.fg)('rovo_chat_broadcast_confirmed_tools_actions')) {
            const confirmedActionContexts = confirmed_tools.tools.filter((tool)=>tool.resolution?.type !== 'cancelled').map((tool)=>({
                    key: tool.key,
                    invocationId: tool.invocation_id,
                    messageId: confirmed_tools.message_id,
                    data: tool.data.arguments,
                    resolution: {
                        type: 'confirm'
                    }
                }));
            if (confirmedActionContexts.length > 0) broadcastConfirmedActions?.(confirmed_tools.message_id, confirmedActionContexts);
        }
        if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
        {
            if (getState().currentConversationId !== conversationId) dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    readStatus: false
                }
            }));
        }
    });











const $3db73ca32f481fa4$export$7c39c589455db491 = (isConversationListMounted)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { conversationPagination: conversationPagination, isConversationsInitialized: isConversationsInitialized } = getState();
        setState({
            conversationPagination: {
                ...conversationPagination,
                isConversationListMounted: isConversationListMounted
            }
        });
        if ((0, $iDrrr.fg)('rovo_chat_conversation_search_pagination') && isConversationListMounted && !conversationPagination.isConversationListMounted && isConversationsInitialized) dispatch((0, $iWQjF.loadMoreConversationChannelsData)());
    };




















const $51c7bf2c092024a3$export$d9d592371c2a2f98 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).stopTask, ({ conversationId: conversationId })=>({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
        const conversation = getState().conversations[conversationId];
        if (conversation?.storeAbortController) {
            dispatch((0, $8OiFS.abortRequests)({
                conversationId: conversationId,
                taskModeEnabled: true
            }));
            return;
        }
        if (!unifiedTasksActions) return;
        const task = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        if (!task?.taskId || (0, $igOtY.isTerminalTaskState)(task.progressState)) return;
        unifiedTasksActions.setTaskProgressState({
            taskId: task.taskId,
            progressState: 'Cancelled',
            updatedAt: new Date().toISOString()
        });
        assistanceService.cancelTask(task.taskId).catch((err)=>{
            (0, $hlvTd.logException)({
                name: 'rovoCancelTaskFromStopTask',
                exception: err,
                tags: {
                    taskId: task.taskId
                }
            });
        });
    });









var $jcJSP = parcelRequire("jcJSP");

const $fc4eff2d3971ee33$export$a1b6e610fd39072e = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).truncateFromLastHumanMessage, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const messages = getMessages(conversationId);
        const lastHumanIdx = (0, $jcJSP.findLastIndex)(messages, (0, $igOtY.isStoreHuman));
        if (lastHumanIdx < 0) return [];
        const tail = messages.slice(lastHumanIdx);
        setMessages(conversationId, messages.slice(0, lastHumanIdx));
        return tail;
    });











const $fa89f225f2a7d029$export$7509704a5a460104 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).updateActionExecutedData, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, executedData: executedData })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const message = agentMessage.result;
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...message,
            content: {
                ...message.content,
                message: {
                    ...message.content.message,
                    message: {
                        ...message.content.message.message,
                        actions: message.content.message.message.actions?.map((action)=>action.invocationId === invocationId ? {
                                ...action,
                                executedData: executedData
                            } : action)
                    }
                }
            }
        };
        setMessages(conversationId, updatedMessages);
    });














const $030fab6f8e6adbfc$export$f020542e7ec82374 = ({ conversationId: conversationId, data: data })=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        let updatedConversation;
        try {
            updatedConversation = await assistanceService?.updateConversationChannel(conversationId, data);
        } catch (error) {
            const pinLimitErrorData = data.isPinned ? (0, $8A2GO.getPinnedConversationLimitErrorData)(error) : undefined;
            if (pinLimitErrorData !== undefined) experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                reason: 'pinned_conversation_limit_reached',
                attributes: {
                    conversationId: conversationId,
                    ...pinLimitErrorData
                }
            });
            else experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
        const nextData = {
            ...data
        };
        if (updatedConversation) {
            if ((0, $iDrrr.fg)('rovo_chat_chat_history_refresh') && updatedConversation.agentSessionState !== undefined) nextData.agentSessionState = updatedConversation.agentSessionState;
            if (updatedConversation.name !== undefined && (data.name !== undefined || !(0, $iDrrr.fg)('rovo_chat_live_conversation_titles'))) nextData.name = updatedConversation.name;
            if (updatedConversation.readStatus !== undefined) nextData.readStatus = updatedConversation.readStatus;
            if (typeof updatedConversation.isPinned === 'boolean') nextData.isPinned = updatedConversation.isPinned;
            if (updatedConversation.pinnedAt !== undefined) nextData.pinnedAt = updatedConversation.pinnedAt;
        }
        dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: nextData
        }));
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).UPDATE_CONVERSATION_CHANNEL
        });
    };

































var $f2kj3 = parcelRequire("f2kj3");









// Only fetchConversation reconnects to a running turn, so a cached copy of one would be shown as a
// static snapshot, or as an empty chat if the turn's messages are not persisted yet.
const $cd0a4aea4e48093b$var$hasSettledHistory = (latestMessages)=>!(0, $579e7cab04e6efec$export$767f5c1ef71cb70c)(latestMessages) && !(0, $bxkJA.isInProgressStreamResponse)(latestMessages.at(-1));
const $cd0a4aea4e48093b$export$b1e09d46e687e819 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).warmConversationCache, ({ conversation: conversationParams, forceRefresh: forceRefresh, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, capabilities: capabilities, onConversationSpacesHydrated: onConversationSpacesHydrated })=>{
        const conversationId = conversationParams.id;
        const existingConversation = getState().conversations[conversationId];
        // Skip if conversation is actively in-flight
        if (existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).loadingChat || existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).awaitingResponse || existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse) return;
        // Skip if conversation is already loaded (idle with messages) unless forceRefresh
        if (existingConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !forceRefresh) return;
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    forceRefresh: Boolean(forceRefresh)
                }
            });
            // Bootstrap conversation in store with provided metadata or client defaults.
            const conversationAgentForWarmLoadingReset = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? existingConversation?.agent ?? (0, $8fLSN.createProvisionalConversationAgent)(conversationParams.agentId ?? existingConversation?.sourceAgentId) : undefined;
            const conversationAgentFieldsForWarmLoadingReset = conversationAgentForWarmLoadingReset ? {
                agent: conversationAgentForWarmLoadingReset
            } : {};
            const messagesBeforeReload = getMessages(conversationId);
            dispatch((0, $lOO5l.initializeConversationData)({
                conversationId: conversationId,
                data: {
                    id: conversationId,
                    name: conversationParams.name ?? existingConversation?.name ?? '',
                    timeCreated: conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                    status: (0, $igOtY.CHAT_STORE_STATUS).loadingChat,
                    traces: [],
                    sourceAgentId: conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                    ...conversationAgentFieldsForWarmLoadingReset,
                    messages: []
                }
            }));
            // If metadata params not fully provided, fetch from API in parallel (silent failure)
            const hasFullMetadata = conversationParams.name != null && conversationParams.timeCreated != null;
            const metadataPromise = hasFullMetadata ? Promise.resolve() : assistanceService.fetchConversationMetadata(conversationId).then((metadata)=>{
                if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_spaces_experiment')) (0, $4c477a4f1aee7cea$export$e3ef4b259ed70a56)({
                    conversationId: conversationId,
                    metadata: metadata,
                    dispatch: dispatch,
                    onConversationSpacesHydrated: onConversationSpacesHydrated
                });
                const fetchedConversationAgentFields = metadata.agent && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? {
                    agent: metadata.agent
                } : {};
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: {
                        name: metadata.name ?? conversationParams.name ?? '',
                        timeCreated: metadata.time_created ?? conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                        sourceAgentId: metadata.agent?.agent_id ?? metadata.agent?.agent_named_id ?? conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                        ...fetchedConversationAgentFields,
                        ...metadata.tags !== undefined ? {
                            tags: metadata.tags
                        } : {},
                        lastRequestedMode: (0, $f2kj3.normalizeRestorableRequestedMode)(metadata.last_requested_mode)
                    }
                }));
            }).catch(()=>{
            // Silent failure — keep client defaults
            });
            // Run messages fetch and metadata fetch in parallel; wait for both
            const chatPromise = assistanceService.getChat(conversationId, capabilities);
            const [chatResult] = await Promise.allSettled([
                chatPromise,
                metadataPromise
            ]);
            if (chatResult.status === 'rejected') {
                const normalizedError = chatResult.reason instanceof Error ? chatResult.reason : new Error(String(chatResult.reason));
                experienceTracker.fail({
                    teamName: 'Rovo Chat',
                    name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
                    error: normalizedError
                });
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversationId,
                    data: (0, $jyZaR.clearStatus)({})
                }));
                onError?.(normalizedError);
                return;
            }
            const serviceChat = chatResult.value;
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $igOtY.CHAT_STORE_STATUS).loadingChat) return;
            if ((0, $iDrrr.fg)('rovo_chat_fetch_waits_for_running_turn') && !$cd0a4aea4e48093b$var$hasSettledHistory(serviceChat)) {
                const { [conversationId]: _warmedConversation, ...otherConversations } = getState().conversations;
                setState({
                    conversations: existingConversation ? {
                        ...otherConversations,
                        [conversationId]: existingConversation
                    } : otherConversations
                });
                setMessages(conversationId, messagesBeforeReload);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE
                });
                onSuccess?.();
                return;
            }
            const messages = (0, $gjWe2.processConversationMessages)({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $927c732e26323e49$export$de552dcf26f1e520)(getState(), conversationId)
            });
            const fetchedAgentVersion = (0, $287b89b445b82017$export$9c99f879b5701ba2)(serviceChat);
            dispatch((0, $6geN3.setConversationData)({
                conversationId: conversationId,
                data: {
                    ...(0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {}
                }
            }));
            setMessages(conversationId, (0, $d2bec76a2cf3a32e$export$78825c8f4b3c575c)(messagesBeforeReload, messages));
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE
            });
            onSuccess?.();
        } catch (e) {
            const normalizedError = e instanceof Error ? e : new Error(String(e));
            experienceTracker.fail({
                teamName: 'Rovo Chat',
                name: (0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
                error: normalizedError
            });
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).WARM_CONVERSATION_CACHE,
    actionErrorHandler: ()=>{
        // Suppress all default error handling for cache warming
        return;
    }
});


const $91133bed95970fa4$var$registerHumanMessageIdReplacementHandler = (handler)=>(_state, { registerHumanMessageIdReplacementHandler: registerHandler })=>registerHandler?.(handler) ?? (()=>{});
const $91133bed95970fa4$export$e324594224ef24da = {
    abortRequests: $8OiFS.abortRequests,
    addAgentMessage: $371ae8b5b22d3b46$export$217edc90936e0581,
    addErrorMessage: $20d942c7fe0333b7$export$1824e64235e4b973,
    answerNow: $3e2d3625545c1ea9$export$d5b8fce20f45b1bf,
    bulkResolveConversationActions: $8c8e302bbc2551a3$export$d5f51c6d14729a9d,
    bulkResolveConversationUIActions: $5505ac2578341bfa$export$e99fa5687f622cbf,
    clearFollowUpMessages: $1385698a2f418aa1$export$bc07ddf1de8d78e4,
    stopTask: $51c7bf2c092024a3$export$d9d592371c2a2f98,
    clearTargetTaskMessageId: $41db72a9378f94af$export$1562f8e01d4b447c,
    createConversationOptimistically: $djNSU.createConversationOptimistically,
    createSeededConversation: $ac50e9856e9d0021$export$916d50c71d1097fc,
    deleteConversation: $f27a0f1ad9682674$export$64c838ca85b298d9,
    ensureConversation: $45b5e09b5dafafbe$export$a3fb5954226ada5d,
    getChat: (0, $b25327492a2eafbb$export$5c7afebc13b5b6d7),
    handleChatOpenPubsubAction: $7924d5732284eb54$export$6914a4ee7f8cbe2c,
    hydrateConversationWithExternalParams: $dHz2q.hydrateConversationWithExternalParams,
    ensurePromptHistoryLoaded: $c09fde7241c81bcf$export$61feb9c9a0822fc5,
    fetchConversationChannelsData: $7eGGZ.fetchConversationChannelsData,
    loadMoreConversationChannelsData: $iWQjF.loadMoreConversationChannelsData,
    setConversationListMounted: $3db73ca32f481fa4$export$7c39c589455db491,
    setNeedsReviewListMounted: (isNeedsReviewListMounted)=>({ setState: setState })=>{
            setState({
                isNeedsReviewListMounted: isNeedsReviewListMounted
            });
        },
    setConversationData: $6geN3.setConversationData,
    removeMessage: $6279909d4ebd325a$export$f9a3c275d8ffdac0,
    truncateFromLastHumanMessage: $fc4eff2d3971ee33$export$a1b6e610fd39072e,
    resolveConversationAction: $6ebccb4cae0d59cc$export$11688a59b4c1bf2b,
    sendA2UIAction: $0b1976f4f4504448$export$3c932f8ca2641253,
    sendMessage: $7c8a1ce87ec5e959$export$465cb47180de50f0,
    sendMessageConfirmedTools: $3fbe59e6722fdc18$export$a520ca869831c96e,
    updateActionExecutedData: $fa89f225f2a7d029$export$7509704a5a460104,
    setSelectedConversation: $c8Sl1.setSelectedConversation,
    updateConversation: $030fab6f8e6adbfc$export$f020542e7ec82374,
    removeConversationFromStore: $77b987c9b91a6f83$export$53f4d2378049701e,
    reconnectToInProgressStream: $7a4a093d6dd23d1c$export$873fca975736004b,
    registerHumanMessageIdReplacementHandler: $91133bed95970fa4$var$registerHumanMessageIdReplacementHandler,
    restoreTaskModeIfNeeded: $eQl6Z.restoreTaskModeIfNeeded,
    warmConversationCache: $cd0a4aea4e48093b$export$b1e09d46e687e819,
    prefetchConversationMessages: $b0af940bfa1b3612$export$b798bd7f9b4e76a0,
    seedConversation: $fef4f32b3ef3f920$export$1a0f0d45b9f5743b
};


const $bb9b6d1522218f88$export$b3bf59e98866a2c9 = (0, $4m5jb.createChatStore)((0, $91133bed95970fa4$export$e324594224ef24da));
module.exports["chatStore"] = $bb9b6d1522218f88$export$b3bf59e98866a2c9;

});

parcelRegister("8OiFS", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $irnO2 = parcelRequire("irnO2");


var $igOtY = parcelRequire("igOtY");


var $2VSIF = parcelRequire("2VSIF");


var $lwUDA = parcelRequire("lwUDA");


var $jyZaR = parcelRequire("jyZaR");


var $l6xCb = parcelRequire("l6xCb");


var $16g08 = parcelRequire("16g08");




const $3505e3e9b34506aa$export$304863f72794c019 = (chat)=>{
    const isInFlight = (action)=>{
        const lower = action.status?.toLowerCase();
        return lower === 'streaming' || lower === 'preparing';
    };
    const hasInFlightAction = chat.some((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.message.message.actions?.some(isInFlight));
    if (!hasInFlightAction) return chat;
    return chat.map((message)=>{
        if (!(0, $igOtY.isStoreAssistant)(message) || !message.content.message.message.actions?.some(isInFlight)) return message;
        return {
            ...message,
            content: {
                ...message.content,
                message: {
                    ...message.content.message,
                    message: {
                        ...message.content.message.message,
                        actions: message.content.message.message.actions.map((action)=>isInFlight(action) ? {
                                ...action,
                                status: 'cancelled'
                            } : action)
                    }
                }
            }
        };
    });
};



var $6geN3 = parcelRequire("6geN3");


var $dxD6w = parcelRequire("dxD6w");

const $99be9b013bc211a2$var$markAssistantMessageAsAborted = (messages, assistantMessageId)=>{
    if (!assistantMessageId) return messages;
    let hasChanged = false;
    const nextMessages = messages.map((message)=>{
        if (!(0, $igOtY.isStoreAssistant)(message) || message.content.message.message.id !== assistantMessageId || message.isAborted === true) return message;
        hasChanged = true;
        return {
            ...message,
            isAborted: true
        };
    });
    return hasChanged ? nextMessages : messages;
};
const $99be9b013bc211a2$export$39589cf038b415bc = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).abortRequests, ({ conversationId: conversationId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, deepResearchEnabled: deepResearchEnabled } = {})=>({ getState: getState, dispatch: dispatch }, { experienceTracker: experienceTracker, setReasoningMode: setReasoningMode, isReconnecting: isReconnecting, unifiedTasksActions: unifiedTasksActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, clearMessageResearch: clearMessageResearch, getMessages: getMessages, setMessages: setMessages })=>{
        const conversations = getState().conversations;
        if (conversationId && (0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments')) (0, $2VSIF.setConversationCancelled)(conversationId, true);
        const abortConversationStream = (conversation)=>{
            const shouldSynchronouslyCancelRemix = conversation?.isViewModeRemix === true;
            if (conversation?.id && ((0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true) || shouldSynchronouslyCancelRemix || conversationId && (0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments'))) {
                dispatch((0, $6geN3.setConversationData)({
                    conversationId: conversation.id,
                    data: (0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'CANCELLED'
                    })
                }));
                // Only clear research when answer streaming has started.
                if (conversation.status === (0, $igOtY.CHAT_STORE_STATUS).typingResponse) {
                    const streamingAssistantMessageIds = getMessages(conversation.id).filter((message)=>(0, $igOtY.isStoreAssistant)(message) && message.content.streamingComplete !== true).map((message)=>message.content.message.message.id);
                    streamingAssistantMessageIds.forEach((messageId)=>{
                        markIncompleteResearchesErrored({
                            messageId: messageId
                        });
                        clearMessageResearch({
                            messageId: messageId
                        });
                    });
                }
            }
            if (conversation?.storeAbortController) {
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).ABORT_AGENT_STREAM,
                    id: conversation?.id,
                    attributes: {
                        conversationId: conversation?.id,
                        isReconnecting: isReconnecting(conversation?.id ?? '')
                    }
                });
                (0, $lwUDA.abortPreviewCardRenderExperience)({
                    experienceTracker: experienceTracker,
                    reason: 'User cancelled before preview card rendered',
                    terminalReason: 'user-cancelled',
                    attributes: {
                        conversationId: conversation.id,
                        isProgrammaticAbort: true
                    }
                });
                if (conversation.id) {
                    const currentMessages = getMessages(conversation.id);
                    let nextMessages = $99be9b013bc211a2$var$markAssistantMessageAsAborted(currentMessages, (0, $dxD6w.activeAssistantMessageIds).get(conversation.storeAbortController));
                    if (!isReconnecting(conversation.id)) nextMessages = (0, $3505e3e9b34506aa$export$304863f72794c019)(nextMessages);
                    if (nextMessages !== currentMessages) setMessages(conversation.id, nextMessages);
                }
                conversation.storeAbortController.abort();
                if (!conversationId && conversation.id && (0, $4o0zT.isExperimentEnabled)('platform_editor_inline_agentic_comments')) (0, $2VSIF.setConversationCancelled)(conversation.id, true);
                experienceTracker.abort({
                    name: (0, $16g08.getSendMessageExperienceName)({
                        deepResearchEnabled: deepResearchEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        taskModeEnabled: taskModeEnabled,
                        fastModeEnabled: fastModeEnabled
                    }),
                    reason: 'Aborted',
                    attributes: {
                        isProgrammaticAbort: true
                    }
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).ABORT_AGENT_STREAM
                });
                if (taskModeEnabled && conversation?.id && unifiedTasksActions && (0, $iDrrr.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskProgressState({
                    conversationId: conversation.id,
                    progressState: 'Cancelled',
                    updatedAt: new Date().toISOString()
                });
            }
        };
        if (conversationId) abortConversationStream(conversations[conversationId]);
        else Object.values(conversations).forEach(abortConversationStream);
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).ABORT_AGENT_STREAM
});
module.exports["abortRequests"] = $99be9b013bc211a2$export$39589cf038b415bc;

});

parcelRegister("2VSIF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $560bd34c096434ea$var$MAX_RETAINED_CANCELLED_CONVERSATIONS = 100;
const $560bd34c096434ea$var$cancelledConversationIds = new Set();
const $560bd34c096434ea$var$subscribers = new Set();
const $560bd34c096434ea$var$notifySubscribers = ()=>{
    for (const subscriber of $560bd34c096434ea$var$subscribers)try {
        subscriber();
    } catch  {
    // A subscriber observes cancellation; it must not affect stopping a stream.
    }
};
const $560bd34c096434ea$var$subscribe = (subscriber)=>{
    $560bd34c096434ea$var$subscribers.add(subscriber);
    return ()=>$560bd34c096434ea$var$subscribers.delete(subscriber);
};
const $560bd34c096434ea$export$b19adef69aa20f4f = (conversationId, cancelled)=>{
    if (!conversationId) return;
    if (!cancelled) {
        if ($560bd34c096434ea$var$cancelledConversationIds.delete(conversationId)) $560bd34c096434ea$var$notifySubscribers();
        return;
    }
    if ($560bd34c096434ea$var$cancelledConversationIds.has(conversationId)) return;
    $560bd34c096434ea$var$cancelledConversationIds.add(conversationId);
    if ($560bd34c096434ea$var$cancelledConversationIds.size > $560bd34c096434ea$var$MAX_RETAINED_CANCELLED_CONVERSATIONS) {
        const oldestConversationId = $560bd34c096434ea$var$cancelledConversationIds.values().next().value;
        if (oldestConversationId) $560bd34c096434ea$var$cancelledConversationIds.delete(oldestConversationId);
    }
    $560bd34c096434ea$var$notifySubscribers();
};
const $560bd34c096434ea$export$981e35b7e75898af = (conversationId)=>Boolean(conversationId && $560bd34c096434ea$var$cancelledConversationIds.has(conversationId));
const $560bd34c096434ea$export$34b9a4d4b2e97dc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== conversationId) {
        t0 = ()=>$560bd34c096434ea$export$981e35b7e75898af(conversationId);
        $[0] = conversationId;
        $[1] = t0;
    } else t0 = $[1];
    const getSnapshot = t0;
    let t1;
    if ($[2] !== conversationId) {
        t1 = (subscriber)=>conversationId ? $560bd34c096434ea$var$subscribe(subscriber) : $560bd34c096434ea$var$_temp;
        $[2] = conversationId;
        $[3] = t1;
    } else t1 = $[3];
    const subscribeToConversation = t1;
    return (0, $cozmU.useSyncExternalStore)(subscribeToConversation, getSnapshot, getSnapshot);
} : (conversationId)=>{
    const getSnapshot = (0, $cozmU.useCallback)(()=>$560bd34c096434ea$export$981e35b7e75898af(conversationId), [
        conversationId
    ]);
    const subscribeToConversation = (0, $cozmU.useCallback)((subscriber)=>conversationId ? $560bd34c096434ea$var$subscribe(subscriber) : ()=>{}, [
        conversationId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribeToConversation, getSnapshot, getSnapshot);
};
function $560bd34c096434ea$var$_temp() {}
module.exports["setConversationCancelled"] = $560bd34c096434ea$export$b19adef69aa20f4f;
module.exports["isConversationCancelled"] = $560bd34c096434ea$export$981e35b7e75898af;
module.exports["useIsConversationCancelled"] = $560bd34c096434ea$export$34b9a4d4b2e97dc;

});

parcelRegister("eBgZa", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $b6N3q = parcelRequire("b6N3q");


var $bMRok = parcelRequire("bMRok");


var $hHBvs = parcelRequire("hHBvs");


var $kncFb = parcelRequire("kncFb");


var $hwHCO = parcelRequire("hwHCO");


var $bQxqB = parcelRequire("bQxqB");


var $icBz6 = parcelRequire("icBz6");

const $2bb3767adaced59b$export$5782d74d68fa92c6 = (error, prefix = '', actionLoggableNameIfActionExecutionFailed, entryPoint)=>{
    let status_code, message_template, timeout;
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error';
    let prefixedMessage = prefix ? `${prefix}: ${message}` : message;
    let errorType;
    let traceId;
    if (error instanceof (0, $hwHCO.StreamErrorException)) {
        status_code = error.detail.message.status_code;
        message_template = error.detail.message.message_template;
        timeout = error.detail.metadata?.timeout;
        errorType = 'StreamErrorException';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $8A2GO.ApiError)) {
        status_code = error.errorAttributes.statusCode;
        message_template = error.errorAttributes.errorCode;
        errorType = 'ApiError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $hHBvs.MessageActionError)) {
        status_code = error.errorAttributes.statusCode;
        message_template = error.errorAttributes.errorCode;
        errorType = 'MessageActionError';
        traceId = error.errorAttributes.traceId;
        // Prefer showing only the raw API error message (without codes) to end users
        const rawErrorMessage = error.errorAttributes.rawErrorMessage;
        if (typeof rawErrorMessage === 'string') prefixedMessage = prefix ? `${prefix}: ${rawErrorMessage}` : rawErrorMessage;
    }
    if (error instanceof (0, $bQxqB.StreamGeneratorError)) {
        errorType = 'StreamGeneratorError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $kncFb.NoFinalResponseError)) {
        errorType = 'NoFinalResponseError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $b6N3q.RovoChatStreamTimeoutError)) {
        errorType = 'RovoChatStreamTimeoutError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $bMRok.DeepResearchError)) {
        message_template = error.message_template;
        errorType = 'DeepResearchError';
        traceId = error.errorAttributes.traceId;
    }
    return {
        type: 'ERROR',
        content: prefixedMessage,
        time_created: new Date().toLocaleString(),
        status_code: status_code,
        message_template: message_template,
        timeout: timeout,
        id: (0, $icBz6.generateId)(),
        errorType: errorType,
        traceId: traceId,
        ...entryPoint ? {
            entryPoint: entryPoint
        } : {},
        storeActionExecutionError: actionLoggableNameIfActionExecutionFailed ? {
            actionLoggableName: actionLoggableNameIfActionExecutionFailed
        } : undefined
    };
};
module.exports["createStoreError"] = $2bb3767adaced59b$export$5782d74d68fa92c6;

});

parcelRegister("1IZrU", function(module, exports) {

var $4m5jb = parcelRequire("4m5jb");

const $1e88240d2a144a7a$export$b178621992ef9541 = (conversationId)=>conversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID) || conversationId === undefined;
module.exports["isEmptyConversation"] = $1e88240d2a144a7a$export$b178621992ef9541;

});

parcelRegister("fjUOt", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");

const $c4fd37cdefb60c84$export$6fc20c9b92c92c1c = (storeMessage)=>{
    if ((0, $igOtY.isStoreAssistant)(storeMessage)) return (0, $bkEBw.getId)(storeMessage.content);
    return storeMessage.content.id;
};
module.exports["getStoreMessageId"] = $c4fd37cdefb60c84$export$6fc20c9b92c92c1c;

});

parcelRegister("boScW", function(module, exports) {
const $125cacaba79baed0$export$82e177c6719dc71c = (status)=>status >= 500 && status < 600;
module.exports["is5xxHttpStatus"] = $125cacaba79baed0$export$82e177c6719dc71c;

});

parcelRegister("k1kN6", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $5iFVe = parcelRequire("5iFVe");


var $cWP9O = parcelRequire("cWP9O");

const $bdba74cd3dd86c9c$export$1a288f9aecfed8b4 = (messages, agentMessageId)=>{
    try {
        const agentMessage = (0, $cWP9O.getAgentMessageById)(messages, agentMessageId).result;
        if (agentMessage && (0, $igOtY.isStoreAssistant)(agentMessage)) {
            const foundId = (0, $5iFVe.findPreviousByTypeFromId)({
                messages: messages,
                messageId: agentMessageId,
                searchType: 'HUMAN'
            })?.content.id;
            return foundId ? String(foundId) : undefined;
        }
    } catch  {
        return undefined;
    }
};
module.exports["getAssociatedHumanMessageId"] = $bdba74cd3dd86c9c$export$1a288f9aecfed8b4;

});

parcelRegister("b2pOf", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- this controller exposes one cohesive persistence boundary plus its pure codec and eligibility helpers */ 
var $iDrrr = parcelRequire("iDrrr");


var $4m5jb = parcelRequire("4m5jb");


var $8VLb5 = parcelRequire("8VLb5");


var $iWk4y = parcelRequire("iWk4y");




const $295a18506815ec6a$export$e5a3af287978673c = (siteId)=>siteId ? `${0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY}_${siteId}` : (0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY);





const $61a0979f42bdaa38$export$23660cbd62c35e47 = (siteId)=>siteId ? `${0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY}_${siteId}` : (0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY);



var $oV0CU = parcelRequire("oV0CU");

const $1d759ad68861991d$export$589976df4d188aac = (timestamp)=>{
    if (timestamp === null) {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.removeItem((0, $oV0CU.LS_LAST_MESSAGE_SENT_AT));
        return;
    }
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem((0, $oV0CU.LS_LAST_MESSAGE_SENT_AT), timestamp.toString());
};


const $d66b70ee5b7a48e6$export$a9deb0d4eb645dd2 = 'rovo_chat_persisted_conversation_restoration';
const $d66b70ee5b7a48e6$export$c70d328fcf26ea56 = 60000;
const $d66b70ee5b7a48e6$var$getBrowserLocalStorage = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- all reads and writes are protected by the non-essential storage kill switch at their call sites
    return typeof localStorage === 'undefined' ? null : localStorage;
};
const $d66b70ee5b7a48e6$var$isPersistedConversationActivity = (value)=>{
    if (typeof value !== 'object' || value === null || Array.isArray(value)) return false;
    const candidate = value;
    return candidate.version === 1 && typeof candidate.conversationId === 'string' && candidate.conversationId.trim().length > 0 && (candidate.lastMessageSentAt === null || typeof candidate.lastMessageSentAt === 'number' && Number.isFinite(candidate.lastMessageSentAt));
};
const $d66b70ee5b7a48e6$export$2d5a1db6906f058e = (rawValue)=>{
    if (!rawValue) return null;
    try {
        const parsed = JSON.parse(rawValue);
        return $d66b70ee5b7a48e6$var$isPersistedConversationActivity(parsed) ? parsed : null;
    } catch  {
        return null;
    }
};
const $d66b70ee5b7a48e6$export$cc8cd4a22284d76 = (activity)=>$d66b70ee5b7a48e6$var$isPersistedConversationActivity(activity) ? JSON.stringify(activity) : null;
const $d66b70ee5b7a48e6$export$9ea55b949b04fb81 = ()=>(0, $iDrrr.fg)($d66b70ee5b7a48e6$export$a9deb0d4eb645dd2);
const $d66b70ee5b7a48e6$export$39ed32c8dc854042 = (siteId)=>(0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        return $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.getItem((0, $295a18506815ec6a$export$e5a3af287978673c)(siteId)) ?? null;
    });
const $d66b70ee5b7a48e6$var$getPersistedConversationActivityWithoutGateCheck = (siteId)=>{
    const rawValue = (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        return $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.getItem((0, $61a0979f42bdaa38$export$23660cbd62c35e47)(siteId)) ?? null;
    });
    return $d66b70ee5b7a48e6$export$2d5a1db6906f058e(rawValue);
};
const $d66b70ee5b7a48e6$export$22a1db86992546d2 = (siteId)=>$d66b70ee5b7a48e6$export$9ea55b949b04fb81() ? $d66b70ee5b7a48e6$var$getPersistedConversationActivityWithoutGateCheck(siteId) : null;
const $d66b70ee5b7a48e6$var$writeLegacyConversationId = (siteId, conversationId)=>{
    (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.setItem((0, $295a18506815ec6a$export$e5a3af287978673c)(siteId), conversationId);
    });
};
const $d66b70ee5b7a48e6$var$writePersistedConversationActivity = (siteId, activity)=>{
    const serialized = $d66b70ee5b7a48e6$export$cc8cd4a22284d76(activity);
    if (serialized === null) return;
    (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY), ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
        $d66b70ee5b7a48e6$var$getBrowserLocalStorage()?.setItem((0, $61a0979f42bdaa38$export$23660cbd62c35e47)(siteId), serialized);
    });
};
const $d66b70ee5b7a48e6$export$9f594350969a7227 = (event)=>{
    if (event.type === 'conversation-deleted') {
        try {
            // Check each reference independently; another window may have selected a different chat.
            (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_CHAT_LOAD_PREFERENCE_KEY), ()=>{
                const storage = $d66b70ee5b7a48e6$var$getBrowserLocalStorage();
                const key = (0, $295a18506815ec6a$export$e5a3af287978673c)(event.siteId);
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
                if (storage?.getItem(key) === event.conversationId) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
                storage.removeItem(key);
            });
            (0, $iWk4y.withNonEssentialLocalStorage)((0, $8VLb5.LS_RECENT_CONVERSATION_ACTIVITY_KEY), ()=>{
                const storage = $d66b70ee5b7a48e6$var$getBrowserLocalStorage();
                const key = (0, $61a0979f42bdaa38$export$23660cbd62c35e47)(event.siteId);
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
                const activity = $d66b70ee5b7a48e6$export$2d5a1db6906f058e(storage?.getItem(key) ?? null);
                if (activity?.conversationId === event.conversationId) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- protected by the non-essential storage kill switch
                storage?.removeItem(key);
            });
        } catch  {
        // Storage can be disabled by the browser; deletion must still reach the remaining caches.
        }
        return;
    }
    const isRestorationEnabled = $d66b70ee5b7a48e6$export$9ea55b949b04fb81();
    if (event.type === 'conversation-selected') {
        const existingActivity = isRestorationEnabled ? $d66b70ee5b7a48e6$var$getPersistedConversationActivityWithoutGateCheck(event.siteId) : null;
        $d66b70ee5b7a48e6$var$writeLegacyConversationId(event.siteId, event.conversationId);
        if (event.clearLegacyLastMessageSentAt) (0, $1d759ad68861991d$export$589976df4d188aac)(null);
        if (isRestorationEnabled) $d66b70ee5b7a48e6$var$writePersistedConversationActivity(event.siteId, {
            version: 1,
            conversationId: event.conversationId,
            lastMessageSentAt: event.conversationId !== (0, $4m5jb.EMPTY_CONVERSATION_ID) && existingActivity?.conversationId === event.conversationId ? existingActivity.lastMessageSentAt : null
        });
        return;
    }
    if (!isRestorationEnabled) {
        (0, $1d759ad68861991d$export$589976df4d188aac)(event.lastMessageSentAt);
        return;
    }
    $d66b70ee5b7a48e6$var$writeLegacyConversationId(event.siteId, event.conversationId);
    (0, $1d759ad68861991d$export$589976df4d188aac)(event.lastMessageSentAt);
    $d66b70ee5b7a48e6$var$writePersistedConversationActivity(event.siteId, {
        version: 1,
        conversationId: event.conversationId,
        lastMessageSentAt: event.lastMessageSentAt
    });
};
const $d66b70ee5b7a48e6$export$8dc7d0c9532ed7e9 = ({ selectedConversationId: selectedConversationId, activity: activity, now: now, timeout: timeout })=>{
    if (selectedConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID) || !activity || activity.conversationId !== selectedConversationId || activity.lastMessageSentAt === null || !Number.isFinite(now) || !Number.isFinite(timeout) || timeout <= 0) return false;
    const futureOffset = activity.lastMessageSentAt - now;
    if (futureOffset > $d66b70ee5b7a48e6$export$c70d328fcf26ea56) return false;
    const activityAge = Math.max(0, now - activity.lastMessageSentAt);
    return activityAge < timeout;
};
module.exports["isPersistedConversationRestorationEnabled"] = $d66b70ee5b7a48e6$export$9ea55b949b04fb81;
module.exports["getPersistedRecentConversationId"] = $d66b70ee5b7a48e6$export$39ed32c8dc854042;
module.exports["getPersistedConversationActivity"] = $d66b70ee5b7a48e6$export$22a1db86992546d2;
module.exports["persistRecentConversation"] = $d66b70ee5b7a48e6$export$9f594350969a7227;
module.exports["isPersistedConversationActivityRestorable"] = $d66b70ee5b7a48e6$export$8dc7d0c9532ed7e9;

});

parcelRegister("oV0CU", function(module, exports) {
const $b9ae9242f3c4f5b9$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $b9ae9242f3c4f5b9$export$a3498676d970e6e5 = '63867aef-06e5-4520-855f-4d29e062f22c';
const $b9ae9242f3c4f5b9$export$c87b1e2e3344192f = 1000;
const $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e = 60;
const $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb = $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * 60;
const $b9ae9242f3c4f5b9$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $b9ae9242f3c4f5b9$export$e8114853eca81277 = 'ai-mate';
const $b9ae9242f3c4f5b9$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $b9ae9242f3c4f5b9$export$1ea9613e3e37d315 = 30 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$501af059da333e01 = 5 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $b9ae9242f3c4f5b9$export$85d90d98449e85fd = 140;
const $b9ae9242f3c4f5b9$export$cad0f6e78cd99203 = '600px';
const $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda = 380;
const $b9ae9242f3c4f5b9$export$2c094f7f70c376e3 = 480;
const $b9ae9242f3c4f5b9$export$2e9abc2f500a1704 = 280;
const $b9ae9242f3c4f5b9$export$ac95424456cde4ce = 760;
const $b9ae9242f3c4f5b9$export$1a72156daebf0ea3 = 'conversation-assistant.split-layout.right-width';
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $b9ae9242f3c4f5b9$export$4b225aae27e9366b;
module.exports["CWR_FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $b9ae9242f3c4f5b9$export$a3498676d970e6e5;
module.exports["MS_IN_SECOND"] = $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb;
module.exports["AI_MATE_EXPERIENCE_ID"] = $b9ae9242f3c4f5b9$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $b9ae9242f3c4f5b9$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $b9ae9242f3c4f5b9$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $b9ae9242f3c4f5b9$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $b9ae9242f3c4f5b9$export$cad0f6e78cd99203;
module.exports["SPLIT_LAYOUT_INITIAL_WIDTH"] = $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda;
module.exports["SPLIT_LAYOUT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2c094f7f70c376e3;
module.exports["SPLIT_LAYOUT_ADJACENT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2e9abc2f500a1704;
module.exports["SPLIT_LAYOUT_MIN_PANEL_WIDTH"] = $b9ae9242f3c4f5b9$export$ac95424456cde4ce;
module.exports["SPLIT_LAYOUT_STORAGE_KEY"] = $b9ae9242f3c4f5b9$export$1a72156daebf0ea3;

});

parcelRegister("7eGGZ", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $7H855 = parcelRequire("7H855");


var $idzM5 = parcelRequire("idzM5");


var $awqa1 = parcelRequire("awqa1");


var $l6xCb = parcelRequire("l6xCb");


var $9bLpG = parcelRequire("9bLpG");


var $1IZrU = parcelRequire("1IZrU");


var $iWQjF = parcelRequire("iWQjF");


var $hQJOO = parcelRequire("hQJOO");


var $eQl6Z = parcelRequire("eQl6Z");


var $c8Sl1 = parcelRequire("c8Sl1");

const $7dc4b12cf023d92e$export$767e11ac0b9abe0b = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).fetchConversationChannelsData, ({ isInitialLoad: isInitialLoad = false, reconcileFirstPage: reconcileFirstPage = false } = {})=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, unifiedTasksActions: unifiedTasksActions })=>{
        if (reconcileFirstPage && !getState().conversationPagination.isConversationListMounted && (!((0, $iDrrr.fg)('rovo_chat_suggestions_empty_states') && (0, $2pQiO.UNSAFE_expValNoExposure)('rovo_chat_schedule_chat_skill_experiment', 'isEnabled', false) === true) || !getState().isNeedsReviewListMounted)) return;
        // A concurrent load-more may be in flight; skip the first-page reconciliation
        // rather than stomping its cursor/hasMore metadata. Best-effort: the next
        // visibility event will reconcile correctly.
        if (reconcileFirstPage && getState().conversationPagination.isLoadingMore) return;
        if (isInitialLoad) experienceTracker.start({
            id: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD,
            name: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD
        });
        else experienceTracker.start({
            id: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS,
            name: (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS
        });
        // Capture conversation IDs before API call to detect changes during the call
        const conversationsBeforeAPICall = new Set(Object.keys(getState().conversations));
        let conversationChannelsResponse;
        try {
            conversationChannelsResponse = await assistanceService.getConversationChannels({
                limit: (0, $awqa1.CONVERSATION_LIST_PAGE_SIZE)
            });
        } catch (error) {
            if (isInitialLoad && (0, $iDrrr.fg)('rovo_chat_non_blocking_conversation_history_failure')) setState({
                isConversationsInitialized: true,
                conversationPagination: {
                    ...getState().conversationPagination,
                    isLoadingMore: false,
                    loadMoreError: null
                }
            });
            throw error;
        }
        const channelsFromAPI = conversationChannelsResponse.items;
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const channelIds = new Set(channelsFromAPI.map((channel)=>channel.id));
        // Identify conversations deleted during the API call (were there before but aren't now)
        const conversationsDeletedDuringCall = new Set(Array.from(conversationsBeforeAPICall).filter((id)=>!conversations[id] && !(0, $1IZrU.isEmptyConversation)(id)));
        // Identify conversations created during the API call (exist in state but weren't there before and aren't in API response)
        const conversationsCreatedDuringCall = new Set(Object.keys(conversations).filter((id)=>!conversationsBeforeAPICall.has(id) && !channelIds.has(id)));
        // Preserve all local conversations not yet on the server
        // (they may have just finished processing or be in-flight)
        // e.g. optimistic conversation when URL params are used to open a chat
        const optimisticConversationsToPreserve = new Set(Object.keys(conversations).filter((id)=>!channelIds.has(id) && !(0, $1IZrU.isEmptyConversation)(id)));
        const conversationIdsToPreserve = new Set([
            ...conversationsCreatedDuringCall,
            ...optimisticConversationsToPreserve
        ]);
        const conversationsToPreserve = Object.fromEntries(Array.from(conversationIdsToPreserve, (id)=>[
                id,
                conversations[id]
            ]));
        const processedChannels = (0, $9bLpG.getProcessedConversationChannels)({
            channelsFromAPI: channelsFromAPI,
            conversations: conversations,
            conversationsDeletedDuringCall: conversationsDeletedDuringCall
        });
        (0, $hQJOO.mergeConversationChannelTasks)(channelsFromAPI, unifiedTasksActions);
        // Hydrate the store with the fetched conversation channels
        // whilst preserving the empty state and and any conversations created during the API call, so drafts are never lost
        // due to rehydration (e.g window refocus) when this is called
        setState({
            conversations: {
                EMPTY_CONVERSATION_ID: conversations[0, $4m5jb.EMPTY_CONVERSATION_ID],
                ...processedChannels,
                ...conversationsToPreserve
            },
            isConversationsInitialized: true,
            conversationPagination: {
                ...getState().conversationPagination,
                nextCursor: conversationChannelsResponse.cursor,
                hasMore: conversationChannelsResponse.hasNext,
                isLoadingMore: false,
                loadMoreError: null
            }
        });
        if (isInitialLoad && (0, $iDrrr.fg)('rovo_chat_conversation_search_pagination') && getState().conversationPagination.isConversationListMounted) dispatch((0, $iWQjF.loadMoreConversationChannelsData)());
        const currentConversationDeleted = !(0, $1IZrU.isEmptyConversation)(currentConversationId) && !channelIds.has(currentConversationId) && !conversationIdsToPreserve.has(currentConversationId);
        if (currentConversationDeleted && !isInitialLoad) dispatch((0, $c8Sl1.setSelectedConversation)({
            conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
        }));
        const selectedConversationTasks = channelsFromAPI.find((channel)=>channel.id === currentConversationId)?.tasks ?? [];
        const shouldRestoreTaskMode = selectedConversationTasks.some((task)=>!(0, $igOtY.isTerminalTaskState)((0, $7H855.mapApiTaskStatusToProgressState)(task.status)));
        if (isInitialLoad && (0, $iDrrr.fg)('rovo_chat_enable_tasks') && shouldRestoreTaskMode) dispatch((0, $eQl6Z.restoreTaskModeIfNeeded)());
        experienceTracker.succeed({
            name: isInitialLoad ? (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS
        });
    }, {
    experienceName: (args)=>args?.[0]?.isInitialLoad ? (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $irnO2.ExperienceName).GET_CONVERSATION_CHANNELS,
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        if (args.isInitialLoad) {
            if ((0, $iDrrr.fg)('rovo_chat_non_blocking_conversation_history_failure')) {
                context.containerProps.showFlag?.((0, $idzM5.StoreErrorFlagId).CONVERSATION_HISTORY_LOAD_FAILED);
                return undefined;
            }
            return {
                proceedToDefaultHandling: true
            };
        }
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
module.exports["fetchConversationChannelsData"] = $7dc4b12cf023d92e$export$767e11ac0b9abe0b;

});

parcelRegister("7H855", function(module, exports) {
// ─── API status → progress state mapping ──────────────────────────────────────
const $c0fc28e9ab853b0e$var$API_STATUS_TO_PROGRESS_STATE = {
    DRAFT: 'Draft',
    QUEUED: 'Queued',
    RUNNING: 'Running',
    AWAITING_DISAMBIGUATION: 'AwaitingDisambiguation',
    AWAITING_PLAN_CONFIRMATION: 'AwaitingPlanConfirmation',
    AWAITING_ACTION_CONFIRMATION: 'AwaitingActionConfirmation',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled'
};
const $c0fc28e9ab853b0e$export$f0ca788f58c1a6a9 = (status)=>$c0fc28e9ab853b0e$var$API_STATUS_TO_PROGRESS_STATE[status];
const $c0fc28e9ab853b0e$export$d5ce4d18fe97a26a = (existing, incoming)=>{
    if (!incoming || incoming.length === 0) return existing ?? null;
    if (!existing || existing.length === 0) return incoming;
    const toMs = (iso)=>new Date(iso).getTime();
    const incomingRanges = incoming.map((seg)=>({
            start: toMs(seg.startedAt),
            end: seg.endedAt ? toMs(seg.endedAt) : Date.now()
        }));
    const overlaps = (seg)=>{
        const start = toMs(seg.startedAt);
        const end = seg.endedAt ? toMs(seg.endedAt) : Date.now();
        return incomingRanges.some((r)=>start < r.end && end > r.start);
    };
    const retained = existing.filter((seg)=>!overlaps(seg));
    const merged = [
        ...retained,
        ...incoming
    ];
    return merged.sort((a, b)=>toMs(a.startedAt) - toMs(b.startedAt));
};
module.exports["mapApiTaskStatusToProgressState"] = $c0fc28e9ab853b0e$export$f0ca788f58c1a6a9;
module.exports["mergeExecutionSegments"] = $c0fc28e9ab853b0e$export$d5ce4d18fe97a26a;

});

parcelRegister("idzM5", function(module, exports) {
var $f43618a8171c9b35$export$33c7ec07de4be904 = /*#__PURE__*/ function(StoreErrorFlagId) {
    StoreErrorFlagId["CONVERSATION_FORBIDDEN"] = "conversationForbidden";
    StoreErrorFlagId["CONVERSATION_HISTORY_LOAD_FAILED"] = "conversationHistoryLoadFailed";
    StoreErrorFlagId["FOLLOW_UP_AGENT_UNAVAILABLE"] = "followUpAgentUnavailable";
    return StoreErrorFlagId;
}({});
module.exports["StoreErrorFlagId"] = $f43618a8171c9b35$export$33c7ec07de4be904;

});

parcelRegister("3Cuhs", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

const $14776b99fc344204$export$2813a13604911e2d = (messages)=>{
    try {
        const last = (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreAssistant));
        return last?.content.message.message.id;
    } catch  {
        return undefined;
    }
};
module.exports["getLastAgentMessageID"] = $14776b99fc344204$export$2813a13604911e2d;

});

parcelRegister("2g97a", function(module, exports) {
// findLast polyfill since it's a newer ECMAScript feature.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLast
// The type-guard overload lets callers narrow the result (e.g. to a specific
// StoreChatItem subtype) without an intermediate array allocation.
function $b4936b98e2cb53b7$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return array[i];
    }
    return undefined;
}
module.exports["findLast"] = $b4936b98e2cb53b7$export$296de88ccac4bedb;

});

parcelRegister("gDq7w", function(module, exports) {
/**
 * Per the AI Feature Instrumentation for KRs contract with DE/DS. Two maps live here so JSM can
 * own eligibility in one file; they must stay separate:
 *
 * - MCI_KR_VIEW_KEY_CONFIG tags `aiResult viewed` via substring match on skill/minion/plugin/
 *   agent identifiers.
 * - MCI_KR_ACTION_KEY_CONFIG tags `aiResult actioned` via exact `actionKey` match.
 *
 * Do not add action keys to MCI_KR_VIEW_KEY_CONFIG (that would tag viewed). Do not feed action
 * keys through mciKrAttributes (substring).
 */ const $8000f26bd38f9a67$export$cdc6e1684c356a17 = {
    // Agent example — matched via agentExternalConfigReference
    jsm_example_agent: {
        serviceOrOps: 'ops',
        countsTowardMciPlusKr: true
    },
    // Skill example — matches any skill/minion name containing this substring
    jsm_atlassian_work_item: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    SurveysStratusMinion: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    jsm_service_triage_agent: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    }
};
const $8000f26bd38f9a67$export$2645f5d97480779e = {
    // Request type
    'jsm-atlassian-project-create-jsm-request-type': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-create-jsm-request-type-with-fields': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    SuggestAndAddFieldsToRequestType: {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-update-request-type-groups': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-request-type-update-workflow': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    // Queue
    'jsm-atlassian-project-create-jsm-queue': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-update-jsm-queue': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-create-jsm-queue-group': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    },
    'jsm-atlassian-project-update-jsm-queue-group': {
        serviceOrOps: 'service',
        countsTowardMciPlusKr: true,
        countsTowardAiAdoptedKr: true
    }
};
module.exports["MCI_KR_VIEW_KEY_CONFIG"] = $8000f26bd38f9a67$export$cdc6e1684c356a17;
module.exports["MCI_KR_ACTION_KEY_CONFIG"] = $8000f26bd38f9a67$export$2645f5d97480779e;

});

parcelRegister("0Z0Rs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $e700b04a04ad8a25$var$PEOPLE_DATA_PROVIDERS = [
    'workday',
    'google',
    'microsoft',
    's3'
];
const $e700b04a04ad8a25$export$9b478e9fdb4d3297 = (value)=>{
    if (!(0, $iDrrr.fg)('kd_chat_people_data_attribution') || !Array.isArray(value)) return [];
    return $e700b04a04ad8a25$var$PEOPLE_DATA_PROVIDERS.filter((provider)=>value.includes(provider));
};
const $e700b04a04ad8a25$export$a94f218d6da72e0c = (peopleDataProviders)=>peopleDataProviders.length > 0 ? {
        peopleDataProviders: peopleDataProviders
    } : {};
module.exports["getPeopleDataProviders"] = $e700b04a04ad8a25$export$9b478e9fdb4d3297;
module.exports["getPeopleDataProviderAttributes"] = $e700b04a04ad8a25$export$a94f218d6da72e0c;

});

parcelRegister("gYfOr", function(module, exports) {
const $6473a3daf4438662$var$getCreatedContentActionData = (action)=>action.data;
const $6473a3daf4438662$export$32f3c2791170494a = (action)=>$6473a3daf4438662$var$getCreatedContentActionData(action)?.title ?? '';
const $6473a3daf4438662$export$1b968a6b473955a8 = (action)=>String($6473a3daf4438662$var$getCreatedContentActionData(action)?.contentId ?? '');
module.exports["getActionTitle"] = $6473a3daf4438662$export$32f3c2791170494a;
module.exports["getActionContentId"] = $6473a3daf4438662$export$1b968a6b473955a8;

});

parcelRegister("8HiCX", function(module, exports) {

var $aYC8J = parcelRequire("aYC8J");


var $227OX = parcelRequire("227OX");


var $xHMAX = parcelRequire("xHMAX");

const $49b0295f9e03a8e5$var$VISUAL_BLOCK_COUNT_READERS = {
    [(0, $aYC8J.CONFLUENCE_AIFC_PAGE_CREATE_KEY)]: (0, $xHMAX.getGeneratedVisualBlockCounts),
    [(0, $aYC8J.AIFC_ADF_UPDATE_KEY)]: (0, $227OX.getGeneratedEditVisualBlockCounts)
};
const $49b0295f9e03a8e5$export$a93b18d138b56033 = (actions)=>{
    const countedActions = actions?.filter((action)=>action.key in $49b0295f9e03a8e5$var$VISUAL_BLOCK_COUNT_READERS) ?? [];
    if (countedActions.length !== 1) return {};
    const [action] = countedActions;
    return $49b0295f9e03a8e5$var$VISUAL_BLOCK_COUNT_READERS[action.key](action.data);
};
module.exports["getMessageVisualBlockCounts"] = $49b0295f9e03a8e5$export$a93b18d138b56033;

});

parcelRegister("227OX", function(module, exports) {
const $4436df5a88378ecf$var$EDIT_VISUAL_BLOCK_COUNT_FIELDS = [
    'imageBlocks',
    'mauiAppBlocks',
    'addedImageBlocks',
    'replacedImageBlocks',
    'removedImageBlocks',
    'addedMauiAppBlocks',
    'replacedMauiAppBlocks',
    'removedMauiAppBlocks'
];
const $4436df5a88378ecf$var$isBlockCount = (value)=>typeof value === 'number' && Number.isInteger(value) && value >= 0;
const $4436df5a88378ecf$export$a772cea504bc7eb9 = (data)=>{
    if (typeof data !== 'object' || data === null) return {};
    const record = data;
    if (!$4436df5a88378ecf$var$EDIT_VISUAL_BLOCK_COUNT_FIELDS.every((field)=>$4436df5a88378ecf$var$isBlockCount(record[field]))) return {};
    return Object.fromEntries($4436df5a88378ecf$var$EDIT_VISUAL_BLOCK_COUNT_FIELDS.map((field)=>[
            field,
            record[field]
        ]));
};
module.exports["getGeneratedEditVisualBlockCounts"] = $4436df5a88378ecf$export$a772cea504bc7eb9;

});

parcelRegister("xHMAX", function(module, exports) {
/**
 * Counts of generated visuals present in the final page, set by the backend on the terminal
 * page-create payload only. `0` means the type was eligible but none made it into the page; an
 * absent field means not eligible or unknown (experiment off, legacy payload, older backend).
 */ const $f91c4efe5f5a8ac7$var$isBlockCount = (value)=>typeof value === 'number' && Number.isInteger(value) && value >= 0;
const $f91c4efe5f5a8ac7$export$eafbc574ea4b5a42 = (data)=>{
    if (typeof data !== 'object' || data === null) return {};
    const { imageBlocks: imageBlocks, mauiAppBlocks: mauiAppBlocks } = data;
    return {
        ...$f91c4efe5f5a8ac7$var$isBlockCount(imageBlocks) && {
            imageBlocks: imageBlocks
        },
        ...$f91c4efe5f5a8ac7$var$isBlockCount(mauiAppBlocks) && {
            mauiAppBlocks: mauiAppBlocks
        }
    };
};
module.exports["getGeneratedVisualBlockCounts"] = $f91c4efe5f5a8ac7$export$eafbc574ea4b5a42;

});

parcelRegister("4eyID", function(module, exports) {
const $5c37fa1bb8ea7f45$export$48acf215f1610b8e = (sources)=>{
    const connectorInfo = sources?.map((source)=>{
        const { ari: ari } = source;
        const { provider_id: provider_id, datasource_id: datasource_id, connector_product: connector_product, connector_type: connector_type, searchRetrievalType: searchRetrievalType, sourceProduct: sourceProduct } = source.connector_info ?? source.connectorInfo ?? {};
        if (!provider_id && !connector_product && !connector_type && !searchRetrievalType && !sourceProduct) return undefined;
        return {
            ...ari && {
                ari: ari
            },
            ...provider_id && {
                provider_id: provider_id
            },
            ...datasource_id && {
                datasource_id: datasource_id
            },
            ...connector_product && {
                connector_product: connector_product
            },
            ...connector_type && {
                connector_type: connector_type
            },
            ...searchRetrievalType && {
                search_retrieval_type: searchRetrievalType
            },
            ...sourceProduct && {
                source_product: sourceProduct
            }
        };
    }).filter((value)=>Boolean(value));
    return connectorInfo?.length ? connectorInfo : undefined;
};
module.exports["extractConnectorInfo"] = $5c37fa1bb8ea7f45$export$48acf215f1610b8e;

});

parcelRegister("4BHwn", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $fjUOt = parcelRequire("fjUOt");

const $ed14f64875699056$export$64b557ae352795d6 = (chat, messageId)=>chat.findIndex((storeMessage)=>(0, $igOtY.isStoreMessage)(storeMessage) && (messageId ? (0, $fjUOt.getStoreMessageId)(storeMessage) === messageId : true));
module.exports["findStoreMessageIndex"] = $ed14f64875699056$export$64b557ae352795d6;

});

parcelRegister("foVqg", function(module, exports) {

var $2yWJZ = parcelRequire("2yWJZ");

const $fe75fa81a4258faa$var$normalizeString = (value)=>typeof value === 'string' && value.trim() ? value.trim() : undefined;
const $fe75fa81a4258faa$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $fe75fa81a4258faa$export$5e9f4827a7d04fed = (storeAssistant)=>{
    if (storeAssistant?.type !== 'ASSISTANT') return undefined;
    const message = storeAssistant?.content?.message?.message;
    if (!$fe75fa81a4258faa$var$isRecord(message) || message.role !== 'ASSISTANT') return undefined;
    const author = $fe75fa81a4258faa$var$isRecord(message.author) ? message.author : undefined;
    const canonicalAgentId = $fe75fa81a4258faa$var$normalizeString(author?.id);
    const identityAccountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)($fe75fa81a4258faa$var$normalizeString(author?.ari));
    if (!canonicalAgentId) return undefined;
    return {
        id: canonicalAgentId,
        ...identityAccountId ? {
            identityAccountId: identityAccountId
        } : {}
    };
};
module.exports["deriveFollowUpSendAgentIdentity"] = $fe75fa81a4258faa$export$5e9f4827a7d04fed;

});

parcelRegister("kNXXO", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

const $02966cdc09a260a9$export$24c718731d9a7b6a = (messages, predicate)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $igOtY.isStoreAssistant)(msg)) {
            const actionParts = msg.content.message?.message?.actions ?? [];
            const action = (0, $2g97a.findLast)(actionParts, predicate);
            if (action) return action;
        }
    }
    return undefined;
};
module.exports["findLastAssistantAction"] = $02966cdc09a260a9$export$24c718731d9a7b6a;

});

parcelRegister("9vNm5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

/**
 * States that end the run's turn. Once a record reaches one, later emits on the same conversation are
 * ignored so a trailing backend event can't revive it. `needs-input` is excluded: the run pauses for
 * the user and resumes on the same conversation, so a follow-up state must still apply.
 */ const $a9d5e82290950109$var$TURN_END_STATES = new Set([
    'done',
    'failed',
    'blocked'
]);
/**
 * States where a turn is in flight. A run left in one of these when its stream ends (abort, timeout,
 * dropped request) never settled and should be cleared. `needs-input` is a valid resting state, so
 * it is not here.
 */ const $a9d5e82290950109$var$ACTIVE_STATES = new Set([
    'thinking',
    'working',
    'editing'
]);
const $a9d5e82290950109$var$store = (0, $8s9DV.createStore)({
    name: 'agentMentionRunState',
    initialState: {
        runByConversationId: {}
    },
    actions: {
        setRun: (conversationId, record)=>({ setState: setState, getState: getState })=>{
                setState({
                    runByConversationId: {
                        ...getState().runByConversationId,
                        [conversationId]: record
                    }
                });
            },
        clearRun: (conversationId)=>({ setState: setState, getState: getState })=>{
                const next = {
                    ...getState().runByConversationId
                };
                delete next[conversationId];
                setState({
                    runByConversationId: next
                });
            }
    }
});
const $a9d5e82290950109$var$getRun = (conversationId)=>(0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).storeState.getState().runByConversationId[conversationId];
const $a9d5e82290950109$var$applyRun = (conversationId, record)=>{
    (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.setRun(conversationId, record);
};
const $a9d5e82290950109$export$942c558e1f0d1197 = (conversationId, localId)=>{
    if (!conversationId || !localId) return;
    const runs = (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).storeState.getState().runByConversationId;
    Object.keys(runs).forEach((priorConversationId)=>{
        if (priorConversationId !== conversationId && runs[priorConversationId].invokedByNodeLocalId === localId) (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.clearRun(priorConversationId);
    });
    $a9d5e82290950109$var$applyRun(conversationId, {
        state: 'working',
        invokedByNodeLocalId: localId
    });
};
const $a9d5e82290950109$export$26a3487b4a5c9ed7 = (conversationId, runState)=>{
    const current = $a9d5e82290950109$var$getRun(conversationId);
    if (!current || $a9d5e82290950109$var$TURN_END_STATES.has(current.state)) return;
    if (current.state === runState) // Same state re-emitted (the stream reports e.g. `working`/`editing` more than once) — nothing
    // changed, so skip the write
    return;
    $a9d5e82290950109$var$applyRun(conversationId, {
        ...current,
        state: runState
    });
};
const $a9d5e82290950109$export$b1e88479c5d1c49d = (conversationId)=>{
    if (!conversationId) return;
    (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.clearRun(conversationId);
};
const $a9d5e82290950109$export$8feb5c3fccc062d8 = (conversationId)=>{
    const current = $a9d5e82290950109$var$getRun(conversationId);
    if (current && $a9d5e82290950109$var$ACTIVE_STATES.has(current.state)) (0, $c6StJ.defaultRegistry).getStore($a9d5e82290950109$var$store).actions.clearRun(conversationId);
};
// Some invocation paths insert the prompt as a draft, so the user sends it manually and the invoking
// node localId can't ride the send call. Stash it when the chat is opened; the send action consumes
// it when the run actually starts.
let $a9d5e82290950109$var$pendingInvocationLocalId = null;
const $a9d5e82290950109$export$6e28f2eaa4376143 = (localId)=>{
    $a9d5e82290950109$var$pendingInvocationLocalId = localId || null;
};
const $a9d5e82290950109$export$77f394cf411f3457 = ()=>{
    const localId = $a9d5e82290950109$var$pendingInvocationLocalId;
    $a9d5e82290950109$var$pendingInvocationLocalId = null;
    return localId;
};
// Wrapped in explicitly-typed functions so the public API satisfies --isolatedDeclarations.
const $a9d5e82290950109$var$useRunsInternal = (0, $kBr4q.createStateHook)($a9d5e82290950109$var$store, {
    selector: (state)=>state.runByConversationId
});
const $a9d5e82290950109$var$useRunStateForConversationInternal = (0, $kBr4q.createStateHook)($a9d5e82290950109$var$store, {
    selector: (state, conversationId)=>state.runByConversationId[conversationId]?.state
});
const $a9d5e82290950109$var$useRunStateForNodeInternal = (0, $kBr4q.createStateHook)($a9d5e82290950109$var$store, {
    selector: (state, localId)=>Object.values(state.runByConversationId).find((r)=>r.invokedByNodeLocalId === localId)?.state
});
const $a9d5e82290950109$export$287e00800c881bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $a9d5e82290950109$var$useRunsInternal();
} : ()=>$a9d5e82290950109$var$useRunsInternal();
const $a9d5e82290950109$export$64d7c3f05a87cb99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    return $a9d5e82290950109$var$useRunStateForConversationInternal(conversationId);
} : (conversationId)=>$a9d5e82290950109$var$useRunStateForConversationInternal(conversationId);
const $a9d5e82290950109$export$160dcbab0bbffcf5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (localId)=>{
    return $a9d5e82290950109$var$useRunStateForNodeInternal(localId);
} : (localId)=>$a9d5e82290950109$var$useRunStateForNodeInternal(localId);
module.exports["beginAgentRun"] = $a9d5e82290950109$export$942c558e1f0d1197;
module.exports["notifyAgentRunStateForConversation"] = $a9d5e82290950109$export$26a3487b4a5c9ed7;
module.exports["endActiveAgentRun"] = $a9d5e82290950109$export$8feb5c3fccc062d8;
module.exports["stashAgentRunInvocation"] = $a9d5e82290950109$export$6e28f2eaa4376143;
module.exports["consumeAgentRunInvocation"] = $a9d5e82290950109$export$77f394cf411f3457;
module.exports["useAgentRuns"] = $a9d5e82290950109$export$287e00800c881bcb;

});

parcelRegister("hNzKs", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $hq9Cp = parcelRequire("hq9Cp");

const $3449bf794213f362$export$39b613e1a7c67d40 = (creatorType)=>{
    if (creatorType) return (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType);
    return (0, $4o0zT.isExperimentEnabled)('rovo_chat_details_preprocess_unknown_agent');
};
module.exports["shouldPreprocessDetailsForCreatorType"] = $3449bf794213f362$export$39b613e1a7c67d40;

});

parcelRegister("dHz2q", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gXfti = parcelRequire("gXfti");


var $dTEBe = parcelRequire("dTEBe");


var $6rwn6 = parcelRequire("6rwn6");


var $irnO2 = parcelRequire("irnO2");


var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $oV0CU = parcelRequire("oV0CU");

const $40c25f53fe39b33d$export$1afac255ab1e880e = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const lastMessageSentAt = localStorage.getItem((0, $oV0CU.LS_LAST_MESSAGE_SENT_AT));
    if (!lastMessageSentAt) return null;
    const timestamp = parseInt(lastMessageSentAt);
    if (isNaN(timestamp)) return null;
    return timestamp;
};



var $b2pOf = parcelRequire("b2pOf");


var $djNSU = parcelRequire("djNSU");


var $l6xCb = parcelRequire("l6xCb");




const $7b5c7e5fb885c250$export$69a500a38d2b93ab = ()=>{
    return 0, $oV0CU.SHORTER_TIMEOUT_BEFORE_NEW_CHAT;
};



var $1IZrU = parcelRequire("1IZrU");




const $fc5e957f3a72b1d1$export$b77ba8e4ec693266 = (jsonString)=>{
    try {
        const parsed = JSON.parse(jsonString);
        if ((0, $6rwn6.isAdfContent)(parsed)) return true;
        return false;
    } catch  {
        return false;
    }
};



var $58Xbw = parcelRequire("58Xbw");


var $6geN3 = parcelRequire("6geN3");


var $c8Sl1 = parcelRequire("c8Sl1");




const $c390b46d98b6474a$export$1b532e69dded7033 = (hasConsumedPreserveIntent, currentConversationId, inMemoryConversation)=>{
    if (!hasConsumedPreserveIntent || !currentConversationId || currentConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID)) return false;
    return Boolean(inMemoryConversation);
};





const $e2f5ab4cfced7f8a$export$cb6ccc30d1a390cc = (currentConversationId, inMemoryConversation)=>{
    if (!currentConversationId || currentConversationId === (0, $4m5jb.EMPTY_CONVERSATION_ID)) return false;
    return Boolean(inMemoryConversation?.rovoSpaceId);
};


const $359ad6370a73004a$export$f8c82f179628191f = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).hydrateConversation, ({ autoSelectConversation: autoSelectConversation, forceRestoreConversationId: forceRestoreConversationId })=>async ({ getState: getState, dispatch: dispatch }, { siteId: siteId, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setChatStatus: setChatStatus, initChatInitiator: initChatInitiator, insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder, setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, setInvocationIdSelectedForPreview: setInvocationIdSelectedForPreview, preserveUrlConversationId: preserveUrlConversationId })=>{
        const hasConsumedModeSwitchPreserveIntent = (0, $58Xbw.modeSwitchConversationPreservation).consume();
        const shouldConsiderModeSwitchPreservation = hasConsumedModeSwitchPreserveIntent;
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION,
            name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
        });
        // An explicit modal-open target must win over the ambient
        // restorability/expiry heuristics below -- even when they would
        // otherwise select a different (or empty) conversation.
        if (forceRestoreConversationId) {
            const hasLocalTarget = Boolean(getState().conversations[forceRestoreConversationId]);
            if (getState().currentConversationId !== forceRestoreConversationId) dispatch(hasLocalTarget ? (0, $c8Sl1.setSelectedConversation)({
                conversationId: forceRestoreConversationId
            }) : (0, $djNSU.createConversationOptimistically)({
                id: forceRestoreConversationId
            }));
            (0, $gXfti.addUFOCustomData)({
                isEmptyConversation: !hasLocalTarget
            });
            setChatStatus('online');
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
            });
            return;
        }
        const rovoParamsUnsanitized = (0, $dTEBe.getRovoParams)();
        const rovoParams = Object.fromEntries(Object.entries(rovoParamsUnsanitized).filter(([, v])=>v !== 'undefined'));
        let initWithParams = autoSelectConversation && rovoParams.pathway === 'chat';
        const { currentConversationId: currentConversationId } = getState();
        if (rovoParams.stagingAreaOpen) {
            // Dedicated deep-link launch signal — attributable separately from
            // other smart-create openings so we can measure deep-link launch
            // volume and drop-off before the staging-area view.
            const deepLinkAttributes = {
                entryPoint: 'queryParamDeepLink',
                ...rovoParams.conversationId && {
                    conversationId: rovoParams.conversationId
                },
                ...rovoParams.messageIdSelectedForPreview && {
                    messageId: rovoParams.messageIdSelectedForPreview
                },
                ...rovoParams.invocationIdSelectedForPreview && {
                    invocationId: rovoParams.invocationIdSelectedForPreview
                },
                sourceUrlMode: 'queryParam'
            };
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).AIFC_DEEP_LINK_LAUNCH,
                id: (0, $irnO2.ExperienceName).AIFC_DEEP_LINK_LAUNCH,
                attributes: {
                    source: 'hydrateConversationWithExternalParams',
                    ...deepLinkAttributes
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                actionSubject: 'aifcDeepLink',
                action: 'launched',
                attributes: deepLinkAttributes
            });
            setStagingAreaMode('inline', 'queryParamDeepLink');
            (0, $dTEBe.updatePageRovoParams)({
                stagingAreaOpen: undefined
            });
        }
        if (rovoParams.messageIdSelectedForPreview) {
            setMessageIdSelectedForPreview(rovoParams.messageIdSelectedForPreview);
            (0, $dTEBe.updatePageRovoParams)({
                messageIdSelectedForPreview: undefined
            });
            // Start experience on Home side — the originating tab (e.g. Bitbucket) can't track it cross-tab.
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
                id: rovoParams.messageIdSelectedForPreview,
                timeout: 30000,
                attributes: {
                    source: 'hydrateConversationWithExternalParams',
                    restoredFromUrl: true,
                    messageId: rovoParams.messageIdSelectedForPreview,
                    ...rovoParams.invocationIdSelectedForPreview && {
                        invocationId: rovoParams.invocationIdSelectedForPreview
                    }
                }
            });
        }
        if (rovoParams.invocationIdSelectedForPreview) {
            setInvocationIdSelectedForPreview?.(rovoParams.invocationIdSelectedForPreview);
            (0, $dTEBe.updatePageRovoParams)({
                invocationIdSelectedForPreview: undefined
            });
        }
        if (rovoParams.triggerOpen) // if the rovo chat was actually open with url param
        initChatInitiator(rovoParams.initiator);
        // Process params as a priority
        if (initWithParams) {
            const rovoJourneyId = (0, $iDrrr.fg)('rovo_search_chat_convergence_instrumentation') && rovoParams.conversationId && rovoParams.rovoJourneyId ? rovoParams.rovoJourneyId : undefined;
            if (rovoParams.prompt) // URL prompts are one-shot inputs. Remove the prompt before selecting,
            // creating, or sending so any Appification remount reads a URL with no
            // prompt left to replay.
            (0, $dTEBe.updatePageRovoParams)({
                prompt: undefined,
                insertPrompt: undefined
            }, {
                historyMode: 'replace'
            });
            const localConversation = rovoParams.conversationId ? getState().conversations[rovoParams.conversationId] : undefined;
            if (rovoParams.conversationId && localConversation) {
                if (rovoJourneyId) dispatch((0, $6geN3.setConversationData)({
                    conversationId: rovoParams.conversationId,
                    data: {
                        rovoJourneyId: rovoJourneyId
                    }
                }));
                dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: rovoParams.conversationId,
                    sourceAgentId: rovoParams.agentId
                }));
                if (!preserveUrlConversationId) // Clear conversationId from URL after consuming it so subsequent chat opens
                // don't reuse it and get stuck in the same conversation.
                (0, $dTEBe.updatePageRovoParams)({
                    conversationId: undefined
                }, {
                    historyMode: 'replace'
                });
            } else dispatch((0, $djNSU.createConversationOptimistically)({
                id: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId,
                ...rovoJourneyId ? {
                    rovoJourneyId: rovoJourneyId
                } : {}
            }));
            // Mark a deep-linked conversation as recently active
            // so later ambient hydrations restore it instead of resetting to empty.
            if ((0, $iDrrr.fg)('rovo_chat_mark_conversation_active_on_deeplink') && rovoParams.conversationId && (0, $b2pOf.getPersistedRecentConversationId)(siteId) === rovoParams.conversationId) (0, $b2pOf.persistRecentConversation)({
                type: 'message-sent',
                siteId: siteId,
                conversationId: rovoParams.conversationId,
                lastMessageSentAt: Date.now()
            });
            if (rovoParams.prompt) {
                // For cases where the prompt is a json string containing ADF, we need to parse it
                const shouldParse = (0, $fc5e957f3a72b1d1$export$b77ba8e4ec693266)(rovoParams.prompt);
                const prompt = shouldParse ? JSON.parse(rovoParams.prompt) : rovoParams.prompt;
                const urlPromptProvenance = {
                    source: 'url-param',
                    conversationId: getState().currentConversationId
                };
                if (rovoParams.insertPrompt === 'highlight-action') insertHighlightActionsEditorPlaceholder(prompt, urlPromptProvenance);
                else // Security (VULN-1804729): never auto-send a prompt supplied via the
                // `rovoChatPrompt` URL query param. A crafted link could otherwise inject
                // and one-click execute an arbitrary prompt as the signed-in user
                // (prompt injection / data exfiltration). Instead, pre-fill the prompt
                // into the chat input as an editable draft so the user must explicitly
                // review and send it, keeping a human in the loop.
                insertHighlightActionsEditorPlaceholder((0, $6rwn6.encodeAdf)(prompt, false, undefined, true), {
                    skipPlaceholderPrompt: true,
                    ...urlPromptProvenance
                });
            }
            // for UFO performance tracking dimensions
            (0, $gXfti.addUFOCustomData)({
                isEmptyConversation: !rovoParams.conversationId,
                hasInitialPrompt: !!rovoParams.prompt
            });
        } else if (autoSelectConversation) {
            if ((0, $c390b46d98b6474a$export$1b532e69dded7033)(shouldConsiderModeSwitchPreservation, currentConversationId, getState().conversations[currentConversationId ?? ''])) {
                // Scope the refetch-skip to exactly this mode-switch remount rather than
                // broadly skipping refetches on every mount: flag the preserved
                // conversation so the imminent ChatHistory getChat() is a one-shot no-op,
                // which avoids blanking the already-loaded messages and flashing the
                // "Reloading chat" spinner. `skipNextFetch` is consumed (reset to false)
                // by the very next fetchConversation, so it cannot suppress later,
                // legitimate fetches. `currentConversationId` is guaranteed non-empty here
                // by shouldPreserveConversationOnModeSwitch; the guard is just for TS.
                if (currentConversationId) dispatch((0, $6geN3.setConversationData)({
                    conversationId: currentConversationId,
                    data: {
                        skipNextFetch: true
                    }
                }));
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: false
                });
                setChatStatus('online');
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
                });
                return;
            }
            const timeoutBeforeNewChat = (0, $7b5c7e5fb885c250$export$69a500a38d2b93ab)();
            const isAssociationRestorationEnabled = (0, $b2pOf.isPersistedConversationRestorationEnabled)();
            // HOT-303866: a since-reverted change stored a stringified JSON object under
            // this key instead of a plain conversation ID. If we detect that corrupt object
            // shape, self-heal by overwriting the key and start a new conversation.
            const getSafeStoredConversationId = ()=>{
                const raw = (0, $b2pOf.getPersistedRecentConversationId)(siteId);
                if (!raw) return 0, $4m5jb.EMPTY_CONVERSATION_ID;
                let isCorruptObject = false;
                try {
                    const parsed = JSON.parse(raw);
                    isCorruptObject = typeof parsed === 'object' && parsed !== null;
                } catch  {
                // Not JSON — a plain conversation ID string, use it as-is.
                }
                if (isCorruptObject) {
                    (0, $b2pOf.persistRecentConversation)({
                        type: 'conversation-selected',
                        siteId: siteId,
                        conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                    });
                    return 0, $4m5jb.EMPTY_CONVERSATION_ID;
                }
                return raw;
            };
            const targetConversationId = getSafeStoredConversationId();
            // Preserve in-memory space chat across container remount.
            // See `shouldPreserveSpaceChatOnHydrate` for full rationale.
            if ((0, $e2f5ab4cfced7f8a$export$cb6ccc30d1a390cc)(currentConversationId, getState().conversations[currentConversationId ?? ''])) {
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: false
                });
                setChatStatus('online');
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
                });
                return;
            }
            const hasTargetChanged = targetConversationId !== currentConversationId;
            const isTargetConversationEmpty = (0, $1IZrU.isEmptyConversation)(targetConversationId);
            const hasLocalTargetConversation = Boolean(getState().conversations[targetConversationId]);
            if (isAssociationRestorationEnabled) {
                const isTargetRestorable = (0, $b2pOf.isPersistedConversationActivityRestorable)({
                    selectedConversationId: targetConversationId,
                    activity: (0, $b2pOf.getPersistedConversationActivity)(siteId),
                    now: Date.now(),
                    timeout: timeoutBeforeNewChat
                });
                if (!isTargetRestorable) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                }));
                else if (hasTargetChanged && hasLocalTargetConversation) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: targetConversationId
                }));
                else if (hasTargetChanged) dispatch((0, $djNSU.createConversationOptimistically)({
                    id: targetConversationId
                }));
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: !isTargetRestorable
                });
            } else {
                const lastMessageSentAt = (0, $40c25f53fe39b33d$export$1afac255ab1e880e)();
                const isTargetExpired = lastMessageSentAt && Date.now() - lastMessageSentAt >= timeoutBeforeNewChat;
                // start new conversation: if recent expired
                if (isTargetExpired) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                    clearLegacyLastMessageSentAt: true
                }));
                else if (hasTargetChanged && isTargetConversationEmpty) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID)
                }));
                else if (hasTargetChanged && hasLocalTargetConversation) dispatch((0, $c8Sl1.setSelectedConversation)({
                    conversationId: targetConversationId
                }));
                else if (hasTargetChanged) dispatch((0, $djNSU.createConversationOptimistically)({
                    id: targetConversationId
                }));
                // for UFO performance tracking dimensions
                (0, $gXfti.addUFOCustomData)({
                    isEmptyConversation: !isTargetExpired && hasTargetChanged
                });
            }
        }
        // Set online status later, to ensure that pubsub listener doesn't race condition with store init state
        setChatStatus('online');
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
        });
    }, {
    experienceName: ()=>(0, $irnO2.ExperienceName).HYDRATE_CONVERSATION
});
module.exports["hydrateConversationWithExternalParams"] = $359ad6370a73004a$export$f8c82f179628191f;

});

parcelRegister("58Xbw", function(module, exports) {
let $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = false;
const $eb5776e63adf4bb5$export$aaf1586aa3f2b604 = {
    mark: ()=>{
        $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = true;
    },
    consume: ()=>{
        const shouldPreserve = $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate;
        $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = false;
        return shouldPreserve;
    },
    clear: ()=>{
        $eb5776e63adf4bb5$var$preserveConversationOnNextHydrate = false;
    }
};
module.exports["modeSwitchConversationPreservation"] = $eb5776e63adf4bb5$export$aaf1586aa3f2b604;

});

parcelRegister("lUXDc", function(module, exports) {

var $dw75i = parcelRequire("dw75i");


var $igOtY = parcelRequire("igOtY");


var $aYC8J = parcelRequire("aYC8J");

const $f883fc6caf827ec4$var$getActions = (message)=>message.content?.message?.message?.actions ?? [];
const $f883fc6caf827ec4$var$isConfluenceCreateAction = (action)=>(0, $aYC8J.isConfluenceCreatableAction)({
        key: action.key
    });
const $f883fc6caf827ec4$var$isConfluenceEditAction = (action)=>(0, $aYC8J.isConfluenceUpdatableAction)({
        key: action.key
    });
const $f883fc6caf827ec4$var$getActionContentId = (action)=>{
    const data = action.data;
    const contentId = data?.contentId ?? data?.metadata?.contentId;
    return contentId === undefined ? undefined : String(contentId);
};
const $f883fc6caf827ec4$var$getPreviousAssistantActions = (messages, beforeIndex)=>{
    for(let i = beforeIndex - 1; i >= 0; i--){
        const message = messages[i];
        if (!(0, $igOtY.isStoreAssistant)(message)) continue;
        const actions = $f883fc6caf827ec4$var$getActions(message);
        if (actions.length) return actions;
    }
    return [];
};
const $f883fc6caf827ec4$var$getCreateMessageIndexByContentId = (messages, contentId)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const message = messages[i];
        if (!(0, $igOtY.isStoreAssistant)(message)) continue;
        const selectedAction = $f883fc6caf827ec4$var$getActions(message)[0];
        if (selectedAction && $f883fc6caf827ec4$var$isConfluenceCreateAction(selectedAction) && $f883fc6caf827ec4$var$getActionContentId(selectedAction) === contentId) return i;
    }
    return -1;
};
const $f883fc6caf827ec4$var$hasAskQuestionBeforeMessageAtIndex = (messages, messageIndex)=>$f883fc6caf827ec4$var$getPreviousAssistantActions(messages, messageIndex).some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
const $f883fc6caf827ec4$var$wasDisambiguationUsedOnCreation = (messages, contentId)=>{
    const selectedIndex = $f883fc6caf827ec4$var$getCreateMessageIndexByContentId(messages, contentId);
    if (selectedIndex < 0) return false;
    return $f883fc6caf827ec4$var$hasAskQuestionBeforeMessageAtIndex(messages, selectedIndex);
};
const $f883fc6caf827ec4$var$wasDisambiguationUsedOnEdit = (messages, contentId)=>{
    return messages.some((message, index)=>{
        if (!(0, $igOtY.isStoreAssistant)(message)) return false;
        const actions = $f883fc6caf827ec4$var$getActions(message);
        const hasMatchingEdit = actions.some((action)=>$f883fc6caf827ec4$var$isConfluenceEditAction(action) && $f883fc6caf827ec4$var$getActionContentId(action) === contentId);
        return hasMatchingEdit && $f883fc6caf827ec4$var$hasAskQuestionBeforeMessageAtIndex(messages, index);
    });
};
function $f883fc6caf827ec4$export$af0b9b8df489c05d({ messages: messages, contentId: contentId }) {
    if (!contentId) return {
        disambiguationUsedOnCreation: false,
        disambiguationUsedOnEdit: false
    };
    return {
        disambiguationUsedOnCreation: $f883fc6caf827ec4$var$wasDisambiguationUsedOnCreation(messages, contentId),
        disambiguationUsedOnEdit: $f883fc6caf827ec4$var$wasDisambiguationUsedOnEdit(messages, contentId)
    };
}
module.exports["getConfluenceResultAcceptanceAttributesForAskQuestion"] = $f883fc6caf827ec4$export$af0b9b8df489c05d;

});

parcelRegister("l2exp", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $8lhhf = parcelRequire("8lhhf");

/**
 * URL-based first-party (1P) vs third-party (3P) classifier for links found in
 * finalized CWR (Create With Rovo) ADF content.
 */ function $fc385e4b36cd85fa$export$8c4674ec524aaf2c(resourceUrl) {
    if (!resourceUrl) return false;
    // Coarse URL-substring buckets — kept bug-for-bug in sync with `getLinkType` in the Confluence source of truth.
    const isJira = resourceUrl.includes('/jira/') || resourceUrl.includes('/servicedesk/') || resourceUrl.includes('/helpcenter/') || resourceUrl.includes('/projects/');
    const isConfluence = resourceUrl.includes('/wiki/');
    const isBitbucket = resourceUrl.includes('bitbucket');
    const isOtherAtlassian = resourceUrl.includes('atlassian') || resourceUrl.includes('jira-dev');
    return isJira || isConfluence || isBitbucket || isOtherAtlassian;
}



var $8et9H = parcelRequire("8et9H");

const $55f222983c253e4b$var$countThirdPartySmartLink = (currentValue, url)=>{
    if (!url || (0, $fc385e4b36cd85fa$export$8c4674ec524aaf2c)(url)) return currentValue;
    const count3PSources = currentValue.count3PSources + 1;
    return {
        ...currentValue,
        count3PSources: count3PSources,
        has3PSources: true
    };
};
const $55f222983c253e4b$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            {
                const linkMark = node.marks?.find((mark)=>mark.type === 'link');
                const linkCount = linkMark ? currentValue.linkCount + 1 : currentValue.linkCount;
                const linkHref = typeof linkMark?.attrs?.href === 'string' ? linkMark.attrs.href : undefined;
                return $55f222983c253e4b$var$countThirdPartySmartLink({
                    ...currentValue,
                    textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                    wordCount: currentValue.wordCount + (0, $8et9H.wordCount)(node.text),
                    linkCount: linkCount
                }, linkHref);
            }
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
        case 'blockCard':
            return $55f222983c253e4b$var$countThirdPartySmartLink({
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            }, typeof node.attrs?.url === 'string' ? node.attrs.url : undefined);
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $55f222983c253e4b$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: [],
        // Initialised because the reducer only assigns these on a 3P hit — pages with zero/only-1P sources must still emit stable neutral values to Data Portal.
        has3PSources: false,
        count3PSources: 0
    };
    return (0, $4EPzQ.reduce)(adf, (currentValue, node)=>$55f222983c253e4b$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $55f222983c253e4b$export$a148305df2eb5487;

});

parcelRegister("6iQ4q", function(module, exports) {
const $1264174a0720175f$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC',
    actor_type: 'AGENT',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
module.exports["DEFAULT_AGENT"] = $1264174a0720175f$export$48783720d93c2d26;

});

parcelRegister("jb3zd", function(module, exports) {
/**
 * Enum representing the different lifecycle states of a message stream.
 */ var $d434bd349610b667$export$680ab500cb1105eb = /*#__PURE__*/ function(StreamLifecycleState) {
    StreamLifecycleState["SEND_CONTEXT_READY"] = "send-context-ready";
    StreamLifecycleState["COMPLETED"] = "completed";
    StreamLifecycleState["ERRORED"] = "errored";
    StreamLifecycleState["ABORTED"] = "aborted";
    return StreamLifecycleState;
}({});
module.exports["StreamLifecycleState"] = $d434bd349610b667$export$680ab500cb1105eb;

});

parcelRegister("Iv7dD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $10781fbd919b9a6a$var$REQUEST_TIMEOUT_MS = 300000;
const $10781fbd919b9a6a$var$ACK_TIMEOUT_MS = 30000;
const $10781fbd919b9a6a$var$MAX_REQUESTS = 100;
// Allow up to 2 ms of observed cross-context browser precision inversion.
// Keep larger ordering errors invalid rather than hiding them in successful latency.
const $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS = 2;
// Communicating browser contexts share a monotonic epoch; their relative time origins can differ.
// https://www.w3.org/TR/hr-time-3/#sec-time-origin
const $10781fbd919b9a6a$var$clock = ()=>performance.timeOrigin + performance.now();
class $10781fbd919b9a6a$export$4b2479447b785912 {
    mount(receiverId, contentId, supportsMeasurement) {
        if (!(0, $iDrrr.fg)('rovo_slides_ai_edit_latency')) return;
        this.targets.set(receiverId, {
            contentId: contentId,
            supportsMeasurement: supportsMeasurement
        });
        if (!this.observing) {
            this.observing = true;
            this.observeVisibility();
            this.doc?.addEventListener('visibilitychange', this.observeVisibility);
        }
    }
    unmount(receiverId) {
        this.targets.delete(receiverId);
        for (const [id, request] of this.requests)if (request.submissionReceiverIds.includes(receiverId) || [
            ...request.actions.values()
        ].some((action)=>action.receiverId === receiverId)) this.finish(id, 'cancelled');
    }
    begin({ editRequestId: editRequestId, editSubmittedAt: editSubmittedAt, inline: inline, contentId: contentId, emit: emit }) {
        if (!(0, $iDrrr.fg)('rovo_slides_ai_edit_latency')) return undefined;
        const id = editRequestId || crypto.randomUUID();
        if (this.requests.has(id)) return id;
        if (this.requests.size >= $10781fbd919b9a6a$var$MAX_REQUESTS) {
            const oldest = this.requests.keys().next().value;
            if (oldest) this.finish(oldest, 'missing_acknowledgement');
        }
        const receivedAt = this.now();
        const submittedAt = editSubmittedAt ?? receivedAt;
        const submissionTargets = [
            ...this.targets
        ].filter(([, target])=>contentId !== undefined && target.contentId === String(contentId));
        const firstHiddenAt = this.visibility.reduce((first, change, index)=>{
            const next = this.visibility[index + 1];
            return first ?? (change.hidden && (!next || next.at > submittedAt) ? Math.max(change.at, submittedAt) : undefined);
        }, undefined) ?? (this.doc?.visibilityState === 'hidden' ? submittedAt : undefined);
        this.requests.set(id, {
            submittedAt: submittedAt,
            entrypoint: inline ? 'inline' : 'chat',
            submissionReceiverIds: submissionTargets.map(([receiverId])=>receiverId),
            eligible: inline,
            inlineReceiverSupported: inline ? submissionTargets.some(([, target])=>target.supportsMeasurement === true) : undefined,
            senderSupported: !inline || Boolean(editRequestId && editSubmittedAt !== undefined),
            invalid: !Number.isFinite(submittedAt) || submittedAt - receivedAt > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS || receivedAt - submittedAt > $10781fbd919b9a6a$var$REQUEST_TIMEOUT_MS,
            failed: false,
            actions: new Map(),
            firstHiddenAt: firstHiddenAt,
            acknowledgementLagMs: 0,
            deadline: receivedAt + $10781fbd919b9a6a$var$REQUEST_TIMEOUT_MS,
            timer: setTimeout(()=>this.finish(id, 'missing_acknowledgement'), $10781fbd919b9a6a$var$REQUEST_TIMEOUT_MS),
            emit: emit
        });
        return id;
    }
    classify(id, kind) {
        const request = id ? this.requests.get(id) : undefined;
        if (!request || !id) return;
        if (kind === 'create') {
            clearTimeout(request.timer);
            this.requests.delete(id);
        } else request.eligible = true;
    }
    deliver(id, actionId, receiverId) {
        const request = id ? this.requests.get(id) : undefined;
        if (!request) return;
        request.eligible = true;
        if (!actionId) {
            request.invalid = true;
            return;
        }
        if (!request.actions.has(actionId)) request.actions.set(actionId, {
            receiverId: receiverId,
            supported: this.targets.get(receiverId)?.supportsMeasurement === true
        });
    }
    firstWrite(command) {
        const request = this.requests.get(command.editRequestId);
        const action = request?.actions.get(command.editActionId);
        if (!request || !action?.supported || action.receiverId !== command.senderId) return;
        if (!Number.isFinite(command.firstAppliedAt) || request.submittedAt - command.firstAppliedAt > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS || command.firstAppliedAt - this.now() > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS) {
            request.invalid = true;
            return;
        }
        request.firstAppliedAt = Math.min(request.firstAppliedAt ?? Infinity, command.firstAppliedAt);
        request.acknowledgementLagMs = Math.max(request.acknowledgementLagMs, this.now() - command.firstAppliedAt);
    }
    complete(command) {
        const request = this.requests.get(command.editRequestId);
        const action = request?.actions.get(command.editActionId);
        if (!request || !action?.supported || action.receiverId !== command.senderId || action.completion) return;
        const validCounts = [
            command.affectedSlideCount,
            command.changedChildElementCount
        ].every((count)=>Number.isSafeInteger(count) && count >= 0);
        if (![
            'success',
            'failure',
            'cancelled'
        ].includes(command.status) || !validCounts || !Number.isFinite(command.completedAt) || request.submittedAt - command.completedAt > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS || command.completedAt - this.now() > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS || command.firstAppliedAt !== undefined && command.firstAppliedAt - command.completedAt > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS) request.invalid = true;
        if (command.firstAppliedAt !== undefined) this.firstWrite({
            ...command,
            firstAppliedAt: command.firstAppliedAt
        });
        action.completion = command;
        request.acknowledgementLagMs = Math.max(request.acknowledgementLagMs, this.now() - command.completedAt);
        this.maybeFinish(command.editRequestId);
    }
    markFailed(id) {
        const request = id ? this.requests.get(id) : undefined;
        if (request) request.failed = true;
    }
    end(id, outcome) {
        const request = id ? this.requests.get(id) : undefined;
        if (!request || !id) return;
        request.terminal = request.terminal === 'failure' || request.terminal === 'cancelled' ? request.terminal : outcome;
        clearTimeout(request.timer);
        const now = this.now();
        request.deadline = Math.min(request.deadline, now + $10781fbd919b9a6a$var$ACK_TIMEOUT_MS);
        if (request.deadline <= now) {
            this.finish(id, 'missing_acknowledgement');
            return;
        }
        request.timer = setTimeout(()=>this.finish(id, 'missing_acknowledgement'), request.deadline - now);
        this.maybeFinish(id);
    }
    maybeFinish(id) {
        const request = this.requests.get(id);
        if (!request?.terminal) return;
        if ([
            ...request.actions.values()
        ].every((action)=>!action.supported || action.completion)) this.finish(id, request.terminal);
    }
    finish(id, fallback) {
        const request = this.requests.get(id);
        if (!request) return;
        this.requests.delete(id);
        clearTimeout(request.timer);
        if (!request.eligible) return;
        const actions = [
            ...request.actions.values()
        ];
        const supported = request.inlineReceiverSupported !== false && actions.every((action)=>action.supported);
        const completions = actions.flatMap((action)=>action.completion ? [
                action.completion
            ] : []);
        // Canvas snapshots count distinct changes across all actions in this request, per receiver.
        // Take each receiver's maximum because an earlier snapshot can arrive after a later one.
        const counts = new Map();
        for (const completion of completions){
            const previous = counts.get(completion.senderId);
            counts.set(completion.senderId, {
                slides: Math.max(previous?.slides ?? 0, completion.affectedSlideCount),
                children: Math.max(previous?.children ?? 0, completion.changedChildElementCount)
            });
        }
        const affectedSlideCount = [
            ...counts.values()
        ].reduce((total, count)=>total + count.slides, 0);
        const changedChildElementCount = [
            ...counts.values()
        ].reduce((total, count)=>total + count.children, 0);
        const completedAt = completions.length ? Math.max(...completions.map((completion)=>completion.completedAt)) : undefined;
        let outcome = fallback;
        if (request.failed || request.terminal === 'failure' || completions.some((completion)=>completion.status === 'failure')) outcome = 'failure';
        else if (request.terminal === 'cancelled' || completions.some((completion)=>completion.status === 'cancelled')) outcome = 'cancelled';
        else if (!request.senderSupported) outcome = 'unsupported_sender';
        else if (!supported) outcome = 'unsupported_receiver';
        else if (request.invalid || affectedSlideCount > 0 && request.firstAppliedAt === undefined || request.firstAppliedAt !== undefined && affectedSlideCount === 0 && completions.length === actions.length || completedAt !== undefined && request.firstAppliedAt !== undefined && request.firstAppliedAt - completedAt > $10781fbd919b9a6a$var$TIMESTAMP_PRECISION_MS) outcome = 'invalid_measurement';
        else if (fallback === 'success') outcome = request.firstAppliedAt === undefined ? 'no_edit' : 'success';
        const firstAppliedAt = request.firstAppliedAt;
        const validFirst = request.senderSupported && !request.invalid && firstAppliedAt !== undefined;
        const validFull = outcome === 'success' && completedAt !== undefined;
        // Normalize only after validating the precision bound, keeping first <= full and durations >= 0.
        const firstAppliedDurationMs = validFirst ? Math.max(0, firstAppliedAt - request.submittedAt) : undefined;
        const fullyAppliedDurationMs = validFull ? Math.max(firstAppliedDurationMs ?? 0, completedAt - request.submittedAt) : undefined;
        const endpoint = fullyAppliedDurationMs !== undefined ? request.submittedAt + fullyAppliedDurationMs : this.now();
        request.emit({
            outcome: outcome,
            entrypoint: request.entrypoint,
            protocolVersion: 1,
            protocolSupported: supported && request.senderSupported,
            alwaysVisible: request.firstHiddenAt === undefined || request.firstHiddenAt > endpoint,
            updateActionCount: actions.length,
            affectedSlideCount: Number.isSafeInteger(affectedSlideCount) ? affectedSlideCount : 0,
            changedChildElementCount: Number.isSafeInteger(changedChildElementCount) ? changedChildElementCount : 0,
            firstAppliedDurationMs: firstAppliedDurationMs,
            fullyAppliedDurationMs: fullyAppliedDurationMs,
            acknowledgementLagMs: !request.invalid && completions.length ? request.acknowledgementLagMs : undefined
        });
    }
    dispose() {
        for (const id of this.requests.keys())this.finish(id, 'cancelled');
        this.targets.clear();
        this.doc?.removeEventListener('visibilitychange', this.observeVisibility);
        this.observing = false;
        this.visibility = [];
    }
    constructor(now = $10781fbd919b9a6a$var$clock, doc = typeof document === 'undefined' ? undefined : document){
        this.now = now;
        this.doc = doc;
        this.requests = new Map();
        this.targets = new Map();
        this.visibility = [];
        this.observing = false;
        this.observeVisibility = ()=>{
            var _request;
            const at = this.now();
            const hidden = this.doc?.visibilityState === 'hidden';
            this.visibility.push({
                at: at,
                hidden: hidden
            });
            // Retain the state immediately before the oldest possible live request.
            while(this.visibility.length > 1 && this.visibility[1].at < at - $10781fbd919b9a6a$var$REQUEST_TIMEOUT_MS)this.visibility.shift();
            if (hidden) for (const request of this.requests.values())(_request = request).firstHiddenAt ?? (_request.firstHiddenAt = at);
        };
    }
}


const $bafa67289f501974$export$281c2cc4d003bae8 = new (0, $10781fbd919b9a6a$export$4b2479447b785912)();
module.exports["slidesAiEditLatency"] = $bafa67289f501974$export$281c2cc4d003bae8;

});

parcelRegister("bWtmp", function(module, exports) {
const $568eca473e5b7c46$export$22c007d0f0e64cc9 = 5;
module.exports["MAX_VISIBLE_SELECTED_WORK_ITEMS"] = $568eca473e5b7c46$export$22c007d0f0e64cc9;

});

parcelRegister("gxA6a", function(module, exports) {
const $3c4f0794e5b63717$var$BLOCK_NODE_TYPES = new Set([
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'codeBlock'
]);
const $3c4f0794e5b63717$var$getStringValue = (value)=>typeof value === 'string' ? value : '';
const $3c4f0794e5b63717$var$getLinkHref = (marks)=>{
    const linkMark = marks?.find((mark)=>mark.type === 'link');
    return $3c4f0794e5b63717$var$getStringValue(linkMark?.attrs?.href);
};
const $3c4f0794e5b63717$var$getExtensionPromptText = (attrs)=>{
    const parameters = attrs?.parameters;
    if (!parameters || typeof parameters !== 'object') return '';
    const parameterMap = parameters;
    const skillName = $3c4f0794e5b63717$var$getStringValue(parameterMap.slug) || $3c4f0794e5b63717$var$getStringValue(parameterMap.name);
    return skillName ? `/${skillName}` : '';
};
const $3c4f0794e5b63717$var$escapeMarkdownLinkText = (text)=>text.replace(/\\/g, '\\\\').replace(/]/g, '\\]');
const $3c4f0794e5b63717$var$escapeMarkdownLinkHref = (href)=>href.replace(/\\/g, '\\\\').replace(/\)/g, '\\)');
const $3c4f0794e5b63717$var$getTextNodePromptText = (node)=>{
    const text = node.text ?? '';
    const href = $3c4f0794e5b63717$var$getLinkHref(node.marks);
    if (!text && href) return href;
    if (!href || text === href) return text;
    return `[${$3c4f0794e5b63717$var$escapeMarkdownLinkText(text)}](${$3c4f0794e5b63717$var$escapeMarkdownLinkHref(href)})`;
};
const $3c4f0794e5b63717$var$extractFromNode = (node)=>{
    if (node.type === 'text') return $3c4f0794e5b63717$var$getTextNodePromptText(node);
    if (node.type === 'hardBreak') return '\n';
    if (node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard') return $3c4f0794e5b63717$var$getStringValue(node.attrs?.url);
    if (node.type === 'mention') return $3c4f0794e5b63717$var$getStringValue(node.attrs?.text);
    if (node.type === 'emoji') return $3c4f0794e5b63717$var$getStringValue(node.attrs?.text) || $3c4f0794e5b63717$var$getStringValue(node.attrs?.shortName);
    if (node.type === 'inlineExtension') return $3c4f0794e5b63717$var$getExtensionPromptText(node.attrs);
    const childText = Array.isArray(node.content) ? node.content.map($3c4f0794e5b63717$var$extractFromNode).join('') : '';
    if (node.type && $3c4f0794e5b63717$var$BLOCK_NODE_TYPES.has(node.type) && childText) return `${childText}\n`;
    return childText;
};
const $3c4f0794e5b63717$export$18874949654c5a1d = (adf)=>$3c4f0794e5b63717$var$extractFromNode(adf).trim();
module.exports["extractPromptTextFromAdf"] = $3c4f0794e5b63717$export$18874949654c5a1d;

});

parcelRegister("jkAry", function(module, exports) {
/**
 * Extracts the numeric page ID from a Confluence page URL.
 *
 * Takes the URL as an argument instead of reading `window.location`, so hosts that are not on the
 * page they are asking about can use it: the Rovo browser extension's chat lives in a Chrome side
 * panel, where `window.location` is the panel. `getCurrentPageId` is the `window.location` wrapper.
 */ const $6e5da6dcd273dca5$export$34ef9695f77fe7fe = (pageUrl)=>{
    return pageUrl?.match(/\/pages\/(?:edit-v2\/)?(\d+)/)?.[1];
};


const $93ce060b6123b497$export$365076dec8e1120e = ()=>{
    // Extracts the numeric page ID from the current Confluence page URL.
    // Handles both view and edit URL formats:
    //   View: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/<pageId>/<page-title>
    //   Edit: https://<site>.atlassian.net/wiki/spaces/<spaceKey>/pages/edit-v2/<pageId>
    return (0, $6e5da6dcd273dca5$export$34ef9695f77fe7fe)(window?.location.href);
};
module.exports["getCurrentPageId"] = $93ce060b6123b497$export$365076dec8e1120e;

});

parcelRegister("5odSY", function(module, exports) {
function $d2af83c72660dee3$export$2e053248db1c2516({ sourceMode: sourceMode, spaceId: spaceId }) {
    return spaceId ? sourceMode : undefined;
}
module.exports["getSpaceScopedSourceMode"] = $d2af83c72660dee3$export$2e053248db1c2516;

});

parcelRegister("9qJ1N", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8jkGR = parcelRequire("8jkGR");


var $7H855 = parcelRequire("7H855");

/**
 * Task notices: subscribers subscribe to notices about task status.
 *
 * A notice is raised when a task reaches a state worth telling the user about. Every consumer —
 * inbox list, menu badge, notifications — derives from this selector, so they cannot disagree.
 * Notices are derived state, not delivered events: they appear, disappear when the task moves on,
 * and can be raised again later.
 */ /** The single place that decides whether a task status warrants a notice. */ const $094743d67f51b17f$var$NOTICE_REASON_BY_PROGRESS_STATE = {
    AwaitingDisambiguation: 'needs-input',
    AwaitingPlanConfirmation: 'needs-input',
    AwaitingActionConfirmation: 'needs-input'
};
/**
 * Contract gap: no task field means "entered the current state" — only `created_at`,
 * `started_at`, `updated_at` and `completed_at` exist. Substituting `updatedAt` would claim
 * precision the contract lacks, so age stays unknown until a dedicated field lands. This is the
 * single place to populate it; ordering and row age then pick it up automatically.
 */ const $094743d67f51b17f$var$resolveVerifiedRaisedAt = (task)=>{
    return undefined;
};
/**
 * Maps a task to its notice, or `undefined` when none applies.
 *
 * Tasks missing the identifiers needed to open the blocking message raise no notice rather than
 * appearing as dead ends. Every reason needs a target today; revisit if a purely informational
 * reason is added.
 */ const $094743d67f51b17f$var$toTaskNotice = (task)=>{
    const { progressState: progressState, conversationId: conversationId, currentMessageId: currentMessageId } = task;
    const reason = $094743d67f51b17f$var$NOTICE_REASON_BY_PROGRESS_STATE[progressState];
    if (!reason || !conversationId || !currentMessageId) return undefined;
    return {
        taskId: task.taskId,
        conversationId: conversationId,
        currentMessageId: currentMessageId,
        agentId: task.agentId,
        title: task.title,
        reason: reason,
        progressState: progressState,
        raisedAt: $094743d67f51b17f$var$resolveVerifiedRaisedAt(task),
        updatedAt: task.updatedAt
    };
};
/** Unparseable timestamps compare equal so they fall through to the next tie-break. */ const $094743d67f51b17f$var$toComparableTime = (iso)=>{
    const ms = Date.parse(iso);
    return Number.isNaN(ms) ? 0 : ms;
};
/**
 * Newest raised notice first, then newest store update, then `taskId`. Notices with a known
 * `raisedAt` always rank above those without.
 */ const $094743d67f51b17f$var$compareTaskNotices = (a, b)=>{
    const aRaisedAt = a.raisedAt;
    const bRaisedAt = b.raisedAt;
    if (aRaisedAt !== undefined || bRaisedAt !== undefined) {
        if (aRaisedAt === undefined) return 1;
        if (bRaisedAt === undefined) return -1;
        const raisedDelta = $094743d67f51b17f$var$toComparableTime(bRaisedAt) - $094743d67f51b17f$var$toComparableTime(aRaisedAt);
        if (raisedDelta !== 0) return raisedDelta;
    }
    const updatedDelta = $094743d67f51b17f$var$toComparableTime(b.updatedAt) - $094743d67f51b17f$var$toComparableTime(a.updatedAt);
    if (updatedDelta !== 0) return updatedDelta;
    if (a.taskId === b.taskId) return 0;
    return a.taskId < b.taskId ? -1 : 1;
};
const $094743d67f51b17f$export$fd731d6c9b6341fb = (tasks)=>{
    const noticesByTaskId = new Map();
    for (const task of tasks){
        const notice = $094743d67f51b17f$var$toTaskNotice(task);
        if (notice) noticesByTaskId.set(notice.taskId, notice);
        else noticesByTaskId.delete(task.taskId);
    }
    return Array.from(noticesByTaskId.values()).sort($094743d67f51b17f$var$compareTaskNotices);
};


const $52c66879efe97862$var$initialState = {
    tasksByTaskId: new Map(),
    allTasksNextCursor: null,
    hasLoadedAllTasksPage: false,
    activeConversationId: null,
    activeConversationLastAgentMessageId: null,
    activeConversationStatus: null,
    sseSubscriberCount: 0,
    sseConnected: false
};
// ─── Terminal status constants ────────────────────────────────────────────────
const $52c66879efe97862$var$TERMINAL_STATUSES = new Set([
    'COMPLETED',
    'FAILED',
    'CANCELLED'
]);
const $52c66879efe97862$var$TERMINAL_PROGRESS_STATES = new Set([
    'Completed',
    'Failed',
    'Cancelled'
]);
const $52c66879efe97862$var$isTerminalStatus = (status)=>$52c66879efe97862$var$TERMINAL_STATUSES.has(status);
const $52c66879efe97862$var$isTerminalProgressState = (state)=>$52c66879efe97862$var$TERMINAL_PROGRESS_STATES.has(state);
/**
 * Progress states that carry a pending-prompt `activeInvocationId`. The id is
 * only meaningful while the task stays in one of these states; once it leaves
 * (to RUNNING, a terminal status, or a *different* awaiting state) the prompt is
 * gone and the id must be cleared so a dead invocation can't later rebind an
 * overlay on a fresh mount.
 */ const $52c66879efe97862$var$INVOCATION_BEARING_PROGRESS_STATES = new Set([
    'AwaitingDisambiguation',
    'AwaitingPlanConfirmation'
]);
const $52c66879efe97862$var$shouldPreserveActiveInvocationId = (existing, resolvedProgressState)=>!!existing && existing.progressState === resolvedProgressState && $52c66879efe97862$var$INVOCATION_BEARING_PROGRESS_STATES.has(resolvedProgressState);
// ─── Status mapping ───────────────────────────────────────────────────────────
// Sourced from the shared `tasks-shared/task-helpers` module.
// ─── Merge helpers ────────────────────────────────────────────────────────────
/**
 * Returns true if `incoming` should overwrite `existing` for the same taskId.
 *
 * Monotonic rules:
 *   1. No existing → always accept incoming.
 *   2. Existing is terminal → only accept a strictly newer terminal update.
 *   3. Otherwise → accept if incoming.updated_at >= existing.updated_at.
 */ function $52c66879efe97862$var$shouldOverwrite(existing, incomingUpdatedAt, incomingStatus) {
    if (!existing) return true;
    if ($52c66879efe97862$var$isTerminalStatus(existing.rawStatus)) return $52c66879efe97862$var$isTerminalStatus(incomingStatus) && incomingUpdatedAt > existing.updatedAt;
    return incomingUpdatedAt >= existing.updatedAt;
}
function $52c66879efe97862$export$609ffd14cb121e86(raw) {
    if (!raw) return null;
    try {
        return Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                startedAt: parsed.startedAt,
                ...parsed.endedAt ? {
                    endedAt: parsed.endedAt
                } : {}
            };
        });
    } catch  {
        return null;
    }
}
function $52c66879efe97862$export$27c41772233f8b90(raw) {
    if (!raw) return undefined;
    try {
        const todos = Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                id: parsed.id,
                content: parsed.content,
                status: parsed.status,
                priority: parsed.priority,
                active_form: parsed.activeForm ?? parsed.active_form
            };
        });
        return {
            todos: todos
        };
    } catch  {
        return undefined;
    }
}
// ─── Module-level SSE deduplication ──────────────────────────────────────────
/**
 * Reference-equality dedup tracker. Since subscribeToTasksSSE fans the same
 * event object reference to every subscriber, we track the last ingested
 * reference to avoid writing to the store N times for N mounted subscribers.
 */ let $52c66879efe97862$var$lastIngestedSSEEvent = null;
const $52c66879efe97862$var$store = (0, $8s9DV.createStore)({
    name: 'tasks',
    initialState: $52c66879efe97862$var$initialState,
    actions: {
        // ─── SSE Lifecycle ────────────────────────────────────────────────────
        mountSSESubscriber: (getService)=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = sseSubscriberCount + 1;
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 1) {
                    // First subscriber — open SSE connection via existing ref-counted manager.
                    // The module-level subscribeToTasksSSE handles tab-visibility and reconnect.
                    const unsubscribe = (0, $8jkGR.subscribeToTasksSSE)(getService, (event, eventType)=>{
                        // Deduplicate store ingestion across multiple mounted subscribers
                        if ($52c66879efe97862$var$lastIngestedSSEEvent?.event !== event) {
                            (0, $c6StJ.defaultRegistry).getStore($52c66879efe97862$var$store).actions.ingestTasksSSEEvent(event, eventType);
                            $52c66879efe97862$var$lastIngestedSSEEvent = {
                                event: event,
                                eventType: eventType
                            };
                        }
                    });
                    // Store the unsubscribe fn at module level so unmountSSESubscriber can call it
                    $52c66879efe97862$var$sseUnsubscribe = unsubscribe;
                }
            },
        unmountSSESubscriber: ()=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = Math.max(0, sseSubscriberCount - 1);
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 0 && $52c66879efe97862$var$sseUnsubscribe) {
                    $52c66879efe97862$var$sseUnsubscribe();
                    $52c66879efe97862$var$sseUnsubscribe = null;
                    $52c66879efe97862$var$lastIngestedSSEEvent = null;
                }
            },
        _setSSEConnected: (connected)=>({ setState: setState })=>{
                setState({
                    sseConnected: connected
                });
            },
        // ─── Active Conversation Context ──────────────────────────────────────
        setActiveConversationContext: ({ conversationId: conversationId, lastAgentMessageId: lastAgentMessageId, status: status })=>({ setState: setState })=>{
                setState({
                    activeConversationId: conversationId,
                    activeConversationLastAgentMessageId: lastAgentMessageId,
                    activeConversationStatus: status
                });
            },
        // ─── SSE Ingestion ────────────────────────────────────────────────────
        ingestTasksSSEEvent: (event, eventType)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                if (eventType === 'connected') {
                    setState({
                        sseConnected: true
                    });
                    return;
                }
                if (eventType === 'task_snapshot') {
                    const snapshot = event;
                    const tasks = snapshot.tasks ?? [];
                    if (tasks.length === 0) return;
                    const next = new Map(state.tasksByTaskId);
                    let changed = false;
                    for (const incoming of tasks){
                        const existing = next.get(incoming.task_id);
                        if (!$52c66879efe97862$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                        next.set(incoming.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming));
                        changed = true;
                    }
                    if (changed) setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_status') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A: reject if the owning conversation is actively streaming
                    // (CHAT_STORE_STATUS.idle = 0; non-idle means streaming/loading)
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B: reject stale SSE reconnect replays by currentMessageId mismatch
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    const progressState = (0, $7H855.mapApiTaskStatusToProgressState)(update.status);
                    // Skip if already applied (same state from stream)
                    if (existing && existing.progressState === progressState && existing.currentMessageId === (update.current_message_id ?? null) && existing.updatedAt >= update.updated_at) return;
                    if (!$52c66879efe97862$var$shouldOverwrite(existing, update.updated_at, update.status)) return;
                    const next = new Map(state.tasksByTaskId);
                    if (!existing) // Create-if-missing: task arrived via SSE before stream
                    next.set(update.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(undefined, update));
                    else next.set(update.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, update));
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_todo_update') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A (parity with task_status): reject if the owning conversation
                    // is actively streaming. The in-flight stream will deliver a fresher
                    // todo snapshot momentarily.
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B (parity with task_status): reject stale SSE reconnect
                    // replays by currentMessageId mismatch.
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    if (!existing || $52c66879efe97862$var$isTerminalProgressState(existing.progressState)) return;
                    const todoSnapshot = $52c66879efe97862$export$27c41772233f8b90(update.todo_list ?? undefined);
                    if (!todoSnapshot) return;
                    const next = new Map(state.tasksByTaskId);
                    next.set(update.task_id, {
                        ...existing,
                        todoSnapshot: todoSnapshot
                    });
                    setState({
                        tasksByTaskId: next
                    });
                }
            },
        // ─── Task Mutations from Stream ───────────────────────────────────────
        createTaskFromStream: ({ taskId: taskId, conversationId: conversationId, title: title, updatedAt: updatedAt, messageId: messageId, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                // Idempotency guard — skip if task already exists
                if (tasksByTaskId.has(taskId)) return;
                const newTask = {
                    taskId: taskId,
                    conversationId: conversationId,
                    agentId: null,
                    triggerType: null,
                    progressState: 'Draft',
                    rawStatus: 'DRAFT',
                    activeInvocationId: null,
                    title: title,
                    plan: null,
                    resultSummary: null,
                    errorMessage: null,
                    todoSnapshot: undefined,
                    currentStep: null,
                    executionSegments: executionSegments ?? null,
                    messageId: messageId ?? null,
                    completionMessageId: null,
                    currentMessageId: currentMessageId ?? null,
                    seekingCompletedAck: false,
                    createdAt: createdAt ?? null,
                    startedAt: startedAt ?? null,
                    // Prefer the supplied updatedAt, then fall back to createdAt so the
                    // initial monotonic comparison in `shouldOverwrite` doesn't reject a
                    // real BE update that arrives with an older timestamp than `Date.now()`.
                    updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                    completedAt: completedAt ?? null
                };
                const next = new Map(tasksByTaskId);
                next.set(taskId, newTask);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskProgressState: ({ taskId: taskId, conversationId: conversationId, progressState: progressState, title: title, seekingCompletedAck: seekingCompletedAck, messageId: messageId, completionMessageId: completionMessageId, updatedAt: updatedAt, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments, activeInvocationId: activeInvocationId, currentStep: currentStep, resultSummary: resultSummary, errorMessage: errorMessage })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $52c66879efe97862$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                // Auto-create when there is no active task yet for the conversation.
                // Allows the chat-store to drive optimistic state changes
                // (e.g. AwaitingPlanConfirmation) before
                // the BE has issued a real task_id.
                if (!resolvedTaskId) {
                    if (!conversationId) return;
                    const localTaskId = `task-${Date.now()}`;
                    const newTask = {
                        taskId: localTaskId,
                        conversationId: conversationId,
                        agentId: null,
                        triggerType: null,
                        progressState: progressState,
                        rawStatus: $52c66879efe97862$var$progressStateToApiStatus(progressState),
                        activeInvocationId: activeInvocationId ?? null,
                        title: title ?? '',
                        plan: null,
                        resultSummary: resultSummary ?? null,
                        errorMessage: errorMessage ?? null,
                        todoSnapshot: undefined,
                        currentStep: currentStep ?? null,
                        executionSegments: executionSegments ?? null,
                        messageId: messageId ?? null,
                        completionMessageId: completionMessageId ?? null,
                        currentMessageId: currentMessageId ?? null,
                        seekingCompletedAck: seekingCompletedAck ?? false,
                        createdAt: createdAt ?? new Date().toISOString(),
                        startedAt: startedAt ?? null,
                        updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                        completedAt: completedAt ?? null
                    };
                    const next = new Map(tasksByTaskId);
                    next.set(localTaskId, newTask);
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing) return;
                // Terminal state protection
                if ($52c66879efe97862$var$isTerminalProgressState(existing.progressState)) return;
                const merged = {
                    ...existing,
                    progressState: progressState,
                    rawStatus: $52c66879efe97862$var$progressStateToApiStatus(progressState),
                    // `null` is meaningful — explicit clear; `undefined` leaves field unchanged.
                    ...activeInvocationId !== undefined ? {
                        activeInvocationId: activeInvocationId
                    } : {},
                    ...title !== undefined ? {
                        title: title
                    } : {},
                    ...seekingCompletedAck !== undefined ? {
                        seekingCompletedAck: seekingCompletedAck
                    } : {},
                    ...messageId !== undefined ? {
                        messageId: messageId
                    } : {},
                    ...completionMessageId !== undefined ? {
                        completionMessageId: completionMessageId
                    } : {},
                    ...updatedAt !== undefined ? {
                        updatedAt: updatedAt
                    } : {},
                    ...currentMessageId !== undefined ? {
                        currentMessageId: currentMessageId
                    } : {},
                    ...createdAt !== undefined ? {
                        createdAt: createdAt
                    } : {},
                    ...startedAt !== undefined ? {
                        startedAt: startedAt
                    } : {},
                    ...completedAt !== undefined ? {
                        completedAt: completedAt
                    } : {},
                    ...executionSegments !== undefined ? {
                        executionSegments: (0, $7H855.mergeExecutionSegments)(existing.executionSegments, executionSegments)
                    } : {},
                    // `null` is meaningful — explicit clear; `undefined` leaves field unchanged.
                    ...currentStep !== undefined ? {
                        currentStep: currentStep
                    } : {},
                    ...resultSummary !== undefined ? {
                        resultSummary: resultSummary
                    } : {},
                    ...errorMessage !== undefined ? {
                        errorMessage: errorMessage
                    } : {}
                };
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, merged);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskTodoSnapshot: ({ taskId: taskId, conversationId: conversationId, todoSnapshot: todoSnapshot })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $52c66879efe97862$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                if (!resolvedTaskId) return;
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing || $52c66879efe97862$var$isTerminalProgressState(existing.progressState)) return;
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, {
                    ...existing,
                    todoSnapshot: todoSnapshot
                });
                setState({
                    tasksByTaskId: next
                });
            },
        ackTaskCompleted: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    seekingCompletedAck: false
                });
                setState({
                    tasksByTaskId: next
                });
            },
        clearTask: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── REST Merge ───────────────────────────────────────────────────────
        mergeConversationChannelTasks: (remoteTasks)=>({ getState: getState, setState: setState })=>{
                if (!remoteTasks || remoteTasks.length === 0) return;
                // Sort ascending by created_at (oldest first, newest last = active)
                const sorted = [
                    ...remoteTasks
                ].sort((a, b)=>new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const remote of sorted){
                    const existing = next.get(remote.task_id);
                    const merged = $52c66879efe97862$var$mergeChannelTaskIntoUnified(existing, remote);
                    next.set(remote.task_id, merged);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksSnapshot: (tasks)=>({ getState: getState, setState: setState })=>{
                if (!tasks) return;
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                // 1. Upsert all tasks from the snapshot (REST is authoritative for tasks it returns).
                const snapshotIds = new Set();
                for (const incoming of tasks){
                    snapshotIds.add(incoming.task_id);
                    const existing = next.get(incoming.task_id);
                    if (!$52c66879efe97862$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                // 2. Reconcile: remove any task absent from the REST snapshot **only** when
                //    it's already in a terminal state. Non-terminal (in-flight) tasks may
                //    legitimately be present locally but not yet visible in REST (race), so
                //    we preserve them and rely on SSE to deliver their final state.
                for (const [taskId, task] of tasksByTaskId){
                    if (snapshotIds.has(taskId)) continue;
                    if ($52c66879efe97862$var$isTerminalProgressState(task.progressState)) {
                        next.delete(taskId);
                        changed = true;
                    }
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksPage: (tasks, nextCursor)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const incoming of tasks){
                    const existing = next.get(incoming.task_id);
                    if (!$52c66879efe97862$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                if (changed || nextCursor !== undefined) setState({
                    ...changed ? {
                        tasksByTaskId: next
                    } : {},
                    ...nextCursor !== undefined ? {
                        allTasksNextCursor: nextCursor,
                        hasLoadedAllTasksPage: true
                    } : {}
                });
            },
        // ─── Optimistic mutations from UI (tasks-list, etc.) ─────────────────
        /**
     * Removes a single task by taskId. Used for optimistic delete from
     * the tasks-list screen before the API call resolves.
     */ removeTaskById: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        /**
     * Optimistically marks a task as Cancelled (terminal state). Used by the
     * tasks-list stop action before the API call resolves.
     */ markTaskCancelled: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const now = new Date().toISOString();
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    progressState: 'Cancelled',
                    rawStatus: 'CANCELLED',
                    updatedAt: now,
                    completedAt: existing.completedAt ?? now
                });
                setState({
                    tasksByTaskId: next
                });
            },
        /**
     * Optimistically updates a task's title. Used by the tasks-list rename
     * action before the API call resolves.
     */ setTaskTitle: (taskId, title)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing || existing.title === title) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    title: title,
                    updatedAt: new Date().toISOString()
                });
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── Conversation cleanup ─────────────────────────────────────────────
        removeTasksForConversation: (conversationId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const [taskId, task] of tasksByTaskId)if (task.conversationId === conversationId) {
                    next.delete(taskId);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        // Read-only accessor — used by chat-store actions that need the latest
        // active task synchronously without going through React.
        getActiveTaskForConversation: (conversationId)=>({ getState: getState })=>{
                return $52c66879efe97862$var$findActiveTaskForConversation(getState().tasksByTaskId, conversationId);
            },
        // Read-only accessor — single-task lookup by id. Same imperative shape as
        // `getActiveTaskForConversation` so chat-store callers don't need any
        // React state plumbing.
        getTaskById: (taskId)=>({ getState: getState })=>{
                return getState().tasksByTaskId.get(taskId);
            }
    }
});
// ─── Module-level SSE unsubscribe reference ───────────────────────────────────
// Stored outside the store state (not serializable, not reactive).
let $52c66879efe97862$var$sseUnsubscribe = null;
/**
 * Finds the active task for a conversation.
 * Prefers the most recent **non-terminal** task; falls back to the most recent
 * task overall if all tasks for the conversation are in terminal state.
 *
 * "Active" semantics: a conversation has at most one in-flight task at any
 * point in time. Older tasks (terminal) remain associated with the conversation
 * for history but should not be treated as the current active task.
 */ /**
 * Internal selector helper. Use the `useActiveTaskForConversation` /
 * `useActiveTasksForConversations` hooks (React) or the
 * `getActiveTaskForConversation` action (non-React) instead.
 */ function $52c66879efe97862$var$findActiveTaskForConversation(tasksByTaskId, conversationId) {
    let latestNonTerminal;
    let latestAny;
    for (const task of tasksByTaskId.values()){
        if (task.conversationId !== conversationId) continue;
        if (!latestAny || (task.createdAt ?? '') > (latestAny.createdAt ?? '')) latestAny = task;
        if (!$52c66879efe97862$var$isTerminalProgressState(task.progressState)) {
            if (!latestNonTerminal || (task.createdAt ?? '') > (latestNonTerminal.createdAt ?? '')) latestNonTerminal = task;
        }
    }
    return latestNonTerminal ?? latestAny;
}
function $52c66879efe97862$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) {
    return $52c66879efe97862$var$findActiveTaskForConversation(tasksByTaskId, conversationId)?.taskId;
}
// ─── Internal merge helpers ───────────────────────────────────────────────────
function $52c66879efe97862$var$progressStateToApiStatus(state) {
    const map = {
        Draft: 'DRAFT',
        Queued: 'QUEUED',
        Running: 'RUNNING',
        AwaitingDisambiguation: 'AWAITING_DISAMBIGUATION',
        AwaitingPlanConfirmation: 'AWAITING_PLAN_CONFIRMATION',
        AwaitingActionConfirmation: 'AWAITING_ACTION_CONFIRMATION',
        Completed: 'COMPLETED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED'
    };
    return map[state];
}
function $52c66879efe97862$var$mergeSSEUpdateIntoTask(existing, incoming) {
    const progressState = (0, $7H855.mapApiTaskStatusToProgressState)(incoming.status);
    // `current_step` only exists on the SSE shape; REST snapshots don't carry it.
    const incomingCurrentStep = 'current_step' in incoming ? incoming.current_step ?? null : existing?.currentStep ?? null;
    // `agent_id` and `trigger_type` are on the REST shape but not on every SSE update.
    const incomingAgentId = 'agent_id' in incoming ? incoming.agent_id : existing?.agentId ?? null;
    const incomingTriggerType = 'trigger_type' in incoming ? incoming.trigger_type : existing?.triggerType ?? null;
    const incomingPlan = 'plan' in incoming ? incoming.plan ?? null : existing?.plan ?? null;
    const incomingCompletedAt = 'completed_at' in incoming ? incoming.completed_at ?? existing?.completedAt ?? null : existing?.completedAt ?? null;
    return {
        taskId: incoming.task_id,
        conversationId: incoming.conversation_id ?? existing?.conversationId ?? null,
        agentId: incomingAgentId,
        triggerType: incomingTriggerType,
        progressState: progressState,
        rawStatus: incoming.status,
        // Not carried on the SSE/REST wire shape. Preserve the local value only while
        // the task stays in the same invocation-bearing awaiting state; otherwise clear
        // it so a dead invocation id can't outlive its prompt.
        activeInvocationId: $52c66879efe97862$var$shouldPreserveActiveInvocationId(existing, progressState) ? existing?.activeInvocationId ?? null : null,
        title: incoming.title,
        plan: incomingPlan,
        resultSummary: incoming.result_summary,
        errorMessage: incoming.error_message,
        todoSnapshot: existing?.todoSnapshot,
        currentStep: incomingCurrentStep,
        executionSegments: $52c66879efe97862$export$609ffd14cb121e86(incoming.execution_segments ?? undefined),
        messageId: incoming.message_id ?? existing?.messageId ?? null,
        completionMessageId: incoming.completion_message_id ?? existing?.completionMessageId ?? null,
        currentMessageId: incoming.current_message_id ?? existing?.currentMessageId ?? null,
        // Local-only UI state: preserve from existing
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: incoming.created_at ?? existing?.createdAt ?? null,
        startedAt: incoming.started_at ?? existing?.startedAt ?? null,
        updatedAt: incoming.updated_at,
        completedAt: incomingCompletedAt
    };
}
function $52c66879efe97862$var$mergeChannelTaskIntoUnified(existing, remote) {
    const progressState = (0, $7H855.mapApiTaskStatusToProgressState)(remote.status);
    const remoteExecutionSegments = $52c66879efe97862$export$609ffd14cb121e86(remote.execution_segments ?? undefined);
    const remoteTodoSnapshot = $52c66879efe97862$export$27c41772233f8b90(remote.todo_list ?? undefined);
    // Local wins for progressState and todoSnapshot when local is strictly newer
    const localIsNewer = existing?.updatedAt && existing.updatedAt > remote.updated_at;
    const resolvedProgressState = localIsNewer ? existing?.progressState ?? progressState : progressState;
    return {
        taskId: remote.task_id,
        conversationId: remote.conversation_id,
        agentId: remote.agent_id,
        triggerType: remote.trigger_type,
        progressState: resolvedProgressState,
        rawStatus: localIsNewer ? existing?.rawStatus ?? remote.status : remote.status,
        // Not carried on the channel wire shape. Preserve the local value only while
        // the task stays in the same invocation-bearing awaiting state (compared
        // against the FINAL resolved progressState, which accounts for localIsNewer);
        // otherwise clear it so a dead invocation id can't outlive its prompt.
        activeInvocationId: $52c66879efe97862$var$shouldPreserveActiveInvocationId(existing, resolvedProgressState) ? existing?.activeInvocationId ?? null : null,
        title: remote.title,
        plan: remote.plan,
        resultSummary: remote.result_summary,
        errorMessage: remote.error_message,
        todoSnapshot: localIsNewer ? existing?.todoSnapshot : remoteTodoSnapshot ?? existing?.todoSnapshot,
        currentStep: existing?.currentStep ?? null,
        executionSegments: (0, $7H855.mergeExecutionSegments)(existing?.executionSegments, remoteExecutionSegments),
        messageId: remote.message_id,
        completionMessageId: remote.completion_message_id,
        currentMessageId: remote.current_message_id,
        // Local-only: seekingCompletedAck NEVER overwritten by REST
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: remote.created_at,
        startedAt: remote.started_at,
        updatedAt: remote.updated_at,
        completedAt: remote.completed_at
    };
}
const $52c66879efe97862$export$c2ad39067c031726 = (0, $kBr4q.createHook)($52c66879efe97862$var$store);
const $52c66879efe97862$export$e398e9c82ae1ea3e = (0, $kBr4q.createActionsHook)($52c66879efe97862$var$store);
const $52c66879efe97862$export$4a89b1af24c66aec = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state, conversationId)=>{
        if (!conversationId) return undefined;
        return $52c66879efe97862$var$findActiveTaskForConversation(state.tasksByTaskId, conversationId);
    }
});
const $52c66879efe97862$export$37ef8d89dd7c4479 = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>Array.from(state.tasksByTaskId.values())
});
const $52c66879efe97862$export$ccf22665055675b = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>(0, $094743d67f51b17f$export$fd731d6c9b6341fb)(state.tasksByTaskId.values())
});
const $52c66879efe97862$export$294781cac1da1fda = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>({
            allTasksNextCursor: state.allTasksNextCursor,
            hasLoadedAllTasksPage: state.hasLoadedAllTasksPage
        })
});
const $52c66879efe97862$export$86ae895223d55438 = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state, conversationIds)=>{
        const result = new Map();
        for (const id of conversationIds)result.set(id, $52c66879efe97862$var$findActiveTaskForConversation(state.tasksByTaskId, id));
        return result;
    }
});
const $52c66879efe97862$export$8adc54d746bc9a7f = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state, taskId)=>state.tasksByTaskId.get(taskId)
});
const $52c66879efe97862$export$2a84773e9f93301a = (0, $kBr4q.createHook)($52c66879efe97862$var$store, {
    selector: (state)=>state.sseConnected
});
const $52c66879efe97862$export$f68962e2c5dae5a0 = (task)=>({
        task_id: task.taskId,
        title: task.title,
        status: task.rawStatus,
        current_step: task.currentStep,
        result_summary: task.resultSummary,
        error_message: task.errorMessage,
        conversation_id: task.conversationId,
        message_id: task.messageId,
        completion_message_id: task.completionMessageId,
        current_message_id: task.currentMessageId,
        created_at: task.createdAt,
        started_at: task.startedAt,
        updated_at: task.updatedAt,
        // Preserve raw shape for execution_segments and todo_list (Record<string,string>).
        // We do not have the raw representation any more after parsing, so leave as null.
        execution_segments: null,
        todo_list: null
    });
module.exports["parseExecutionSegments"] = $52c66879efe97862$export$609ffd14cb121e86;
module.exports["parseTodoList"] = $52c66879efe97862$export$27c41772233f8b90;
module.exports["useTasksStoreActions"] = $52c66879efe97862$export$e398e9c82ae1ea3e;
module.exports["useActiveTaskForConversation"] = $52c66879efe97862$export$4a89b1af24c66aec;
module.exports["useAllTasks"] = $52c66879efe97862$export$37ef8d89dd7c4479;
module.exports["useAllTasksPaginationState"] = $52c66879efe97862$export$294781cac1da1fda;
module.exports["useActiveTasksForConversations"] = $52c66879efe97862$export$86ae895223d55438;
module.exports["unifiedTaskToApiSSE"] = $52c66879efe97862$export$f68962e2c5dae5a0;

});

parcelRegister("8jkGR", function(module, exports) {
/**
 * Tasks SSE Connection Manager
 *
 * A plain TS module (no React, no store) that manages a single shared SSE connection
 * to the Tasks stream endpoint (`GET /rovo/v1/tasks/stream`).
 *
 * Key design properties:
 * - **Single connection**: only one SSE connection is open at a time, regardless of
 *   how many consumers are subscribed.
 * - **Reference-counted**: connection opens when the first subscriber arrives,
 *   closes when the last subscriber leaves.
 * - **Tab-visibility aware**: connection is dropped when the tab becomes hidden and
 *   re-established when the tab becomes visible again. This is fully managed here,
 *   not by any React component.
 * - **Decoupled from React lifecycle**: module-level state survives component
 *   mount/unmount cycles.
 * - **External trigger support**: can subscribe
 *  by providing `getService` explicitly — no component mounting required.
 */ 
var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $hlvTd = parcelRequire("hlvTd");


var $bxkJA = parcelRequire("bxkJA");

// ─── Module-level state (singleton) ──────────────────────────────────────────
/** Active SSE fetch abort controller. Null when disconnected. */ let $3931780bbccb0af6$var$abortController = null;
/** The AssistanceService instance used for the current (or next) connection. */ let $3931780bbccb0af6$var$serviceRef = null;
/** All active subscribers. Connection is open iff this Set is non-empty. */ const $3931780bbccb0af6$var$subscribers = new Set();
/** Cleanup function for the visibilitychange listener. Null when unbound. */ let $3931780bbccb0af6$var$visibilityUnbind = null;
// ─── Internal helpers ─────────────────────────────────────────────────────────
/**
 * Opens the SSE connection using the stored `serviceRef`.
 * Fans out each incoming event to all current subscribers.
 * Safe to call if a connection is already open (no-op guard via abortController).
 */ async function $3931780bbccb0af6$var$openConnection() {
    if (!$3931780bbccb0af6$var$serviceRef) return;
    // Prevent duplicate connections
    if ($3931780bbccb0af6$var$abortController) return;
    $3931780bbccb0af6$var$abortController = new AbortController();
    const localAbort = $3931780bbccb0af6$var$abortController;
    try {
        const { generator: generator } = await $3931780bbccb0af6$var$serviceRef.getTasksStream(localAbort);
        for await (const message of generator){
            // Bail out if connection was closed while we were iterating
            if (localAbort.signal.aborted) break;
            // The SSE stream yields ParsedSSEMessage<ApiTaskSSEUpdate> wrappers.
            // The event_type is carried in the SSE `event:` envelope line → message.eventType.
            if (!(0, $bxkJA.isSSEMessage)(message)) continue;
            const event = message.data;
            const eventType = message.eventType ?? 'task_status';
            if (event) $3931780bbccb0af6$var$subscribers.forEach((listener)=>listener(event, eventType));
        }
    } catch (error) {
        // AbortError is expected on intentional disconnect — swallow it silently
        if (error instanceof DOMException && error.name === 'AbortError') return;
        // Report unexpected errors to Sentry. We deliberately do NOT re-throw:
        // `openConnection` is invoked via `void openConnection()` at every call
        // site, so a thrown error would surface as an unhandled promise rejection
        // — which can crash strict hosts and would otherwise tear down the chat
        // session for what is only a side-channel failure.
        (0, $hlvTd.logException)({
            name: 'rovoTasksSSEConnection',
            exception: error
        });
    } finally{
        // Ensure controller is cleared once the loop exits for any reason
        if ($3931780bbccb0af6$var$abortController === localAbort) $3931780bbccb0af6$var$abortController = null;
    }
}
/**
 * Aborts the current SSE connection.
 * Safe to call when already disconnected.
 */ function $3931780bbccb0af6$var$closeConnection() {
    if ($3931780bbccb0af6$var$abortController) {
        $3931780bbccb0af6$var$abortController.abort();
        $3931780bbccb0af6$var$abortController = null;
    }
}
/**
 * Binds a `visibilitychange` listener on the document.
 * - Tab hidden  → close connection
 * - Tab visible → re-open connection (reuses stored serviceRef)
 *
 * Binding is done once per subscriber session (first subscriber triggers it).
 */ function $3931780bbccb0af6$var$bindVisibility() {
    if ($3931780bbccb0af6$var$visibilityUnbind) // Already bound — nothing to do
    return;
    const doc = (0, $1hQ0e.getDocument)();
    if (!doc) return;
    $3931780bbccb0af6$var$visibilityUnbind = (0, $cbY7C.bind)(doc, {
        type: 'visibilitychange',
        listener: ()=>{
            if (doc.hidden) $3931780bbccb0af6$var$closeConnection();
            else // Re-open connection when tab becomes visible again
            $3931780bbccb0af6$var$openConnection();
        }
    });
}
/**
 * Removes the `visibilitychange` listener.
 * Called when the last subscriber unsubscribes.
 */ function $3931780bbccb0af6$var$unbindVisibility() {
    $3931780bbccb0af6$var$visibilityUnbind?.();
    $3931780bbccb0af6$var$visibilityUnbind = null;
}
function $3931780bbccb0af6$export$285816b4ea71cce1(getService, onEvent) {
    $3931780bbccb0af6$var$subscribers.add(onEvent);
    if ($3931780bbccb0af6$var$subscribers.size === 1) {
        // First subscriber — resolve service, open connection, bind visibility
        $3931780bbccb0af6$var$serviceRef = getService();
        $3931780bbccb0af6$var$bindVisibility();
        // Only open connection if tab is currently visible
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc || !doc.hidden) $3931780bbccb0af6$var$openConnection();
    }
    return function unsubscribe() {
        $3931780bbccb0af6$var$subscribers.delete(onEvent);
        if ($3931780bbccb0af6$var$subscribers.size === 0) {
            // Last subscriber left — tear everything down
            $3931780bbccb0af6$var$closeConnection();
            $3931780bbccb0af6$var$unbindVisibility();
            $3931780bbccb0af6$var$serviceRef = null;
        }
    };
}
module.exports["subscribeToTasksSSE"] = $3931780bbccb0af6$export$285816b4ea71cce1;

});

parcelRegister("iEKWu", function(module, exports) {
const $acee56d2cf65b7f0$export$420f5414c6aecb85 = (interactionModeExecuted)=>interactionModeExecuted ? {
        interactionModeExecuted: interactionModeExecuted
    } : {};
module.exports["interactionModeExecutedAttributes"] = $acee56d2cf65b7f0$export$420f5414c6aecb85;

});

parcelRegister("cC5sC", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

/**
 * Per-experience creation context contracts.
 *
 * Add a row as each experience is migrated. An experience with no row here is passed through
 * untouched, so this is safe to extend one experience at a time.
 */ const $d754fa0337b217c7$var$CREATION_CONTEXT_CONTRACTS = {
    remix_edit: {
        omit: [
            'contentTypes'
        ],
        // A remix edit can target existing content, or a subtype-only style update.
        targets: [
            'contentMauiId',
            'mediaFileId',
            'dynamicUiSubtype'
        ],
        exclusiveOneOf: [
            'contentMauiId',
            'mediaFileId'
        ],
        // 'image' is not in the published contract table, but image remixes are a real block type
        // and must not be reported as one of the others.
        blocks: [
            'chart',
            'diagram',
            'visual-aid',
            'infographic',
            'image'
        ]
    }
};
function $d754fa0337b217c7$export$11b60038f3efc9bb(creationContext) {
    const experience = creationContext.experience;
    const contract = typeof experience === 'string' ? $d754fa0337b217c7$var$CREATION_CONTEXT_CONTRACTS[experience] : undefined;
    if (!contract) return creationContext;
    const result = {};
    for (const [key, value] of Object.entries(creationContext))if (!contract.omit.includes(key)) result[key] = value;
    if (contract.targets) {
        for (const key of contract.targets)if (result[key] === undefined || result[key] === '') delete result[key];
    }
    if (contract.exclusiveOneOf) {
        const [kept] = contract.exclusiveOneOf.filter((key)=>result[key] !== undefined && result[key] !== '');
        for (const key of contract.exclusiveOneOf)if (key !== kept) delete result[key];
    }
    if (contract.blocks) {
        const allowed = contract.blocks;
        const isAllowed = (value)=>typeof value === 'string' && allowed.includes(value);
        // The block being edited is authoritative: a call site can derive `blocks` from the
        // presence of a media id, which mislabels a visual aid as an image.
        const declared = Array.isArray(result.blocks) ? result.blocks.filter(isAllowed) : [];
        const resolved = isAllowed(result.dynamicUiType) ? [
            result.dynamicUiType
        ] : declared.length > 0 ? declared : undefined;
        if (resolved) result.blocks = resolved;
        else delete result.blocks;
    }
    return result;
}


function $a608bfd48681563a$export$780f1f00b9b71ec({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, slidesContext: slidesContext }) {
    if (editorContext) return 'page';
    if (whiteboardContext) return 'whiteboard';
    if (databaseContext) return 'database';
    if (slidesContext) return 'slide';
    return undefined;
}


const $281fa3f29881e068$var$REMIX_EDIT_BLOCKS = [
    'chart',
    'diagram',
    'visual-aid',
    'infographic',
    'image'
];
function $281fa3f29881e068$export$e1dc015944c90cb9({ existingBlocks: existingBlocks, experience: experience, source: source, contentMauiId: contentMauiId, mediaFileId: mediaFileId, dynamicUiType: dynamicUiType, isCreationContextContractEnabled: isCreationContextContractEnabled = false }) {
    if (existingBlocks && existingBlocks.length > 0) return existingBlocks;
    if (isCreationContextContractEnabled && experience === 'remix_edit') {
        if (dynamicUiType && $281fa3f29881e068$var$REMIX_EDIT_BLOCKS.includes(dynamicUiType)) return [
            dynamicUiType
        ];
        // The contract requires a block on every remix edit. The exact value matters less than its
        // presence: the MAUI types are handled by one subagent and the image types by another, so
        // fall back to the block family implied by the content reference.
        return mediaFileId && !contentMauiId ? [
            'image'
        ] : [
            'chart'
        ];
    }
    if (source === 'remix' && experience === 'remix_edit' && mediaFileId) return [
        'image'
    ];
    return undefined;
}





/** Entry points that start a Create with Rovo session, mirroring `isCreateWithRovoSend`. */ const $859bfbfa800411c6$var$CREATE_WITH_ROVO_SOURCES = [
    'ai-first-creation',
    'chat-only-creation-modal'
];
/**
 * `cwr` means a Confluence Create-with-Rovo session and the backend routes agent selection on it,
 * so a host that declares a creation source of its own is running a different experience and must
 * not be relabelled — the staging area is shared UI, not a Confluence signal. Gated because
 * AdminHub is the only host declaring another source today, so the labelling is unchanged for every
 * existing surface while the gate is off.
 */ const $859bfbfa800411c6$var$hasOwnCreationSource = (creationContextSource)=>creationContextSource !== undefined && !$859bfbfa800411c6$var$CREATE_WITH_ROVO_SOURCES.includes(creationContextSource) && (0, $iDrrr.fg)('adminhub-create-policy-with-rovo');
function $859bfbfa800411c6$export$e5ce245ce709fc21({ contentContextValue: contentContextValue, isFirstPrompt: isFirstPrompt, source: source, creationContextSource: creationContextSource, existingExperience: existingExperience, existingContentTypes: existingContentTypes, chatContextContentType: chatContextContentType, isRemixAction: isRemixAction, isViewMode: isViewMode, contentMauiId: contentMauiId, mediaFileId: mediaFileId, isCreationContextContractEnabled: isCreationContextContractEnabled = false }) {
    const resolvedContentTypes = existingContentTypes && existingContentTypes.length > 0 ? existingContentTypes : chatContextContentType ? [
        chatContextContentType
    ] : undefined;
    if (existingExperience === 'inline_edit' && (contentMauiId || mediaFileId)) {
        // A remix edit is identified by the block being edited, not by the content hosting it, so
        // it must still be reported when no content type can be resolved.
        if (isCreationContextContractEnabled) return {
            experience: 'remix_edit'
        };
        return resolvedContentTypes ? {
            experience: 'remix_edit',
            contentTypes: resolvedContentTypes
        } : undefined;
    }
    if (existingExperience === 'cwr_edit') {
        if (resolvedContentTypes) return {
            experience: 'cwr_edit',
            contentTypes: resolvedContentTypes
        };
        return {
            experience: 'cwr'
        };
    }
    if (existingExperience) return undefined;
    // The host-source check comes last so the gate is only read for a send that would otherwise be
    // labelled, rather than on every Confluence send.
    const isCwrStagingAreaFollowUp = contentContextValue === 'staging-area' && !isFirstPrompt && source !== 'remix' && creationContextSource !== 'remix' && !isRemixAction && !$859bfbfa800411c6$var$hasOwnCreationSource(creationContextSource);
    if (isCwrStagingAreaFollowUp) {
        if (chatContextContentType) return {
            experience: 'cwr_edit',
            contentTypes: [
                chatContextContentType
            ]
        };
        return {
            experience: 'cwr'
        };
    }
    // When both the contract gate and the new live page gate are on: a first-prompt in the
    // staging-area with the draft editor open is a chat_edit — the user is asking Rovo to
    // modify the current draft.
    const isStagingAreaChatEdit = (0, $iDrrr.fg)('confluence_aifc_new_live_page_chat_context') && contentContextValue === 'staging-area' && isFirstPrompt && source !== 'remix' && creationContextSource !== 'remix' && !isRemixAction;
    if (isStagingAreaChatEdit && chatContextContentType) return {
        experience: 'chat_edit',
        contentTypes: [
            chatContextContentType
        ]
    };
    if (contentContextValue === 'global' && chatContextContentType) return {
        experience: isViewMode ? 'chat_view' : 'chat_edit',
        contentTypes: [
            chatContextContentType
        ]
    };
    return undefined;
}


const $8e750f2baceb2078$export$bcaf715379dd74b = ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, userPreference: userPreference, sendAnalyticsEvent: sendAnalyticsEvent, activeTargetId: activeTargetId, isStagingArea: stagingAreaFromStore })=>{
    const inStagingArea = contentContext === 'staging-area';
    // Source values for Inline Rovo
    const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    const shouldProvideContext = // Inline Rovo
    sourceEligible || // Within staging area & not the first prompt
    inStagingArea && !isFirstPrompt || // Not within staging area, default to user preference
    !inStagingArea && !!userPreference;
    // If there's no editor context when we should be providing it,
    // something went wrong so send analytics to track
    if (shouldProvideContext) sendAnalyticsEvent({
        eventType: 'operational',
        action: 'missing',
        actionSubject: 'editorContext',
        attributes: {
            contentContext: contentContext,
            source: source,
            userPreference: userPreference,
            isFirstPrompt: isFirstPrompt,
            activeTargetId: activeTargetId,
            isStagingArea: stagingAreaFromStore
        }
    });
};


const $d0254ff0647fc0e0$export$e038cea4925a1058 = async (chatContextStoreActions, isFirstPrompt, source, prompt, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixAction, searchArtifact, additionalContextReceiverId, editorContextFallback, excludePageContext)=>{
    // Scoped to Confluence: the contract comes from the Confluence experience routing spec, and
    // Jira runs its own remix-edit rollout with a different payload shape.
    const isCreationContextContractEnabled = productKey === 'confluence' && (0, $iDrrr.fg)('confluence_aifc_experience_rearchitecture');
    // When the gate is on and the user is in the CWR staging-area on the first prompt with no
    // eligible source, getContextRequirements returns false for contentContext='staging-area'
    // (it ignores userPreference). To ensure the draft editor context is always fetched, fetch
    // with contentContext='global' which respects userPreference=true. The effective content
    // context for all other purposes (isStagingArea, experience, etc.) remains 'staging-area'.
    const isStagingAreaFirstPromptFix = (0, $iDrrr.fg)('confluence_aifc_new_live_page_chat_context') && contentContextValue === 'staging-area' && isFirstPrompt;
    const fetchedEditorContext = skipEditorContext ? undefined : await chatContextStoreActions.getEditorContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        // For staging-area first prompts, getContextRequirements ignores userPreference.
        // Use 'global' so userPreference=true is respected and the draft context is fetched.
        contentContext: isStagingAreaFirstPromptFix ? 'global' : contentContextValue,
        addCurrentPageAsContextUserPreference: isStagingAreaFirstPromptFix ? true : !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId,
        prompt: prompt
    });
    // The Remix entry point already has an editor context when it selects REMIX_CUSTOM_EDIT. A
    // send-time bridge read can still transiently return undefined; retain the entry-point context
    // so the required PAGE_CONTEXT is not dropped from the request.
    const editorContext = fetchedEditorContext ?? (!skipEditorContext && productKey === 'confluence' && creationContextParams?.experience === 'remix_custom_edit' && editorContextFallback ? {
        ...editorContextFallback
    } : undefined);
    const currentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
    // If there's no editor context available and the current target CAN
    // provide context, send analytics to track this error state
    if (!editorContext && !skipEditorContext && currentTarget?.canProvideContext) (0, $8e750f2baceb2078$export$bcaf715379dd74b)({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        userPreference: !!addCurrentPageAsContextUserPreference,
        sendAnalyticsEvent: sendAnalyticsEvent,
        activeTargetId: !!activeTargetId,
        isStagingArea: chatContextStoreActions.getIsStagingArea()
    });
    const whiteboardContext = await chatContextStoreActions.getWhiteboardContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const slidesContext = await chatContextStoreActions.getSlidesContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const databaseContext = await chatContextStoreActions.getDatabaseContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const dashboardEditorContext = await chatContextStoreActions.getDashboardEditorContext({
        contentContext: contentContextValue,
        activeTargetId: activeTargetId
    });
    const browserContext = await chatContextStoreActions.getBrowserContext({
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        enabled: true
    });
    const jiraContext = await (async ()=>{
        // Only fetch Jira context when in staging area and product is Jira
        // and not the first prompt (refinement messages)
        if (!isFirstPrompt && contentContextValue === 'staging-area' && productKey === 'jira') return chatContextStoreActions.getJiraContext?.();
        return undefined;
    })();
    const additionalCreationContext = editorContext?.additionalContext;
    const additionalCreationContextParams = creationContextParams?.additionalContext;
    const bridgeAdditionalContext = additionalContextReceiverId ? await chatContextStoreActions.getAdditionalContext(additionalContextReceiverId) : undefined;
    if (editorContext && editorContext.additionalContext) delete editorContext.additionalContext;
    const useGenericEditorSkill = editorContext?.useGenericEditorSkill;
    if (editorContext && 'useGenericEditorSkill' in editorContext) delete editorContext.useGenericEditorSkill;
    const isViewMode = contentContextValue === 'staging-area' ? !!editorContext?.isViewMode : !!(editorContext?.isViewMode || whiteboardContext?.isViewMode || slidesContext?.isViewMode || databaseContext?.isViewMode);
    const editorContentType = (0, $a608bfd48681563a$export$780f1f00b9b71ec)({
        editorContext: editorContext,
        whiteboardContext: whiteboardContext,
        databaseContext: databaseContext,
        slidesContext: slidesContext
    });
    const aiFeatureContext = chatContextStoreActions.getAIFeatureContext();
    const hasSurfaceContext = !!(editorContext || whiteboardContext || slidesContext || databaseContext);
    const isNewViewRoutingEnabled = productKey === 'confluence' && !skipEditorContext && !hasSurfaceContext && (0, $4o0zT.isExperimentEnabled)('aifc_creation_context_stale_target_fix');
    const publishedView = aiFeatureContext?.confluence_view_context;
    const hasSelectedPageView = isNewViewRoutingEnabled && contentContextValue === 'global' && activeTargetId === undefined && !currentTarget?.canProvideContext && addCurrentPageAsContextUserPreference === true && creationContextParams?.isViewMode !== false && typeof publishedView === 'object' && publishedView !== null && 'contentId' in publishedView && typeof publishedView.contentId === 'string' && 'contentType' in publishedView && publishedView.contentType === 'page';
    // The control cohort retains the original MAUI-on inference when no bridge is registered.
    const legacyPageView = productKey === 'confluence' && !skipEditorContext && !hasSurfaceContext;
    const creationContextIsViewMode = (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? creationContextParams?.isViewMode !== undefined ? creationContextParams.isViewMode : isViewMode || (isNewViewRoutingEnabled ? hasSelectedPageView : legacyPageView) : isNewViewRoutingEnabled && creationContextParams?.isViewMode !== undefined ? creationContextParams.isViewMode : isViewMode || hasSelectedPageView;
    const isDraftLockedForEditing = !!editorContext?.isDraftLockedForEditing;
    const isRemoveBackground = productKey === 'confluence' && creationContextParams?.additionalContext?.imageEditAction === 'removeBackground' && (0, $2pQiO.UNSAFE_expValNoExposure)('cc_image_remove_background', 'isEnabled', false);
    const remixContext = isRemoveBackground ? {
        ...creationContextParams,
        mediaCollection: creationContextParams?.additionalContext?.mediaCollection
    } : editorContext;
    const contentMauiId = remixContext?.contentMauiId ?? creationContextParams?.contentMauiId;
    const mediaFileId = remixContext?.mediaFileId ?? creationContextParams?.mediaFileId;
    const dynamicUiType = remixContext?.dynamicUiType || creationContextParams?.dynamicUiType || lastAssistantMessageDynamicUiType;
    // The collection id for the selected media node, sent so the backend can resolve the
    // current media's collection when editing an existing image (image-create action).
    const mediaCollection = remixContext?.mediaCollection;
    // An Ask Rovo edit on a whiteboard embed names the board by content id, not by `contentMauiId`,
    // so its `remix` source would otherwise lose to the inline editor's top-level source.
    const isWhiteboardRemixEdit = source === 'CONFLUENCE_MAUI_INLINE_EDITOR' && creationContextParams?.source === 'remix' && Boolean(whiteboardContext) && (0, $4o0zT.isExperimentEnabled)('cc_maui_whiteboard_inline_edit');
    const creationContextSource = contentMauiId || mediaFileId || isWhiteboardRemixEdit ? 'remix' : // If source is explicitly passed, use that, otherwise rely on creationContextParams.source which is set at creation entry point (e.g. 'remix', 'ai-first-creation')
    source ?? creationContextParams?.source;
    // The context store returns the raw content context; the outbound
    // creationContext experience/contentTypes are attached here when the request is built.
    const creationContextExperience = (0, $859bfbfa800411c6$export$e5ce245ce709fc21)({
        contentContextValue: contentContextValue,
        isFirstPrompt: isFirstPrompt,
        source: source,
        creationContextSource: creationContextParams?.source,
        existingExperience: creationContextParams?.experience,
        existingContentTypes: creationContextParams?.contentTypes,
        chatContextContentType: editorContentType ?? (hasSelectedPageView ? 'page' : undefined),
        isRemixAction: isRemixAction,
        isViewMode: creationContextIsViewMode,
        contentMauiId: contentMauiId,
        mediaFileId: mediaFileId,
        isCreationContextContractEnabled: isCreationContextContractEnabled
    });
    // A remix edit must always carry the block being edited and its source, so these cannot stay
    // behind an unrelated experiment once the contract is enforced.
    const isRemixEditContract = isCreationContextContractEnabled && (creationContextExperience?.experience ?? creationContextParams?.experience) === 'remix_edit';
    const creationContextBlocks = (0, $281fa3f29881e068$export$e1dc015944c90cb9)({
        existingBlocks: creationContextParams?.blocks,
        experience: creationContextExperience?.experience ?? creationContextParams?.experience,
        source: creationContextSource,
        contentMauiId: contentMauiId,
        mediaFileId: mediaFileId,
        dynamicUiType: remixContext?.dynamicUiType ?? creationContextParams?.dynamicUiType,
        isCreationContextContractEnabled: isCreationContextContractEnabled
    });
    const stagingAreaEntryPoint = chatContextStoreActions.getStagingAreaEntryPoint();
    const isFormsOrSurveysSmartCreate = contentContextValue === 'staging-area' && (stagingAreaEntryPoint === 'jsmFormsRovoCreate' && (0, $iDrrr.fg)('soju-5536-forms-skill') && (0, $4o0zT.isExperimentEnabled)('rovo_chat_manage_forms_experiment') || stagingAreaEntryPoint === 'jsmSurveyRovoCreate' && (0, $iDrrr.fg)('phx_stop_confluence_page_create_when_create_survey'));
    const isAgentCreationSmartCreate = stagingAreaEntryPoint === 'rovo-agent-create-modal' && (0, $iDrrr.fg)('sltns-1529-draft-agent-non-consequential');
    const creationContext = {
        ...creationContextParams ? creationContextParams : {},
        // When the rearchitecture gate is on and we're fixing a staging-area first-prompt
        // (user opened Rovo chat on a live page they just created via CWR), the staging-area
        // store state is stale. The user is chatting about the page they're editing — not
        // running a CWR create flow — so isStagingArea should be false.
        isStagingArea: isStagingAreaFirstPromptFix ? false : contentContextValue === 'staging-area',
        productKey: productKey,
        // When `contentMauiId` or `mediaFileId` is present, we don't need to send the source
        // Ideally we want to set it upstream, but we need to ensure we don't break existing functionality
        source: creationContextSource,
        isViewMode: creationContextIsViewMode,
        isDraftLockedForEditing: isDraftLockedForEditing,
        useGenericEditorSkill: useGenericEditorSkill,
        additionalContext: additionalCreationContext || additionalCreationContextParams || bridgeAdditionalContext || mediaCollection ? {
            ...additionalCreationContext,
            ...additionalCreationContextParams,
            ...mediaCollection ? {
                mediaCollection: mediaCollection
            } : {},
            ...bridgeAdditionalContext
        } : undefined,
        ...jiraContext && {
            jiraContext: jiraContext
        },
        ...((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) || isRemixEditContract || isRemoveBackground) && {
            ...remixContext?.dynamicUiSource && {
                dynamicUiSource: {
                    ...remixContext.dynamicUiSource,
                    ...creationContextParams?.dynamicUiSource?.fragmentAdf && {
                        fragmentAdf: creationContextParams.dynamicUiSource.fragmentAdf
                    }
                }
            },
            ...(isRemixAction || source === 'remix' || creationContextParams?.source === 'remix' || isRemixEditContract) && {
                dynamicUiType: dynamicUiType
            },
            ...remixContext?.dynamicUiSubtype && {
                dynamicUiSubtype: remixContext.dynamicUiSubtype
            },
            contentMauiId: contentMauiId,
            mediaFileId: mediaFileId
        },
        ...creationContextBlocks && {
            blocks: creationContextBlocks
        },
        // Derive experience and contentTypes for CWR staging-area follow-ups and global chat context.
        ...creationContextExperience,
        // JSM Forms and Surveys use their own skill routing for initial prompts and refinements.
        ...(isFormsOrSurveysSmartCreate || isAgentCreationSmartCreate) && {
            experience: null,
            isStagingArea: false
        }
    };
    // A remix edit targets a block, not the content hosting it, so the contract requires every
    // surface context to be absent. The context is still resolved above, because it carries the
    // MAUI identifiers that classify the edit in the first place.
    const sendsSurfaceContext = !isRemixEditContract;
    // Bookmark
    const artifactContext = chatContextStoreActions.getArtifactContext?.();
    return {
        browserContext: browserContext,
        editorContext: sendsSurfaceContext ? editorContext : undefined,
        whiteboardContext: sendsSurfaceContext ? whiteboardContext : undefined,
        slidesContext: sendsSurfaceContext ? slidesContext : undefined,
        databaseContext: sendsSurfaceContext ? databaseContext : undefined,
        dashboardEditorContext: dashboardEditorContext,
        additionalContext: {
            creationContext: isCreationContextContractEnabled || (0, $iDrrr.fg)('confluence_aifc_new_live_page_chat_context') ? (0, $d754fa0337b217c7$export$11b60038f3efc9bb)(creationContext) : creationContext,
            userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            search_artifact: searchArtifact
        },
        computedExperience: isFormsOrSurveysSmartCreate || isAgentCreationSmartCreate ? undefined : creationContextExperience?.experience,
        aiFeatureContext: productKey === 'confluence' && publishedView && !hasSelectedPageView && (0, $4o0zT.isExperimentEnabled)('aifc_creation_context_stale_target_fix') ? {
            ...aiFeatureContext,
            confluence_view_context: undefined
        } : aiFeatureContext,
        jiraWorkflowContext: chatContextStoreActions.getJiraWorkflowContext(),
        dashboardContext: chatContextStoreActions.getDashboardContext(),
        artifactContext: artifactContext,
        useCurrentBrowsingContext: chatContextStoreActions.useCurrentBrowsingContext(!!addCurrentPageAsContextUserPreference, excludePageContext ? {
            excludePageContext: excludePageContext
        } : undefined)
    };
};
module.exports["populateSendMessageContext"] = $d0254ff0647fc0e0$export$e038cea4925a1058;

});

parcelRegister("kc9aB", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $8et9H = parcelRequire("8et9H");

const $4d3a981e5d8e63af$export$d6a1a695ea643f8e = (fragmentNodes)=>fragmentNodes.reduce((total, node)=>(0, $4EPzQ.reduce)(node, (count, n)=>n.type === 'text' ? count + (0, $8et9H.wordCount)(n.text) : count, total), 0);
module.exports["countFragmentWords"] = $4d3a981e5d8e63af$export$d6a1a695ea643f8e;

});

parcelRegister("fC0nb", function(module, exports) {
/**
 * Checks whether a top-level adf block has a given localId anywhere in its subtree.
 */ const $ab72d10cf1425a37$var$containsLocalId = (node, localId)=>{
    if (node.attrs?.localId === localId) return true;
    return (node.content ?? []).some((child)=>$ab72d10cf1425a37$var$containsLocalId(child, localId));
};
const $ab72d10cf1425a37$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension',
    'multiBodiedExtension'
]);
const $ab72d10cf1425a37$var$getTopLevelNodeAnatomy = (node)=>{
    if (!$ab72d10cf1425a37$var$EXTENSION_NODE_TYPES.has(node.type)) return node.type;
    const extensionKey = node.attrs?.extensionKey;
    if (typeof extensionKey !== 'string' || !extensionKey) return node.type;
    const extensionType = node.attrs?.extensionType;
    const isMacro = typeof extensionType === 'string' && extensionType.includes('macro');
    return `${isMacro ? 'macro' : 'extension'}:${extensionKey}`;
};
const $ab72d10cf1425a37$export$1e86d752377e082a = (fullAdf, startLocalId, endLocalId, options = {})=>{
    if (!startLocalId || !endLocalId) return [];
    try {
        const topLevelNodes = fullAdf?.content ?? [];
        // A selection anchor can be anywhere in the doc tree, not just at the top level. We need to know which top-level ADF component the selection belongs to.
        let startNodeIndex;
        let endNodeIndex;
        for(let i = 0; i < topLevelNodes.length; i++){
            if (startNodeIndex === undefined && $ab72d10cf1425a37$var$containsLocalId(topLevelNodes[i], startLocalId)) startNodeIndex = i;
            if (endNodeIndex === undefined && $ab72d10cf1425a37$var$containsLocalId(topLevelNodes[i], endLocalId)) endNodeIndex = i;
            if (startNodeIndex !== undefined && endNodeIndex !== undefined) break;
        }
        if (startNodeIndex === undefined || endNodeIndex === undefined) return [];
        // The editor gives IDs in selection direction (can be right-to-left), so we use
        // min/max to get everything between the two anchors regardless of order.
        const from = Math.min(startNodeIndex, endNodeIndex);
        const to = Math.max(startNodeIndex, endNodeIndex);
        return [
            ...new Set(topLevelNodes.slice(from, to + 1).filter(options.includeNode ?? (()=>true)).map($ab72d10cf1425a37$var$getTopLevelNodeAnatomy).filter((nodeAnatomy)=>Boolean(nodeAnatomy)))
        ];
    } catch  {
        // swallow the error and return nothing since this is just for analytics.
        return [];
    }
};
module.exports["getTopLevelNodeTypes"] = $ab72d10cf1425a37$export$1e86d752377e082a;

});

parcelRegister("cgxs9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $b616865c5b999c46$export$d4401c5bcbf9905e = ()=>(0, $iDrrr.fg)('rovo_chat_enable_inline_lumina') && (0, $iDrrr.fg)('rovo_chat_answer_ui_parts');
module.exports["isAnswerUiPartsEnabled"] = $b616865c5b999c46$export$d4401c5bcbf9905e;

});

parcelRegister("gulpi", function(module, exports) {
/** Display label and dedup key for the synthetic suggestion (not the prompt sent on click). */ const $5a4419e3b28274bd$export$43489e04a87de7d0 = 'Create a Confluence page from this response';
module.exports["CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT"] = $5a4419e3b28274bd$export$43489e04a87de7d0;

});

parcelRegister("042Lk", function(module, exports) {

var $dw75i = parcelRequire("dw75i");


var $cHkvP = parcelRequire("cHkvP");

function $15425edb4a069f0c$export$daae0e815c1fe242(messages) {
    return (0, $cHkvP.getLastAssistantActions)(messages).some((action)=>action.key === (0, $dw75i.ASK_QUESTION_KEY));
}
module.exports["lastAssistantHasAskQuestionAction"] = $15425edb4a069f0c$export$daae0e815c1fe242;

});

parcelRegister("cWJWG", function(module, exports) {
/**
 * Minimum interval threshold in milliseconds.
 * Intervals at or below this threshold are excluded from dead air tracking.
 */ const $659fb01017b58587$export$a47f8ff651baafd3 = 20;


const $748bcb1250622518$export$1dad78007a379433 = (intervalMs)=>{
    return intervalMs <= (0, $659fb01017b58587$export$a47f8ff651baafd3);
};
module.exports["shouldExcludeInterval"] = $748bcb1250622518$export$1dad78007a379433;

});

parcelRegister("jr1ne", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iW40i = parcelRequire("iW40i");


var $c7So7 = parcelRequire("c7So7");

const $34f4f9147dd524c7$export$4124b3cbf6d26820 = ({ useSmartCreationChatStoreApi: useSmartCreationChatStoreApi })=>{
    const { activeConversation: activeConversation } = useSmartCreationChatStoreApi();
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: activeConversation?.id
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('aifc_show_connected_apps_auth_login_screen')) return null;
        if (chatMessages.length === 0) return null;
        const lastAssistantMessage = (0, $c7So7.findLastAssistantMessage)(chatMessages);
        if (!lastAssistantMessage) return null;
        return $34f4f9147dd524c7$export$74c2c8fe0412025(lastAssistantMessage?.content?.message?.message?.content ?? '');
    }, [
        chatMessages
    ]);
};
function $34f4f9147dd524c7$export$74c2c8fe0412025(content) {
    if (!content) return null;
    let textContent;
    if (typeof content === 'object') textContent = JSON.stringify(content);
    else textContent = content;
    const regex = /https:\/\/id\.(stg\.internal\.)?atlassian\.com\/outboundAuth\/start[^\s)"]*/g;
    const matches = textContent.match(regex);
    return matches ? matches[0] : null;
}
module.exports["useLastAssistantMessageAuthLink"] = $34f4f9147dd524c7$export$4124b3cbf6d26820;
module.exports["extractOutboundAuthLink"] = $34f4f9147dd524c7$export$74c2c8fe0412025;

});

parcelRegister("6pP3y", function(module, exports) {
const $499d3f3a0572e475$var$lifecycleStage = {
    STARTED: 'started',
    ACTION_PREPARE: 'actionPrepare',
    ACTION_PART: 'actionPart',
    ACTION_COMPLETE: 'actionComplete'
};
const $499d3f3a0572e475$var$MAX_TRACKED_REQUESTS = 100;
const $499d3f3a0572e475$var$lifecycleByRequest = new Map();
const $499d3f3a0572e475$var$getRequestKey = ({ conversationId: conversationId, messageId: messageId })=>JSON.stringify([
        conversationId,
        messageId
    ]);
const $499d3f3a0572e475$var$setLifecycleSnapshot = (requestKey, snapshot)=>{
    // Refresh insertion order so eviction keeps the requests that changed most recently.
    $499d3f3a0572e475$var$lifecycleByRequest.delete(requestKey);
    $499d3f3a0572e475$var$lifecycleByRequest.set(requestKey, snapshot);
    if ($499d3f3a0572e475$var$lifecycleByRequest.size > $499d3f3a0572e475$var$MAX_TRACKED_REQUESTS) {
        const oldestRequestKey = $499d3f3a0572e475$var$lifecycleByRequest.keys().next().value;
        if (oldestRequestKey !== undefined) $499d3f3a0572e475$var$lifecycleByRequest.delete(oldestRequestKey);
    }
};
const $499d3f3a0572e475$var$start = ({ conversationId: conversationId, messageId: messageId, startedAtMs: startedAtMs, latencyBudgetMs: latencyBudgetMs })=>{
    const requestKey = $499d3f3a0572e475$var$getRequestKey({
        conversationId: conversationId,
        messageId: messageId
    });
    if ($499d3f3a0572e475$var$lifecycleByRequest.has(requestKey)) return;
    $499d3f3a0572e475$var$setLifecycleSnapshot(requestKey, {
        startedAtMs: startedAtMs,
        latencyBudgetMs: latencyBudgetMs,
        latestLifecycleStage: $499d3f3a0572e475$var$lifecycleStage.STARTED
    });
};
const $499d3f3a0572e475$var$update = ({ conversationId: conversationId, messageId: messageId, latestLifecycleStage: latestLifecycleStage })=>{
    const requestKey = $499d3f3a0572e475$var$getRequestKey({
        conversationId: conversationId,
        messageId: messageId
    });
    const lifecycle = $499d3f3a0572e475$var$lifecycleByRequest.get(requestKey);
    if (!lifecycle) return;
    $499d3f3a0572e475$var$setLifecycleSnapshot(requestKey, {
        ...lifecycle,
        latestLifecycleStage: latestLifecycleStage
    });
};
const $499d3f3a0572e475$var$get = ({ conversationId: conversationId, messageId: messageId })=>{
    const lifecycle = $499d3f3a0572e475$var$lifecycleByRequest.get($499d3f3a0572e475$var$getRequestKey({
        conversationId: conversationId,
        messageId: messageId
    }));
    return lifecycle ? {
        ...lifecycle
    } : undefined;
};
const $499d3f3a0572e475$export$39fd3c8ef5faa292 = {
    featureGate: 'aifc_preview_card_mount_event',
    stage: $499d3f3a0572e475$var$lifecycleStage,
    start: $499d3f3a0572e475$var$start,
    update: $499d3f3a0572e475$var$update,
    get: $499d3f3a0572e475$var$get
};
module.exports["previewCardRenderLifecycle"] = $499d3f3a0572e475$export$39fd3c8ef5faa292;

});

parcelRegister("1dlVf", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $hpOyG = parcelRequire("hpOyG");


var $1Tpom = parcelRequire("1Tpom");

const $502ee9e70a8bf8b6$export$24a03a39abc3110e = ()=>{
    const additionalAttributes = {
        isInitialDataReceived: null
    };
    const subExperienceCollect = (0, $hpOyG.collectAllWithSubExperienceAttributes)([
        (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
    ], additionalAttributes);
    return (events, experience)=>{
        for (const event of events)if (event.name === (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED) {
            if (event.action === 'taskSuccess') additionalAttributes.isInitialDataReceived = true;
            else if (event.action === 'taskFail') additionalAttributes.isInitialDataReceived = false;
        }
        // If AIFC_INITIAL_DATA_RECEIVED fails, fail AIFC_GENERATE_CONTENT
        (0, $1Tpom.failExperienceOnSubExperienceFail)((0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED, experience, events, additionalAttributes);
        subExperienceCollect(events, experience);
    };
};
module.exports["createAifcExperienceCollect"] = $502ee9e70a8bf8b6$export$24a03a39abc3110e;

});

parcelRegister("4u5Na", function(module, exports) {
const $89bc7ec19f06314f$var$controllers = new WeakSet();
const $89bc7ec19f06314f$export$51bb5ff0485253d0 = {
    mark (controller) {
        if (controller) $89bc7ec19f06314f$var$controllers.add(controller);
    },
    has (controller) {
        return $89bc7ec19f06314f$var$controllers.has(controller);
    }
};
module.exports["explicitUserCancellations"] = $89bc7ec19f06314f$export$51bb5ff0485253d0;

});

parcelRegister("4KNZy", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

const $1a12400c97e2750c$var$latestUserSubmissionByConversation = new Map();
const $1a12400c97e2750c$export$7054fc0c83e73365 = {
    recordLatestUserSubmission (submission, { abortSignal: abortSignal } = {}) {
        $1a12400c97e2750c$var$latestUserSubmissionByConversation.set(submission.conversationId, submission);
        const clearIfStillLatest = ()=>{
            if ($1a12400c97e2750c$var$latestUserSubmissionByConversation.get(submission.conversationId) === submission) $1a12400c97e2750c$var$latestUserSubmissionByConversation.delete(submission.conversationId);
        };
        if (abortSignal?.aborted) clearIfStillLatest();
        else if (abortSignal) (0, $cbY7C.bind)(abortSignal, {
            type: 'abort',
            listener: clearIfStillLatest,
            options: {
                once: true
            }
        });
        return clearIfStillLatest;
    },
    getLatestUserSubmission (conversationId) {
        return $1a12400c97e2750c$var$latestUserSubmissionByConversation.get(conversationId);
    },
    replaceHumanMessageId ({ conversationId: conversationId, oldId: oldId, newId: newId }) {
        const submission = $1a12400c97e2750c$var$latestUserSubmissionByConversation.get(conversationId);
        if (submission?.humanMessageId === oldId) submission.humanMessageId = newId;
    },
    clearLatestUserSubmission ({ conversationId: conversationId, humanMessageId: humanMessageId }) {
        const submission = $1a12400c97e2750c$var$latestUserSubmissionByConversation.get(conversationId);
        if (!humanMessageId || submission?.humanMessageId === humanMessageId) $1a12400c97e2750c$var$latestUserSubmissionByConversation.delete(conversationId);
    }
};
module.exports["userSubmissionLifecycle"] = $1a12400c97e2750c$export$7054fc0c83e73365;

});

parcelRegister("6yl1r", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $db3c42afc4fa6735$export$c928e016dc251d41 = ()=>(0, $iDrrr.fg)('jira_ai_task_level_planning_ootb_agent') || (0, $iDrrr.fg)('jira-ai-repo-selection-technical-extraction');
module.exports["isPlanWorkItemTechChangesEnabled"] = $db3c42afc4fa6735$export$c928e016dc251d41;

});

parcelRegister("eHZQi", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $1dlVf = parcelRequire("1dlVf");

const $36de52eea4825a49$export$7f96f53f53522bb4 = ({ experienceTracker: experienceTracker, conversationId: conversationId, attributes: attributes })=>{
    const childAttributes = {
        ...attributes,
        parentExperienceId: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
    };
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        id: conversationId,
        collect: (0, $1dlVf.createAifcExperienceCollect)(),
        attributes: attributes
    });
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        id: conversationId,
        attributes: childAttributes
    });
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        id: conversationId,
        attributes: childAttributes
    });
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        id: `${conversationId}-initial`,
        attributes: childAttributes
    });
};
module.exports["startAifcGenerateContentExperiences"] = $36de52eea4825a49$export$7f96f53f53522bb4;

});

parcelRegister("4tJut", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");

const $d8449325d3bd5f74$export$86db56030b57ba34 = {
    initializeChannels: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.initialize-channels'
    }),
    timeToRenderMessageContent: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.time-to-render-message-content'
    }),
    timeToRenderFinalResponse: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.time-to-render-final-response'
    }),
    sendConfirmedToolsTimeToFinishStream: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-finish-stream'
    }),
    sendConfirmedToolsTimeToFirstAnswerPart: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part'
    }),
    messageCompositionTime: (0, $iDdTC.metrics).interaction({
        key: 'ai-mate.message-composition-time'
    })
};
module.exports["interactionMetrics"] = $d8449325d3bd5f74$export$86db56030b57ba34;

});

parcelRegister("1YDZA", function(module, exports) {

var $7weDN = parcelRequire("7weDN");


var $4jIXV = parcelRequire("4jIXV");


var $igOtY = parcelRequire("igOtY");

const $5596f0e6fe6fefb8$var$parsePolicyPreviewActionData = (rawData)=>{
    let data = rawData;
    if (typeof data === 'string') try {
        data = JSON.parse(data);
    } catch  {
        return null;
    }
    if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
    if ('input' in data) {
        data = data.input;
        if (typeof data === 'string') try {
            data = JSON.parse(data);
        } catch  {
            return null;
        }
    }
    if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
    return data;
};
const $5596f0e6fe6fefb8$export$5e69f99ba3976139 = (messages)=>{
    for(let messageIndex = messages.length - 1; messageIndex >= 0; messageIndex -= 1){
        const message = messages[messageIndex];
        if (!(0, $igOtY.isStoreAssistant)(message)) continue;
        const actions = message.content.message.message.actions ?? [];
        for(let actionIndex = actions.length - 1; actionIndex >= 0; actionIndex -= 1){
            const action = actions[actionIndex];
            if (!(0, $4jIXV.isAdminhubPolicyCreateAction)(action) && !(0, $4jIXV.isAdminhubPolicyUpdateAction)(action)) continue;
            const data = $5596f0e6fe6fefb8$var$parsePolicyPreviewActionData(action.data);
            if (typeof data?.contentId === 'string' && data.contentId) return data.contentId;
        }
    }
    return undefined;
};


const $8b3c0db4a6142710$export$a1332a75c08a0c11 = (conversationId, messages)=>{
    const contentId = (0, $5596f0e6fe6fefb8$export$5e69f99ba3976139)(messages);
    return contentId !== undefined ? (0, $7weDN.getAdminhubPolicyPreviewClientId)(conversationId, contentId) : undefined;
};
module.exports["getPolicyPreviewReceiverId"] = $8b3c0db4a6142710$export$a1332a75c08a0c11;

});

parcelRegister("9MJ4r", function(module, exports) {
const $1c01c81c8cad171f$var$THIRD_PARTY_SOURCE_PRODUCTS = [
    'github',
    'google',
    'msteams',
    'outlook',
    'sharepoint',
    'slack'
];
const $1c01c81c8cad171f$export$3e411851a5f12cbb = (actionKey)=>{
    if (!actionKey) return null;
    const normalizedActionKey = actionKey.toLowerCase();
    return $1c01c81c8cad171f$var$THIRD_PARTY_SOURCE_PRODUCTS.find((sourceProduct)=>normalizedActionKey.startsWith(sourceProduct)) ?? null;
};
module.exports["getThirdPartySourceProductFromActionKey"] = $1c01c81c8cad171f$export$3e411851a5f12cbb;

});

parcelRegister("jUUpp", function(module, exports) {
const $a9bd253ecf93f89c$var$MCP_TOOL_SOURCE = 'MCP_TOOL';
const $a9bd253ecf93f89c$export$af4bad69aa3a06c5 = ({ toolDefinitionSource: toolDefinitionSource, key: key })=>toolDefinitionSource === $a9bd253ecf93f89c$var$MCP_TOOL_SOURCE ? undefined : key;
module.exports["redactToolKeyForPii"] = $a9bd253ecf93f89c$export$af4bad69aa3a06c5;

});

parcelRegister("bFeyZ", function(module, exports) {

var $iqkMb = parcelRequire("iqkMb");

const $62c65da6b8eb1f61$export$bab8a3e4fa0b7d89 = (storeAssistant)=>(0, $iqkMb.getInteractionModeExecutedFromStreamResponse)(storeAssistant?.content);
module.exports["getInteractionModeExecutedFromStoreAssistant"] = $62c65da6b8eb1f61$export$bab8a3e4fa0b7d89;

});

parcelRegister("jcJSP", function(module, exports) {
// findLastIndex polyfill since it's a newer ECMAScript feature
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLastIndex
const $ec7fe81370ed0fdb$export$8855a8be7bd3e9f8 = (array, predicate)=>{
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return i;
    }
    return -1;
};
module.exports["findLastIndex"] = $ec7fe81370ed0fdb$export$8855a8be7bd3e9f8;

});

parcelRegister("3TxKn", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $78444cf71927560a$export$b8d7540a5f22fede = (0, $kBr4q.createActionsHook)((0, $lx3cN.chatStore));
module.exports["useChatStoreActions"] = $78444cf71927560a$export$b8d7540a5f22fede;

});

parcelRegister("aXdbm", function(module, exports) {
const $6501787cbfb565d1$export$1c0805bd5fc59c20 = (content)=>{
    if (content == null || typeof content !== 'object' || !('structured' in content)) return null;
    const { text_parts: text_parts, data_parts: data_parts } = content;
    const textContent = text_parts?.map((part)=>part.text ?? '').join('').trim() || '';
    const a2uiMessages = data_parts?.filter((part)=>part?.metadata?.mimeType === 'application/json+a2ui' && part?.data != null).map((part)=>part.data);
    return {
        textContent: textContent,
        a2uiMessages: a2uiMessages && a2uiMessages.length > 0 ? a2uiMessages : undefined
    };
};
module.exports["extractA2UIFromStructuredContent"] = $6501787cbfb565d1$export$1c0805bd5fc59c20;

});

parcelRegister("5XX4K", function(module, exports) {

var $f3OgL = parcelRequire("f3OgL");


var $bxkJA = parcelRequire("bxkJA");

const $bb8517d09864aa83$export$bb73d89e7217c465 = ({ streamMessage: streamMessage, boundaryStart: boundaryStart, boundaryEnd: boundaryEnd, replacementContent: replacementContent })=>{
    const messageContent = (0, $bxkJA.isStreamResponse)(streamMessage) ? streamMessage.message.message.content : streamMessage.message.content;
    if (!messageContent || typeof messageContent !== 'string') return {
        processedStreamMessage: streamMessage,
        boundaryContents: []
    };
    const { processedText: processedText, boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(messageContent, boundaryStart, boundaryEnd, replacementContent);
    if (boundaryContents.length > 0) {
        if ((0, $bxkJA.isStreamResponse)(streamMessage)) streamMessage.message.message.content = processedText;
        else streamMessage.message.content = processedText;
    }
    return {
        processedStreamMessage: streamMessage,
        boundaryContents: boundaryContents
    };
};
module.exports["extractMarkdownContent"] = $bb8517d09864aa83$export$bb73d89e7217c465;

});

parcelRegister("eK93A", function(module, exports) {

var $l5TuZ = parcelRequire("l5TuZ");

const $6e31fae473633a0a$export$823ed9c8e3d751f5 = (streamMessage)=>{
    const content = streamMessage.message.message.content;
    if (typeof content !== 'string') return streamMessage;
    return {
        ...streamMessage,
        message: {
            ...streamMessage.message,
            message: {
                ...streamMessage.message.message,
                content: (0, $l5TuZ.preprocessDetails)(content)
            }
        }
    };
};
module.exports["preprocessStreamResponseDetails"] = $6e31fae473633a0a$export$823ed9c8e3d751f5;

});

parcelRegister("l5TuZ", function(module, exports) {
/**
 * Rewrites HTML `<details>` / `<summary>` collapsed sections embedded in
 * markdown into the Rovo-native boundary format that the rest of the stream
 * pipeline already understands.
 *
 *   <details><summary>Title</summary>Body</details>  →  ▞Title\nBody▚
 *
 * Downstream, the existing `expand` streamable component (see
 * `getStreamableComponents` in `chat-store/utils.ts`) picks up `▞…▚`, swaps
 * in the `[^expand^]` placeholder, and renders the body out-of-band through
 * `markdownData`.
 *
 * Spec reference: the HTML `<details>` element (rendered as a disclosure
 * widget) and its `<summary>` child, as documented by MDN and supported by
 * common markdown renderers.
 *
 * Known limitations (V1):
 *  - Code-fence aware rewriting is not implemented. A `<details>` block
 *    embedded inside a ``` code fence will still be rewritten. Agents
 *    producing collapsed sections generally don't do this, but if it becomes
 *    a real problem the fence-tracking state machine from
 *    `sanitize-markdown.ts` can be ported here.
 *  - Nested `<details>` are passed through unchanged.
 */ const $5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY = "\u259E";
const $5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY = "\u259A";
const $5fc0b06474009091$var$DEFAULT_TITLE = 'Details';
// Complete-tag matchers. Case-insensitive, allow attributes on open tags.
const $5fc0b06474009091$var$DETAILS_OPEN_RE = /^<details(?:\s[^>]*)?>$/i;
const $5fc0b06474009091$var$SUMMARY_OPEN_RE = /^<summary(?:\s[^>]*)?>$/i;
const $5fc0b06474009091$var$SUMMARY_CLOSE_RE = /^<\/summary\s*>$/i;
const $5fc0b06474009091$var$DETAILS_CLOSE_RE = /^<\/details\s*>$/i;
// Fast-path probe: if the text cannot possibly contain a relevant tag, skip
// the scan entirely.
const $5fc0b06474009091$var$HAS_RELEVANT_TAG_RE = /<\/?(?:details|summary)\b/i;
/**
 * Shared scan used by both the streaming and one-shot paths.
 *
 * When `allowBuffer` is `true`, a trailing incomplete tag (i.e. a `<` with
 * no subsequent `>`) is stashed on `state.buffer` for the next call instead
 * of being emitted. When `false` (flush / one-shot), the partial text is
 * emitted as literal.
 */ const $5fc0b06474009091$var$scan = (input, state, allowBuffer)=>{
    let out = '';
    let i = 0;
    const emitText = (text)=>{
        if (state.mode === 'IN_DETAILS_PRE_SUMMARY') // Silently discard text between `<details>` and `<summary>` (in
        // practice this is whitespace / newlines the agent formats for
        // readability).
        return;
        if (state.mode === 'IN_SUMMARY') {
            // Collapse newlines inside the summary so the downstream
            // `splitHeaderAndContent` (first-newline split) still sees a
            // single-line title.
            out += text.replace(/\r?\n/g, ' ');
            return;
        }
        out += text;
    };
    while(i < input.length){
        const lt = input.indexOf('<', i);
        if (lt === -1) {
            emitText(input.slice(i));
            break;
        }
        if (lt > i) emitText(input.slice(i, lt));
        const gt = input.indexOf('>', lt);
        if (gt === -1) {
            if (allowBuffer) {
                state.buffer = input.slice(lt);
                return out;
            }
            // One-shot path: emit the dangling partial tag as literal.
            emitText(input.slice(lt));
            break;
        }
        const tag = input.slice(lt, gt + 1);
        if ($5fc0b06474009091$var$DETAILS_OPEN_RE.test(tag)) {
            if (state.mode === 'NORMAL') state.mode = 'IN_DETAILS_PRE_SUMMARY';
            else // Nested or unexpected — pass through so we don't eat user text.
            emitText(tag);
        } else if ($5fc0b06474009091$var$SUMMARY_OPEN_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                state.mode = 'IN_SUMMARY';
                out += $5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY;
            } else emitText(tag);
        } else if ($5fc0b06474009091$var$SUMMARY_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_SUMMARY') {
                state.mode = 'IN_DETAILS_BODY';
                out += '\n';
            } else emitText(tag);
        } else if ($5fc0b06474009091$var$DETAILS_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_BODY') {
                state.mode = 'NORMAL';
                out += $5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY;
            } else if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                // `<details>…</details>` with no `<summary>`. Synthesise a
                // default header so the renderer has something to show.
                state.mode = 'NORMAL';
                out += `${$5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY}${$5fc0b06474009091$var$DEFAULT_TITLE}\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
            } else if (state.mode === 'IN_SUMMARY') {
                // Malformed: `</details>` while still inside `<summary>`. Close
                // the summary implicitly and close the details.
                state.mode = 'NORMAL';
                out += `\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
            } else emitText(tag);
        } else // Unrelated tag (e.g. `<span>`, `<a href=…>`) — pass through.
        emitText(tag);
        i = gt + 1;
    }
    state.buffer = '';
    return out;
};
const $5fc0b06474009091$var$synthesiseClosers = (state)=>{
    let out = '';
    if (state.mode === 'IN_DETAILS_PRE_SUMMARY') out += `${$5fc0b06474009091$var$DETAILS_OPEN_BOUNDARY}${$5fc0b06474009091$var$DEFAULT_TITLE}\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_SUMMARY') out += `\n${$5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_DETAILS_BODY') out += $5fc0b06474009091$var$DETAILS_CLOSE_BOUNDARY;
    state.mode = 'NORMAL';
    return out;
};
const $5fc0b06474009091$export$c00e46a308694bc9 = (text)=>{
    if (!text || !$5fc0b06474009091$var$HAS_RELEVANT_TAG_RE.test(text)) return text;
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    let out = $5fc0b06474009091$var$scan(text, state, /* allowBuffer */ false);
    out += $5fc0b06474009091$var$synthesiseClosers(state);
    return out;
};
const $5fc0b06474009091$export$88c7624283baadd3 = ()=>{
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    return {
        process (chunk) {
            const combined = state.buffer + (chunk ?? '');
            state.buffer = '';
            // Fast-path: when we are not inside a details block and the combined
            // text contains no `<` at all, a tag is impossible — skip the scan.
            // We deliberately do NOT use a name-level regex here: a partial tag
            // like `<det` spanning a chunk boundary must still be buffered for
            // the next chunk to complete it.
            if (!combined || state.mode === 'NORMAL' && !combined.includes('<')) return combined;
            return $5fc0b06474009091$var$scan(combined, state, /* allowBuffer */ true);
        },
        flush () {
            let out = '';
            if (state.buffer) {
                const leftover = state.buffer;
                state.buffer = '';
                out += $5fc0b06474009091$var$scan(leftover, state, /* allowBuffer */ false);
            }
            out += $5fc0b06474009091$var$synthesiseClosers(state);
            return out;
        }
    };
};
module.exports["preprocessDetails"] = $5fc0b06474009091$export$c00e46a308694bc9;
module.exports["createDetailsPreprocessor"] = $5fc0b06474009091$export$88c7624283baadd3;

});

parcelRegister("7crhj", function(module, exports) {
const $b370bad343af9dc4$export$380cb1859b59b828 = (a2uiMessage)=>{
    const wire = a2uiMessage;
    return wire.createSurface !== undefined || wire.beginRendering !== undefined || wire.type === 'createSurface';
};
module.exports["isCreateSurface"] = $b370bad343af9dc4$export$380cb1859b59b828;

});

parcelRegister("3iEfv", function(module, exports) {

var $6Bfyn = parcelRequire("6Bfyn");


var $4vH8u = parcelRequire("4vH8u");


var $5XX4K = parcelRequire("5XX4K");

const $792d422e77036578$export$b7cc8b01149baaeb = ({ streamMessage: streamMessage, markdownData: markdownData })=>{
    const followUpsMsg = (0, $5XX4K.extractMarkdownContent)({
        streamMessage: streamMessage,
        boundaryStart: (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_MARKER),
        boundaryEnd: '',
        replacementContent: `\n\n[^${(0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY)}^]\n\n`
    });
    followUpsMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`${0, $4vH8u.ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}-${index}`] = content;
    });
    return followUpsMsg.processedStreamMessage;
};
module.exports["extractActionableFollowUpsMarkdownData"] = $792d422e77036578$export$b7cc8b01149baaeb;

});

parcelRegister("lwUDA", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");

const $42ee3d9adb0996af$export$74030c0e2cebe61b = ({ experienceTracker: experienceTracker, reason: reason, terminalReason: terminalReason, attributes: attributes = {} })=>{
    experienceTracker.abort({
        name: (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
        reason: reason,
        checkForTimeout: false,
        attributes: {
            ...attributes,
            [(0, $irnO2.PreviewCardRenderDiagnosticAttribute).TERMINAL_REASON]: terminalReason
        }
    });
};
module.exports["abortPreviewCardRenderExperience"] = $42ee3d9adb0996af$export$74030c0e2cebe61b;

});

parcelRegister("jyZaR", function(module, exports) {

var $igOtY = parcelRequire("igOtY");

const $45b4795bcee59329$export$b53f205a52449551 = ({ lastAgentMessageStatus: lastAgentMessageStatus })=>({
        status: (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: [],
        storeAbortController: undefined,
        ...lastAgentMessageStatus !== undefined && {
            lastAgentMessageStatus: lastAgentMessageStatus
        }
    });
module.exports["clearStatus"] = $45b4795bcee59329$export$b53f205a52449551;

});

parcelRegister("l6xCb", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hlvTd = parcelRequire("hlvTd");


var $6geN3 = parcelRequire("6geN3");


var $8zf2J = parcelRequire("8zf2J");

const $aa6ef2d1d495b174$var$isFromPreviousSite = (api, containerProps)=>{
    const actionSiteId = containerProps.siteId;
    if (!actionSiteId) return false;
    const { hydratedSiteId: hydratedSiteId } = api.getState();
    return hydratedSiteId !== undefined && hydratedSiteId !== actionSiteId;
};
const $aa6ef2d1d495b174$var$withSiteGuard = (api, containerProps, actionLoggableName)=>{
    const actionSiteId = containerProps.siteId;
    if (!actionSiteId) return api;
    const dropped = (what)=>{
        (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: dropped ${actionLoggableName} ${what} from a previous site`);
    };
    return {
        getState: api.getState,
        setState: (partialState)=>{
            if ($aa6ef2d1d495b174$var$isFromPreviousSite(api, containerProps)) {
                dropped('state update');
                return;
            }
            api.setState(partialState);
        },
        dispatch: (actionThunk)=>{
            if ($aa6ef2d1d495b174$var$isFromPreviousSite(api, containerProps)) {
                dropped('dispatch');
                return undefined;
            }
            return api.dispatch(actionThunk);
        }
    };
};
const $aa6ef2d1d495b174$export$f65ce059a9114838 = (actionLoggableName, actionHOF, props)=>(...args)=>async (api, containerProps)=>{
            const guardedApi = (0, $iDrrr.fg)('rovo_chat_site_switch_reset') ? $aa6ef2d1d495b174$var$withSiteGuard(api, containerProps, actionLoggableName) : api;
            /*
    Add custom logic here
   */ // General try/catch statement to handle unexpected errors
            try {
                (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: executing ${actionLoggableName}`);
                // Here we call the action callback
                // Same as dispatch(actionHOF)
                const action = actionHOF(...args);
                // Here we execute the action i.e. what happens internally when the action is dispatched
                const result = await action(guardedApi, containerProps);
                return result;
            } catch (error) {
                // `storeErrorHandler` reports through `containerProps`, which the guarded api cannot
                // reach, so a late rejection would return the new site to the error state the switch
                // just cleared.
                if ((0, $iDrrr.fg)('rovo_chat_site_switch_reset') && $aa6ef2d1d495b174$var$isFromPreviousSite(api, containerProps)) {
                    (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: dropped ${actionLoggableName} error handling from a previous site`);
                    // Abort, not fail: the request was abandoned by the site change.
                    if (props?.experienceName) containerProps.experienceTracker.abort({
                        name: props.experienceName(args),
                        reason: 'site changed'
                    });
                    return undefined;
                }
                (0, $8zf2J.storeErrorHandler)({
                    args: args,
                    api: guardedApi,
                    actionLoggableName: actionLoggableName,
                    error: error,
                    containerProps: containerProps,
                    setConversationData: $6geN3.setConversationData,
                    experienceName: props?.experienceName,
                    getRateLimitState: props?.getRateLimitState,
                    entryPoint: props?.getErrorEntryPoint?.(args),
                    actionErrorHandler: props?.actionErrorHandler
                });
                return undefined;
            }
        };
module.exports["createSafeAction"] = $aa6ef2d1d495b174$export$f65ce059a9114838;

});

parcelRegister("16g08", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");

const $f6dab18fdd29edf9$export$4bae3e18e89647a6 = (params)=>{
    if (params.isCustomRovoAgent) return (0, $irnO2.ExperienceName).SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (params.deepResearchEnabled) return (0, $irnO2.ExperienceName).SEND_DR_MESSAGE;
    if (params.thinkDeeperEnabled) return (0, $irnO2.ExperienceName).SEND_TD_MESSAGE;
    if (params.taskModeEnabled) return (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE;
    return (0, $irnO2.ExperienceName).SEND_MESSAGE;
};
module.exports["getSendMessageExperienceName"] = $f6dab18fdd29edf9$export$4bae3e18e89647a6;

});

parcelRegister("6geN3", function(module, exports) {
const $f69dde7553530487$export$5f5161e42606b2f1 = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        if (!getState().conversations[conversationId]) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId],
                    ...data
                }
            }
        });
    };
module.exports["setConversationData"] = $f69dde7553530487$export$5f5161e42606b2f1;

});

parcelRegister("dxD6w", function(module, exports) {
const $dd42129a708aebbe$var$assistantMessageIdGetters = new WeakMap();
const $dd42129a708aebbe$export$706979ec12751d01 = {
    register (storeAbortController, getAssistantMessageId) {
        $dd42129a708aebbe$var$assistantMessageIdGetters.set(storeAbortController, getAssistantMessageId);
    },
    get (storeAbortController) {
        return $dd42129a708aebbe$var$assistantMessageIdGetters.get(storeAbortController)?.();
    }
};
module.exports["activeAssistantMessageIds"] = $dd42129a708aebbe$export$706979ec12751d01;

});

parcelRegister("b6N3q", function(module, exports) {
const $e6fbdb99a6cf72b1$var$generateTraceId = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
class $e6fbdb99a6cf72b1$export$63af9387abd4676e extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            requestId: params.requestId,
            traceId: params.traceId ?? params.requestId ?? `RovoChatStreamTimeout-${$e6fbdb99a6cf72b1$var$generateTraceId()}`
        };
    }
}
module.exports["RovoChatStreamTimeoutError"] = $e6fbdb99a6cf72b1$export$63af9387abd4676e;

});

parcelRegister("bMRok", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $60d28b90aa6f9524$export$f2869f2905168ef1 extends Error {
    constructor(message, params = {}){
        super(message);
        this.errorAttributes = void 0;
        this.message_template = void 0;
        this.name = this.constructor.name;
        this.message_template = 'DEEP_RESEARCH_ERROR';
        this.errorAttributes = {
            errorCode: 'DEEP_RESEARCH_ERROR',
            traceId: params.traceId ?? `DeepResearch-${(0, $64wzj.generateTraceId)()}`,
            requestId: params.requestId
        };
    }
}
module.exports["DeepResearchError"] = $60d28b90aa6f9524$export$f2869f2905168ef1;

});

parcelRegister("hHBvs", function(module, exports) {

var $3PJhM = parcelRequire("3PJhM");

const $2db34f132729276a$var$getCauseErrorAttributes = (cause)=>{
    if (!cause || !('errorAttributes' in cause) || !(0, $3PJhM.isRecord)(cause.errorAttributes)) return {};
    const { statusCode: statusCode, errorCode: errorCode, rawErrorMessage: rawErrorMessage, traceId: traceId, requestId: requestId } = cause.errorAttributes;
    return {
        ...typeof statusCode === 'number' ? {
            statusCode: statusCode
        } : {},
        ...typeof errorCode === 'string' ? {
            errorCode: errorCode
        } : {},
        ...typeof rawErrorMessage === 'string' ? {
            rawErrorMessage: rawErrorMessage
        } : {},
        ...typeof traceId === 'string' ? {
            traceId: traceId
        } : {},
        ...typeof requestId === 'string' ? {
            requestId: requestId
        } : {}
    };
};
class $2db34f132729276a$export$a4ff042cd5c23500 extends Error {
    constructor(params){
        super(params.message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            conversationId: params.conversationId,
            messageId: params.messageId,
            invocationId: params.invocationId,
            actionKey: params.actionKey,
            ...$2db34f132729276a$var$getCauseErrorAttributes(params.cause)
        };
        if (params.cause) this.cause = params.cause;
    }
}
module.exports["MessageActionError"] = $2db34f132729276a$export$a4ff042cd5c23500;

});

parcelRegister("kncFb", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $75b7e2ed8237dfd5$export$cdcaebd3b25a3ac3 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            traceId: params.traceId ?? `NoFinalResponse-${(0, $64wzj.generateTraceId)()}`
        };
    }
}
module.exports["NoFinalResponseError"] = $75b7e2ed8237dfd5$export$cdcaebd3b25a3ac3;

});

parcelRegister("hwHCO", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $fa6e1ddcaead349c$export$7ed16f132715a198 extends Error {
    constructor(message, params){
        const { detail: detail, traceId: traceId } = params;
        super(message);
        this.detail = void 0;
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.detail = detail;
        this.errorAttributes = {
            errorCode: this.detail.message.message_template,
            statusCode: this.detail.message.status_code,
            rawErrorMessage: this.detail.message.content,
            // in case there is no traceId, we generate one in FE
            // and make it distinguishable from BE generated traceId
            // appended by random 5 digit number
            traceId: traceId ?? `StreamError-${(0, $64wzj.generateTraceId)()}`,
            requestId: this.detail.metadata?.request_id,
            latestStreamMessageType: this.detail.type,
            latestStreamMessageMillisOffset: this.detail.millisOffset
        };
    }
}
module.exports["StreamErrorException"] = $fa6e1ddcaead349c$export$7ed16f132715a198;

});

parcelRegister("bQxqB", function(module, exports) {

var $64wzj = parcelRequire("64wzj");

class $66c03daf42c2e3ec$export$7a01d8a5a5a1ae0a extends Error {
    constructor(message, params, cause){
        super(message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.cause = cause;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamGenerator-${(0, $64wzj.generateTraceId)()}`,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
    }
}
module.exports["StreamGeneratorError"] = $66c03daf42c2e3ec$export$7a01d8a5a5a1ae0a;

});

parcelRegister("icBz6", function(module, exports) {
const $44b6de0f59a4542f$export$567fc7097e064344 = ()=>String(Math.floor(Math.random() * 1000000));
module.exports["generateId"] = $44b6de0f59a4542f$export$567fc7097e064344;

});

parcelRegister("5iFVe", function(module, exports) {
const $60b66865acc994c3$export$3dfca8d0ecaaf31f = ({ messages: messages, messageId: messageId, searchType: searchType })=>{
    const startIndex = messages.findIndex((item)=>{
        switch(item.type){
            case 'HUMAN':
                return item.content.id === messageId;
            case 'ASSISTANT':
                return item.content.message.message.id === messageId;
            case 'FOLLOW_UP':
                return String(item.id) === messageId;
            default:
                return false;
        }
    });
    for(let i = startIndex; i >= 0; i--){
        if (messages[i].type === searchType) return messages[i];
    }
    return undefined;
};
module.exports["findPreviousByTypeFromId"] = $60b66865acc994c3$export$3dfca8d0ecaaf31f;

});

parcelRegister("cWP9O", function(module, exports) {

var $bkEBw = parcelRequire("bkEBw");


var $igOtY = parcelRequire("igOtY");

const $19ee74b7a1ea01da$export$7fd69d5cdd838542 = (messages, messageId)=>{
    let index = -1;
    const result = messages.find((item, i)=>{
        index = i;
        return (0, $igOtY.isStoreAssistant)(item) && (0, $bkEBw.getId)(item.content) === messageId;
    });
    return result ? {
        result: result,
        index: index
    } : {
        result: false,
        index: index
    };
};
module.exports["getAgentMessageById"] = $19ee74b7a1ea01da$export$7fd69d5cdd838542;

});

parcelRegister("awqa1", function(module, exports) {
const $407144c16139718a$export$e5fd1b788c68cb23 = 25;
const $407144c16139718a$export$6a4c5f0f0d581946 = 75;
const $407144c16139718a$export$bf3618a660f60d46 = 100;
const $407144c16139718a$export$f0248a5607f066a8 = 'Action execution failed';
module.exports["CONVERSATION_LIST_PAGE_SIZE"] = $407144c16139718a$export$e5fd1b788c68cb23;
module.exports["CONVERSATION_LIST_LOAD_MORE_PAGE_SIZE"] = $407144c16139718a$export$6a4c5f0f0d581946;
module.exports["CONVERSATION_LIST_MAX_SIZE"] = $407144c16139718a$export$bf3618a660f60d46;
module.exports["ACTION_EXECUTION_FAILED"] = $407144c16139718a$export$f0248a5607f066a8;

});

parcelRegister("9bLpG", function(module, exports) {

var $8ssI02 = parcelRequire("8ssI02");

const $b47f1c04462aca8a$export$221a61151a747a40 = ({ channelsFromAPI: channelsFromAPI, conversations: conversations, conversationsDeletedDuringCall: conversationsDeletedDuringCall = new Set() })=>{
    const localConversationByBackendId = new Map(Object.values(conversations).filter((c)=>Boolean(c.backendConversationId)).map((c)=>[
            c.backendConversationId,
            c
        ]));
    return channelsFromAPI.filter((channel)=>!conversationsDeletedDuringCall.has(channel.id)).reduce((acc, channel)=>{
        const localConversation = conversations[channel.id] ?? localConversationByBackendId.get(channel.id);
        acc[channel.id] = (0, $8ssI02.mergeConversationWithNetworkPriority)(channel, localConversation);
        return acc;
    }, {});
};
module.exports["getProcessedConversationChannels"] = $b47f1c04462aca8a$export$221a61151a747a40;

});

parcelRegister("iWQjF", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $igOtY = parcelRequire("igOtY");


var $awqa1 = parcelRequire("awqa1");


var $l6xCb = parcelRequire("l6xCb");


var $eBgZa = parcelRequire("eBgZa");


var $9bLpG = parcelRequire("9bLpG");


var $1IZrU = parcelRequire("1IZrU");


var $hQJOO = parcelRequire("hQJOO");

const $dbfaf0ab050513fc$var$runExperienceTrackerSafely = (stage, callback, isKillSwitchEnabled)=>{
    if (isKillSwitchEnabled) {
        callback();
        return;
    }
    try {
        callback();
    } catch (error) {
        (0, $hlvTd.addSentryBreadcrumb)({
            message: 'loadMoreConversationChannelsData: experience tracking failed',
            data: {
                stage: stage,
                error: error instanceof Error ? error.message : String(error)
            }
        });
    }
};
const $dbfaf0ab050513fc$export$95850e3f7783749e = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).loadMoreConversationChannelsData, ()=>async ({ setState: setState, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, unifiedTasksActions: unifiedTasksActions })=>{
        const isKillSwitchEnabled = (0, $iDrrr.fg)('rovo_chat_view_all_error_handling_killswitch');
        const { conversationPagination: conversationPagination, conversations: loadedConversations } = getState();
        const isSearchPaginationEnabled = (0, $iDrrr.fg)('rovo_chat_conversation_search_pagination');
        if (conversationPagination.isLoadingMore || !conversationPagination.hasMore || !conversationPagination.nextCursor && !isSearchPaginationEnabled) return;
        let pageLimit = (0, $awqa1.CONVERSATION_LIST_LOAD_MORE_PAGE_SIZE);
        if (isSearchPaginationEnabled) {
            const loadedCount = Object.keys(loadedConversations).filter((id)=>!(0, $1IZrU.isEmptyConversation)(id)).length;
            if (loadedCount >= (0, $awqa1.CONVERSATION_LIST_MAX_SIZE)) {
                setState({
                    conversationPagination: {
                        ...conversationPagination,
                        nextCursor: null,
                        hasMore: false,
                        loadMoreError: null
                    }
                });
                return;
            }
            pageLimit = Math.min(pageLimit, (0, $awqa1.CONVERSATION_LIST_MAX_SIZE) - loadedCount);
        }
        setState({
            conversationPagination: {
                ...conversationPagination,
                isLoadingMore: true,
                loadMoreError: null
            }
        });
        $dbfaf0ab050513fc$var$runExperienceTrackerSafely('start', ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS,
                name: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS
            });
        }, isKillSwitchEnabled);
        try {
            const conversationChannelsResponse = await assistanceService.getConversationChannels({
                limit: pageLimit,
                ...conversationPagination.nextCursor ? {
                    cursor: conversationPagination.nextCursor
                } : {}
            });
            let channelsFromAPI = conversationChannelsResponse.items;
            const { conversations: conversations } = getState();
            if (isSearchPaginationEnabled) {
                const loadedIds = new Set(Object.keys(conversations).filter((id)=>!(0, $1IZrU.isEmptyConversation)(id)));
                // Chats created during the request use capacity without being removed.
                channelsFromAPI = channelsFromAPI.filter((channel)=>{
                    if (loadedIds.has(channel.id) || (0, $1IZrU.isEmptyConversation)(channel.id)) return true;
                    if (loadedIds.size >= (0, $awqa1.CONVERSATION_LIST_MAX_SIZE)) return false;
                    loadedIds.add(channel.id);
                    return true;
                });
            }
            const processedChannels = (0, $9bLpG.getProcessedConversationChannels)({
                channelsFromAPI: channelsFromAPI,
                conversations: conversations
            });
            (0, $hQJOO.mergeConversationChannelTasks)(channelsFromAPI, unifiedTasksActions);
            const mergedConversations = {
                ...conversations,
                ...processedChannels
            };
            const isAtConversationLimit = isSearchPaginationEnabled && Object.keys(mergedConversations).filter((id)=>!(0, $1IZrU.isEmptyConversation)(id)).length >= (0, $awqa1.CONVERSATION_LIST_MAX_SIZE);
            if (isSearchPaginationEnabled && !isAtConversationLimit && conversationChannelsResponse.hasNext && (!conversationChannelsResponse.cursor || conversationChannelsResponse.cursor === conversationPagination.nextCursor)) {
                setState({
                    conversations: mergedConversations
                });
                throw new Error('Conversation pagination cursor did not advance');
            }
            setState({
                conversations: mergedConversations,
                conversationPagination: {
                    ...getState().conversationPagination,
                    nextCursor: isAtConversationLimit ? null : conversationChannelsResponse.cursor,
                    hasMore: !isAtConversationLimit && conversationChannelsResponse.hasNext,
                    isLoadingMore: false,
                    loadMoreError: null
                }
            });
            $dbfaf0ab050513fc$var$runExperienceTrackerSafely('succeed', ()=>{
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS
                });
            }, isKillSwitchEnabled);
        } catch (error) {
            const setLoadMoreError = ()=>setState({
                    conversationPagination: {
                        ...getState().conversationPagination,
                        isLoadingMore: false,
                        loadMoreError: (0, $eBgZa.createStoreError)(error, undefined, (0, $igOtY.StoreActionLoggableName).loadMoreConversationChannelsData)
                    }
                });
            const failExperience = ()=>$dbfaf0ab050513fc$var$runExperienceTrackerSafely('fail', ()=>{
                    experienceTracker.fail({
                        teamName: 'Rovo Chat',
                        name: (0, $irnO2.ExperienceName).LOAD_MORE_CONVERSATION_CHANNELS,
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }, isKillSwitchEnabled);
            if (isKillSwitchEnabled) {
                failExperience();
                setLoadMoreError();
                return;
            }
            setLoadMoreError();
            failExperience();
        }
    });
module.exports["loadMoreConversationChannelsData"] = $dbfaf0ab050513fc$export$95850e3f7783749e;

});

parcelRegister("hQJOO", function(module, exports) {
const $4745959a462aeb63$export$3bb35e4b7521ba6c = (channelsFromAPI, unifiedTasksActions)=>{
    if (!unifiedTasksActions) return;
    const allChannelTasks = channelsFromAPI.flatMap((channel)=>channel.tasks ?? []);
    if (allChannelTasks.length > 0) unifiedTasksActions.mergeConversationChannelTasks(allChannelTasks);
};
module.exports["mergeConversationChannelTasks"] = $4745959a462aeb63$export$3bb35e4b7521ba6c;

});

parcelRegister("eQl6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $igOtY = parcelRequire("igOtY");


var $6Hbrh = parcelRequire("6Hbrh");

const $2b8e200878e063c4$export$5ca6cb2fe3cf209c = ()=>({ getState: getState }, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!unifiedTasksActions || !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return;
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const task = unifiedTasksActions.getActiveTaskForConversation(currentConversationId);
        if (task && !(0, $igOtY.isTerminalTaskState)(task.progressState) && (0, $6Hbrh.shouldRestoreMaxModeFromLastRequestedMode)(conversations[currentConversationId]?.lastRequestedMode)) setReasoningMode(currentConversationId, 'task');
    };
module.exports["restoreTaskModeIfNeeded"] = $2b8e200878e063c4$export$5ca6cb2fe3cf209c;

});

parcelRegister("c8Sl1", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $4m5jb = parcelRequire("4m5jb");


var $8fLSN = parcelRequire("8fLSN");


var $igOtY = parcelRequire("igOtY");


var $b2pOf = parcelRequire("b2pOf");


var $8z5uc = parcelRequire("8z5uc");


var $l6xCb = parcelRequire("l6xCb");


var $lOO5l = parcelRequire("lOO5l");


var $6geN3 = parcelRequire("6geN3");

const $15f48e1bd7e00399$export$c954041354ede17c = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).setSelectedConversation, ({ conversationId: conversationId, sourceAgentId: sourceAgentId, conversationMetadata: conversationMetadata, targetMessageId: targetMessageId, clearLegacyLastMessageSentAt: clearLegacyLastMessageSentAt })=>({ setState: setState, getState: getState, dispatch: dispatch }, { siteId: siteId })=>{
        let resolvedConversationId = conversationId;
        if (!getState().conversations[conversationId]) {
            if (conversationMetadata?.id === conversationId) dispatch((0, $lOO5l.initializeConversationData)({
                conversationId: conversationId,
                data: {
                    ...(0, $8z5uc.conversationMetadataForStore)(conversationMetadata),
                    ...targetMessageId ? {
                        targetTaskMessageId: targetMessageId
                    } : {}
                }
            }));
            else resolvedConversationId = (0, $4m5jb.EMPTY_CONVERSATION_ID);
        } else if (targetMessageId) dispatch((0, $6geN3.setConversationData)({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: targetMessageId
            }
        }));
        setState({
            currentConversationId: resolvedConversationId
        });
        // Keep the agent id provided when selecting this conversation; gate-on also seeds `conversation.agent` for the header.
        if (sourceAgentId) {
            const conversationAgentFromSource = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? (0, $8fLSN.createProvisionalConversationAgent)(sourceAgentId) : undefined;
            const conversationAgentSourceData = conversationAgentFromSource ? {
                agent: conversationAgentFromSource
            } : {};
            dispatch((0, $6geN3.setConversationData)({
                conversationId: resolvedConversationId,
                data: {
                    sourceAgentId: sourceAgentId,
                    ...conversationAgentSourceData
                }
            }));
        }
        // Store preference.
        // For space-scoped conversations, store EMPTY_CONVERSATION_ID instead of the
        // client-generated UUID. The client UUID is never returned by the backend /conversations
        // API, so restoring it on refresh creates an orphaned optimistic entry that has no
        // rovoSpaceId and cannot be matched to any API channel — causing a ghost item to
        // appear in the regular conversation list. Starting fresh (empty chat) on refresh
        // is the correct behaviour for space conversations.
        const conversationForStorage = getState().conversations[resolvedConversationId];
        const localStorageConversationId = conversationForStorage?.rovoSpaceId && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) ? (0, $4m5jb.EMPTY_CONVERSATION_ID) : resolvedConversationId;
        (0, $b2pOf.persistRecentConversation)({
            type: 'conversation-selected',
            siteId: siteId,
            conversationId: localStorageConversationId,
            clearLegacyLastMessageSentAt: clearLegacyLastMessageSentAt
        });
    });
module.exports["setSelectedConversation"] = $15f48e1bd7e00399$export$c954041354ede17c;

});

parcelRegister("djNSU", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $5BnQI = parcelRequire("5BnQI");


var $7td41 = parcelRequire("7td41");


var $4m5jb = parcelRequire("4m5jb");


var $igOtY = parcelRequire("igOtY");


var $l6xCb = parcelRequire("l6xCb");


var $lOO5l = parcelRequire("lOO5l");


var $6MYo6 = parcelRequire("6MYo6");


var $c8Sl1 = parcelRequire("c8Sl1");

const $c61cad8d9ccd4ab2$export$91a9628d52e15401 = (0, $l6xCb.createSafeAction)((0, $igOtY.StoreActionLoggableName).createConversationOptimistically, (options)=>async ({ dispatch: dispatch }, { setMessages: setMessages })=>{
        const conversationId = options?.id ?? (0, $4m5jb.EMPTY_CONVERSATION_ID);
        const time = new Date().toISOString();
        // Seed `conversation.agent` from the known optimistic conversation identity.
        const agentForOptimisticConversation = (0, $6MYo6.resolveConversationSeedAgent)({
            backendAgent: options?.agent,
            agentId: options?.sourceAgentId,
            legacyAgent: options?.agent
        });
        // Under the selected-agent gate the header derives the displayed agent
        // solely from `conversation.agent`. When this optimistic creation re-uses an
        // existing conversation slot (e.g. EMPTY_CONVERSATION_ID) the data is
        // shallow-merged, so omitting the `agent` key would leave a previously-seeded
        // specialist agent in place. Selecting "Chat with Rovo" (no agent id) must
        // therefore explicitly clear `conversation.agent` back to the default Rovo
        // agent rather than silently preserving the stale one.
        const optimisticConversationAgentData = agentForOptimisticConversation ? {
            agent: agentForOptimisticConversation
        } : (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? {
            agent: undefined
        } // explicit clear so "Chat with Rovo" resets a stale specialist
         : {};
        // A user-initiated top-selector choice ("Chat with Rovo" or another agent)
        // lands here, and it commonly re-initialises an existing conversation slot
        // (EMPTY_CONVERSATION_ID) rather than allocating a new id. The unsent
        // selected-agent draft is keyed by that same id, so without an explicit
        // reset a prior inline `@`-mention would survive the switch and keep
        // routing later prompts to the old agent. Any mention nodes already typed
        // stay in the prompt document and merely become inactive.
        if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) (0, $5BnQI.clearSelectedAgentDraftOverride)(conversationId);
        dispatch((0, $lOO5l.initializeConversationData)({
            conversationId: conversationId,
            data: {
                id: conversationId,
                lastMessageTimestamp: options.lastMessageTimestamp ?? time,
                name: options.name ?? (0, $7td41.generateConversationName)(),
                sourceAgentId: options.sourceAgentId,
                sourceId: options.sourceId ?? undefined,
                // Journey attribution belongs to a canonical conversation ID. Empty optimistic
                // slots are reused and must not retain attribution from a prior launch.
                rovoJourneyId: options.id ? options.rovoJourneyId : undefined,
                status: options?.status ?? (0, $igOtY.CHAT_STORE_STATUS).idle,
                timeCreated: options?.timeCreated ?? time,
                traces: [],
                messages: [],
                lastMessageType: options?.lastMessageType ?? [],
                lastAgentMessageStatus: options?.lastAgentMessageStatus,
                resultAttributionContext: options?.resultAttributionContext,
                // Explicitly set rovoSpaceId (including undefined) so that re-initialising
                // EMPTY_CONVERSATION_ID without a space clears any stale rovoSpaceId left
                // from a previous space-scoped conversation.
                rovoSpaceId: options?.rovoSpaceId,
                // Same reasoning as rovoSpaceId: this action commonly re-initialises the
                // EMPTY_CONVERSATION_ID slot, and the data is shallow-merged, so the key
                // must be set even when undefined. Otherwise a chat launched from a
                // product surface would keep attributing later, unrelated chats to it.
                chatEntryPoint: options?.chatEntryPoint,
                isViewModeRemix: options?.isViewModeRemix,
                // Same reasoning again: a stale 3P cohort left on a re-initialised slot would
                // be mirrored onto an unrelated conversation's events, including the org-wide
                // AI-MAU events this experiment does not own (CCINT-8714).
                thirdPartyPrompt: undefined,
                ...optimisticConversationAgentData,
                // Reusing the empty conversation must not retain another agent's version.
                ...(0, $iDrrr.fg)('rovo_chat_reset_agent_version') || options?.agentVersion ? {
                    agentVersion: options?.agentVersion
                } : {},
                ...options?.scopes ? {
                    scopes: options.scopes
                } : {}
            }
        }));
        setMessages(conversationId, []);
        dispatch((0, $c8Sl1.setSelectedConversation)({
            conversationId: conversationId
        }));
    });
module.exports["createConversationOptimistically"] = $c61cad8d9ccd4ab2$export$91a9628d52e15401;

});

parcelRegister("8et9H", function(module, exports) {

var $2Z4XK = parcelRequire("2Z4XK");

const $fe0c133b8a00207b$export$24d5ff955141c347 = (text)=>{
    if (!text) return 0;
    // We use Intl here since it is locale-aware and accurately handles word counts across all languages. The regex will undercount non-English languages.
    if (0, $2Z4XK.segmenter) return [
        ...(0, $2Z4XK.segmenter).segment(text)
    ].filter((s)=>s.isWordLike).length;
    return text.match(/\S+/g)?.length ?? 0;
};
module.exports["wordCount"] = $fe0c133b8a00207b$export$24d5ff955141c347;

});

parcelRegister("cHkvP", function(module, exports) {

var $igOtY = parcelRequire("igOtY");


var $2g97a = parcelRequire("2g97a");

function $92531449a63cd135$export$61d3f10a1a228aae(messages) {
    const lastAssistant = (0, $2g97a.findLast)(messages, (0, $igOtY.isStoreAssistant));
    return lastAssistant?.content?.message?.message?.actions ?? [];
}
module.exports["getLastAssistantActions"] = $92531449a63cd135$export$61d3f10a1a228aae;

});

parcelRegister("hpOyG", function(module, exports) {
const $fee6bf724b914a99$export$da415d22ae15cf08 = (subExperiences, additionalAttributes)=>{
    const subExperienceNameSet = new Set(subExperiences);
    const mergedAttributes = {};
    return (events, experience)=>{
        // all subExperiences must succeed for the parent experience to succeed
        // a failure/abort to any subExperience will fail/abort the parent experience
        events.forEach((event)=>{
            if (subExperienceNameSet.has(event.name)) switch(event.action){
                case 'taskSuccess':
                    if (subExperienceNameSet.delete(event.name)) Object.assign(mergedAttributes, event.attributes ?? {});
                    break;
                case 'taskFail':
                    if ('error' in event) experience.fail({
                        error: event.error,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes
                        }
                    });
                    break;
                case 'taskAbort':
                    experience.abort({
                        reason: `${event.name} aborted`,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes,
                            childAbortReason: event.reason
                        }
                    });
                    break;
            }
        });
        if (subExperienceNameSet.size === 0) experience.succeed({
            ...additionalAttributes,
            ...mergedAttributes
        });
    };
};
module.exports["collectAllWithSubExperienceAttributes"] = $fee6bf724b914a99$export$da415d22ae15cf08;

});

parcelRegister("1Tpom", function(module, exports) {
const $004bf9e6a327298d$export$51ee55de82fed0a0 = (subExperienceNameToCheck, mainExperienceToFail, events, additionalAttributes)=>{
    const subExperienceFailEvent = events.find((event)=>event.action === 'taskFail' && event.name === subExperienceNameToCheck);
    if (subExperienceFailEvent) mainExperienceToFail.fail({
        error: subExperienceFailEvent.error,
        attributes: {
            ...additionalAttributes,
            ...subExperienceFailEvent.attributes
        }
    });
};
module.exports["failExperienceOnSubExperienceFail"] = $004bf9e6a327298d$export$51ee55de82fed0a0;

});

parcelRegister("iqkMb", function(module, exports) {

var $8XbBy = parcelRequire("8XbBy");

const $eb24afa4da9a6ecc$export$c13c17c66364de2d = (streamResponse)=>(0, $8XbBy.getInteractionModeExecutedFromMessage)(streamResponse?.message?.message);
module.exports["getInteractionModeExecutedFromStreamResponse"] = $eb24afa4da9a6ecc$export$c13c17c66364de2d;

});

parcelRegister("8zf2J", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $fCunh = parcelRequire("fCunh");


var $bxkJA = parcelRequire("bxkJA");


var $igOtY = parcelRequire("igOtY");


var $jyZaR = parcelRequire("jyZaR");


var $eBgZa = parcelRequire("eBgZa");


var $hwHCO = parcelRequire("hwHCO");


var $1IZrU = parcelRequire("1IZrU");

const $82c770e2b2e5e9f1$var$getErrorReason = ({ error: error, storeError: storeError, currentConversationId: currentConversationId, conversations: conversations })=>{
    if ((0, $bxkJA.isHipaaError)(error)) return 'hipaa';
    if ((0, $bxkJA.isAUPViolationError)(error)) return 'aupViolation';
    if ((0, $bxkJA.isChannelNotFoundError)(error)) return 'channelNotFound';
    if (!conversations?.[currentConversationId] || (0, $1IZrU.isEmptyConversation)(currentConversationId)) return 'noActiveConversation';
    if (storeError.status_code === 429 || (0, $bxkJA.isRateLimitedError)(error)) return 'rateLimited';
    return 'generic';
};
const $82c770e2b2e5e9f1$var$reportChatError = (sendAnalyticsEvent, reason, storeError)=>{
    sendAnalyticsEvent({
        eventType: 'operational',
        action: 'unhandledError',
        actionSubject: 'aiMate',
        attributes: {
            reason: reason,
            statusCode: storeError.status_code,
            messageTemplate: storeError.message_template,
            errorType: storeError.errorType,
            traceId: storeError.traceId,
            errorContent: storeError.content,
            ...storeError.storeActionExecutionError ? {
                actionLoggableName: storeError.storeActionExecutionError.actionLoggableName
            } : {}
        }
    });
};
const $82c770e2b2e5e9f1$export$769f721a7d2183c3 = (props)=>{
    const { args: args, api: api, actionLoggableName: actionLoggableName, error: error, containerProps: containerProps, actionErrorHandler: actionErrorHandler, setConversationData: setConversationData } = props;
    const { getState: getState, setState: setState, dispatch: dispatch } = api;
    (0, $hlvTd.addSentryBreadcrumb)(`createSafeAction: ${actionLoggableName} errored`);
    const storeError = (0, $eBgZa.createStoreError)(error, undefined, actionLoggableName, props.entryPoint);
    const errorReason = $82c770e2b2e5e9f1$var$getErrorReason({
        error: error,
        storeError: storeError,
        currentConversationId: getState().currentConversationId,
        conversations: getState().conversations
    });
    // ============================================
    // PHASE 1: Mandatory checks (cannot be overridden)
    // ============================================
    // Handle experience tracking
    // Rate limits are ignored because they trigger a retry, not an experience termination
    if (props?.experienceName && errorReason !== 'rateLimited') {
        if (errorReason === 'aupViolation') {
            const aupError = error;
            containerProps.experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
                reason: aupError.detail.message.message_template,
                attributes: {
                    ...aupError.errorAttributes,
                    errorType: error instanceof (0, $hwHCO.StreamErrorException) ? 'StreamErrorException' : ''
                }
            });
        } else containerProps.experienceTracker.fail({
            name: props.experienceName(args),
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
    // Handle restricted use errors
    if (errorReason === 'hipaa') {
        containerProps.setConversationError({
            type: 'hipaa',
            underlyingError: storeError
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'hipaa', storeError);
        return;
    }
    // ============================================
    // PHASE 2: Action-specific error handling (optional)
    // ============================================
    if (actionErrorHandler) {
        const result = actionErrorHandler({
            args: args,
            error: error,
            storeError: storeError,
            containerProps: containerProps,
            errorReason: errorReason
        });
        if (!result?.proceedToDefaultHandling) return;
    }
    // ============================================
    // PHASE 3: Default error handlers
    // ============================================
    if (errorReason === 'channelNotFound') {
        containerProps.setConversationError({
            type: 'conversationNotFound',
            underlyingError: storeError
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'channelNotFound', storeError);
        return;
    }
    if (errorReason === 'noActiveConversation') {
        containerProps.setConversationError({
            type: 'conversationEmptyOrNotPresentInStore',
            underlyingError: storeError
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'noActiveConversation', storeError);
        if (storeError.message_template === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE) containerProps.setRovoEnabled(false, storeError.message_template);
        return;
    }
    const currentConversationId = getState().currentConversationId;
    if (errorReason === 'rateLimited') {
        const rateLimitState = props?.getRateLimitState?.(args) ?? {};
        setState({
            conversations: {
                ...getState().conversations,
                [currentConversationId]: {
                    ...getState().conversations[currentConversationId],
                    ...(0, $jyZaR.clearStatus)({
                        lastAgentMessageStatus: 'FAILED'
                    })
                }
            }
        });
        containerProps.setConversationError({
            type: 'rateLimited',
            underlyingError: storeError,
            rateLimitedActionType: rateLimitState.isDeepResearchAttempt ? 'deep-research' : 'generic'
        });
        $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'rateLimited', storeError);
        return;
    }
    dispatch(setConversationData({
        conversationId: currentConversationId,
        data: {
            ...(0, $jyZaR.clearStatus)({
                lastAgentMessageStatus: 'FAILED'
            })
        }
    }));
    const currentMessages = containerProps.getMessages(currentConversationId);
    const lastMessage = currentMessages[currentMessages.length - 1];
    const isDuplicateError = lastMessage && (0, $igOtY.isStoreError)(lastMessage) && lastMessage.content === storeError.content;
    if (!isDuplicateError) containerProps.setMessages(currentConversationId, [
        ...currentMessages,
        storeError
    ]);
    const errorAttributes = error?.errorAttributes;
    containerProps.experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).AIFC_MESSAGE,
        error: error instanceof Error ? error : new Error(String(error)),
        attributes: {
            latestStreamMessageType: errorAttributes?.latestStreamMessageType,
            latestStreamMessageMillisOffset: errorAttributes?.latestStreamMessageMillisOffset
        }
    });
    $82c770e2b2e5e9f1$var$reportChatError(containerProps.sendAnalyticsEvent, 'generic', storeError);
};
module.exports["storeErrorHandler"] = $82c770e2b2e5e9f1$export$769f721a7d2183c3;

});

parcelRegister("64wzj", function(module, exports) {
const $286c7f27b5852cf3$export$dc6d7ea554bcce10 = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
module.exports["generateTraceId"] = $286c7f27b5852cf3$export$dc6d7ea554bcce10;

});

parcelRegister("8ssI02", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $7td41 = parcelRequire("7td41");


var $igOtY = parcelRequire("igOtY");


var $f2kj3 = parcelRequire("f2kj3");

const $15d69fdc4e9e25c3$export$60a662127f30e1e1 = (remoteConversation, localConversation)=>{
    const remoteParticipants = Array.isArray(remoteConversation.participants) ? remoteConversation.participants : undefined;
    const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    return {
        id: remoteConversation.id,
        // Prioritize API data if present, otherwise use local or generate new
        name: remoteConversation.name ?? localConversation?.name ?? (0, $7td41.generateConversationName)(),
        timeCreated: remoteConversation.time_created ?? localConversation?.timeCreated,
        lastMessage: remoteConversation.last_message ?? localConversation?.lastMessage ?? undefined,
        lastMessageType: remoteConversation.last_message_type ?? localConversation?.lastMessageType ?? [],
        lastMessageTimestamp: remoteConversation.last_message_timestamp ?? localConversation?.lastMessageTimestamp,
        lastAgentMessageStatus: remoteConversation.last_agent_message_status ?? localConversation?.lastAgentMessageStatus,
        ...remoteConversation.agentSessionState ? {
            agentSessionState: remoteConversation.agentSessionState
        } : {},
        readStatus: remoteConversation.readStatus ?? localConversation?.readStatus,
        isPinned: remoteConversation.isPinned ?? localConversation?.isPinned,
        pinnedAt: remoteConversation.pinnedAt ?? localConversation?.pinnedAt,
        tags: remoteConversation.tags ?? localConversation?.tags,
        // Omission is authoritative: CAP uses it to clear a previously-restorable mode.
        lastRequestedMode: (0, $f2kj3.normalizeRestorableRequestedMode)(remoteConversation.last_requested_mode),
        // Use local state data if it exists (messages, status are maintained locally)
        messages: localConversation?.messages ?? [],
        status: localConversation?.status ?? (0, $igOtY.CHAT_STORE_STATUS).idle,
        traces: localConversation?.traces ?? [],
        ...localConversation?.sourceAgentId ? {
            sourceAgentId: localConversation.sourceAgentId
        } : {},
        ...localConversation?.sourceId ? {
            sourceId: localConversation.sourceId
        } : {},
        // Front-end-only journey attribution belongs to one exact conversation ID. Preserve it for
        // same-ID refreshes, but never copy it when backend alias hydration changes the ID.
        ...localConversation?.id === remoteConversation.id && localConversation.rovoJourneyId !== undefined ? {
            rovoJourneyId: localConversation.rovoJourneyId
        } : {},
        ...localConversation?.id === remoteConversation.id && localConversation.searchResultsReturn ? {
            searchResultsReturn: localConversation.searchResultsReturn
        } : {},
        ...localConversation?.resultAttributionContext ? {
            resultAttributionContext: localConversation.resultAttributionContext
        } : {},
        // `chatEntryPoint` is front-end-only state — the backend channel never returns it — so it
        // must be carried over from local state or a channel rehydration (init / refocus) would
        // silently drop entry-point attribution mid-conversation.
        ...localConversation?.chatEntryPoint ? {
            chatEntryPoint: localConversation.chatEntryPoint
        } : {},
        // Same reasoning as `chatEntryPoint`: front-end-only, so a rehydration would otherwise
        // drop it and the conversation would stop reporting its cohort mid-flight.
        ...localConversation?.thirdPartyPrompt ? {
            thirdPartyPrompt: localConversation.thirdPartyPrompt
        } : {},
        // Preserve runtime abort controller so Stop button works after channels rehydration (e.g. refocus)
        ...localConversation?.storeAbortController != null ? {
            storeAbortController: localConversation.storeAbortController
        } : {},
        ...localConversation?.rovoSpaceId ? {
            rovoSpaceId: localConversation.rovoSpaceId
        } : {},
        sourceMode: remoteConversation.sourceMode === 'STRICT' ? 'STRICT' : 'GENERAL',
        // `agent` is optional on ConversationChannel, so the server-sourced channel can
        // Preserve the former all-flags-off behavior while retaining the local seed in
        // the experiment variation when the server omits the agent.
        agent: isMentionAgentsExperimentEnabled ? remoteConversation.agent ?? localConversation?.agent : remoteConversation.agent,
        scopes: remoteConversation.scopes ?? localConversation?.scopes,
        ...remoteParticipants !== undefined && isMentionAgentsExperimentEnabled ? {
            participants: remoteParticipants
        } : {}
    };
};
module.exports["mergeConversationWithNetworkPriority"] = $15d69fdc4e9e25c3$export$60a662127f30e1e1;

});

parcelRegister("6Hbrh", function(module, exports) {
const $63f6a798d3de12fd$export$2389649a7be8eb77 = (lastRequestedMode)=>lastRequestedMode === 'MAX';
module.exports["shouldRestoreMaxModeFromLastRequestedMode"] = $63f6a798d3de12fd$export$2389649a7be8eb77;

});

parcelRegister("8fLSN", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $9c1a3c9bb4b54fb7$export$fc6a9cdad8ea90e0 = (agentId)=>{
    if (!agentId) return undefined;
    return {
        agent_id: agentId,
        agent_named_id: agentId,
        agent_name: '',
        creator_type: ''
    };
};
const $9c1a3c9bb4b54fb7$export$9e56ee965c896858 = ({ conversation: conversation, fallbackAgentId: fallbackAgentId })=>{
    const storedConversationAgentId = conversation?.agent?.agent_id || undefined;
    return storedConversationAgentId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? storedConversationAgentId : fallbackAgentId;
};
module.exports["createProvisionalConversationAgent"] = $9c1a3c9bb4b54fb7$export$fc6a9cdad8ea90e0;
module.exports["resolveConversationAgentIdForRouting"] = $9c1a3c9bb4b54fb7$export$9e56ee965c896858;

});

parcelRegister("8z5uc", function(module, exports) {
const $6527329df61749d1$export$8d14a3ee8564ea0e = (conversation)=>{
    const { isEmpty: _isEmpty, currentTask: _currentTask, ...storeConversation } = conversation;
    return storeConversation;
};
module.exports["conversationMetadataForStore"] = $6527329df61749d1$export$8d14a3ee8564ea0e;

});

parcelRegister("lOO5l", function(module, exports) {
const $973523ae4fef70e5$export$7124b61407e3c15b = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId],
                    ...data
                }
            }
        });
    };
module.exports["initializeConversationData"] = $973523ae4fef70e5$export$7124b61407e3c15b;

});

parcelRegister("6MYo6", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $8fLSN = parcelRequire("8fLSN");

const $3e220ccac9a02b6e$export$f9d99d78335a8a06 = ({ backendAgent: backendAgent, agentId: agentId, legacyAgent: legacyAgent })=>{
    if ((0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) return backendAgent ?? (0, $8fLSN.createProvisionalConversationAgent)(agentId);
    return legacyAgent && (0, $iDrrr.fg)('rovo_chat_chat_history_refresh') ? legacyAgent : undefined;
};
module.exports["resolveConversationSeedAgent"] = $3e220ccac9a02b6e$export$f9d99d78335a8a06;

});

parcelRegister("2Z4XK", function(module, exports) {

var $62wRL = parcelRequire("62wRL");

const $c8a4fb02a7704daf$export$2057cd6e00c107b4 = (0, $62wRL.createSegmenter)();
module.exports["segmenter"] = $c8a4fb02a7704daf$export$2057cd6e00c107b4;

});

parcelRegister("8XbBy", function(module, exports) {

var $2YVJu = parcelRequire("2YVJu");

const $4f4d12a710043968$export$41ee2caec24cebc0 = (message)=>(0, $2YVJu.getInteractionModeExecutedFromMetadata)(message?.message_metadata);
module.exports["getInteractionModeExecutedFromMessage"] = $4f4d12a710043968$export$41ee2caec24cebc0;

});

parcelRegister("f2kj3", function(module, exports) {
const $f3deeaf7274014cf$export$521dc6882b67f1aa = (mode)=>{
    if (mode === 'MAX' || mode === 'MARATHON' || mode === 'DEEP_RESEARCH') return mode;
    return undefined;
};
module.exports["normalizeRestorableRequestedMode"] = $f3deeaf7274014cf$export$521dc6882b67f1aa;

});

parcelRegister("62wRL", function(module, exports) {
const $0612fd78d8462bd5$export$aa9d968a842359fd = ()=>{
    try {
        return Intl?.Segmenter ? new Intl.Segmenter(undefined, {
            granularity: 'word'
        }) : null;
    } catch  {
        return null;
    }
};
module.exports["createSegmenter"] = $0612fd78d8462bd5$export$aa9d968a842359fd;

});

parcelRegister("2YVJu", function(module, exports) {
const $0c5a9f05ef283ae7$export$3ac8b179c5bae1cb = (metadata)=>metadata?.interaction_mode_executed ?? undefined;
module.exports["getInteractionModeExecutedFromMetadata"] = $0c5a9f05ef283ae7$export$3ac8b179c5bae1cb;

});


//# sourceMappingURL=provider.2a283d0b.js.map
